// source: common.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
goog.exportSymbol('proto.Common.AllocAcctIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.ApplicationSequenceControl', null, global);
goog.exportSymbol('proto.Common.AttrbGrp', null, global);
goog.exportSymbol('proto.Common.AttrbGrp.InstrAttribTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.BaseTradingRules', null, global);
goog.exportSymbol('proto.Common.BenchmarkCurveNameEnum', null, global);
goog.exportSymbol('proto.Common.BenchmarkPriceTypeEnum', null, global);
goog.exportSymbol('proto.Common.BenchmarkSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.CPProgramEnum', null, global);
goog.exportSymbol('proto.Common.ClearingInstructionEnum', null, global);
goog.exportSymbol('proto.Common.ClrInstGrp', null, global);
goog.exportSymbol('proto.Common.CommTypeEnum', null, global);
goog.exportSymbol('proto.Common.CommissionData', null, global);
goog.exportSymbol('proto.Common.CompIDReqGrp', null, global);
goog.exportSymbol('proto.Common.CompIDStatGrp', null, global);
goog.exportSymbol('proto.Common.ComplexEventConditionEnum', null, global);
goog.exportSymbol('proto.Common.ComplexEventDates', null, global);
goog.exportSymbol('proto.Common.ComplexEventPriceBoundaryMethodEnum', null, global);
goog.exportSymbol('proto.Common.ComplexEventPriceTimeTypeEnum', null, global);
goog.exportSymbol('proto.Common.ComplexEventTimes', null, global);
goog.exportSymbol('proto.Common.ComplexEventTypeEnum', null, global);
goog.exportSymbol('proto.Common.ComplexEvents', null, global);
goog.exportSymbol('proto.Common.ContAmtGrp', null, global);
goog.exportSymbol('proto.Common.ContAmtTypeEnum', null, global);
goog.exportSymbol('proto.Common.ContraGrp', null, global);
goog.exportSymbol('proto.Common.ContractMultiplierUnitEnum', null, global);
goog.exportSymbol('proto.Common.CorporateActionEnum', null, global);
goog.exportSymbol('proto.Common.DeliveryFormEnum', null, global);
goog.exportSymbol('proto.Common.DeliveryTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeContractMultiplierUnitEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeEventTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeEventsGrp', null, global);
goog.exportSymbol('proto.Common.DerivativeExerciseStyleEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeFlowScheduleTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrAttribTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrmtAssignmentMethodEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrument', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrument.DerivativeFlowScheduleTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentAttribute', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentParties', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeInstrumentPartySubIDsGrp', null, global);
goog.exportSymbol('proto.Common.DerivativeListMethodEnum', null, global);
goog.exportSymbol('proto.Common.DerivativePriceQuoteMethodEnum', null, global);
goog.exportSymbol('proto.Common.DerivativePriceUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeProductEnum', null, global);
goog.exportSymbol('proto.Common.DerivativePutOrCallEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityAltIDGrp', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityAltIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityDefinition', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityStatusEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityTypeEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSecurityXML', null, global);
goog.exportSymbol('proto.Common.DerivativeSettlMethodEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeSymbolSfxEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeTimeUnitEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.DerivativeValuationMethodEnum', null, global);
goog.exportSymbol('proto.Common.DeskOrderHandlingInstEnum', null, global);
goog.exportSymbol('proto.Common.DeskTypeEnum', null, global);
goog.exportSymbol('proto.Common.DeskTypeSourceEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionInstEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionInstructions', null, global);
goog.exportSymbol('proto.Common.DiscretionLimitTypeEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionMoveTypeEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionOffsetTypeEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionRoundDirectionEnum', null, global);
goog.exportSymbol('proto.Common.DiscretionScopeEnum', null, global);
goog.exportSymbol('proto.Common.DisplayInstruction', null, global);
goog.exportSymbol('proto.Common.DisplayMethodEnum', null, global);
goog.exportSymbol('proto.Common.DisplayWhenEnum', null, global);
goog.exportSymbol('proto.Common.DlvyInstGrp', null, global);
goog.exportSymbol('proto.Common.DlvyInstTypeEnum', null, global);
goog.exportSymbol('proto.Common.EventTypeEnum', null, global);
goog.exportSymbol('proto.Common.EvntGrp', null, global);
goog.exportSymbol('proto.Common.EvntGrp.EventTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.ExecInstRules', null, global);
goog.exportSymbol('proto.Common.ExecInstValueEnum', null, global);
goog.exportSymbol('proto.Common.ExerciseStyleEnum', null, global);
goog.exportSymbol('proto.Common.ExpirationCycleEnum', null, global);
goog.exportSymbol('proto.Common.FinancingDetails', null, global);
goog.exportSymbol('proto.Common.FlowScheduleTypeEnum', null, global);
goog.exportSymbol('proto.Common.FundRenewWaivEnum', null, global);
goog.exportSymbol('proto.Common.ImpliedMarketIndicatorEnum', null, global);
goog.exportSymbol('proto.Common.InstrAttribTypeEnum', null, global);
goog.exportSymbol('proto.Common.InstrmtGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtLegExecGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtLegGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtLegIOIGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtLegSecListGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtMDReqGrp', null, global);
goog.exportSymbol('proto.Common.InstrmtMDReqGrp.SettlTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.Instrument', null, global);
goog.exportSymbol('proto.Common.Instrument.CpProgramUnionCase', null, global);
goog.exportSymbol('proto.Common.Instrument.FlowScheduleTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.Instrument.StrikePriceDeterminationMethodUnionCase', null, global);
goog.exportSymbol('proto.Common.InstrumentExtension', null, global);
goog.exportSymbol('proto.Common.InstrumentLeg', null, global);
goog.exportSymbol('proto.Common.InstrumentLeg.LegFlowScheduleTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.InstrumentParties', null, global);
goog.exportSymbol('proto.Common.InstrumentPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.InstrumentPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.InstrumentPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.InstrumentPtysSubGrp', null, global);
goog.exportSymbol('proto.Common.LegBenchmarkCurveData', null, global);
goog.exportSymbol('proto.Common.LegBenchmarkCurveNameEnum', null, global);
goog.exportSymbol('proto.Common.LegContractMultiplierUnitEnum', null, global);
goog.exportSymbol('proto.Common.LegCoveredOrUncoveredEnum', null, global);
goog.exportSymbol('proto.Common.LegExecInstEnum', null, global);
goog.exportSymbol('proto.Common.LegExerciseStyleEnum', null, global);
goog.exportSymbol('proto.Common.LegFlowScheduleTypeEnum', null, global);
goog.exportSymbol('proto.Common.LegIOIQtyEnum', null, global);
goog.exportSymbol('proto.Common.LegPositionEffectEnum', null, global);
goog.exportSymbol('proto.Common.LegPreAllocGrp', null, global);
goog.exportSymbol('proto.Common.LegPriceUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.LegProductEnum', null, global);
goog.exportSymbol('proto.Common.LegSecAltIDGrp', null, global);
goog.exportSymbol('proto.Common.LegSecurityAltIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.LegSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.LegSecurityTypeEnum', null, global);
goog.exportSymbol('proto.Common.LegSettlTypeEnum', null, global);
goog.exportSymbol('proto.Common.LegSideEnum', null, global);
goog.exportSymbol('proto.Common.LegStipulationTypeEnum', null, global);
goog.exportSymbol('proto.Common.LegStipulations', null, global);
goog.exportSymbol('proto.Common.LegSwapTypeEnum', null, global);
goog.exportSymbol('proto.Common.LegSymbolSfxEnum', null, global);
goog.exportSymbol('proto.Common.LegTimeUnitEnum', null, global);
goog.exportSymbol('proto.Common.LegUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.LinesOfTextGrp', null, global);
goog.exportSymbol('proto.Common.ListMethodEnum', null, global);
goog.exportSymbol('proto.Common.ListUpdateActionEnum', null, global);
goog.exportSymbol('proto.Common.LotTypeEnum', null, global);
goog.exportSymbol('proto.Common.LotTypeRules', null, global);
goog.exportSymbol('proto.Common.MDBookTypeEnum', null, global);
goog.exportSymbol('proto.Common.MarketDataFeedTypes', null, global);
goog.exportSymbol('proto.Common.MarketSegmentGrp', null, global);
goog.exportSymbol('proto.Common.MatchRules', null, global);
goog.exportSymbol('proto.Common.MatchTypeEnum', null, global);
goog.exportSymbol('proto.Common.MaturityMonthYearFormatEnum', null, global);
goog.exportSymbol('proto.Common.MaturityMonthYearIncrementUnitsEnum', null, global);
goog.exportSymbol('proto.Common.MaturityRules', null, global);
goog.exportSymbol('proto.Common.MiscFeeBasisEnum', null, global);
goog.exportSymbol('proto.Common.MiscFeeTypeEnum', null, global);
goog.exportSymbol('proto.Common.MiscFeesGrp', null, global);
goog.exportSymbol('proto.Common.MsgDirectionEnum', null, global);
goog.exportSymbol('proto.Common.MsgTypeGrp', null, global);
goog.exportSymbol('proto.Common.MultilegModelEnum', null, global);
goog.exportSymbol('proto.Common.MultilegPriceMethodEnum', null, global);
goog.exportSymbol('proto.Common.Nested2PartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.Nested2PartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.Nested2PartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.Nested3PartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.Nested3PartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.Nested3PartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.Nested4PartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.Nested4PartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.Nested4PartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.NestedInstrAttribTypeEnum', null, global);
goog.exportSymbol('proto.Common.NestedInstrumentAttribute', null, global);
goog.exportSymbol('proto.Common.NestedParties', null, global);
goog.exportSymbol('proto.Common.NestedParties2', null, global);
goog.exportSymbol('proto.Common.NestedParties3', null, global);
goog.exportSymbol('proto.Common.NestedParties4', null, global);
goog.exportSymbol('proto.Common.NestedPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.NestedPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.NestedPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.NstdPtys2SubGrp', null, global);
goog.exportSymbol('proto.Common.NstdPtys3SubGrp', null, global);
goog.exportSymbol('proto.Common.NstdPtys4SubGrp', null, global);
goog.exportSymbol('proto.Common.NstdPtysSubGrp', null, global);
goog.exportSymbol('proto.Common.OptPayoutTypeEnum', null, global);
goog.exportSymbol('proto.Common.OrdAllocGrp', null, global);
goog.exportSymbol('proto.Common.OrdTypeEnum', null, global);
goog.exportSymbol('proto.Common.OrdTypeRules', null, global);
goog.exportSymbol('proto.Common.OrderQtyData', null, global);
goog.exportSymbol('proto.Common.Parties', null, global);
goog.exportSymbol('proto.Common.PartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.PartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.PartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.PegInstructions', null, global);
goog.exportSymbol('proto.Common.PegLimitTypeEnum', null, global);
goog.exportSymbol('proto.Common.PegMoveTypeEnum', null, global);
goog.exportSymbol('proto.Common.PegOffsetTypeEnum', null, global);
goog.exportSymbol('proto.Common.PegPriceTypeEnum', null, global);
goog.exportSymbol('proto.Common.PegRoundDirectionEnum', null, global);
goog.exportSymbol('proto.Common.PegScopeEnum', null, global);
goog.exportSymbol('proto.Common.PegSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.PosAmtTypeEnum', null, global);
goog.exportSymbol('proto.Common.PosQtyStatusEnum', null, global);
goog.exportSymbol('proto.Common.PosTypeEnum', null, global);
goog.exportSymbol('proto.Common.PositionAmountData', null, global);
goog.exportSymbol('proto.Common.PositionQty', null, global);
goog.exportSymbol('proto.Common.PreAllocGrp', null, global);
goog.exportSymbol('proto.Common.PreAllocMlegGrp', null, global);
goog.exportSymbol('proto.Common.PriceLimitTypeEnum', null, global);
goog.exportSymbol('proto.Common.PriceLimits', null, global);
goog.exportSymbol('proto.Common.PriceQuoteMethodEnum', null, global);
goog.exportSymbol('proto.Common.PriceTypeEnum', null, global);
goog.exportSymbol('proto.Common.PriceUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.ProductEnum', null, global);
goog.exportSymbol('proto.Common.PtysSubGrp', null, global);
goog.exportSymbol('proto.Common.PtysSubGrp.PartySubIdTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.PutOrCallEnum', null, global);
goog.exportSymbol('proto.Common.QuoteTypeEnum', null, global);
goog.exportSymbol('proto.Common.RateSource', null, global);
goog.exportSymbol('proto.Common.RateSourceEnum', null, global);
goog.exportSymbol('proto.Common.RateSourceTypeEnum', null, global);
goog.exportSymbol('proto.Common.RefApplVerIDEnum', null, global);
goog.exportSymbol('proto.Common.RefMsgTypeEnum', null, global);
goog.exportSymbol('proto.Common.RelSymDerivSecUpdGrp', null, global);
goog.exportSymbol('proto.Common.RestructuringTypeEnum', null, global);
goog.exportSymbol('proto.Common.RootParties', null, global);
goog.exportSymbol('proto.Common.RootPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.RootPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.RootPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.RootSubParties', null, global);
goog.exportSymbol('proto.Common.RoundingDirectionEnum', null, global);
goog.exportSymbol('proto.Common.RoutingGrp', null, global);
goog.exportSymbol('proto.Common.RoutingTypeEnum', null, global);
goog.exportSymbol('proto.Common.SecAltIDGrp', null, global);
goog.exportSymbol('proto.Common.SecondaryPriceLimitTypeEnum', null, global);
goog.exportSymbol('proto.Common.SecondaryPriceLimits', null, global);
goog.exportSymbol('proto.Common.SecurityAltIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.SecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.SecurityStatusEnum', null, global);
goog.exportSymbol('proto.Common.SecurityTradingRules', null, global);
goog.exportSymbol('proto.Common.SecurityTypeEnum', null, global);
goog.exportSymbol('proto.Common.SecurityXML', null, global);
goog.exportSymbol('proto.Common.SeniorityEnum', null, global);
goog.exportSymbol('proto.Common.SettlDeliveryTypeEnum', null, global);
goog.exportSymbol('proto.Common.SettlDetails', null, global);
goog.exportSymbol('proto.Common.SettlInstSourceEnum', null, global);
goog.exportSymbol('proto.Common.SettlInstructionsData', null, global);
goog.exportSymbol('proto.Common.SettlMethodEnum', null, global);
goog.exportSymbol('proto.Common.SettlObligSourceEnum', null, global);
goog.exportSymbol('proto.Common.SettlParties', null, global);
goog.exportSymbol('proto.Common.SettlPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.SettlPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.SettlPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.SettlPtysSubGrp', null, global);
goog.exportSymbol('proto.Common.SettlTypeEnum', null, global);
goog.exportSymbol('proto.Common.SpreadOrBenchmarkCurveData', null, global);
goog.exportSymbol('proto.Common.StandInstDbTypeEnum', null, global);
goog.exportSymbol('proto.Common.StatusValueEnum', null, global);
goog.exportSymbol('proto.Common.StipulationTypeEnum', null, global);
goog.exportSymbol('proto.Common.Stipulations', null, global);
goog.exportSymbol('proto.Common.StrategyParameterTypeEnum', null, global);
goog.exportSymbol('proto.Common.StrategyParametersGrp', null, global);
goog.exportSymbol('proto.Common.StrikeExerciseStyleEnum', null, global);
goog.exportSymbol('proto.Common.StrikePriceBoundaryMethodEnum', null, global);
goog.exportSymbol('proto.Common.StrikePriceDeterminationMethodEnum', null, global);
goog.exportSymbol('proto.Common.StrikeRules', null, global);
goog.exportSymbol('proto.Common.SymbolSfxEnum', null, global);
goog.exportSymbol('proto.Common.TargetParties', null, global);
goog.exportSymbol('proto.Common.TargetPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.TargetPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.TerminationTypeEnum', null, global);
goog.exportSymbol('proto.Common.TickRuleTypeEnum', null, global);
goog.exportSymbol('proto.Common.TickRules', null, global);
goog.exportSymbol('proto.Common.TimeInForceEnum', null, global);
goog.exportSymbol('proto.Common.TimeInForceRules', null, global);
goog.exportSymbol('proto.Common.TimeUnitEnum', null, global);
goog.exportSymbol('proto.Common.TradSesMethodEnum', null, global);
goog.exportSymbol('proto.Common.TradSesModeEnum', null, global);
goog.exportSymbol('proto.Common.TradSesStatusEnum', null, global);
goog.exportSymbol('proto.Common.TradSesStatusRejReasonEnum', null, global);
goog.exportSymbol('proto.Common.TradSesUpdateActionEnum', null, global);
goog.exportSymbol('proto.Common.TradingSessionIDEnum', null, global);
goog.exportSymbol('proto.Common.TradingSessionRules', null, global);
goog.exportSymbol('proto.Common.TradingSessionRulesGrp', null, global);
goog.exportSymbol('proto.Common.TradingSessionRulesGrp.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TradingSessionRulesGrp.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TradingSessionSubIDEnum', null, global);
goog.exportSymbol('proto.Common.TrdRegTimestampTypeEnum', null, global);
goog.exportSymbol('proto.Common.TrdRegTimestamps', null, global);
goog.exportSymbol('proto.Common.TrdSessLstGrp', null, global);
goog.exportSymbol('proto.Common.TrdSessLstGrp.TradSesStatusRejReasonUnionCase', null, global);
goog.exportSymbol('proto.Common.TrdSessLstGrp.TradSesStatusUnionCase', null, global);
goog.exportSymbol('proto.Common.TrdSessLstGrp.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TrdSessLstGrp.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TrdgSesGrp', null, global);
goog.exportSymbol('proto.Common.TrdgSesGrp.TradingSessionIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TrdgSesGrp.TradingSessionSubIdUnionCase', null, global);
goog.exportSymbol('proto.Common.TriggerActionEnum', null, global);
goog.exportSymbol('proto.Common.TriggerOrderTypeEnum', null, global);
goog.exportSymbol('proto.Common.TriggerPriceDirectionEnum', null, global);
goog.exportSymbol('proto.Common.TriggerPriceTypeEnum', null, global);
goog.exportSymbol('proto.Common.TriggerPriceTypeScopeEnum', null, global);
goog.exportSymbol('proto.Common.TriggerSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.TriggerTypeEnum', null, global);
goog.exportSymbol('proto.Common.TriggeringInstruction', null, global);
goog.exportSymbol('proto.Common.UndInstrmtGrp', null, global);
goog.exportSymbol('proto.Common.UndSecAltIDGrp', null, global);
goog.exportSymbol('proto.Common.UnderlyingCashTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingContractMultiplierUnitEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingExerciseStyleEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingFXRateCalcEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingFlowScheduleTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingInstrument', null, global);
goog.exportSymbol('proto.Common.UnderlyingInstrument.UnderlyingFlowScheduleTypeUnionCase', null, global);
goog.exportSymbol('proto.Common.UnderlyingInstrumentPartyIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingInstrumentPartyRoleEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingInstrumentPartySubIDTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingPriceDeterminationMethodEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingPriceUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingProductEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingRestructuringTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingSecurityAltIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingSecurityIDSourceEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingSecurityTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingSeniorityEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingSettlementTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingStipTypeEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingStipulations', null, global);
goog.exportSymbol('proto.Common.UnderlyingSymbolSfxEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingTimeUnitEnum', null, global);
goog.exportSymbol('proto.Common.UnderlyingUnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.UndlyInstrumentParties', null, global);
goog.exportSymbol('proto.Common.UndlyInstrumentPtysSubGrp', null, global);
goog.exportSymbol('proto.Common.UnitOfMeasureEnum', null, global);
goog.exportSymbol('proto.Common.ValuationMethodEnum', null, global);
goog.exportSymbol('proto.Common.YieldData', null, global);
goog.exportSymbol('proto.Common.YieldRedemptionPriceTypeEnum', null, global);
goog.exportSymbol('proto.Common.YieldTypeEnum', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.CommissionData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.CommissionData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.CommissionData.displayName = 'proto.Common.CommissionData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DiscretionInstructions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DiscretionInstructions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DiscretionInstructions.displayName = 'proto.Common.DiscretionInstructions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.FinancingDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.FinancingDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.FinancingDetails.displayName = 'proto.Common.FinancingDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.Instrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.Instrument.repeatedFields_, proto.Common.Instrument.oneofGroups_);
};
goog.inherits(proto.Common.Instrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.Instrument.displayName = 'proto.Common.Instrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrumentExtension = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrumentExtension.repeatedFields_, null);
};
goog.inherits(proto.Common.InstrumentExtension, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrumentExtension.displayName = 'proto.Common.InstrumentExtension';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrumentLeg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrumentLeg.repeatedFields_, proto.Common.InstrumentLeg.oneofGroups_);
};
goog.inherits(proto.Common.InstrumentLeg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrumentLeg.displayName = 'proto.Common.InstrumentLeg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LegBenchmarkCurveData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.LegBenchmarkCurveData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LegBenchmarkCurveData.displayName = 'proto.Common.LegBenchmarkCurveData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LegStipulations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.LegStipulations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LegStipulations.displayName = 'proto.Common.LegStipulations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NestedParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.NestedParties.repeatedFields_, null);
};
goog.inherits(proto.Common.NestedParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NestedParties.displayName = 'proto.Common.NestedParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.OrderQtyData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.OrderQtyData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.OrderQtyData.displayName = 'proto.Common.OrderQtyData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.Parties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.Parties.repeatedFields_, null);
};
goog.inherits(proto.Common.Parties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.Parties.displayName = 'proto.Common.Parties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PegInstructions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.PegInstructions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PegInstructions.displayName = 'proto.Common.PegInstructions';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PositionAmountData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.PositionAmountData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PositionAmountData.displayName = 'proto.Common.PositionAmountData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PositionQty = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.PositionQty.repeatedFields_, null);
};
goog.inherits(proto.Common.PositionQty, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PositionQty.displayName = 'proto.Common.PositionQty';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SettlInstructionsData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.SettlInstructionsData.repeatedFields_, null);
};
goog.inherits(proto.Common.SettlInstructionsData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SettlInstructionsData.displayName = 'proto.Common.SettlInstructionsData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SettlParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.SettlParties.repeatedFields_, null);
};
goog.inherits(proto.Common.SettlParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SettlParties.displayName = 'proto.Common.SettlParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SpreadOrBenchmarkCurveData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.SpreadOrBenchmarkCurveData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SpreadOrBenchmarkCurveData.displayName = 'proto.Common.SpreadOrBenchmarkCurveData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.Stipulations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.Stipulations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.Stipulations.displayName = 'proto.Common.Stipulations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TrdRegTimestamps = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.TrdRegTimestamps.repeatedFields_, null);
};
goog.inherits(proto.Common.TrdRegTimestamps, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TrdRegTimestamps.displayName = 'proto.Common.TrdRegTimestamps';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UnderlyingInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.UnderlyingInstrument.repeatedFields_, proto.Common.UnderlyingInstrument.oneofGroups_);
};
goog.inherits(proto.Common.UnderlyingInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UnderlyingInstrument.displayName = 'proto.Common.UnderlyingInstrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.YieldData = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.YieldData, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.YieldData.displayName = 'proto.Common.YieldData';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UnderlyingStipulations = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.UnderlyingStipulations, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UnderlyingStipulations.displayName = 'proto.Common.UnderlyingStipulations';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NestedParties2 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.NestedParties2.repeatedFields_, null);
};
goog.inherits(proto.Common.NestedParties2, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NestedParties2.displayName = 'proto.Common.NestedParties2';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NestedParties3 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.NestedParties3.repeatedFields_, null);
};
goog.inherits(proto.Common.NestedParties3, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NestedParties3.displayName = 'proto.Common.NestedParties3';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ClrInstGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ClrInstGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ClrInstGrp.displayName = 'proto.Common.ClrInstGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.CompIDReqGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.CompIDReqGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.CompIDReqGrp.displayName = 'proto.Common.CompIDReqGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.CompIDStatGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.CompIDStatGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.CompIDStatGrp.displayName = 'proto.Common.CompIDStatGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ContAmtGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ContAmtGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ContAmtGrp.displayName = 'proto.Common.ContAmtGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ContraGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ContraGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ContraGrp.displayName = 'proto.Common.ContraGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.InstrmtGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtGrp.displayName = 'proto.Common.InstrmtGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtLegExecGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrmtLegExecGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.InstrmtLegExecGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtLegExecGrp.displayName = 'proto.Common.InstrmtLegExecGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtLegGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.InstrmtLegGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtLegGrp.displayName = 'proto.Common.InstrmtLegGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtLegIOIGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrmtLegIOIGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.InstrmtLegIOIGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtLegIOIGrp.displayName = 'proto.Common.InstrmtLegIOIGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtLegSecListGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrmtLegSecListGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.InstrmtLegSecListGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtLegSecListGrp.displayName = 'proto.Common.InstrmtLegSecListGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrmtMDReqGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrmtMDReqGrp.repeatedFields_, proto.Common.InstrmtMDReqGrp.oneofGroups_);
};
goog.inherits(proto.Common.InstrmtMDReqGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrmtMDReqGrp.displayName = 'proto.Common.InstrmtMDReqGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LegPreAllocGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.LegPreAllocGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.LegPreAllocGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LegPreAllocGrp.displayName = 'proto.Common.LegPreAllocGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LinesOfTextGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.LinesOfTextGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LinesOfTextGrp.displayName = 'proto.Common.LinesOfTextGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MiscFeesGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.MiscFeesGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MiscFeesGrp.displayName = 'proto.Common.MiscFeesGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.OrdAllocGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.OrdAllocGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.OrdAllocGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.OrdAllocGrp.displayName = 'proto.Common.OrdAllocGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PreAllocGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.PreAllocGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.PreAllocGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PreAllocGrp.displayName = 'proto.Common.PreAllocGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PreAllocMlegGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.PreAllocMlegGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.PreAllocMlegGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PreAllocMlegGrp.displayName = 'proto.Common.PreAllocMlegGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.RoutingGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.RoutingGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.RoutingGrp.displayName = 'proto.Common.RoutingGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TrdgSesGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.TrdgSesGrp.oneofGroups_);
};
goog.inherits(proto.Common.TrdgSesGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TrdgSesGrp.displayName = 'proto.Common.TrdgSesGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UndInstrmtGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.UndInstrmtGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UndInstrmtGrp.displayName = 'proto.Common.UndInstrmtGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.EvntGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.EvntGrp.oneofGroups_);
};
goog.inherits(proto.Common.EvntGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.EvntGrp.displayName = 'proto.Common.EvntGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SecAltIDGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.SecAltIDGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SecAltIDGrp.displayName = 'proto.Common.SecAltIDGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LegSecAltIDGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.LegSecAltIDGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LegSecAltIDGrp.displayName = 'proto.Common.LegSecAltIDGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UndSecAltIDGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.UndSecAltIDGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UndSecAltIDGrp.displayName = 'proto.Common.UndSecAltIDGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.AttrbGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.AttrbGrp.oneofGroups_);
};
goog.inherits(proto.Common.AttrbGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.AttrbGrp.displayName = 'proto.Common.AttrbGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DlvyInstGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.DlvyInstGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.DlvyInstGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DlvyInstGrp.displayName = 'proto.Common.DlvyInstGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SettlPtysSubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.SettlPtysSubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SettlPtysSubGrp.displayName = 'proto.Common.SettlPtysSubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PtysSubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.PtysSubGrp.oneofGroups_);
};
goog.inherits(proto.Common.PtysSubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PtysSubGrp.displayName = 'proto.Common.PtysSubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NstdPtysSubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.NstdPtysSubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NstdPtysSubGrp.displayName = 'proto.Common.NstdPtysSubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NstdPtys2SubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.NstdPtys2SubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NstdPtys2SubGrp.displayName = 'proto.Common.NstdPtys2SubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NstdPtys3SubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.NstdPtys3SubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NstdPtys3SubGrp.displayName = 'proto.Common.NstdPtys3SubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.StrategyParametersGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.StrategyParametersGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.StrategyParametersGrp.displayName = 'proto.Common.StrategyParametersGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrumentParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.InstrumentParties.repeatedFields_, null);
};
goog.inherits(proto.Common.InstrumentParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrumentParties.displayName = 'proto.Common.InstrumentParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.InstrumentPtysSubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.InstrumentPtysSubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.InstrumentPtysSubGrp.displayName = 'proto.Common.InstrumentPtysSubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UndlyInstrumentParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.UndlyInstrumentParties.repeatedFields_, null);
};
goog.inherits(proto.Common.UndlyInstrumentParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UndlyInstrumentParties.displayName = 'proto.Common.UndlyInstrumentParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.UndlyInstrumentPtysSubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.UndlyInstrumentPtysSubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.UndlyInstrumentPtysSubGrp.displayName = 'proto.Common.UndlyInstrumentPtysSubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DisplayInstruction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DisplayInstruction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DisplayInstruction.displayName = 'proto.Common.DisplayInstruction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TriggeringInstruction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.TriggeringInstruction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TriggeringInstruction.displayName = 'proto.Common.TriggeringInstruction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.RootParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.RootParties.repeatedFields_, null);
};
goog.inherits(proto.Common.RootParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.RootParties.displayName = 'proto.Common.RootParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.RootSubParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.RootSubParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.RootSubParties.displayName = 'proto.Common.RootSubParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TrdSessLstGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.TrdSessLstGrp.oneofGroups_);
};
goog.inherits(proto.Common.TrdSessLstGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TrdSessLstGrp.displayName = 'proto.Common.TrdSessLstGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MsgTypeGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.MsgTypeGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MsgTypeGrp.displayName = 'proto.Common.MsgTypeGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SecurityTradingRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.SecurityTradingRules.repeatedFields_, null);
};
goog.inherits(proto.Common.SecurityTradingRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SecurityTradingRules.displayName = 'proto.Common.SecurityTradingRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SettlDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.SettlDetails.repeatedFields_, null);
};
goog.inherits(proto.Common.SettlDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SettlDetails.displayName = 'proto.Common.SettlDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SecurityXML = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.SecurityXML, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SecurityXML.displayName = 'proto.Common.SecurityXML';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TickRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.TickRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TickRules.displayName = 'proto.Common.TickRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.StrikeRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.StrikeRules.repeatedFields_, null);
};
goog.inherits(proto.Common.StrikeRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.StrikeRules.displayName = 'proto.Common.StrikeRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MaturityRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.MaturityRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MaturityRules.displayName = 'proto.Common.MaturityRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.SecondaryPriceLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.SecondaryPriceLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.SecondaryPriceLimits.displayName = 'proto.Common.SecondaryPriceLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.PriceLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.PriceLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.PriceLimits.displayName = 'proto.Common.PriceLimits';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MarketDataFeedTypes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.MarketDataFeedTypes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MarketDataFeedTypes.displayName = 'proto.Common.MarketDataFeedTypes';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.LotTypeRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.LotTypeRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.LotTypeRules.displayName = 'proto.Common.LotTypeRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MatchRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.MatchRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MatchRules.displayName = 'proto.Common.MatchRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ExecInstRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ExecInstRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ExecInstRules.displayName = 'proto.Common.ExecInstRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TimeInForceRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.TimeInForceRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TimeInForceRules.displayName = 'proto.Common.TimeInForceRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.OrdTypeRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.OrdTypeRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.OrdTypeRules.displayName = 'proto.Common.OrdTypeRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TradingSessionRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.TradingSessionRules.repeatedFields_, null);
};
goog.inherits(proto.Common.TradingSessionRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TradingSessionRules.displayName = 'proto.Common.TradingSessionRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TradingSessionRulesGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.Common.TradingSessionRulesGrp.oneofGroups_);
};
goog.inherits(proto.Common.TradingSessionRulesGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TradingSessionRulesGrp.displayName = 'proto.Common.TradingSessionRulesGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.BaseTradingRules = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.BaseTradingRules.repeatedFields_, null);
};
goog.inherits(proto.Common.BaseTradingRules, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.BaseTradingRules.displayName = 'proto.Common.BaseTradingRules';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.MarketSegmentGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.MarketSegmentGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.MarketSegmentGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.MarketSegmentGrp.displayName = 'proto.Common.MarketSegmentGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DerivativeInstrumentPartySubIDsGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeInstrumentPartySubIDsGrp.displayName = 'proto.Common.DerivativeInstrumentPartySubIDsGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeInstrumentParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.DerivativeInstrumentParties.repeatedFields_, null);
};
goog.inherits(proto.Common.DerivativeInstrumentParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeInstrumentParties.displayName = 'proto.Common.DerivativeInstrumentParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeInstrumentAttribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DerivativeInstrumentAttribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeInstrumentAttribute.displayName = 'proto.Common.DerivativeInstrumentAttribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NestedInstrumentAttribute = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.NestedInstrumentAttribute, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NestedInstrumentAttribute.displayName = 'proto.Common.NestedInstrumentAttribute';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeInstrument = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.DerivativeInstrument.repeatedFields_, proto.Common.DerivativeInstrument.oneofGroups_);
};
goog.inherits(proto.Common.DerivativeInstrument, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeInstrument.displayName = 'proto.Common.DerivativeInstrument';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeSecurityAltIDGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DerivativeSecurityAltIDGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeSecurityAltIDGrp.displayName = 'proto.Common.DerivativeSecurityAltIDGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeEventsGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DerivativeEventsGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeEventsGrp.displayName = 'proto.Common.DerivativeEventsGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeSecurityDefinition = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.DerivativeSecurityDefinition.repeatedFields_, null);
};
goog.inherits(proto.Common.DerivativeSecurityDefinition, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeSecurityDefinition.displayName = 'proto.Common.DerivativeSecurityDefinition';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.RelSymDerivSecUpdGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.RelSymDerivSecUpdGrp.repeatedFields_, null);
};
goog.inherits(proto.Common.RelSymDerivSecUpdGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.RelSymDerivSecUpdGrp.displayName = 'proto.Common.RelSymDerivSecUpdGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.DerivativeSecurityXML = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.DerivativeSecurityXML, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.DerivativeSecurityXML.displayName = 'proto.Common.DerivativeSecurityXML';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ApplicationSequenceControl = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ApplicationSequenceControl, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ApplicationSequenceControl.displayName = 'proto.Common.ApplicationSequenceControl';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NstdPtys4SubGrp = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.NstdPtys4SubGrp, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NstdPtys4SubGrp.displayName = 'proto.Common.NstdPtys4SubGrp';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.NestedParties4 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.NestedParties4.repeatedFields_, null);
};
goog.inherits(proto.Common.NestedParties4, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.NestedParties4.displayName = 'proto.Common.NestedParties4';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.RateSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.RateSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.RateSource.displayName = 'proto.Common.RateSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.TargetParties = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.TargetParties, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.TargetParties.displayName = 'proto.Common.TargetParties';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ComplexEvents = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.ComplexEvents.repeatedFields_, null);
};
goog.inherits(proto.Common.ComplexEvents, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ComplexEvents.displayName = 'proto.Common.ComplexEvents';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ComplexEventDates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.Common.ComplexEventDates.repeatedFields_, null);
};
goog.inherits(proto.Common.ComplexEventDates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ComplexEventDates.displayName = 'proto.Common.ComplexEventDates';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.Common.ComplexEventTimes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.Common.ComplexEventTimes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.Common.ComplexEventTimes.displayName = 'proto.Common.ComplexEventTimes';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.CommissionData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.CommissionData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.CommissionData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CommissionData.toObject = function(includeInstance, msg) {
  var f, obj = {
    commCurrency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    commType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    commission: (f = msg.getCommission()) && fix_pb.Decimal64.toObject(includeInstance, f),
    fundRenewWaiv: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.CommissionData}
 */
proto.Common.CommissionData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.CommissionData;
  return proto.Common.CommissionData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.CommissionData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.CommissionData}
 */
proto.Common.CommissionData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommCurrency(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.CommTypeEnum} */ (reader.readEnum());
      msg.setCommType(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCommission(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.FundRenewWaivEnum} */ (reader.readEnum());
      msg.setFundRenewWaiv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.CommissionData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.CommissionData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.CommissionData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CommissionData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCommType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCommission();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFundRenewWaiv();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional string comm_currency = 1;
 * @return {string}
 */
proto.Common.CommissionData.prototype.getCommCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CommissionData} returns this
 */
proto.Common.CommissionData.prototype.setCommCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional CommTypeEnum comm_type = 2;
 * @return {!proto.Common.CommTypeEnum}
 */
proto.Common.CommissionData.prototype.getCommType = function() {
  return /** @type {!proto.Common.CommTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.CommTypeEnum} value
 * @return {!proto.Common.CommissionData} returns this
 */
proto.Common.CommissionData.prototype.setCommType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 commission = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.CommissionData.prototype.getCommission = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.CommissionData} returns this
*/
proto.Common.CommissionData.prototype.setCommission = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.CommissionData} returns this
 */
proto.Common.CommissionData.prototype.clearCommission = function() {
  return this.setCommission(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.CommissionData.prototype.hasCommission = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional FundRenewWaivEnum fund_renew_waiv = 4;
 * @return {!proto.Common.FundRenewWaivEnum}
 */
proto.Common.CommissionData.prototype.getFundRenewWaiv = function() {
  return /** @type {!proto.Common.FundRenewWaivEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.FundRenewWaivEnum} value
 * @return {!proto.Common.CommissionData} returns this
 */
proto.Common.CommissionData.prototype.setFundRenewWaiv = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DiscretionInstructions.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DiscretionInstructions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DiscretionInstructions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DiscretionInstructions.toObject = function(includeInstance, msg) {
  var f, obj = {
    discretionInst: jspb.Message.getFieldWithDefault(msg, 1, 0),
    discretionLimitType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    discretionMoveType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    discretionOffsetType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    discretionOffsetValue: (f = msg.getDiscretionOffsetValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    discretionRoundDirection: jspb.Message.getFieldWithDefault(msg, 6, 0),
    discretionScope: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DiscretionInstructions}
 */
proto.Common.DiscretionInstructions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DiscretionInstructions;
  return proto.Common.DiscretionInstructions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DiscretionInstructions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DiscretionInstructions}
 */
proto.Common.DiscretionInstructions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.DiscretionInstEnum} */ (reader.readEnum());
      msg.setDiscretionInst(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.DiscretionLimitTypeEnum} */ (reader.readEnum());
      msg.setDiscretionLimitType(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.DiscretionMoveTypeEnum} */ (reader.readEnum());
      msg.setDiscretionMoveType(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.DiscretionOffsetTypeEnum} */ (reader.readEnum());
      msg.setDiscretionOffsetType(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDiscretionOffsetValue(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.DiscretionRoundDirectionEnum} */ (reader.readEnum());
      msg.setDiscretionRoundDirection(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.DiscretionScopeEnum} */ (reader.readEnum());
      msg.setDiscretionScope(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DiscretionInstructions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DiscretionInstructions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DiscretionInstructions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DiscretionInstructions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDiscretionInst();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDiscretionLimitType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDiscretionMoveType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDiscretionOffsetType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDiscretionOffsetValue();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDiscretionRoundDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getDiscretionScope();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
};


/**
 * optional DiscretionInstEnum discretion_inst = 1;
 * @return {!proto.Common.DiscretionInstEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionInst = function() {
  return /** @type {!proto.Common.DiscretionInstEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.DiscretionInstEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionInst = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional DiscretionLimitTypeEnum discretion_limit_type = 2;
 * @return {!proto.Common.DiscretionLimitTypeEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionLimitType = function() {
  return /** @type {!proto.Common.DiscretionLimitTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DiscretionLimitTypeEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionLimitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DiscretionMoveTypeEnum discretion_move_type = 3;
 * @return {!proto.Common.DiscretionMoveTypeEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionMoveType = function() {
  return /** @type {!proto.Common.DiscretionMoveTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.DiscretionMoveTypeEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionMoveType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional DiscretionOffsetTypeEnum discretion_offset_type = 4;
 * @return {!proto.Common.DiscretionOffsetTypeEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionOffsetType = function() {
  return /** @type {!proto.Common.DiscretionOffsetTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.DiscretionOffsetTypeEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionOffsetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 discretion_offset_value = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionOffsetValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DiscretionInstructions} returns this
*/
proto.Common.DiscretionInstructions.prototype.setDiscretionOffsetValue = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.clearDiscretionOffsetValue = function() {
  return this.setDiscretionOffsetValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DiscretionInstructions.prototype.hasDiscretionOffsetValue = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DiscretionRoundDirectionEnum discretion_round_direction = 6;
 * @return {!proto.Common.DiscretionRoundDirectionEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionRoundDirection = function() {
  return /** @type {!proto.Common.DiscretionRoundDirectionEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.DiscretionRoundDirectionEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionRoundDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional DiscretionScopeEnum discretion_scope = 7;
 * @return {!proto.Common.DiscretionScopeEnum}
 */
proto.Common.DiscretionInstructions.prototype.getDiscretionScope = function() {
  return /** @type {!proto.Common.DiscretionScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.DiscretionScopeEnum} value
 * @return {!proto.Common.DiscretionInstructions} returns this
 */
proto.Common.DiscretionInstructions.prototype.setDiscretionScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.FinancingDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.FinancingDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.FinancingDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.FinancingDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    agreementCurrency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    agreementDate: jspb.Message.getFieldWithDefault(msg, 2, 0),
    agreementDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    agreementId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    deliveryType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    endDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    marginRatio: (f = msg.getMarginRatio()) && fix_pb.Decimal64.toObject(includeInstance, f),
    startDate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    terminationType: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.FinancingDetails}
 */
proto.Common.FinancingDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.FinancingDetails;
  return proto.Common.FinancingDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.FinancingDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.FinancingDetails}
 */
proto.Common.FinancingDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementCurrency(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setAgreementDate(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementDesc(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgreementId(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.DeliveryTypeEnum} */ (reader.readEnum());
      msg.setDeliveryType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEndDate(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMarginRatio(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setStartDate(value);
      break;
    case 9:
      var value = /** @type {!proto.Common.TerminationTypeEnum} */ (reader.readEnum());
      msg.setTerminationType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.FinancingDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.FinancingDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.FinancingDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.FinancingDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgreementCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAgreementDate();
  if (f !== 0) {
    writer.writeSfixed32(
      2,
      f
    );
  }
  f = message.getAgreementDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAgreementId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getEndDate();
  if (f !== 0) {
    writer.writeSfixed32(
      6,
      f
    );
  }
  f = message.getMarginRatio();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStartDate();
  if (f !== 0) {
    writer.writeSfixed32(
      8,
      f
    );
  }
  f = message.getTerminationType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
};


/**
 * optional string agreement_currency = 1;
 * @return {string}
 */
proto.Common.FinancingDetails.prototype.getAgreementCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setAgreementCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed32 agreement_date = 2;
 * @return {number}
 */
proto.Common.FinancingDetails.prototype.getAgreementDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setAgreementDate = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string agreement_desc = 3;
 * @return {string}
 */
proto.Common.FinancingDetails.prototype.getAgreementDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setAgreementDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string agreement_id = 4;
 * @return {string}
 */
proto.Common.FinancingDetails.prototype.getAgreementId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setAgreementId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional DeliveryTypeEnum delivery_type = 5;
 * @return {!proto.Common.DeliveryTypeEnum}
 */
proto.Common.FinancingDetails.prototype.getDeliveryType = function() {
  return /** @type {!proto.Common.DeliveryTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.DeliveryTypeEnum} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional sfixed32 end_date = 6;
 * @return {number}
 */
proto.Common.FinancingDetails.prototype.getEndDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setEndDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional fix.Decimal64 margin_ratio = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.FinancingDetails.prototype.getMarginRatio = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.FinancingDetails} returns this
*/
proto.Common.FinancingDetails.prototype.setMarginRatio = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.clearMarginRatio = function() {
  return this.setMarginRatio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.FinancingDetails.prototype.hasMarginRatio = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional sfixed32 start_date = 8;
 * @return {number}
 */
proto.Common.FinancingDetails.prototype.getStartDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setStartDate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional TerminationTypeEnum termination_type = 9;
 * @return {!proto.Common.TerminationTypeEnum}
 */
proto.Common.FinancingDetails.prototype.getTerminationType = function() {
  return /** @type {!proto.Common.TerminationTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.Common.TerminationTypeEnum} value
 * @return {!proto.Common.FinancingDetails} returns this
 */
proto.Common.FinancingDetails.prototype.setTerminationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.Instrument.repeatedFields_ = [38,40,48,74];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.Instrument.oneofGroups_ = [[34,35],[76,77],[87,88]];

/**
 * @enum {number}
 */
proto.Common.Instrument.CpProgramUnionCase = {
  CP_PROGRAM_UNION_NOT_SET: 0,
  CP_PROGRAM: 34,
  CP_PROGRAM_RESERVED100PLUS: 35
};

/**
 * @return {proto.Common.Instrument.CpProgramUnionCase}
 */
proto.Common.Instrument.prototype.getCpProgramUnionCase = function() {
  return /** @type {proto.Common.Instrument.CpProgramUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.Instrument.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.Common.Instrument.FlowScheduleTypeUnionCase = {
  FLOW_SCHEDULE_TYPE_UNION_NOT_SET: 0,
  FLOW_SCHEDULE_TYPE: 76,
  FLOW_SCHEDULE_TYPE_RESERVED100PLUS: 77
};

/**
 * @return {proto.Common.Instrument.FlowScheduleTypeUnionCase}
 */
proto.Common.Instrument.prototype.getFlowScheduleTypeUnionCase = function() {
  return /** @type {proto.Common.Instrument.FlowScheduleTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.Instrument.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.Common.Instrument.StrikePriceDeterminationMethodUnionCase = {
  STRIKE_PRICE_DETERMINATION_METHOD_UNION_NOT_SET: 0,
  STRIKE_PRICE_DETERMINATION_METHOD: 87,
  STRIKE_PRICE_DETERMINATION_METHOD_RESERVED100PLUS: 88
};

/**
 * @return {proto.Common.Instrument.StrikePriceDeterminationMethodUnionCase}
 */
proto.Common.Instrument.prototype.getStrikePriceDeterminationMethodUnionCase = function() {
  return /** @type {proto.Common.Instrument.StrikePriceDeterminationMethodUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.Instrument.oneofGroups_[2]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.Instrument.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.Instrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.Instrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Instrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    cfiCode: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contractMultiplier: (f = msg.getContractMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    countryOfIssue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    couponPaymentDate: jspb.Message.getFieldWithDefault(msg, 4, 0),
    couponRate: (f = msg.getCouponRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    creditRating: jspb.Message.getFieldWithDefault(msg, 6, ""),
    encodedIssuer: jspb.Message.getFieldWithDefault(msg, 7, ""),
    encodedIssuerLen: jspb.Message.getFieldWithDefault(msg, 8, 0),
    encodedSecurityDesc: jspb.Message.getFieldWithDefault(msg, 9, ""),
    encodedSecurityDescLen: jspb.Message.getFieldWithDefault(msg, 10, 0),
    factor: (f = msg.getFactor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    instrRegistry: jspb.Message.getFieldWithDefault(msg, 12, ""),
    issueDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    issuer: jspb.Message.getFieldWithDefault(msg, 14, ""),
    localeOfIssue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    maturityDate: jspb.Message.getFieldWithDefault(msg, 16, 0),
    maturityMonthYear: jspb.Message.getFieldWithDefault(msg, 17, 0),
    optAttribute: msg.getOptAttribute_asB64(),
    product: jspb.Message.getFieldWithDefault(msg, 19, 0),
    redemptionDate: jspb.Message.getFieldWithDefault(msg, 20, 0),
    repoCollateralSecurityType: jspb.Message.getFieldWithDefault(msg, 21, ""),
    repurchaseRate: (f = msg.getRepurchaseRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    repurchaseTerm: jspb.Message.getFieldWithDefault(msg, 23, 0),
    securityDesc: jspb.Message.getFieldWithDefault(msg, 24, ""),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 25, ""),
    securityId: jspb.Message.getFieldWithDefault(msg, 26, ""),
    securityIdSource: jspb.Message.getFieldWithDefault(msg, 27, 0),
    securityType: jspb.Message.getFieldWithDefault(msg, 28, 0),
    stateOrProvinceOfIssue: jspb.Message.getFieldWithDefault(msg, 29, ""),
    strikePrice: (f = msg.getStrikePrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    symbol: jspb.Message.getFieldWithDefault(msg, 31, ""),
    symbolSfx: jspb.Message.getFieldWithDefault(msg, 32, 0),
    contractSettlMonth: jspb.Message.getFieldWithDefault(msg, 33, 0),
    cpProgram: jspb.Message.getFieldWithDefault(msg, 34, 0),
    cpProgramReserved100plus: jspb.Message.getFieldWithDefault(msg, 35, 0),
    cpRegType: jspb.Message.getFieldWithDefault(msg, 36, ""),
    datedDate: jspb.Message.getFieldWithDefault(msg, 37, 0),
    evntGrpList: jspb.Message.toObjectList(msg.getEvntGrpList(),
    proto.Common.EvntGrp.toObject, includeInstance),
    instrmtAssignmentMethod: msg.getInstrmtAssignmentMethod_asB64(),
    instrumentPartiesList: jspb.Message.toObjectList(msg.getInstrumentPartiesList(),
    proto.Common.InstrumentParties.toObject, includeInstance),
    interestAccrualDate: jspb.Message.getFieldWithDefault(msg, 41, 0),
    maturityTime: (f = msg.getMaturityTime()) && fix_pb.LocalTimeOnly.toObject(includeInstance, f),
    minPriceIncrement: (f = msg.getMinPriceIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    ntPositionLimit: jspb.Message.getFieldWithDefault(msg, 44, 0),
    pool: jspb.Message.getFieldWithDefault(msg, 45, ""),
    positionLimit: jspb.Message.getFieldWithDefault(msg, 46, 0),
    putOrCall: jspb.Message.getFieldWithDefault(msg, 47, 0),
    secAltIdGrpList: jspb.Message.toObjectList(msg.getSecAltIdGrpList(),
    proto.Common.SecAltIDGrp.toObject, includeInstance),
    securityStatus: jspb.Message.getFieldWithDefault(msg, 49, 0),
    securitySubType: jspb.Message.getFieldWithDefault(msg, 50, ""),
    settleOnOpenFlag: jspb.Message.getFieldWithDefault(msg, 51, ""),
    strikeCurrency: jspb.Message.getFieldWithDefault(msg, 52, ""),
    strikeMultiplier: (f = msg.getStrikeMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    strikeValue: (f = msg.getStrikeValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    timeUnit: jspb.Message.getFieldWithDefault(msg, 55, 0),
    unitOfMeasure: jspb.Message.getFieldWithDefault(msg, 56, 0),
    capPrice: (f = msg.getCapPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    exerciseStyle: jspb.Message.getFieldWithDefault(msg, 58, 0),
    flexProductEligibilityIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 59, false),
    flexibleIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
    floorPrice: (f = msg.getFloorPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    listMethod: jspb.Message.getFieldWithDefault(msg, 62, 0),
    minPriceIncrementAmount: (f = msg.getMinPriceIncrementAmount()) && fix_pb.Decimal64.toObject(includeInstance, f),
    optPayoutAmount: (f = msg.getOptPayoutAmount()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceQuoteMethod: jspb.Message.getFieldWithDefault(msg, 65, 0),
    priceUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 66, 0),
    priceUnitOfMeasureQty: (f = msg.getPriceUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    productComplex: jspb.Message.getFieldWithDefault(msg, 68, ""),
    securityGroup: jspb.Message.getFieldWithDefault(msg, 69, ""),
    securityXml: (f = msg.getSecurityXml()) && proto.Common.SecurityXML.toObject(includeInstance, f),
    settlMethod: jspb.Message.getFieldWithDefault(msg, 71, 0),
    unitOfMeasureQty: (f = msg.getUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    valuationMethod: jspb.Message.getFieldWithDefault(msg, 73, 0),
    complexEventsList: jspb.Message.toObjectList(msg.getComplexEventsList(),
    proto.Common.ComplexEvents.toObject, includeInstance),
    contractMultiplierUnit: jspb.Message.getFieldWithDefault(msg, 75, 0),
    flowScheduleType: jspb.Message.getFieldWithDefault(msg, 76, 0),
    flowScheduleTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 77, 0),
    attachmentPoint: (f = msg.getAttachmentPoint()) && fix_pb.Decimal64.toObject(includeInstance, f),
    detachmentPoint: (f = msg.getDetachmentPoint()) && fix_pb.Decimal64.toObject(includeInstance, f),
    notionalPercentageOutstanding: (f = msg.getNotionalPercentageOutstanding()) && fix_pb.Decimal64.toObject(includeInstance, f),
    originalNotionalPercentageOutstanding: (f = msg.getOriginalNotionalPercentageOutstanding()) && fix_pb.Decimal64.toObject(includeInstance, f),
    restructuringType: jspb.Message.getFieldWithDefault(msg, 82, 0),
    seniority: jspb.Message.getFieldWithDefault(msg, 83, 0),
    optPayoutType: jspb.Message.getFieldWithDefault(msg, 84, 0),
    strikePriceBoundaryMethod: jspb.Message.getFieldWithDefault(msg, 85, 0),
    strikePriceBoundaryPrecision: (f = msg.getStrikePriceBoundaryPrecision()) && fix_pb.Decimal64.toObject(includeInstance, f),
    strikePriceDeterminationMethod: jspb.Message.getFieldWithDefault(msg, 87, 0),
    strikePriceDeterminationMethodReserved100plus: jspb.Message.getFieldWithDefault(msg, 88, 0),
    underlyingPriceDeterminationMethod: jspb.Message.getFieldWithDefault(msg, 89, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.Instrument}
 */
proto.Common.Instrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.Instrument;
  return proto.Common.Instrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.Instrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.Instrument}
 */
proto.Common.Instrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCfiCode(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setContractMultiplier(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryOfIssue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setCouponPaymentDate(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCouponRate(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreditRating(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedIssuer(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedIssuerLen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedSecurityDesc(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedSecurityDescLen(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFactor(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrRegistry(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setIssueDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setIssuer(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocaleOfIssue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaturityDate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaturityMonthYear(value);
      break;
    case 18:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setOptAttribute(value);
      break;
    case 19:
      var value = /** @type {!proto.Common.ProductEnum} */ (reader.readEnum());
      msg.setProduct(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setRedemptionDate(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setRepoCollateralSecurityType(value);
      break;
    case 22:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRepurchaseRate(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRepurchaseTerm(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityDesc(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 27:
      var value = /** @type {!proto.Common.SecurityIDSourceEnum} */ (reader.readEnum());
      msg.setSecurityIdSource(value);
      break;
    case 28:
      var value = /** @type {!proto.Common.SecurityTypeEnum} */ (reader.readEnum());
      msg.setSecurityType(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setStateOrProvinceOfIssue(value);
      break;
    case 30:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStrikePrice(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 32:
      var value = /** @type {!proto.Common.SymbolSfxEnum} */ (reader.readEnum());
      msg.setSymbolSfx(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setContractSettlMonth(value);
      break;
    case 34:
      var value = /** @type {!proto.Common.CPProgramEnum} */ (reader.readEnum());
      msg.setCpProgram(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setCpProgramReserved100plus(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setCpRegType(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDatedDate(value);
      break;
    case 38:
      var value = new proto.Common.EvntGrp;
      reader.readMessage(value,proto.Common.EvntGrp.deserializeBinaryFromReader);
      msg.addEvntGrp(value);
      break;
    case 39:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setInstrmtAssignmentMethod(value);
      break;
    case 40:
      var value = new proto.Common.InstrumentParties;
      reader.readMessage(value,proto.Common.InstrumentParties.deserializeBinaryFromReader);
      msg.addInstrumentParties(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setInterestAccrualDate(value);
      break;
    case 42:
      var value = new fix_pb.LocalTimeOnly;
      reader.readMessage(value,fix_pb.LocalTimeOnly.deserializeBinaryFromReader);
      msg.setMaturityTime(value);
      break;
    case 43:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinPriceIncrement(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setNtPositionLimit(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setPool(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setPositionLimit(value);
      break;
    case 47:
      var value = /** @type {!proto.Common.PutOrCallEnum} */ (reader.readEnum());
      msg.setPutOrCall(value);
      break;
    case 48:
      var value = new proto.Common.SecAltIDGrp;
      reader.readMessage(value,proto.Common.SecAltIDGrp.deserializeBinaryFromReader);
      msg.addSecAltIdGrp(value);
      break;
    case 49:
      var value = /** @type {!proto.Common.SecurityStatusEnum} */ (reader.readEnum());
      msg.setSecurityStatus(value);
      break;
    case 50:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecuritySubType(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettleOnOpenFlag(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrikeCurrency(value);
      break;
    case 53:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStrikeMultiplier(value);
      break;
    case 54:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStrikeValue(value);
      break;
    case 55:
      var value = /** @type {!proto.Common.TimeUnitEnum} */ (reader.readEnum());
      msg.setTimeUnit(value);
      break;
    case 56:
      var value = /** @type {!proto.Common.UnitOfMeasureEnum} */ (reader.readEnum());
      msg.setUnitOfMeasure(value);
      break;
    case 57:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCapPrice(value);
      break;
    case 58:
      var value = /** @type {!proto.Common.ExerciseStyleEnum} */ (reader.readEnum());
      msg.setExerciseStyle(value);
      break;
    case 59:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlexProductEligibilityIndicator(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFlexibleIndicator(value);
      break;
    case 61:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFloorPrice(value);
      break;
    case 62:
      var value = /** @type {!proto.Common.ListMethodEnum} */ (reader.readEnum());
      msg.setListMethod(value);
      break;
    case 63:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinPriceIncrementAmount(value);
      break;
    case 64:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOptPayoutAmount(value);
      break;
    case 65:
      var value = /** @type {!proto.Common.PriceQuoteMethodEnum} */ (reader.readEnum());
      msg.setPriceQuoteMethod(value);
      break;
    case 66:
      var value = /** @type {!proto.Common.PriceUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setPriceUnitOfMeasure(value);
      break;
    case 67:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPriceUnitOfMeasureQty(value);
      break;
    case 68:
      var value = /** @type {string} */ (reader.readString());
      msg.setProductComplex(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityGroup(value);
      break;
    case 70:
      var value = new proto.Common.SecurityXML;
      reader.readMessage(value,proto.Common.SecurityXML.deserializeBinaryFromReader);
      msg.setSecurityXml(value);
      break;
    case 71:
      var value = /** @type {!proto.Common.SettlMethodEnum} */ (reader.readEnum());
      msg.setSettlMethod(value);
      break;
    case 72:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnitOfMeasureQty(value);
      break;
    case 73:
      var value = /** @type {!proto.Common.ValuationMethodEnum} */ (reader.readEnum());
      msg.setValuationMethod(value);
      break;
    case 74:
      var value = new proto.Common.ComplexEvents;
      reader.readMessage(value,proto.Common.ComplexEvents.deserializeBinaryFromReader);
      msg.addComplexEvents(value);
      break;
    case 75:
      var value = /** @type {!proto.Common.ContractMultiplierUnitEnum} */ (reader.readEnum());
      msg.setContractMultiplierUnit(value);
      break;
    case 76:
      var value = /** @type {!proto.Common.FlowScheduleTypeEnum} */ (reader.readEnum());
      msg.setFlowScheduleType(value);
      break;
    case 77:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setFlowScheduleTypeReserved100plus(value);
      break;
    case 78:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAttachmentPoint(value);
      break;
    case 79:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDetachmentPoint(value);
      break;
    case 80:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setNotionalPercentageOutstanding(value);
      break;
    case 81:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOriginalNotionalPercentageOutstanding(value);
      break;
    case 82:
      var value = /** @type {!proto.Common.RestructuringTypeEnum} */ (reader.readEnum());
      msg.setRestructuringType(value);
      break;
    case 83:
      var value = /** @type {!proto.Common.SeniorityEnum} */ (reader.readEnum());
      msg.setSeniority(value);
      break;
    case 84:
      var value = /** @type {!proto.Common.OptPayoutTypeEnum} */ (reader.readEnum());
      msg.setOptPayoutType(value);
      break;
    case 85:
      var value = /** @type {!proto.Common.StrikePriceBoundaryMethodEnum} */ (reader.readEnum());
      msg.setStrikePriceBoundaryMethod(value);
      break;
    case 86:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStrikePriceBoundaryPrecision(value);
      break;
    case 87:
      var value = /** @type {!proto.Common.StrikePriceDeterminationMethodEnum} */ (reader.readEnum());
      msg.setStrikePriceDeterminationMethod(value);
      break;
    case 88:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setStrikePriceDeterminationMethodReserved100plus(value);
      break;
    case 89:
      var value = /** @type {!proto.Common.UnderlyingPriceDeterminationMethodEnum} */ (reader.readEnum());
      msg.setUnderlyingPriceDeterminationMethod(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.Instrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.Instrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.Instrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Instrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCfiCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContractMultiplier();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCountryOfIssue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCouponPaymentDate();
  if (f !== 0) {
    writer.writeSfixed32(
      4,
      f
    );
  }
  f = message.getCouponRate();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCreditRating();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEncodedIssuer();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEncodedIssuerLen();
  if (f !== 0) {
    writer.writeSfixed64(
      8,
      f
    );
  }
  f = message.getEncodedSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getEncodedSecurityDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      10,
      f
    );
  }
  f = message.getFactor();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getInstrRegistry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getIssueDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getIssuer();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLocaleOfIssue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMaturityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      16,
      f
    );
  }
  f = message.getMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      17,
      f
    );
  }
  f = message.getOptAttribute_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      18,
      f
    );
  }
  f = message.getProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getRedemptionDate();
  if (f !== 0) {
    writer.writeSfixed32(
      20,
      f
    );
  }
  f = message.getRepoCollateralSecurityType();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getRepurchaseRate();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getRepurchaseTerm();
  if (f !== 0) {
    writer.writeSfixed64(
      23,
      f
    );
  }
  f = message.getSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      27,
      f
    );
  }
  f = message.getSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getStateOrProvinceOfIssue();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getStrikePrice();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getSymbolSfx();
  if (f !== 0.0) {
    writer.writeEnum(
      32,
      f
    );
  }
  f = message.getContractSettlMonth();
  if (f !== 0) {
    writer.writeSfixed32(
      33,
      f
    );
  }
  f = /** @type {!proto.Common.CPProgramEnum} */ (jspb.Message.getField(message, 34));
  if (f != null) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 35));
  if (f != null) {
    writer.writeFixed32(
      35,
      f
    );
  }
  f = message.getCpRegType();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getDatedDate();
  if (f !== 0) {
    writer.writeSfixed32(
      37,
      f
    );
  }
  f = message.getEvntGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      38,
      f,
      proto.Common.EvntGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrmtAssignmentMethod_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      39,
      f
    );
  }
  f = message.getInstrumentPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      40,
      f,
      proto.Common.InstrumentParties.serializeBinaryToWriter
    );
  }
  f = message.getInterestAccrualDate();
  if (f !== 0) {
    writer.writeSfixed32(
      41,
      f
    );
  }
  f = message.getMaturityTime();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      fix_pb.LocalTimeOnly.serializeBinaryToWriter
    );
  }
  f = message.getMinPriceIncrement();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNtPositionLimit();
  if (f !== 0) {
    writer.writeSfixed64(
      44,
      f
    );
  }
  f = message.getPool();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getPositionLimit();
  if (f !== 0) {
    writer.writeSfixed64(
      46,
      f
    );
  }
  f = message.getPutOrCall();
  if (f !== 0.0) {
    writer.writeEnum(
      47,
      f
    );
  }
  f = message.getSecAltIdGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      48,
      f,
      proto.Common.SecAltIDGrp.serializeBinaryToWriter
    );
  }
  f = message.getSecurityStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      49,
      f
    );
  }
  f = message.getSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      50,
      f
    );
  }
  f = message.getSettleOnOpenFlag();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getStrikeCurrency();
  if (f.length > 0) {
    writer.writeString(
      52,
      f
    );
  }
  f = message.getStrikeMultiplier();
  if (f != null) {
    writer.writeMessage(
      53,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStrikeValue();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTimeUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      55,
      f
    );
  }
  f = message.getUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      56,
      f
    );
  }
  f = message.getCapPrice();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getExerciseStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      58,
      f
    );
  }
  f = message.getFlexProductEligibilityIndicator();
  if (f) {
    writer.writeBool(
      59,
      f
    );
  }
  f = message.getFlexibleIndicator();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getFloorPrice();
  if (f != null) {
    writer.writeMessage(
      61,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getListMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      62,
      f
    );
  }
  f = message.getMinPriceIncrementAmount();
  if (f != null) {
    writer.writeMessage(
      63,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOptPayoutAmount();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceQuoteMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      65,
      f
    );
  }
  f = message.getPriceUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      66,
      f
    );
  }
  f = message.getPriceUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      67,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getProductComplex();
  if (f.length > 0) {
    writer.writeString(
      68,
      f
    );
  }
  f = message.getSecurityGroup();
  if (f.length > 0) {
    writer.writeString(
      69,
      f
    );
  }
  f = message.getSecurityXml();
  if (f != null) {
    writer.writeMessage(
      70,
      f,
      proto.Common.SecurityXML.serializeBinaryToWriter
    );
  }
  f = message.getSettlMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      71,
      f
    );
  }
  f = message.getUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      72,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getValuationMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      73,
      f
    );
  }
  f = message.getComplexEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      74,
      f,
      proto.Common.ComplexEvents.serializeBinaryToWriter
    );
  }
  f = message.getContractMultiplierUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      75,
      f
    );
  }
  f = /** @type {!proto.Common.FlowScheduleTypeEnum} */ (jspb.Message.getField(message, 76));
  if (f != null) {
    writer.writeEnum(
      76,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 77));
  if (f != null) {
    writer.writeFixed32(
      77,
      f
    );
  }
  f = message.getAttachmentPoint();
  if (f != null) {
    writer.writeMessage(
      78,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDetachmentPoint();
  if (f != null) {
    writer.writeMessage(
      79,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNotionalPercentageOutstanding();
  if (f != null) {
    writer.writeMessage(
      80,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOriginalNotionalPercentageOutstanding();
  if (f != null) {
    writer.writeMessage(
      81,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getRestructuringType();
  if (f !== 0.0) {
    writer.writeEnum(
      82,
      f
    );
  }
  f = message.getSeniority();
  if (f !== 0.0) {
    writer.writeEnum(
      83,
      f
    );
  }
  f = message.getOptPayoutType();
  if (f !== 0.0) {
    writer.writeEnum(
      84,
      f
    );
  }
  f = message.getStrikePriceBoundaryMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      85,
      f
    );
  }
  f = message.getStrikePriceBoundaryPrecision();
  if (f != null) {
    writer.writeMessage(
      86,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.Common.StrikePriceDeterminationMethodEnum} */ (jspb.Message.getField(message, 87));
  if (f != null) {
    writer.writeEnum(
      87,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 88));
  if (f != null) {
    writer.writeFixed32(
      88,
      f
    );
  }
  f = message.getUnderlyingPriceDeterminationMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      89,
      f
    );
  }
};


/**
 * optional string cfi_code = 1;
 * @return {string}
 */
proto.Common.Instrument.prototype.getCfiCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCfiCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional fix.Decimal64 contract_multiplier = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getContractMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setContractMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearContractMultiplier = function() {
  return this.setContractMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasContractMultiplier = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string country_of_issue = 3;
 * @return {string}
 */
proto.Common.Instrument.prototype.getCountryOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCountryOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional sfixed32 coupon_payment_date = 4;
 * @return {number}
 */
proto.Common.Instrument.prototype.getCouponPaymentDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCouponPaymentDate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fix.Decimal64 coupon_rate = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getCouponRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setCouponRate = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearCouponRate = function() {
  return this.setCouponRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasCouponRate = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string credit_rating = 6;
 * @return {string}
 */
proto.Common.Instrument.prototype.getCreditRating = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCreditRating = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string encoded_issuer = 7;
 * @return {string}
 */
proto.Common.Instrument.prototype.getEncodedIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setEncodedIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional sfixed64 encoded_issuer_len = 8;
 * @return {number}
 */
proto.Common.Instrument.prototype.getEncodedIssuerLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setEncodedIssuerLen = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string encoded_security_desc = 9;
 * @return {string}
 */
proto.Common.Instrument.prototype.getEncodedSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setEncodedSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional sfixed64 encoded_security_desc_len = 10;
 * @return {number}
 */
proto.Common.Instrument.prototype.getEncodedSecurityDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setEncodedSecurityDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional fix.Decimal64 factor = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getFactor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setFactor = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearFactor = function() {
  return this.setFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasFactor = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string instr_registry = 12;
 * @return {string}
 */
proto.Common.Instrument.prototype.getInstrRegistry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setInstrRegistry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional sfixed32 issue_date = 13;
 * @return {number}
 */
proto.Common.Instrument.prototype.getIssueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setIssueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string issuer = 14;
 * @return {string}
 */
proto.Common.Instrument.prototype.getIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string locale_of_issue = 15;
 * @return {string}
 */
proto.Common.Instrument.prototype.getLocaleOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setLocaleOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional sfixed32 maturity_date = 16;
 * @return {number}
 */
proto.Common.Instrument.prototype.getMaturityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setMaturityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional sfixed32 maturity_month_year = 17;
 * @return {number}
 */
proto.Common.Instrument.prototype.getMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional bytes opt_attribute = 18;
 * @return {!(string|Uint8Array)}
 */
proto.Common.Instrument.prototype.getOptAttribute = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * optional bytes opt_attribute = 18;
 * This is a type-conversion wrapper around `getOptAttribute()`
 * @return {string}
 */
proto.Common.Instrument.prototype.getOptAttribute_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getOptAttribute()));
};


/**
 * optional bytes opt_attribute = 18;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getOptAttribute()`
 * @return {!Uint8Array}
 */
proto.Common.Instrument.prototype.getOptAttribute_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getOptAttribute()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setOptAttribute = function(value) {
  return jspb.Message.setProto3BytesField(this, 18, value);
};


/**
 * optional ProductEnum product = 19;
 * @return {!proto.Common.ProductEnum}
 */
proto.Common.Instrument.prototype.getProduct = function() {
  return /** @type {!proto.Common.ProductEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.Common.ProductEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional sfixed32 redemption_date = 20;
 * @return {number}
 */
proto.Common.Instrument.prototype.getRedemptionDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setRedemptionDate = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string repo_collateral_security_type = 21;
 * @return {string}
 */
proto.Common.Instrument.prototype.getRepoCollateralSecurityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setRepoCollateralSecurityType = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional fix.Decimal64 repurchase_rate = 22;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getRepurchaseRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 22));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setRepurchaseRate = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearRepurchaseRate = function() {
  return this.setRepurchaseRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasRepurchaseRate = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional sfixed64 repurchase_term = 23;
 * @return {number}
 */
proto.Common.Instrument.prototype.getRepurchaseTerm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setRepurchaseTerm = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional string security_desc = 24;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string security_exchange = 25;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string security_id = 26;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional SecurityIDSourceEnum security_id_source = 27;
 * @return {!proto.Common.SecurityIDSourceEnum}
 */
proto.Common.Instrument.prototype.getSecurityIdSource = function() {
  return /** @type {!proto.Common.SecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {!proto.Common.SecurityIDSourceEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 27, value);
};


/**
 * optional SecurityTypeEnum security_type = 28;
 * @return {!proto.Common.SecurityTypeEnum}
 */
proto.Common.Instrument.prototype.getSecurityType = function() {
  return /** @type {!proto.Common.SecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.Common.SecurityTypeEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional string state_or_province_of_issue = 29;
 * @return {string}
 */
proto.Common.Instrument.prototype.getStateOrProvinceOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setStateOrProvinceOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional fix.Decimal64 strike_price = 30;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getStrikePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 30));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setStrikePrice = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikePrice = function() {
  return this.setStrikePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikePrice = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional string symbol = 31;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional SymbolSfxEnum symbol_sfx = 32;
 * @return {!proto.Common.SymbolSfxEnum}
 */
proto.Common.Instrument.prototype.getSymbolSfx = function() {
  return /** @type {!proto.Common.SymbolSfxEnum} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {!proto.Common.SymbolSfxEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSymbolSfx = function(value) {
  return jspb.Message.setProto3EnumField(this, 32, value);
};


/**
 * optional sfixed32 contract_settl_month = 33;
 * @return {number}
 */
proto.Common.Instrument.prototype.getContractSettlMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setContractSettlMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional CPProgramEnum cp_program = 34;
 * @return {!proto.Common.CPProgramEnum}
 */
proto.Common.Instrument.prototype.getCpProgram = function() {
  return /** @type {!proto.Common.CPProgramEnum} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.Common.CPProgramEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCpProgram = function(value) {
  return jspb.Message.setOneofField(this, 34, proto.Common.Instrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearCpProgram = function() {
  return jspb.Message.setOneofField(this, 34, proto.Common.Instrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasCpProgram = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional fixed32 cp_program_reserved100plus = 35;
 * @return {number}
 */
proto.Common.Instrument.prototype.getCpProgramReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCpProgramReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 35, proto.Common.Instrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearCpProgramReserved100plus = function() {
  return jspb.Message.setOneofField(this, 35, proto.Common.Instrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasCpProgramReserved100plus = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional string cp_reg_type = 36;
 * @return {string}
 */
proto.Common.Instrument.prototype.getCpRegType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setCpRegType = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional sfixed32 dated_date = 37;
 * @return {number}
 */
proto.Common.Instrument.prototype.getDatedDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setDatedDate = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * repeated EvntGrp evnt_grp = 38;
 * @return {!Array<!proto.Common.EvntGrp>}
 */
proto.Common.Instrument.prototype.getEvntGrpList = function() {
  return /** @type{!Array<!proto.Common.EvntGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.EvntGrp, 38));
};


/**
 * @param {!Array<!proto.Common.EvntGrp>} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setEvntGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 38, value);
};


/**
 * @param {!proto.Common.EvntGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.EvntGrp}
 */
proto.Common.Instrument.prototype.addEvntGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 38, opt_value, proto.Common.EvntGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearEvntGrpList = function() {
  return this.setEvntGrpList([]);
};


/**
 * optional bytes instrmt_assignment_method = 39;
 * @return {!(string|Uint8Array)}
 */
proto.Common.Instrument.prototype.getInstrmtAssignmentMethod = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * optional bytes instrmt_assignment_method = 39;
 * This is a type-conversion wrapper around `getInstrmtAssignmentMethod()`
 * @return {string}
 */
proto.Common.Instrument.prototype.getInstrmtAssignmentMethod_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getInstrmtAssignmentMethod()));
};


/**
 * optional bytes instrmt_assignment_method = 39;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getInstrmtAssignmentMethod()`
 * @return {!Uint8Array}
 */
proto.Common.Instrument.prototype.getInstrmtAssignmentMethod_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getInstrmtAssignmentMethod()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setInstrmtAssignmentMethod = function(value) {
  return jspb.Message.setProto3BytesField(this, 39, value);
};


/**
 * repeated InstrumentParties instrument_parties = 40;
 * @return {!Array<!proto.Common.InstrumentParties>}
 */
proto.Common.Instrument.prototype.getInstrumentPartiesList = function() {
  return /** @type{!Array<!proto.Common.InstrumentParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.InstrumentParties, 40));
};


/**
 * @param {!Array<!proto.Common.InstrumentParties>} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setInstrumentPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 40, value);
};


/**
 * @param {!proto.Common.InstrumentParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrumentParties}
 */
proto.Common.Instrument.prototype.addInstrumentParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 40, opt_value, proto.Common.InstrumentParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearInstrumentPartiesList = function() {
  return this.setInstrumentPartiesList([]);
};


/**
 * optional sfixed32 interest_accrual_date = 41;
 * @return {number}
 */
proto.Common.Instrument.prototype.getInterestAccrualDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setInterestAccrualDate = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional fix.LocalTimeOnly maturity_time = 42;
 * @return {?proto.fix.LocalTimeOnly}
 */
proto.Common.Instrument.prototype.getMaturityTime = function() {
  return /** @type{?proto.fix.LocalTimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.LocalTimeOnly, 42));
};


/**
 * @param {?proto.fix.LocalTimeOnly|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setMaturityTime = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearMaturityTime = function() {
  return this.setMaturityTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasMaturityTime = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional fix.Decimal64 min_price_increment = 43;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getMinPriceIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 43));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setMinPriceIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearMinPriceIncrement = function() {
  return this.setMinPriceIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasMinPriceIncrement = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional sfixed64 nt_position_limit = 44;
 * @return {number}
 */
proto.Common.Instrument.prototype.getNtPositionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setNtPositionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional string pool = 45;
 * @return {string}
 */
proto.Common.Instrument.prototype.getPool = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setPool = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional sfixed64 position_limit = 46;
 * @return {number}
 */
proto.Common.Instrument.prototype.getPositionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setPositionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional PutOrCallEnum put_or_call = 47;
 * @return {!proto.Common.PutOrCallEnum}
 */
proto.Common.Instrument.prototype.getPutOrCall = function() {
  return /** @type {!proto.Common.PutOrCallEnum} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {!proto.Common.PutOrCallEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setPutOrCall = function(value) {
  return jspb.Message.setProto3EnumField(this, 47, value);
};


/**
 * repeated SecAltIDGrp sec_alt_id_grp = 48;
 * @return {!Array<!proto.Common.SecAltIDGrp>}
 */
proto.Common.Instrument.prototype.getSecAltIdGrpList = function() {
  return /** @type{!Array<!proto.Common.SecAltIDGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.SecAltIDGrp, 48));
};


/**
 * @param {!Array<!proto.Common.SecAltIDGrp>} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setSecAltIdGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 48, value);
};


/**
 * @param {!proto.Common.SecAltIDGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.SecAltIDGrp}
 */
proto.Common.Instrument.prototype.addSecAltIdGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 48, opt_value, proto.Common.SecAltIDGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearSecAltIdGrpList = function() {
  return this.setSecAltIdGrpList([]);
};


/**
 * optional SecurityStatusEnum security_status = 49;
 * @return {!proto.Common.SecurityStatusEnum}
 */
proto.Common.Instrument.prototype.getSecurityStatus = function() {
  return /** @type {!proto.Common.SecurityStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/**
 * @param {!proto.Common.SecurityStatusEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 49, value);
};


/**
 * optional string security_sub_type = 50;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 50, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 50, value);
};


/**
 * optional string settle_on_open_flag = 51;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSettleOnOpenFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSettleOnOpenFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional string strike_currency = 52;
 * @return {string}
 */
proto.Common.Instrument.prototype.getStrikeCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setStrikeCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 52, value);
};


/**
 * optional fix.Decimal64 strike_multiplier = 53;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getStrikeMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 53));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setStrikeMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 53, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikeMultiplier = function() {
  return this.setStrikeMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikeMultiplier = function() {
  return jspb.Message.getField(this, 53) != null;
};


/**
 * optional fix.Decimal64 strike_value = 54;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getStrikeValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 54));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setStrikeValue = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikeValue = function() {
  return this.setStrikeValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikeValue = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional TimeUnitEnum time_unit = 55;
 * @return {!proto.Common.TimeUnitEnum}
 */
proto.Common.Instrument.prototype.getTimeUnit = function() {
  return /** @type {!proto.Common.TimeUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {!proto.Common.TimeUnitEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setTimeUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 55, value);
};


/**
 * optional UnitOfMeasureEnum unit_of_measure = 56;
 * @return {!proto.Common.UnitOfMeasureEnum}
 */
proto.Common.Instrument.prototype.getUnitOfMeasure = function() {
  return /** @type {!proto.Common.UnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {!proto.Common.UnitOfMeasureEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 56, value);
};


/**
 * optional fix.Decimal64 cap_price = 57;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getCapPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 57));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setCapPrice = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearCapPrice = function() {
  return this.setCapPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasCapPrice = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional ExerciseStyleEnum exercise_style = 58;
 * @return {!proto.Common.ExerciseStyleEnum}
 */
proto.Common.Instrument.prototype.getExerciseStyle = function() {
  return /** @type {!proto.Common.ExerciseStyleEnum} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/**
 * @param {!proto.Common.ExerciseStyleEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setExerciseStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 58, value);
};


/**
 * optional bool flex_product_eligibility_indicator = 59;
 * @return {boolean}
 */
proto.Common.Instrument.prototype.getFlexProductEligibilityIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 59, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setFlexProductEligibilityIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 59, value);
};


/**
 * optional bool flexible_indicator = 60;
 * @return {boolean}
 */
proto.Common.Instrument.prototype.getFlexibleIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setFlexibleIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional fix.Decimal64 floor_price = 61;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getFloorPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 61));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setFloorPrice = function(value) {
  return jspb.Message.setWrapperField(this, 61, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearFloorPrice = function() {
  return this.setFloorPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasFloorPrice = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional ListMethodEnum list_method = 62;
 * @return {!proto.Common.ListMethodEnum}
 */
proto.Common.Instrument.prototype.getListMethod = function() {
  return /** @type {!proto.Common.ListMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {!proto.Common.ListMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setListMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 62, value);
};


/**
 * optional fix.Decimal64 min_price_increment_amount = 63;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getMinPriceIncrementAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 63));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setMinPriceIncrementAmount = function(value) {
  return jspb.Message.setWrapperField(this, 63, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearMinPriceIncrementAmount = function() {
  return this.setMinPriceIncrementAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasMinPriceIncrementAmount = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional fix.Decimal64 opt_payout_amount = 64;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getOptPayoutAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 64));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setOptPayoutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearOptPayoutAmount = function() {
  return this.setOptPayoutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasOptPayoutAmount = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional PriceQuoteMethodEnum price_quote_method = 65;
 * @return {!proto.Common.PriceQuoteMethodEnum}
 */
proto.Common.Instrument.prototype.getPriceQuoteMethod = function() {
  return /** @type {!proto.Common.PriceQuoteMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.Common.PriceQuoteMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setPriceQuoteMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 65, value);
};


/**
 * optional PriceUnitOfMeasureEnum price_unit_of_measure = 66;
 * @return {!proto.Common.PriceUnitOfMeasureEnum}
 */
proto.Common.Instrument.prototype.getPriceUnitOfMeasure = function() {
  return /** @type {!proto.Common.PriceUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {!proto.Common.PriceUnitOfMeasureEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setPriceUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 66, value);
};


/**
 * optional fix.Decimal64 price_unit_of_measure_qty = 67;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getPriceUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 67));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setPriceUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 67, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearPriceUnitOfMeasureQty = function() {
  return this.setPriceUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasPriceUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 67) != null;
};


/**
 * optional string product_complex = 68;
 * @return {string}
 */
proto.Common.Instrument.prototype.getProductComplex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 68, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setProductComplex = function(value) {
  return jspb.Message.setProto3StringField(this, 68, value);
};


/**
 * optional string security_group = 69;
 * @return {string}
 */
proto.Common.Instrument.prototype.getSecurityGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSecurityGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 69, value);
};


/**
 * optional SecurityXML security_xml = 70;
 * @return {?proto.Common.SecurityXML}
 */
proto.Common.Instrument.prototype.getSecurityXml = function() {
  return /** @type{?proto.Common.SecurityXML} */ (
    jspb.Message.getWrapperField(this, proto.Common.SecurityXML, 70));
};


/**
 * @param {?proto.Common.SecurityXML|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setSecurityXml = function(value) {
  return jspb.Message.setWrapperField(this, 70, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearSecurityXml = function() {
  return this.setSecurityXml(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasSecurityXml = function() {
  return jspb.Message.getField(this, 70) != null;
};


/**
 * optional SettlMethodEnum settl_method = 71;
 * @return {!proto.Common.SettlMethodEnum}
 */
proto.Common.Instrument.prototype.getSettlMethod = function() {
  return /** @type {!proto.Common.SettlMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 71, 0));
};


/**
 * @param {!proto.Common.SettlMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSettlMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 71, value);
};


/**
 * optional fix.Decimal64 unit_of_measure_qty = 72;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 72));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 72, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearUnitOfMeasureQty = function() {
  return this.setUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 72) != null;
};


/**
 * optional ValuationMethodEnum valuation_method = 73;
 * @return {!proto.Common.ValuationMethodEnum}
 */
proto.Common.Instrument.prototype.getValuationMethod = function() {
  return /** @type {!proto.Common.ValuationMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 73, 0));
};


/**
 * @param {!proto.Common.ValuationMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setValuationMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 73, value);
};


/**
 * repeated ComplexEvents complex_events = 74;
 * @return {!Array<!proto.Common.ComplexEvents>}
 */
proto.Common.Instrument.prototype.getComplexEventsList = function() {
  return /** @type{!Array<!proto.Common.ComplexEvents>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.ComplexEvents, 74));
};


/**
 * @param {!Array<!proto.Common.ComplexEvents>} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setComplexEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 74, value);
};


/**
 * @param {!proto.Common.ComplexEvents=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ComplexEvents}
 */
proto.Common.Instrument.prototype.addComplexEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 74, opt_value, proto.Common.ComplexEvents, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearComplexEventsList = function() {
  return this.setComplexEventsList([]);
};


/**
 * optional ContractMultiplierUnitEnum contract_multiplier_unit = 75;
 * @return {!proto.Common.ContractMultiplierUnitEnum}
 */
proto.Common.Instrument.prototype.getContractMultiplierUnit = function() {
  return /** @type {!proto.Common.ContractMultiplierUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 75, 0));
};


/**
 * @param {!proto.Common.ContractMultiplierUnitEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setContractMultiplierUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 75, value);
};


/**
 * optional FlowScheduleTypeEnum flow_schedule_type = 76;
 * @return {!proto.Common.FlowScheduleTypeEnum}
 */
proto.Common.Instrument.prototype.getFlowScheduleType = function() {
  return /** @type {!proto.Common.FlowScheduleTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 76, 0));
};


/**
 * @param {!proto.Common.FlowScheduleTypeEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setFlowScheduleType = function(value) {
  return jspb.Message.setOneofField(this, 76, proto.Common.Instrument.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearFlowScheduleType = function() {
  return jspb.Message.setOneofField(this, 76, proto.Common.Instrument.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasFlowScheduleType = function() {
  return jspb.Message.getField(this, 76) != null;
};


/**
 * optional fixed32 flow_schedule_type_reserved100plus = 77;
 * @return {number}
 */
proto.Common.Instrument.prototype.getFlowScheduleTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 77, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setFlowScheduleTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 77, proto.Common.Instrument.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 77, proto.Common.Instrument.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.getField(this, 77) != null;
};


/**
 * optional fix.Decimal64 attachment_point = 78;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getAttachmentPoint = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 78));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setAttachmentPoint = function(value) {
  return jspb.Message.setWrapperField(this, 78, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearAttachmentPoint = function() {
  return this.setAttachmentPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasAttachmentPoint = function() {
  return jspb.Message.getField(this, 78) != null;
};


/**
 * optional fix.Decimal64 detachment_point = 79;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getDetachmentPoint = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 79));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setDetachmentPoint = function(value) {
  return jspb.Message.setWrapperField(this, 79, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearDetachmentPoint = function() {
  return this.setDetachmentPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasDetachmentPoint = function() {
  return jspb.Message.getField(this, 79) != null;
};


/**
 * optional fix.Decimal64 notional_percentage_outstanding = 80;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getNotionalPercentageOutstanding = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 80));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setNotionalPercentageOutstanding = function(value) {
  return jspb.Message.setWrapperField(this, 80, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearNotionalPercentageOutstanding = function() {
  return this.setNotionalPercentageOutstanding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasNotionalPercentageOutstanding = function() {
  return jspb.Message.getField(this, 80) != null;
};


/**
 * optional fix.Decimal64 original_notional_percentage_outstanding = 81;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getOriginalNotionalPercentageOutstanding = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 81));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setOriginalNotionalPercentageOutstanding = function(value) {
  return jspb.Message.setWrapperField(this, 81, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearOriginalNotionalPercentageOutstanding = function() {
  return this.setOriginalNotionalPercentageOutstanding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasOriginalNotionalPercentageOutstanding = function() {
  return jspb.Message.getField(this, 81) != null;
};


/**
 * optional RestructuringTypeEnum restructuring_type = 82;
 * @return {!proto.Common.RestructuringTypeEnum}
 */
proto.Common.Instrument.prototype.getRestructuringType = function() {
  return /** @type {!proto.Common.RestructuringTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 82, 0));
};


/**
 * @param {!proto.Common.RestructuringTypeEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setRestructuringType = function(value) {
  return jspb.Message.setProto3EnumField(this, 82, value);
};


/**
 * optional SeniorityEnum seniority = 83;
 * @return {!proto.Common.SeniorityEnum}
 */
proto.Common.Instrument.prototype.getSeniority = function() {
  return /** @type {!proto.Common.SeniorityEnum} */ (jspb.Message.getFieldWithDefault(this, 83, 0));
};


/**
 * @param {!proto.Common.SeniorityEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setSeniority = function(value) {
  return jspb.Message.setProto3EnumField(this, 83, value);
};


/**
 * optional OptPayoutTypeEnum opt_payout_type = 84;
 * @return {!proto.Common.OptPayoutTypeEnum}
 */
proto.Common.Instrument.prototype.getOptPayoutType = function() {
  return /** @type {!proto.Common.OptPayoutTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 84, 0));
};


/**
 * @param {!proto.Common.OptPayoutTypeEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setOptPayoutType = function(value) {
  return jspb.Message.setProto3EnumField(this, 84, value);
};


/**
 * optional StrikePriceBoundaryMethodEnum strike_price_boundary_method = 85;
 * @return {!proto.Common.StrikePriceBoundaryMethodEnum}
 */
proto.Common.Instrument.prototype.getStrikePriceBoundaryMethod = function() {
  return /** @type {!proto.Common.StrikePriceBoundaryMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 85, 0));
};


/**
 * @param {!proto.Common.StrikePriceBoundaryMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setStrikePriceBoundaryMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 85, value);
};


/**
 * optional fix.Decimal64 strike_price_boundary_precision = 86;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.Instrument.prototype.getStrikePriceBoundaryPrecision = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 86));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.Instrument} returns this
*/
proto.Common.Instrument.prototype.setStrikePriceBoundaryPrecision = function(value) {
  return jspb.Message.setWrapperField(this, 86, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikePriceBoundaryPrecision = function() {
  return this.setStrikePriceBoundaryPrecision(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikePriceBoundaryPrecision = function() {
  return jspb.Message.getField(this, 86) != null;
};


/**
 * optional StrikePriceDeterminationMethodEnum strike_price_determination_method = 87;
 * @return {!proto.Common.StrikePriceDeterminationMethodEnum}
 */
proto.Common.Instrument.prototype.getStrikePriceDeterminationMethod = function() {
  return /** @type {!proto.Common.StrikePriceDeterminationMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 87, 0));
};


/**
 * @param {!proto.Common.StrikePriceDeterminationMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setStrikePriceDeterminationMethod = function(value) {
  return jspb.Message.setOneofField(this, 87, proto.Common.Instrument.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikePriceDeterminationMethod = function() {
  return jspb.Message.setOneofField(this, 87, proto.Common.Instrument.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikePriceDeterminationMethod = function() {
  return jspb.Message.getField(this, 87) != null;
};


/**
 * optional fixed32 strike_price_determination_method_reserved100plus = 88;
 * @return {number}
 */
proto.Common.Instrument.prototype.getStrikePriceDeterminationMethodReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 88, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setStrikePriceDeterminationMethodReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 88, proto.Common.Instrument.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.clearStrikePriceDeterminationMethodReserved100plus = function() {
  return jspb.Message.setOneofField(this, 88, proto.Common.Instrument.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.Instrument.prototype.hasStrikePriceDeterminationMethodReserved100plus = function() {
  return jspb.Message.getField(this, 88) != null;
};


/**
 * optional UnderlyingPriceDeterminationMethodEnum underlying_price_determination_method = 89;
 * @return {!proto.Common.UnderlyingPriceDeterminationMethodEnum}
 */
proto.Common.Instrument.prototype.getUnderlyingPriceDeterminationMethod = function() {
  return /** @type {!proto.Common.UnderlyingPriceDeterminationMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 89, 0));
};


/**
 * @param {!proto.Common.UnderlyingPriceDeterminationMethodEnum} value
 * @return {!proto.Common.Instrument} returns this
 */
proto.Common.Instrument.prototype.setUnderlyingPriceDeterminationMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 89, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrumentExtension.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrumentExtension.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrumentExtension.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrumentExtension} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentExtension.toObject = function(includeInstance, msg) {
  var f, obj = {
    attrbGrpList: jspb.Message.toObjectList(msg.getAttrbGrpList(),
    proto.Common.AttrbGrp.toObject, includeInstance),
    deliveryForm: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pctAtRisk: (f = msg.getPctAtRisk()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrumentExtension}
 */
proto.Common.InstrumentExtension.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrumentExtension;
  return proto.Common.InstrumentExtension.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrumentExtension} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrumentExtension}
 */
proto.Common.InstrumentExtension.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.AttrbGrp;
      reader.readMessage(value,proto.Common.AttrbGrp.deserializeBinaryFromReader);
      msg.addAttrbGrp(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.DeliveryFormEnum} */ (reader.readEnum());
      msg.setDeliveryForm(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPctAtRisk(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrumentExtension.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrumentExtension.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrumentExtension} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentExtension.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAttrbGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Common.AttrbGrp.serializeBinaryToWriter
    );
  }
  f = message.getDeliveryForm();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPctAtRisk();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * repeated AttrbGrp attrb_grp = 1;
 * @return {!Array<!proto.Common.AttrbGrp>}
 */
proto.Common.InstrumentExtension.prototype.getAttrbGrpList = function() {
  return /** @type{!Array<!proto.Common.AttrbGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.AttrbGrp, 1));
};


/**
 * @param {!Array<!proto.Common.AttrbGrp>} value
 * @return {!proto.Common.InstrumentExtension} returns this
*/
proto.Common.InstrumentExtension.prototype.setAttrbGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Common.AttrbGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.AttrbGrp}
 */
proto.Common.InstrumentExtension.prototype.addAttrbGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Common.AttrbGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrumentExtension} returns this
 */
proto.Common.InstrumentExtension.prototype.clearAttrbGrpList = function() {
  return this.setAttrbGrpList([]);
};


/**
 * optional DeliveryFormEnum delivery_form = 2;
 * @return {!proto.Common.DeliveryFormEnum}
 */
proto.Common.InstrumentExtension.prototype.getDeliveryForm = function() {
  return /** @type {!proto.Common.DeliveryFormEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DeliveryFormEnum} value
 * @return {!proto.Common.InstrumentExtension} returns this
 */
proto.Common.InstrumentExtension.prototype.setDeliveryForm = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 pct_at_risk = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentExtension.prototype.getPctAtRisk = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentExtension} returns this
*/
proto.Common.InstrumentExtension.prototype.setPctAtRisk = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentExtension} returns this
 */
proto.Common.InstrumentExtension.prototype.clearPctAtRisk = function() {
  return this.setPctAtRisk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentExtension.prototype.hasPctAtRisk = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrumentLeg.repeatedFields_ = [42];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.InstrumentLeg.oneofGroups_ = [[54,55]];

/**
 * @enum {number}
 */
proto.Common.InstrumentLeg.LegFlowScheduleTypeUnionCase = {
  LEG_FLOW_SCHEDULE_TYPE_UNION_NOT_SET: 0,
  LEG_FLOW_SCHEDULE_TYPE: 54,
  LEG_FLOW_SCHEDULE_TYPE_RESERVED100PLUS: 55
};

/**
 * @return {proto.Common.InstrumentLeg.LegFlowScheduleTypeUnionCase}
 */
proto.Common.InstrumentLeg.prototype.getLegFlowScheduleTypeUnionCase = function() {
  return /** @type {proto.Common.InstrumentLeg.LegFlowScheduleTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.InstrumentLeg.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrumentLeg.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrumentLeg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrumentLeg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentLeg.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedLegIssuer: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedLegIssuerLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    encodedLegSecurityDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    encodedLegSecurityDescLen: jspb.Message.getFieldWithDefault(msg, 4, 0),
    legCfiCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    legContractMultiplier: (f = msg.getLegContractMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legCountryOfIssue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    legCouponPaymentDate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    legCouponRate: (f = msg.getLegCouponRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legCreditRating: jspb.Message.getFieldWithDefault(msg, 10, ""),
    legFactor: (f = msg.getLegFactor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legInstrRegistry: jspb.Message.getFieldWithDefault(msg, 12, ""),
    legIssueDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    legIssuer: jspb.Message.getFieldWithDefault(msg, 14, ""),
    legLocaleOfIssue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    legMaturityDate: jspb.Message.getFieldWithDefault(msg, 16, 0),
    legMaturityMonthYear: jspb.Message.getFieldWithDefault(msg, 17, 0),
    legOptAttribute: msg.getLegOptAttribute_asB64(),
    legProduct: jspb.Message.getFieldWithDefault(msg, 19, 0),
    legRatioQty: (f = msg.getLegRatioQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legRedemptionDate: jspb.Message.getFieldWithDefault(msg, 21, 0),
    legRepoCollateralSecurityType: jspb.Message.getFieldWithDefault(msg, 22, ""),
    legRepurchaseRate: (f = msg.getLegRepurchaseRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legRepurchaseTerm: jspb.Message.getFieldWithDefault(msg, 24, 0),
    legSecurityDesc: jspb.Message.getFieldWithDefault(msg, 25, ""),
    legSecurityExchange: jspb.Message.getFieldWithDefault(msg, 26, ""),
    legSecurityId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    legSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 28, 0),
    legSecurityType: jspb.Message.getFieldWithDefault(msg, 29, 0),
    legSide: jspb.Message.getFieldWithDefault(msg, 30, 0),
    legStateOrProvinceOfIssue: jspb.Message.getFieldWithDefault(msg, 31, ""),
    legStrikePrice: (f = msg.getLegStrikePrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legSymbol: jspb.Message.getFieldWithDefault(msg, 33, ""),
    legSymbolSfx: jspb.Message.getFieldWithDefault(msg, 34, 0),
    legContractSettlMonth: jspb.Message.getFieldWithDefault(msg, 35, 0),
    legCurrency: jspb.Message.getFieldWithDefault(msg, 36, ""),
    legDatedDate: jspb.Message.getFieldWithDefault(msg, 37, 0),
    legInterestAccrualDate: jspb.Message.getFieldWithDefault(msg, 38, 0),
    legOptionRatio: (f = msg.getLegOptionRatio()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legPool: jspb.Message.getFieldWithDefault(msg, 40, ""),
    legPrice: (f = msg.getLegPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legSecAltIdGrpList: jspb.Message.toObjectList(msg.getLegSecAltIdGrpList(),
    proto.Common.LegSecAltIDGrp.toObject, includeInstance),
    legSecuritySubType: jspb.Message.getFieldWithDefault(msg, 43, ""),
    legStrikeCurrency: jspb.Message.getFieldWithDefault(msg, 44, ""),
    legTimeUnit: jspb.Message.getFieldWithDefault(msg, 45, 0),
    legUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 46, 0),
    legExerciseStyle: jspb.Message.getFieldWithDefault(msg, 47, 0),
    legMaturityTime: (f = msg.getLegMaturityTime()) && fix_pb.LocalTimeOnly.toObject(includeInstance, f),
    legPriceUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 49, 0),
    legPriceUnitOfMeasureQty: (f = msg.getLegPriceUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legPutOrCall: jspb.Message.getFieldWithDefault(msg, 51, 0),
    legUnitOfMeasureQty: (f = msg.getLegUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legContractMultiplierUnit: jspb.Message.getFieldWithDefault(msg, 53, 0),
    legFlowScheduleType: jspb.Message.getFieldWithDefault(msg, 54, 0),
    legFlowScheduleTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 55, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrumentLeg}
 */
proto.Common.InstrumentLeg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrumentLeg;
  return proto.Common.InstrumentLeg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrumentLeg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrumentLeg}
 */
proto.Common.InstrumentLeg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedLegIssuer(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedLegIssuerLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedLegSecurityDesc(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedLegSecurityDescLen(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegCfiCode(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegContractMultiplier(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegCountryOfIssue(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegCouponPaymentDate(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegCouponRate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegCreditRating(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegFactor(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegInstrRegistry(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegIssueDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegIssuer(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegLocaleOfIssue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegMaturityDate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegMaturityMonthYear(value);
      break;
    case 18:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setLegOptAttribute(value);
      break;
    case 19:
      var value = /** @type {!proto.Common.LegProductEnum} */ (reader.readEnum());
      msg.setLegProduct(value);
      break;
    case 20:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegRatioQty(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegRedemptionDate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegRepoCollateralSecurityType(value);
      break;
    case 23:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegRepurchaseRate(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setLegRepurchaseTerm(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSecurityDesc(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSecurityExchange(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSecurityId(value);
      break;
    case 28:
      var value = /** @type {!proto.Common.LegSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setLegSecurityIdSource(value);
      break;
    case 29:
      var value = /** @type {!proto.Common.LegSecurityTypeEnum} */ (reader.readEnum());
      msg.setLegSecurityType(value);
      break;
    case 30:
      var value = /** @type {!proto.Common.LegSideEnum} */ (reader.readEnum());
      msg.setLegSide(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegStateOrProvinceOfIssue(value);
      break;
    case 32:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegStrikePrice(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSymbol(value);
      break;
    case 34:
      var value = /** @type {!proto.Common.LegSymbolSfxEnum} */ (reader.readEnum());
      msg.setLegSymbolSfx(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegContractSettlMonth(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegCurrency(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegDatedDate(value);
      break;
    case 38:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegInterestAccrualDate(value);
      break;
    case 39:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegOptionRatio(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegPool(value);
      break;
    case 41:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegPrice(value);
      break;
    case 42:
      var value = new proto.Common.LegSecAltIDGrp;
      reader.readMessage(value,proto.Common.LegSecAltIDGrp.deserializeBinaryFromReader);
      msg.addLegSecAltIdGrp(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSecuritySubType(value);
      break;
    case 44:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegStrikeCurrency(value);
      break;
    case 45:
      var value = /** @type {!proto.Common.LegTimeUnitEnum} */ (reader.readEnum());
      msg.setLegTimeUnit(value);
      break;
    case 46:
      var value = /** @type {!proto.Common.LegUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setLegUnitOfMeasure(value);
      break;
    case 47:
      var value = /** @type {!proto.Common.LegExerciseStyleEnum} */ (reader.readEnum());
      msg.setLegExerciseStyle(value);
      break;
    case 48:
      var value = new fix_pb.LocalTimeOnly;
      reader.readMessage(value,fix_pb.LocalTimeOnly.deserializeBinaryFromReader);
      msg.setLegMaturityTime(value);
      break;
    case 49:
      var value = /** @type {!proto.Common.LegPriceUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setLegPriceUnitOfMeasure(value);
      break;
    case 50:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegPriceUnitOfMeasureQty(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setLegPutOrCall(value);
      break;
    case 52:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegUnitOfMeasureQty(value);
      break;
    case 53:
      var value = /** @type {!proto.Common.LegContractMultiplierUnitEnum} */ (reader.readEnum());
      msg.setLegContractMultiplierUnit(value);
      break;
    case 54:
      var value = /** @type {!proto.Common.LegFlowScheduleTypeEnum} */ (reader.readEnum());
      msg.setLegFlowScheduleType(value);
      break;
    case 55:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setLegFlowScheduleTypeReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrumentLeg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrumentLeg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrumentLeg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentLeg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedLegIssuer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedLegIssuerLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getEncodedLegSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEncodedLegSecurityDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      4,
      f
    );
  }
  f = message.getLegCfiCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLegContractMultiplier();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegCountryOfIssue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getLegCouponPaymentDate();
  if (f !== 0) {
    writer.writeSfixed32(
      8,
      f
    );
  }
  f = message.getLegCouponRate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegCreditRating();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLegFactor();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegInstrRegistry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getLegIssueDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getLegIssuer();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getLegLocaleOfIssue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getLegMaturityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      16,
      f
    );
  }
  f = message.getLegMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      17,
      f
    );
  }
  f = message.getLegOptAttribute_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      18,
      f
    );
  }
  f = message.getLegProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getLegRatioQty();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegRedemptionDate();
  if (f !== 0) {
    writer.writeSfixed32(
      21,
      f
    );
  }
  f = message.getLegRepoCollateralSecurityType();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getLegRepurchaseRate();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegRepurchaseTerm();
  if (f !== 0) {
    writer.writeSfixed64(
      24,
      f
    );
  }
  f = message.getLegSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getLegSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getLegSecurityId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getLegSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getLegSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      29,
      f
    );
  }
  f = message.getLegSide();
  if (f !== 0.0) {
    writer.writeEnum(
      30,
      f
    );
  }
  f = message.getLegStateOrProvinceOfIssue();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getLegStrikePrice();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegSymbol();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getLegSymbolSfx();
  if (f !== 0.0) {
    writer.writeEnum(
      34,
      f
    );
  }
  f = message.getLegContractSettlMonth();
  if (f !== 0) {
    writer.writeSfixed32(
      35,
      f
    );
  }
  f = message.getLegCurrency();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getLegDatedDate();
  if (f !== 0) {
    writer.writeSfixed32(
      37,
      f
    );
  }
  f = message.getLegInterestAccrualDate();
  if (f !== 0) {
    writer.writeSfixed32(
      38,
      f
    );
  }
  f = message.getLegOptionRatio();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegPool();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getLegPrice();
  if (f != null) {
    writer.writeMessage(
      41,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegSecAltIdGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      42,
      f,
      proto.Common.LegSecAltIDGrp.serializeBinaryToWriter
    );
  }
  f = message.getLegSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getLegStrikeCurrency();
  if (f.length > 0) {
    writer.writeString(
      44,
      f
    );
  }
  f = message.getLegTimeUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      45,
      f
    );
  }
  f = message.getLegUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      46,
      f
    );
  }
  f = message.getLegExerciseStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      47,
      f
    );
  }
  f = message.getLegMaturityTime();
  if (f != null) {
    writer.writeMessage(
      48,
      f,
      fix_pb.LocalTimeOnly.serializeBinaryToWriter
    );
  }
  f = message.getLegPriceUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      49,
      f
    );
  }
  f = message.getLegPriceUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegPutOrCall();
  if (f !== 0) {
    writer.writeSfixed64(
      51,
      f
    );
  }
  f = message.getLegUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegContractMultiplierUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = /** @type {!proto.Common.LegFlowScheduleTypeEnum} */ (jspb.Message.getField(message, 54));
  if (f != null) {
    writer.writeEnum(
      54,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 55));
  if (f != null) {
    writer.writeFixed32(
      55,
      f
    );
  }
};


/**
 * optional string encoded_leg_issuer = 1;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getEncodedLegIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setEncodedLegIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_leg_issuer_len = 2;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getEncodedLegIssuerLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setEncodedLegIssuerLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string encoded_leg_security_desc = 3;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getEncodedLegSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setEncodedLegSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional sfixed64 encoded_leg_security_desc_len = 4;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getEncodedLegSecurityDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setEncodedLegSecurityDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string leg_cfi_code = 5;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegCfiCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegCfiCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional fix.Decimal64 leg_contract_multiplier = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegContractMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegContractMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegContractMultiplier = function() {
  return this.setLegContractMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegContractMultiplier = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string leg_country_of_issue = 7;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegCountryOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegCountryOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional sfixed32 leg_coupon_payment_date = 8;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegCouponPaymentDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegCouponPaymentDate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional fix.Decimal64 leg_coupon_rate = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegCouponRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegCouponRate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegCouponRate = function() {
  return this.setLegCouponRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegCouponRate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string leg_credit_rating = 10;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegCreditRating = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegCreditRating = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional fix.Decimal64 leg_factor = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegFactor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegFactor = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegFactor = function() {
  return this.setLegFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegFactor = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string leg_instr_registry = 12;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegInstrRegistry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegInstrRegistry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional sfixed32 leg_issue_date = 13;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegIssueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegIssueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string leg_issuer = 14;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string leg_locale_of_issue = 15;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegLocaleOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegLocaleOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional sfixed32 leg_maturity_date = 16;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegMaturityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegMaturityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional sfixed32 leg_maturity_month_year = 17;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional bytes leg_opt_attribute = 18;
 * @return {!(string|Uint8Array)}
 */
proto.Common.InstrumentLeg.prototype.getLegOptAttribute = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * optional bytes leg_opt_attribute = 18;
 * This is a type-conversion wrapper around `getLegOptAttribute()`
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegOptAttribute_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getLegOptAttribute()));
};


/**
 * optional bytes leg_opt_attribute = 18;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getLegOptAttribute()`
 * @return {!Uint8Array}
 */
proto.Common.InstrumentLeg.prototype.getLegOptAttribute_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getLegOptAttribute()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegOptAttribute = function(value) {
  return jspb.Message.setProto3BytesField(this, 18, value);
};


/**
 * optional LegProductEnum leg_product = 19;
 * @return {!proto.Common.LegProductEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegProduct = function() {
  return /** @type {!proto.Common.LegProductEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.Common.LegProductEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional fix.Decimal64 leg_ratio_qty = 20;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegRatioQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 20));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegRatioQty = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegRatioQty = function() {
  return this.setLegRatioQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegRatioQty = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional sfixed32 leg_redemption_date = 21;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegRedemptionDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegRedemptionDate = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string leg_repo_collateral_security_type = 22;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegRepoCollateralSecurityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegRepoCollateralSecurityType = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional fix.Decimal64 leg_repurchase_rate = 23;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegRepurchaseRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 23));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegRepurchaseRate = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegRepurchaseRate = function() {
  return this.setLegRepurchaseRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegRepurchaseRate = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional sfixed64 leg_repurchase_term = 24;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegRepurchaseTerm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegRepurchaseTerm = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional string leg_security_desc = 25;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string leg_security_exchange = 26;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string leg_security_id = 27;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional LegSecurityIDSourceEnum leg_security_id_source = 28;
 * @return {!proto.Common.LegSecurityIDSourceEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegSecurityIdSource = function() {
  return /** @type {!proto.Common.LegSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.Common.LegSecurityIDSourceEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional LegSecurityTypeEnum leg_security_type = 29;
 * @return {!proto.Common.LegSecurityTypeEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegSecurityType = function() {
  return /** @type {!proto.Common.LegSecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {!proto.Common.LegSecurityTypeEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 29, value);
};


/**
 * optional LegSideEnum leg_side = 30;
 * @return {!proto.Common.LegSideEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegSide = function() {
  return /** @type {!proto.Common.LegSideEnum} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {!proto.Common.LegSideEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 30, value);
};


/**
 * optional string leg_state_or_province_of_issue = 31;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegStateOrProvinceOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegStateOrProvinceOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional fix.Decimal64 leg_strike_price = 32;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegStrikePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 32));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegStrikePrice = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegStrikePrice = function() {
  return this.setLegStrikePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegStrikePrice = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional string leg_symbol = 33;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional LegSymbolSfxEnum leg_symbol_sfx = 34;
 * @return {!proto.Common.LegSymbolSfxEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegSymbolSfx = function() {
  return /** @type {!proto.Common.LegSymbolSfxEnum} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {!proto.Common.LegSymbolSfxEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSymbolSfx = function(value) {
  return jspb.Message.setProto3EnumField(this, 34, value);
};


/**
 * optional sfixed32 leg_contract_settl_month = 35;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegContractSettlMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegContractSettlMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional string leg_currency = 36;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional sfixed32 leg_dated_date = 37;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegDatedDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 37, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegDatedDate = function(value) {
  return jspb.Message.setProto3IntField(this, 37, value);
};


/**
 * optional sfixed32 leg_interest_accrual_date = 38;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegInterestAccrualDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 38, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegInterestAccrualDate = function(value) {
  return jspb.Message.setProto3IntField(this, 38, value);
};


/**
 * optional fix.Decimal64 leg_option_ratio = 39;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegOptionRatio = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 39));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegOptionRatio = function(value) {
  return jspb.Message.setWrapperField(this, 39, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegOptionRatio = function() {
  return this.setLegOptionRatio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegOptionRatio = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional string leg_pool = 40;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegPool = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegPool = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional fix.Decimal64 leg_price = 41;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 41));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegPrice = function(value) {
  return jspb.Message.setWrapperField(this, 41, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegPrice = function() {
  return this.setLegPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegPrice = function() {
  return jspb.Message.getField(this, 41) != null;
};


/**
 * repeated LegSecAltIDGrp leg_sec_alt_id_grp = 42;
 * @return {!Array<!proto.Common.LegSecAltIDGrp>}
 */
proto.Common.InstrumentLeg.prototype.getLegSecAltIdGrpList = function() {
  return /** @type{!Array<!proto.Common.LegSecAltIDGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LegSecAltIDGrp, 42));
};


/**
 * @param {!Array<!proto.Common.LegSecAltIDGrp>} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegSecAltIdGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 42, value);
};


/**
 * @param {!proto.Common.LegSecAltIDGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegSecAltIDGrp}
 */
proto.Common.InstrumentLeg.prototype.addLegSecAltIdGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 42, opt_value, proto.Common.LegSecAltIDGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegSecAltIdGrpList = function() {
  return this.setLegSecAltIdGrpList([]);
};


/**
 * optional string leg_security_sub_type = 43;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional string leg_strike_currency = 44;
 * @return {string}
 */
proto.Common.InstrumentLeg.prototype.getLegStrikeCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 44, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegStrikeCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 44, value);
};


/**
 * optional LegTimeUnitEnum leg_time_unit = 45;
 * @return {!proto.Common.LegTimeUnitEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegTimeUnit = function() {
  return /** @type {!proto.Common.LegTimeUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {!proto.Common.LegTimeUnitEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegTimeUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 45, value);
};


/**
 * optional LegUnitOfMeasureEnum leg_unit_of_measure = 46;
 * @return {!proto.Common.LegUnitOfMeasureEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegUnitOfMeasure = function() {
  return /** @type {!proto.Common.LegUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {!proto.Common.LegUnitOfMeasureEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 46, value);
};


/**
 * optional LegExerciseStyleEnum leg_exercise_style = 47;
 * @return {!proto.Common.LegExerciseStyleEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegExerciseStyle = function() {
  return /** @type {!proto.Common.LegExerciseStyleEnum} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {!proto.Common.LegExerciseStyleEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegExerciseStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 47, value);
};


/**
 * optional fix.LocalTimeOnly leg_maturity_time = 48;
 * @return {?proto.fix.LocalTimeOnly}
 */
proto.Common.InstrumentLeg.prototype.getLegMaturityTime = function() {
  return /** @type{?proto.fix.LocalTimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.LocalTimeOnly, 48));
};


/**
 * @param {?proto.fix.LocalTimeOnly|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegMaturityTime = function(value) {
  return jspb.Message.setWrapperField(this, 48, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegMaturityTime = function() {
  return this.setLegMaturityTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegMaturityTime = function() {
  return jspb.Message.getField(this, 48) != null;
};


/**
 * optional LegPriceUnitOfMeasureEnum leg_price_unit_of_measure = 49;
 * @return {!proto.Common.LegPriceUnitOfMeasureEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegPriceUnitOfMeasure = function() {
  return /** @type {!proto.Common.LegPriceUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/**
 * @param {!proto.Common.LegPriceUnitOfMeasureEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegPriceUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 49, value);
};


/**
 * optional fix.Decimal64 leg_price_unit_of_measure_qty = 50;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegPriceUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 50));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegPriceUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegPriceUnitOfMeasureQty = function() {
  return this.setLegPriceUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegPriceUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional sfixed64 leg_put_or_call = 51;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegPutOrCall = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 51, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegPutOrCall = function(value) {
  return jspb.Message.setProto3IntField(this, 51, value);
};


/**
 * optional fix.Decimal64 leg_unit_of_measure_qty = 52;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrumentLeg.prototype.getLegUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 52));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrumentLeg} returns this
*/
proto.Common.InstrumentLeg.prototype.setLegUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 52, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegUnitOfMeasureQty = function() {
  return this.setLegUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional LegContractMultiplierUnitEnum leg_contract_multiplier_unit = 53;
 * @return {!proto.Common.LegContractMultiplierUnitEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegContractMultiplierUnit = function() {
  return /** @type {!proto.Common.LegContractMultiplierUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.Common.LegContractMultiplierUnitEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegContractMultiplierUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 53, value);
};


/**
 * optional LegFlowScheduleTypeEnum leg_flow_schedule_type = 54;
 * @return {!proto.Common.LegFlowScheduleTypeEnum}
 */
proto.Common.InstrumentLeg.prototype.getLegFlowScheduleType = function() {
  return /** @type {!proto.Common.LegFlowScheduleTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {!proto.Common.LegFlowScheduleTypeEnum} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegFlowScheduleType = function(value) {
  return jspb.Message.setOneofField(this, 54, proto.Common.InstrumentLeg.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegFlowScheduleType = function() {
  return jspb.Message.setOneofField(this, 54, proto.Common.InstrumentLeg.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegFlowScheduleType = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * optional fixed32 leg_flow_schedule_type_reserved100plus = 55;
 * @return {number}
 */
proto.Common.InstrumentLeg.prototype.getLegFlowScheduleTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.setLegFlowScheduleTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 55, proto.Common.InstrumentLeg.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.InstrumentLeg} returns this
 */
proto.Common.InstrumentLeg.prototype.clearLegFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 55, proto.Common.InstrumentLeg.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrumentLeg.prototype.hasLegFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.getField(this, 55) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LegBenchmarkCurveData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LegBenchmarkCurveData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LegBenchmarkCurveData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegBenchmarkCurveData.toObject = function(includeInstance, msg) {
  var f, obj = {
    legBenchmarkCurveCurrency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legBenchmarkCurveName: jspb.Message.getFieldWithDefault(msg, 2, 0),
    legBenchmarkCurvePoint: jspb.Message.getFieldWithDefault(msg, 3, ""),
    legBenchmarkPrice: (f = msg.getLegBenchmarkPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legBenchmarkPriceType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LegBenchmarkCurveData}
 */
proto.Common.LegBenchmarkCurveData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LegBenchmarkCurveData;
  return proto.Common.LegBenchmarkCurveData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LegBenchmarkCurveData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LegBenchmarkCurveData}
 */
proto.Common.LegBenchmarkCurveData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegBenchmarkCurveCurrency(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.LegBenchmarkCurveNameEnum} */ (reader.readEnum());
      msg.setLegBenchmarkCurveName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegBenchmarkCurvePoint(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegBenchmarkPrice(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setLegBenchmarkPriceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LegBenchmarkCurveData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LegBenchmarkCurveData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LegBenchmarkCurveData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegBenchmarkCurveData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegBenchmarkCurveCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegBenchmarkCurveName();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLegBenchmarkCurvePoint();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLegBenchmarkPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegBenchmarkPriceType();
  if (f !== 0) {
    writer.writeSfixed64(
      5,
      f
    );
  }
};


/**
 * optional string leg_benchmark_curve_currency = 1;
 * @return {string}
 */
proto.Common.LegBenchmarkCurveData.prototype.getLegBenchmarkCurveCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
 */
proto.Common.LegBenchmarkCurveData.prototype.setLegBenchmarkCurveCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LegBenchmarkCurveNameEnum leg_benchmark_curve_name = 2;
 * @return {!proto.Common.LegBenchmarkCurveNameEnum}
 */
proto.Common.LegBenchmarkCurveData.prototype.getLegBenchmarkCurveName = function() {
  return /** @type {!proto.Common.LegBenchmarkCurveNameEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.LegBenchmarkCurveNameEnum} value
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
 */
proto.Common.LegBenchmarkCurveData.prototype.setLegBenchmarkCurveName = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string leg_benchmark_curve_point = 3;
 * @return {string}
 */
proto.Common.LegBenchmarkCurveData.prototype.getLegBenchmarkCurvePoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
 */
proto.Common.LegBenchmarkCurveData.prototype.setLegBenchmarkCurvePoint = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fix.Decimal64 leg_benchmark_price = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.LegBenchmarkCurveData.prototype.getLegBenchmarkPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
*/
proto.Common.LegBenchmarkCurveData.prototype.setLegBenchmarkPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
 */
proto.Common.LegBenchmarkCurveData.prototype.clearLegBenchmarkPrice = function() {
  return this.setLegBenchmarkPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.LegBenchmarkCurveData.prototype.hasLegBenchmarkPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sfixed64 leg_benchmark_price_type = 5;
 * @return {number}
 */
proto.Common.LegBenchmarkCurveData.prototype.getLegBenchmarkPriceType = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.LegBenchmarkCurveData} returns this
 */
proto.Common.LegBenchmarkCurveData.prototype.setLegBenchmarkPriceType = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LegStipulations.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LegStipulations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LegStipulations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegStipulations.toObject = function(includeInstance, msg) {
  var f, obj = {
    legStipulationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    legStipulationValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LegStipulations}
 */
proto.Common.LegStipulations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LegStipulations;
  return proto.Common.LegStipulations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LegStipulations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LegStipulations}
 */
proto.Common.LegStipulations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.LegStipulationTypeEnum} */ (reader.readEnum());
      msg.setLegStipulationType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegStipulationValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LegStipulations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LegStipulations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LegStipulations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegStipulations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegStipulationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getLegStipulationValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional LegStipulationTypeEnum leg_stipulation_type = 1;
 * @return {!proto.Common.LegStipulationTypeEnum}
 */
proto.Common.LegStipulations.prototype.getLegStipulationType = function() {
  return /** @type {!proto.Common.LegStipulationTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.LegStipulationTypeEnum} value
 * @return {!proto.Common.LegStipulations} returns this
 */
proto.Common.LegStipulations.prototype.setLegStipulationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string leg_stipulation_value = 2;
 * @return {string}
 */
proto.Common.LegStipulations.prototype.getLegStipulationValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegStipulations} returns this
 */
proto.Common.LegStipulations.prototype.setLegStipulationValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.NestedParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NestedParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NestedParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NestedParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    nestedPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nestedPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nestedPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nstdPtysSubGrpList: jspb.Message.toObjectList(msg.getNstdPtysSubGrpList(),
    proto.Common.NstdPtysSubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NestedParties}
 */
proto.Common.NestedParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NestedParties;
  return proto.Common.NestedParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NestedParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NestedParties}
 */
proto.Common.NestedParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNestedPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.NestedPartyIDSourceEnum} */ (reader.readEnum());
      msg.setNestedPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.NestedPartyRoleEnum} */ (reader.readEnum());
      msg.setNestedPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.NstdPtysSubGrp;
      reader.readMessage(value,proto.Common.NstdPtysSubGrp.deserializeBinaryFromReader);
      msg.addNstdPtysSubGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NestedParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NestedParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NestedParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNestedPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNestedPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNestedPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNstdPtysSubGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.NstdPtysSubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string nested_party_id = 1;
 * @return {string}
 */
proto.Common.NestedParties.prototype.getNestedPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NestedParties} returns this
 */
proto.Common.NestedParties.prototype.setNestedPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NestedPartyIDSourceEnum nested_party_id_source = 2;
 * @return {!proto.Common.NestedPartyIDSourceEnum}
 */
proto.Common.NestedParties.prototype.getNestedPartyIdSource = function() {
  return /** @type {!proto.Common.NestedPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.NestedPartyIDSourceEnum} value
 * @return {!proto.Common.NestedParties} returns this
 */
proto.Common.NestedParties.prototype.setNestedPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional NestedPartyRoleEnum nested_party_role = 3;
 * @return {!proto.Common.NestedPartyRoleEnum}
 */
proto.Common.NestedParties.prototype.getNestedPartyRole = function() {
  return /** @type {!proto.Common.NestedPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.NestedPartyRoleEnum} value
 * @return {!proto.Common.NestedParties} returns this
 */
proto.Common.NestedParties.prototype.setNestedPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated NstdPtysSubGrp nstd_ptys_sub_grp = 4;
 * @return {!Array<!proto.Common.NstdPtysSubGrp>}
 */
proto.Common.NestedParties.prototype.getNstdPtysSubGrpList = function() {
  return /** @type{!Array<!proto.Common.NstdPtysSubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NstdPtysSubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.NstdPtysSubGrp>} value
 * @return {!proto.Common.NestedParties} returns this
*/
proto.Common.NestedParties.prototype.setNstdPtysSubGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.NstdPtysSubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NstdPtysSubGrp}
 */
proto.Common.NestedParties.prototype.addNstdPtysSubGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.NstdPtysSubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.NestedParties} returns this
 */
proto.Common.NestedParties.prototype.clearNstdPtysSubGrpList = function() {
  return this.setNstdPtysSubGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.OrderQtyData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.OrderQtyData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.OrderQtyData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrderQtyData.toObject = function(includeInstance, msg) {
  var f, obj = {
    cashOrderQty: (f = msg.getCashOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderPercent: (f = msg.getOrderPercent()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty: (f = msg.getOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    roundingDirection: jspb.Message.getFieldWithDefault(msg, 4, 0),
    roundingModulus: (f = msg.getRoundingModulus()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.OrderQtyData}
 */
proto.Common.OrderQtyData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.OrderQtyData;
  return proto.Common.OrderQtyData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.OrderQtyData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.OrderQtyData}
 */
proto.Common.OrderQtyData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCashOrderQty(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderPercent(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.RoundingDirectionEnum} */ (reader.readEnum());
      msg.setRoundingDirection(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRoundingModulus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.OrderQtyData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.OrderQtyData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.OrderQtyData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrderQtyData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCashOrderQty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderPercent();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getRoundingDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getRoundingModulus();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 cash_order_qty = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrderQtyData.prototype.getCashOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrderQtyData} returns this
*/
proto.Common.OrderQtyData.prototype.setCashOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrderQtyData} returns this
 */
proto.Common.OrderQtyData.prototype.clearCashOrderQty = function() {
  return this.setCashOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrderQtyData.prototype.hasCashOrderQty = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 order_percent = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrderQtyData.prototype.getOrderPercent = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrderQtyData} returns this
*/
proto.Common.OrderQtyData.prototype.setOrderPercent = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrderQtyData} returns this
 */
proto.Common.OrderQtyData.prototype.clearOrderPercent = function() {
  return this.setOrderPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrderQtyData.prototype.hasOrderPercent = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 order_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrderQtyData.prototype.getOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrderQtyData} returns this
*/
proto.Common.OrderQtyData.prototype.setOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrderQtyData} returns this
 */
proto.Common.OrderQtyData.prototype.clearOrderQty = function() {
  return this.setOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrderQtyData.prototype.hasOrderQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RoundingDirectionEnum rounding_direction = 4;
 * @return {!proto.Common.RoundingDirectionEnum}
 */
proto.Common.OrderQtyData.prototype.getRoundingDirection = function() {
  return /** @type {!proto.Common.RoundingDirectionEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.RoundingDirectionEnum} value
 * @return {!proto.Common.OrderQtyData} returns this
 */
proto.Common.OrderQtyData.prototype.setRoundingDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 rounding_modulus = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrderQtyData.prototype.getRoundingModulus = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrderQtyData} returns this
*/
proto.Common.OrderQtyData.prototype.setRoundingModulus = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrderQtyData} returns this
 */
proto.Common.OrderQtyData.prototype.clearRoundingModulus = function() {
  return this.setRoundingModulus(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrderQtyData.prototype.hasRoundingModulus = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.Parties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.Parties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.Parties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.Parties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Parties.toObject = function(includeInstance, msg) {
  var f, obj = {
    partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    partyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    partyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    ptysSubGrpList: jspb.Message.toObjectList(msg.getPtysSubGrpList(),
    proto.Common.PtysSubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.Parties}
 */
proto.Common.Parties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.Parties;
  return proto.Common.Parties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.Parties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.Parties}
 */
proto.Common.Parties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.PartyIDSourceEnum} */ (reader.readEnum());
      msg.setPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.PartyRoleEnum} */ (reader.readEnum());
      msg.setPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.PtysSubGrp;
      reader.readMessage(value,proto.Common.PtysSubGrp.deserializeBinaryFromReader);
      msg.addPtysSubGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.Parties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.Parties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.Parties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Parties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPtysSubGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.PtysSubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string party_id = 1;
 * @return {string}
 */
proto.Common.Parties.prototype.getPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Parties} returns this
 */
proto.Common.Parties.prototype.setPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PartyIDSourceEnum party_id_source = 2;
 * @return {!proto.Common.PartyIDSourceEnum}
 */
proto.Common.Parties.prototype.getPartyIdSource = function() {
  return /** @type {!proto.Common.PartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.PartyIDSourceEnum} value
 * @return {!proto.Common.Parties} returns this
 */
proto.Common.Parties.prototype.setPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PartyRoleEnum party_role = 3;
 * @return {!proto.Common.PartyRoleEnum}
 */
proto.Common.Parties.prototype.getPartyRole = function() {
  return /** @type {!proto.Common.PartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.PartyRoleEnum} value
 * @return {!proto.Common.Parties} returns this
 */
proto.Common.Parties.prototype.setPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated PtysSubGrp ptys_sub_grp = 4;
 * @return {!Array<!proto.Common.PtysSubGrp>}
 */
proto.Common.Parties.prototype.getPtysSubGrpList = function() {
  return /** @type{!Array<!proto.Common.PtysSubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.PtysSubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.PtysSubGrp>} value
 * @return {!proto.Common.Parties} returns this
*/
proto.Common.Parties.prototype.setPtysSubGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.PtysSubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.PtysSubGrp}
 */
proto.Common.Parties.prototype.addPtysSubGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.PtysSubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.Parties} returns this
 */
proto.Common.Parties.prototype.clearPtysSubGrpList = function() {
  return this.setPtysSubGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PegInstructions.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PegInstructions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PegInstructions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PegInstructions.toObject = function(includeInstance, msg) {
  var f, obj = {
    pegLimitType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    pegMoveType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pegOffsetType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    pegOffsetValue: (f = msg.getPegOffsetValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    pegPriceType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    pegRoundDirection: jspb.Message.getFieldWithDefault(msg, 6, 0),
    pegScope: jspb.Message.getFieldWithDefault(msg, 7, 0),
    pegSecurityDesc: jspb.Message.getFieldWithDefault(msg, 8, ""),
    pegSecurityId: jspb.Message.getFieldWithDefault(msg, 9, ""),
    pegSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 10, 0),
    pegSymbol: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PegInstructions}
 */
proto.Common.PegInstructions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PegInstructions;
  return proto.Common.PegInstructions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PegInstructions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PegInstructions}
 */
proto.Common.PegInstructions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.PegLimitTypeEnum} */ (reader.readEnum());
      msg.setPegLimitType(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.PegMoveTypeEnum} */ (reader.readEnum());
      msg.setPegMoveType(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.PegOffsetTypeEnum} */ (reader.readEnum());
      msg.setPegOffsetType(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPegOffsetValue(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.PegPriceTypeEnum} */ (reader.readEnum());
      msg.setPegPriceType(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.PegRoundDirectionEnum} */ (reader.readEnum());
      msg.setPegRoundDirection(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.PegScopeEnum} */ (reader.readEnum());
      msg.setPegScope(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPegSecurityDesc(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setPegSecurityId(value);
      break;
    case 10:
      var value = /** @type {!proto.Common.PegSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setPegSecurityIdSource(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPegSymbol(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PegInstructions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PegInstructions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PegInstructions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PegInstructions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPegLimitType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getPegMoveType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPegOffsetType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPegOffsetValue();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPegPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getPegRoundDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getPegScope();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getPegSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getPegSecurityId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPegSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getPegSymbol();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional PegLimitTypeEnum peg_limit_type = 1;
 * @return {!proto.Common.PegLimitTypeEnum}
 */
proto.Common.PegInstructions.prototype.getPegLimitType = function() {
  return /** @type {!proto.Common.PegLimitTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.PegLimitTypeEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegLimitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional PegMoveTypeEnum peg_move_type = 2;
 * @return {!proto.Common.PegMoveTypeEnum}
 */
proto.Common.PegInstructions.prototype.getPegMoveType = function() {
  return /** @type {!proto.Common.PegMoveTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.PegMoveTypeEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegMoveType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional PegOffsetTypeEnum peg_offset_type = 3;
 * @return {!proto.Common.PegOffsetTypeEnum}
 */
proto.Common.PegInstructions.prototype.getPegOffsetType = function() {
  return /** @type {!proto.Common.PegOffsetTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.PegOffsetTypeEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegOffsetType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Decimal64 peg_offset_value = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PegInstructions.prototype.getPegOffsetValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PegInstructions} returns this
*/
proto.Common.PegInstructions.prototype.setPegOffsetValue = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.clearPegOffsetValue = function() {
  return this.setPegOffsetValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PegInstructions.prototype.hasPegOffsetValue = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional PegPriceTypeEnum peg_price_type = 5;
 * @return {!proto.Common.PegPriceTypeEnum}
 */
proto.Common.PegInstructions.prototype.getPegPriceType = function() {
  return /** @type {!proto.Common.PegPriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.PegPriceTypeEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional PegRoundDirectionEnum peg_round_direction = 6;
 * @return {!proto.Common.PegRoundDirectionEnum}
 */
proto.Common.PegInstructions.prototype.getPegRoundDirection = function() {
  return /** @type {!proto.Common.PegRoundDirectionEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.PegRoundDirectionEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegRoundDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional PegScopeEnum peg_scope = 7;
 * @return {!proto.Common.PegScopeEnum}
 */
proto.Common.PegInstructions.prototype.getPegScope = function() {
  return /** @type {!proto.Common.PegScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.PegScopeEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string peg_security_desc = 8;
 * @return {string}
 */
proto.Common.PegInstructions.prototype.getPegSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string peg_security_id = 9;
 * @return {string}
 */
proto.Common.PegInstructions.prototype.getPegSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional PegSecurityIDSourceEnum peg_security_id_source = 10;
 * @return {!proto.Common.PegSecurityIDSourceEnum}
 */
proto.Common.PegInstructions.prototype.getPegSecurityIdSource = function() {
  return /** @type {!proto.Common.PegSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.Common.PegSecurityIDSourceEnum} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional string peg_symbol = 11;
 * @return {string}
 */
proto.Common.PegInstructions.prototype.getPegSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PegInstructions} returns this
 */
proto.Common.PegInstructions.prototype.setPegSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PositionAmountData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PositionAmountData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PositionAmountData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PositionAmountData.toObject = function(includeInstance, msg) {
  var f, obj = {
    posAmt: (f = msg.getPosAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    posAmtType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    positionCurrency: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PositionAmountData}
 */
proto.Common.PositionAmountData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PositionAmountData;
  return proto.Common.PositionAmountData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PositionAmountData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PositionAmountData}
 */
proto.Common.PositionAmountData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPosAmt(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.PosAmtTypeEnum} */ (reader.readEnum());
      msg.setPosAmtType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPositionCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PositionAmountData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PositionAmountData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PositionAmountData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PositionAmountData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosAmt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPosAmtType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPositionCurrency();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional fix.Decimal64 pos_amt = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PositionAmountData.prototype.getPosAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PositionAmountData} returns this
*/
proto.Common.PositionAmountData.prototype.setPosAmt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PositionAmountData} returns this
 */
proto.Common.PositionAmountData.prototype.clearPosAmt = function() {
  return this.setPosAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PositionAmountData.prototype.hasPosAmt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional PosAmtTypeEnum pos_amt_type = 2;
 * @return {!proto.Common.PosAmtTypeEnum}
 */
proto.Common.PositionAmountData.prototype.getPosAmtType = function() {
  return /** @type {!proto.Common.PosAmtTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.PosAmtTypeEnum} value
 * @return {!proto.Common.PositionAmountData} returns this
 */
proto.Common.PositionAmountData.prototype.setPosAmtType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string position_currency = 3;
 * @return {string}
 */
proto.Common.PositionAmountData.prototype.getPositionCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PositionAmountData} returns this
 */
proto.Common.PositionAmountData.prototype.setPositionCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.PositionQty.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PositionQty.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PositionQty.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PositionQty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PositionQty.toObject = function(includeInstance, msg) {
  var f, obj = {
    longQty: (f = msg.getLongQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    nestedPartiesList: jspb.Message.toObjectList(msg.getNestedPartiesList(),
    proto.Common.NestedParties.toObject, includeInstance),
    posQtyStatus: jspb.Message.getFieldWithDefault(msg, 3, 0),
    posType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    quantityDate: jspb.Message.getFieldWithDefault(msg, 5, 0),
    shortQty: (f = msg.getShortQty()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PositionQty}
 */
proto.Common.PositionQty.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PositionQty;
  return proto.Common.PositionQty.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PositionQty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PositionQty}
 */
proto.Common.PositionQty.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLongQty(value);
      break;
    case 2:
      var value = new proto.Common.NestedParties;
      reader.readMessage(value,proto.Common.NestedParties.deserializeBinaryFromReader);
      msg.addNestedParties(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.PosQtyStatusEnum} */ (reader.readEnum());
      msg.setPosQtyStatus(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.PosTypeEnum} */ (reader.readEnum());
      msg.setPosType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setQuantityDate(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setShortQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PositionQty.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PositionQty.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PositionQty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PositionQty.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLongQty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNestedPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.NestedParties.serializeBinaryToWriter
    );
  }
  f = message.getPosQtyStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPosType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getQuantityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      5,
      f
    );
  }
  f = message.getShortQty();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 long_qty = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PositionQty.prototype.getLongQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PositionQty} returns this
*/
proto.Common.PositionQty.prototype.setLongQty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.clearLongQty = function() {
  return this.setLongQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PositionQty.prototype.hasLongQty = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated NestedParties nested_parties = 2;
 * @return {!Array<!proto.Common.NestedParties>}
 */
proto.Common.PositionQty.prototype.getNestedPartiesList = function() {
  return /** @type{!Array<!proto.Common.NestedParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties, 2));
};


/**
 * @param {!Array<!proto.Common.NestedParties>} value
 * @return {!proto.Common.PositionQty} returns this
*/
proto.Common.PositionQty.prototype.setNestedPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.NestedParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties}
 */
proto.Common.PositionQty.prototype.addNestedParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.NestedParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.clearNestedPartiesList = function() {
  return this.setNestedPartiesList([]);
};


/**
 * optional PosQtyStatusEnum pos_qty_status = 3;
 * @return {!proto.Common.PosQtyStatusEnum}
 */
proto.Common.PositionQty.prototype.getPosQtyStatus = function() {
  return /** @type {!proto.Common.PosQtyStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.PosQtyStatusEnum} value
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.setPosQtyStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional PosTypeEnum pos_type = 4;
 * @return {!proto.Common.PosTypeEnum}
 */
proto.Common.PositionQty.prototype.getPosType = function() {
  return /** @type {!proto.Common.PosTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.PosTypeEnum} value
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.setPosType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional sfixed32 quantity_date = 5;
 * @return {number}
 */
proto.Common.PositionQty.prototype.getQuantityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.setQuantityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional fix.Decimal64 short_qty = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PositionQty.prototype.getShortQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PositionQty} returns this
*/
proto.Common.PositionQty.prototype.setShortQty = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PositionQty} returns this
 */
proto.Common.PositionQty.prototype.clearShortQty = function() {
  return this.setShortQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PositionQty.prototype.hasShortQty = function() {
  return jspb.Message.getField(this, 6) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.SettlInstructionsData.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SettlInstructionsData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SettlInstructionsData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SettlInstructionsData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlInstructionsData.toObject = function(includeInstance, msg) {
  var f, obj = {
    dlvyInstGrpList: jspb.Message.toObjectList(msg.getDlvyInstGrpList(),
    proto.Common.DlvyInstGrp.toObject, includeInstance),
    settlDeliveryType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    standInstDbId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    standInstDbName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    standInstDbType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SettlInstructionsData}
 */
proto.Common.SettlInstructionsData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SettlInstructionsData;
  return proto.Common.SettlInstructionsData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SettlInstructionsData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SettlInstructionsData}
 */
proto.Common.SettlInstructionsData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.DlvyInstGrp;
      reader.readMessage(value,proto.Common.DlvyInstGrp.deserializeBinaryFromReader);
      msg.addDlvyInstGrp(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.SettlDeliveryTypeEnum} */ (reader.readEnum());
      msg.setSettlDeliveryType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandInstDbId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStandInstDbName(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.StandInstDbTypeEnum} */ (reader.readEnum());
      msg.setStandInstDbType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SettlInstructionsData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SettlInstructionsData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SettlInstructionsData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlInstructionsData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDlvyInstGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Common.DlvyInstGrp.serializeBinaryToWriter
    );
  }
  f = message.getSettlDeliveryType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStandInstDbId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStandInstDbName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStandInstDbType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * repeated DlvyInstGrp dlvy_inst_grp = 1;
 * @return {!Array<!proto.Common.DlvyInstGrp>}
 */
proto.Common.SettlInstructionsData.prototype.getDlvyInstGrpList = function() {
  return /** @type{!Array<!proto.Common.DlvyInstGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DlvyInstGrp, 1));
};


/**
 * @param {!Array<!proto.Common.DlvyInstGrp>} value
 * @return {!proto.Common.SettlInstructionsData} returns this
*/
proto.Common.SettlInstructionsData.prototype.setDlvyInstGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Common.DlvyInstGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DlvyInstGrp}
 */
proto.Common.SettlInstructionsData.prototype.addDlvyInstGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Common.DlvyInstGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.SettlInstructionsData} returns this
 */
proto.Common.SettlInstructionsData.prototype.clearDlvyInstGrpList = function() {
  return this.setDlvyInstGrpList([]);
};


/**
 * optional SettlDeliveryTypeEnum settl_delivery_type = 2;
 * @return {!proto.Common.SettlDeliveryTypeEnum}
 */
proto.Common.SettlInstructionsData.prototype.getSettlDeliveryType = function() {
  return /** @type {!proto.Common.SettlDeliveryTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.SettlDeliveryTypeEnum} value
 * @return {!proto.Common.SettlInstructionsData} returns this
 */
proto.Common.SettlInstructionsData.prototype.setSettlDeliveryType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string stand_inst_db_id = 3;
 * @return {string}
 */
proto.Common.SettlInstructionsData.prototype.getStandInstDbId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SettlInstructionsData} returns this
 */
proto.Common.SettlInstructionsData.prototype.setStandInstDbId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string stand_inst_db_name = 4;
 * @return {string}
 */
proto.Common.SettlInstructionsData.prototype.getStandInstDbName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SettlInstructionsData} returns this
 */
proto.Common.SettlInstructionsData.prototype.setStandInstDbName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional StandInstDbTypeEnum stand_inst_db_type = 5;
 * @return {!proto.Common.StandInstDbTypeEnum}
 */
proto.Common.SettlInstructionsData.prototype.getStandInstDbType = function() {
  return /** @type {!proto.Common.StandInstDbTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.StandInstDbTypeEnum} value
 * @return {!proto.Common.SettlInstructionsData} returns this
 */
proto.Common.SettlInstructionsData.prototype.setStandInstDbType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.SettlParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SettlParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SettlParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SettlParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    settlPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    settlPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    settlPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    settlPtysSubGrpList: jspb.Message.toObjectList(msg.getSettlPtysSubGrpList(),
    proto.Common.SettlPtysSubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SettlParties}
 */
proto.Common.SettlParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SettlParties;
  return proto.Common.SettlParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SettlParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SettlParties}
 */
proto.Common.SettlParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.SettlPartyIDSourceEnum} */ (reader.readEnum());
      msg.setSettlPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.SettlPartyRoleEnum} */ (reader.readEnum());
      msg.setSettlPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.SettlPtysSubGrp;
      reader.readMessage(value,proto.Common.SettlPtysSubGrp.deserializeBinaryFromReader);
      msg.addSettlPtysSubGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SettlParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SettlParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SettlParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettlPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSettlPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSettlPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSettlPtysSubGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.SettlPtysSubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string settl_party_id = 1;
 * @return {string}
 */
proto.Common.SettlParties.prototype.getSettlPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SettlParties} returns this
 */
proto.Common.SettlParties.prototype.setSettlPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SettlPartyIDSourceEnum settl_party_id_source = 2;
 * @return {!proto.Common.SettlPartyIDSourceEnum}
 */
proto.Common.SettlParties.prototype.getSettlPartyIdSource = function() {
  return /** @type {!proto.Common.SettlPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.SettlPartyIDSourceEnum} value
 * @return {!proto.Common.SettlParties} returns this
 */
proto.Common.SettlParties.prototype.setSettlPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional SettlPartyRoleEnum settl_party_role = 3;
 * @return {!proto.Common.SettlPartyRoleEnum}
 */
proto.Common.SettlParties.prototype.getSettlPartyRole = function() {
  return /** @type {!proto.Common.SettlPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.SettlPartyRoleEnum} value
 * @return {!proto.Common.SettlParties} returns this
 */
proto.Common.SettlParties.prototype.setSettlPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated SettlPtysSubGrp settl_ptys_sub_grp = 4;
 * @return {!Array<!proto.Common.SettlPtysSubGrp>}
 */
proto.Common.SettlParties.prototype.getSettlPtysSubGrpList = function() {
  return /** @type{!Array<!proto.Common.SettlPtysSubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.SettlPtysSubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.SettlPtysSubGrp>} value
 * @return {!proto.Common.SettlParties} returns this
*/
proto.Common.SettlParties.prototype.setSettlPtysSubGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.SettlPtysSubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.SettlPtysSubGrp}
 */
proto.Common.SettlParties.prototype.addSettlPtysSubGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.SettlPtysSubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.SettlParties} returns this
 */
proto.Common.SettlParties.prototype.clearSettlPtysSubGrpList = function() {
  return this.setSettlPtysSubGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SpreadOrBenchmarkCurveData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SpreadOrBenchmarkCurveData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SpreadOrBenchmarkCurveData.toObject = function(includeInstance, msg) {
  var f, obj = {
    benchmarkCurveCurrency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    benchmarkCurveName: jspb.Message.getFieldWithDefault(msg, 2, 0),
    benchmarkCurvePoint: jspb.Message.getFieldWithDefault(msg, 3, ""),
    spread: (f = msg.getSpread()) && fix_pb.Decimal64.toObject(includeInstance, f),
    benchmarkPrice: (f = msg.getBenchmarkPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    benchmarkPriceType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    benchmarkSecurityId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    benchmarkSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.Common.SpreadOrBenchmarkCurveData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SpreadOrBenchmarkCurveData;
  return proto.Common.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SpreadOrBenchmarkCurveData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SpreadOrBenchmarkCurveData}
 */
proto.Common.SpreadOrBenchmarkCurveData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenchmarkCurveCurrency(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.BenchmarkCurveNameEnum} */ (reader.readEnum());
      msg.setBenchmarkCurveName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenchmarkCurvePoint(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSpread(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setBenchmarkPrice(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.BenchmarkPriceTypeEnum} */ (reader.readEnum());
      msg.setBenchmarkPriceType(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setBenchmarkSecurityId(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.BenchmarkSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setBenchmarkSecurityIdSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SpreadOrBenchmarkCurveData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SpreadOrBenchmarkCurveData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SpreadOrBenchmarkCurveData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBenchmarkCurveCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBenchmarkCurveName();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getBenchmarkCurvePoint();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSpread();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getBenchmarkPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getBenchmarkPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getBenchmarkSecurityId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBenchmarkSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string benchmark_curve_currency = 1;
 * @return {string}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkCurveCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkCurveCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional BenchmarkCurveNameEnum benchmark_curve_name = 2;
 * @return {!proto.Common.BenchmarkCurveNameEnum}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkCurveName = function() {
  return /** @type {!proto.Common.BenchmarkCurveNameEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.BenchmarkCurveNameEnum} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkCurveName = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string benchmark_curve_point = 3;
 * @return {string}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkCurvePoint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkCurvePoint = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fix.Decimal64 spread = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getSpread = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
*/
proto.Common.SpreadOrBenchmarkCurveData.prototype.setSpread = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.clearSpread = function() {
  return this.setSpread(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.hasSpread = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 benchmark_price = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
*/
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.clearBenchmarkPrice = function() {
  return this.setBenchmarkPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.hasBenchmarkPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BenchmarkPriceTypeEnum benchmark_price_type = 6;
 * @return {!proto.Common.BenchmarkPriceTypeEnum}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkPriceType = function() {
  return /** @type {!proto.Common.BenchmarkPriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.BenchmarkPriceTypeEnum} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string benchmark_security_id = 7;
 * @return {string}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional BenchmarkSecurityIDSourceEnum benchmark_security_id_source = 8;
 * @return {!proto.Common.BenchmarkSecurityIDSourceEnum}
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.getBenchmarkSecurityIdSource = function() {
  return /** @type {!proto.Common.BenchmarkSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.BenchmarkSecurityIDSourceEnum} value
 * @return {!proto.Common.SpreadOrBenchmarkCurveData} returns this
 */
proto.Common.SpreadOrBenchmarkCurveData.prototype.setBenchmarkSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.Stipulations.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.Stipulations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.Stipulations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Stipulations.toObject = function(includeInstance, msg) {
  var f, obj = {
    stipulationType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    stipulationValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.Stipulations}
 */
proto.Common.Stipulations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.Stipulations;
  return proto.Common.Stipulations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.Stipulations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.Stipulations}
 */
proto.Common.Stipulations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.StipulationTypeEnum} */ (reader.readEnum());
      msg.setStipulationType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStipulationValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.Stipulations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.Stipulations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.Stipulations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.Stipulations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStipulationType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getStipulationValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional StipulationTypeEnum stipulation_type = 1;
 * @return {!proto.Common.StipulationTypeEnum}
 */
proto.Common.Stipulations.prototype.getStipulationType = function() {
  return /** @type {!proto.Common.StipulationTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.StipulationTypeEnum} value
 * @return {!proto.Common.Stipulations} returns this
 */
proto.Common.Stipulations.prototype.setStipulationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string stipulation_value = 2;
 * @return {string}
 */
proto.Common.Stipulations.prototype.getStipulationValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.Stipulations} returns this
 */
proto.Common.Stipulations.prototype.setStipulationValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.TrdRegTimestamps.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TrdRegTimestamps.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TrdRegTimestamps.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TrdRegTimestamps} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdRegTimestamps.toObject = function(includeInstance, msg) {
  var f, obj = {
    deskOrderHandlingInstList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    deskType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    deskTypeSource: jspb.Message.getFieldWithDefault(msg, 3, 0),
    trdRegTimestamp: (f = msg.getTrdRegTimestamp()) && fix_pb.Timestamp.toObject(includeInstance, f),
    trdRegTimestampOrigin: jspb.Message.getFieldWithDefault(msg, 5, ""),
    trdRegTimestampType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TrdRegTimestamps}
 */
proto.Common.TrdRegTimestamps.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TrdRegTimestamps;
  return proto.Common.TrdRegTimestamps.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TrdRegTimestamps} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TrdRegTimestamps}
 */
proto.Common.TrdRegTimestamps.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.Common.DeskOrderHandlingInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addDeskOrderHandlingInst(values[i]);
      }
      break;
    case 2:
      var value = /** @type {!proto.Common.DeskTypeEnum} */ (reader.readEnum());
      msg.setDeskType(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.DeskTypeSourceEnum} */ (reader.readEnum());
      msg.setDeskTypeSource(value);
      break;
    case 4:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTrdRegTimestamp(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setTrdRegTimestampOrigin(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.TrdRegTimestampTypeEnum} */ (reader.readEnum());
      msg.setTrdRegTimestampType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TrdRegTimestamps.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TrdRegTimestamps.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TrdRegTimestamps} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdRegTimestamps.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeskOrderHandlingInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getDeskType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDeskTypeSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTrdRegTimestamp();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTrdRegTimestampOrigin();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTrdRegTimestampType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * repeated DeskOrderHandlingInstEnum desk_order_handling_inst = 1;
 * @return {!Array<!proto.Common.DeskOrderHandlingInstEnum>}
 */
proto.Common.TrdRegTimestamps.prototype.getDeskOrderHandlingInstList = function() {
  return /** @type {!Array<!proto.Common.DeskOrderHandlingInstEnum>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.Common.DeskOrderHandlingInstEnum>} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.setDeskOrderHandlingInstList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.Common.DeskOrderHandlingInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.addDeskOrderHandlingInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.clearDeskOrderHandlingInstList = function() {
  return this.setDeskOrderHandlingInstList([]);
};


/**
 * optional DeskTypeEnum desk_type = 2;
 * @return {!proto.Common.DeskTypeEnum}
 */
proto.Common.TrdRegTimestamps.prototype.getDeskType = function() {
  return /** @type {!proto.Common.DeskTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DeskTypeEnum} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.setDeskType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DeskTypeSourceEnum desk_type_source = 3;
 * @return {!proto.Common.DeskTypeSourceEnum}
 */
proto.Common.TrdRegTimestamps.prototype.getDeskTypeSource = function() {
  return /** @type {!proto.Common.DeskTypeSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.DeskTypeSourceEnum} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.setDeskTypeSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Timestamp trd_reg_timestamp = 4;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdRegTimestamps.prototype.getTrdRegTimestamp = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 4));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
*/
proto.Common.TrdRegTimestamps.prototype.setTrdRegTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.clearTrdRegTimestamp = function() {
  return this.setTrdRegTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdRegTimestamps.prototype.hasTrdRegTimestamp = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string trd_reg_timestamp_origin = 5;
 * @return {string}
 */
proto.Common.TrdRegTimestamps.prototype.getTrdRegTimestampOrigin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.setTrdRegTimestampOrigin = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional TrdRegTimestampTypeEnum trd_reg_timestamp_type = 6;
 * @return {!proto.Common.TrdRegTimestampTypeEnum}
 */
proto.Common.TrdRegTimestamps.prototype.getTrdRegTimestampType = function() {
  return /** @type {!proto.Common.TrdRegTimestampTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.TrdRegTimestampTypeEnum} value
 * @return {!proto.Common.TrdRegTimestamps} returns this
 */
proto.Common.TrdRegTimestamps.prototype.setTrdRegTimestampType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.UnderlyingInstrument.repeatedFields_ = [34,55,59];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.UnderlyingInstrument.oneofGroups_ = [[66,67]];

/**
 * @enum {number}
 */
proto.Common.UnderlyingInstrument.UnderlyingFlowScheduleTypeUnionCase = {
  UNDERLYING_FLOW_SCHEDULE_TYPE_UNION_NOT_SET: 0,
  UNDERLYING_FLOW_SCHEDULE_TYPE: 66,
  UNDERLYING_FLOW_SCHEDULE_TYPE_RESERVED100PLUS: 67
};

/**
 * @return {proto.Common.UnderlyingInstrument.UnderlyingFlowScheduleTypeUnionCase}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFlowScheduleTypeUnionCase = function() {
  return /** @type {proto.Common.UnderlyingInstrument.UnderlyingFlowScheduleTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.UnderlyingInstrument.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UnderlyingInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UnderlyingInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UnderlyingInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UnderlyingInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedUnderlyingIssuer: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedUnderlyingIssuerLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    encodedUnderlyingSecurityDesc: jspb.Message.getFieldWithDefault(msg, 3, ""),
    encodedUnderlyingSecurityDescLen: jspb.Message.getFieldWithDefault(msg, 4, 0),
    underlyingCfiCode: jspb.Message.getFieldWithDefault(msg, 5, ""),
    underlyingContractMultiplier: (f = msg.getUnderlyingContractMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingCountryOfIssue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    underlyingCouponPaymentDate: jspb.Message.getFieldWithDefault(msg, 8, 0),
    underlyingCouponRate: (f = msg.getUnderlyingCouponRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingCreditRating: jspb.Message.getFieldWithDefault(msg, 10, ""),
    underlyingFactor: (f = msg.getUnderlyingFactor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingInstrRegistry: jspb.Message.getFieldWithDefault(msg, 12, ""),
    underlyingIssueDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    underlyingIssuer: jspb.Message.getFieldWithDefault(msg, 14, ""),
    underlyingLocaleOfIssue: jspb.Message.getFieldWithDefault(msg, 15, ""),
    underlyingMaturityDate: jspb.Message.getFieldWithDefault(msg, 16, 0),
    underlyingMaturityMonthYear: jspb.Message.getFieldWithDefault(msg, 17, 0),
    underlyingOptAttribute: msg.getUnderlyingOptAttribute_asB64(),
    underlyingProduct: jspb.Message.getFieldWithDefault(msg, 19, 0),
    underlyingPutOrCall: jspb.Message.getFieldWithDefault(msg, 20, 0),
    underlyingRedemptionDate: jspb.Message.getFieldWithDefault(msg, 21, 0),
    underlyingRepoCollateralSecurityType: jspb.Message.getFieldWithDefault(msg, 22, ""),
    underlyingRepurchaseRate: (f = msg.getUnderlyingRepurchaseRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingRepurchaseTerm: jspb.Message.getFieldWithDefault(msg, 24, 0),
    underlyingSecurityDesc: jspb.Message.getFieldWithDefault(msg, 25, ""),
    underlyingSecurityExchange: jspb.Message.getFieldWithDefault(msg, 26, ""),
    underlyingSecurityId: jspb.Message.getFieldWithDefault(msg, 27, ""),
    underlyingSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 28, 0),
    underlyingSecurityType: jspb.Message.getFieldWithDefault(msg, 29, 0),
    underlyingStateOrProvinceOfIssue: jspb.Message.getFieldWithDefault(msg, 30, ""),
    underlyingStrikePrice: (f = msg.getUnderlyingStrikePrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingSymbol: jspb.Message.getFieldWithDefault(msg, 32, ""),
    underlyingSymbolSfx: jspb.Message.getFieldWithDefault(msg, 33, 0),
    undSecAltIdGrpList: jspb.Message.toObjectList(msg.getUndSecAltIdGrpList(),
    proto.Common.UndSecAltIDGrp.toObject, includeInstance),
    underlyingAdjustedQuantity: (f = msg.getUnderlyingAdjustedQuantity()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingAllocationPercent: (f = msg.getUnderlyingAllocationPercent()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingCapValue: (f = msg.getUnderlyingCapValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingCashAmount: (f = msg.getUnderlyingCashAmount()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingCashType: jspb.Message.getFieldWithDefault(msg, 39, 0),
    underlyingCpProgram: jspb.Message.getFieldWithDefault(msg, 40, ""),
    underlyingCpRegType: jspb.Message.getFieldWithDefault(msg, 41, ""),
    underlyingCurrency: jspb.Message.getFieldWithDefault(msg, 42, ""),
    underlyingCurrentValue: (f = msg.getUnderlyingCurrentValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingDirtyPrice: (f = msg.getUnderlyingDirtyPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingEndPrice: (f = msg.getUnderlyingEndPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingEndValue: (f = msg.getUnderlyingEndValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingFxRate: (f = msg.getUnderlyingFxRate()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingFxRateCalc: jspb.Message.getFieldWithDefault(msg, 48, 0),
    underlyingPx: (f = msg.getUnderlyingPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingQty: (f = msg.getUnderlyingQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingSecuritySubType: jspb.Message.getFieldWithDefault(msg, 51, ""),
    underlyingSettlMethod: jspb.Message.getFieldWithDefault(msg, 52, ""),
    underlyingSettlementType: jspb.Message.getFieldWithDefault(msg, 53, 0),
    underlyingStartValue: (f = msg.getUnderlyingStartValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingStipulationsList: jspb.Message.toObjectList(msg.getUnderlyingStipulationsList(),
    proto.Common.UnderlyingStipulations.toObject, includeInstance),
    underlyingStrikeCurrency: jspb.Message.getFieldWithDefault(msg, 56, ""),
    underlyingTimeUnit: jspb.Message.getFieldWithDefault(msg, 57, 0),
    underlyingUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 58, 0),
    undlyInstrumentPartiesList: jspb.Message.toObjectList(msg.getUndlyInstrumentPartiesList(),
    proto.Common.UndlyInstrumentParties.toObject, includeInstance),
    underlyingExerciseStyle: jspb.Message.getFieldWithDefault(msg, 60, 0),
    underlyingMaturityTime: (f = msg.getUnderlyingMaturityTime()) && fix_pb.LocalTimeOnly.toObject(includeInstance, f),
    underlyingPriceUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 62, 0),
    underlyingPriceUnitOfMeasureQty: (f = msg.getUnderlyingPriceUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingUnitOfMeasureQty: (f = msg.getUnderlyingUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingContractMultiplierUnit: jspb.Message.getFieldWithDefault(msg, 65, 0),
    underlyingFlowScheduleType: jspb.Message.getFieldWithDefault(msg, 66, 0),
    underlyingFlowScheduleTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 67, 0),
    underlyingAttachmentPoint: (f = msg.getUnderlyingAttachmentPoint()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingDetachmentPoint: (f = msg.getUnderlyingDetachmentPoint()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingNotionalPercentageOutstanding: (f = msg.getUnderlyingNotionalPercentageOutstanding()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingOriginalNotionalPercentageOutstanding: (f = msg.getUnderlyingOriginalNotionalPercentageOutstanding()) && fix_pb.Decimal64.toObject(includeInstance, f),
    underlyingRestructuringType: jspb.Message.getFieldWithDefault(msg, 72, 0),
    underlyingSeniority: jspb.Message.getFieldWithDefault(msg, 73, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UnderlyingInstrument}
 */
proto.Common.UnderlyingInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UnderlyingInstrument;
  return proto.Common.UnderlyingInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UnderlyingInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UnderlyingInstrument}
 */
proto.Common.UnderlyingInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedUnderlyingIssuer(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedUnderlyingIssuerLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedUnderlyingSecurityDesc(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedUnderlyingSecurityDescLen(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCfiCode(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingContractMultiplier(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCountryOfIssue(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setUnderlyingCouponPaymentDate(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingCouponRate(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCreditRating(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingFactor(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingInstrRegistry(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setUnderlyingIssueDate(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingIssuer(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingLocaleOfIssue(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setUnderlyingMaturityDate(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setUnderlyingMaturityMonthYear(value);
      break;
    case 18:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setUnderlyingOptAttribute(value);
      break;
    case 19:
      var value = /** @type {!proto.Common.UnderlyingProductEnum} */ (reader.readEnum());
      msg.setUnderlyingProduct(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setUnderlyingPutOrCall(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setUnderlyingRedemptionDate(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingRepoCollateralSecurityType(value);
      break;
    case 23:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingRepurchaseRate(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setUnderlyingRepurchaseTerm(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSecurityDesc(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSecurityExchange(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSecurityId(value);
      break;
    case 28:
      var value = /** @type {!proto.Common.UnderlyingSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setUnderlyingSecurityIdSource(value);
      break;
    case 29:
      var value = /** @type {!proto.Common.UnderlyingSecurityTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingSecurityType(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingStateOrProvinceOfIssue(value);
      break;
    case 31:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingStrikePrice(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSymbol(value);
      break;
    case 33:
      var value = /** @type {!proto.Common.UnderlyingSymbolSfxEnum} */ (reader.readEnum());
      msg.setUnderlyingSymbolSfx(value);
      break;
    case 34:
      var value = new proto.Common.UndSecAltIDGrp;
      reader.readMessage(value,proto.Common.UndSecAltIDGrp.deserializeBinaryFromReader);
      msg.addUndSecAltIdGrp(value);
      break;
    case 35:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingAdjustedQuantity(value);
      break;
    case 36:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingAllocationPercent(value);
      break;
    case 37:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingCapValue(value);
      break;
    case 38:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingCashAmount(value);
      break;
    case 39:
      var value = /** @type {!proto.Common.UnderlyingCashTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingCashType(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCpProgram(value);
      break;
    case 41:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCpRegType(value);
      break;
    case 42:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingCurrency(value);
      break;
    case 43:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingCurrentValue(value);
      break;
    case 44:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingDirtyPrice(value);
      break;
    case 45:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingEndPrice(value);
      break;
    case 46:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingEndValue(value);
      break;
    case 47:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingFxRate(value);
      break;
    case 48:
      var value = /** @type {!proto.Common.UnderlyingFXRateCalcEnum} */ (reader.readEnum());
      msg.setUnderlyingFxRateCalc(value);
      break;
    case 49:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingPx(value);
      break;
    case 50:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingQty(value);
      break;
    case 51:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSecuritySubType(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSettlMethod(value);
      break;
    case 53:
      var value = /** @type {!proto.Common.UnderlyingSettlementTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingSettlementType(value);
      break;
    case 54:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingStartValue(value);
      break;
    case 55:
      var value = new proto.Common.UnderlyingStipulations;
      reader.readMessage(value,proto.Common.UnderlyingStipulations.deserializeBinaryFromReader);
      msg.addUnderlyingStipulations(value);
      break;
    case 56:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingStrikeCurrency(value);
      break;
    case 57:
      var value = /** @type {!proto.Common.UnderlyingTimeUnitEnum} */ (reader.readEnum());
      msg.setUnderlyingTimeUnit(value);
      break;
    case 58:
      var value = /** @type {!proto.Common.UnderlyingUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setUnderlyingUnitOfMeasure(value);
      break;
    case 59:
      var value = new proto.Common.UndlyInstrumentParties;
      reader.readMessage(value,proto.Common.UndlyInstrumentParties.deserializeBinaryFromReader);
      msg.addUndlyInstrumentParties(value);
      break;
    case 60:
      var value = /** @type {!proto.Common.UnderlyingExerciseStyleEnum} */ (reader.readEnum());
      msg.setUnderlyingExerciseStyle(value);
      break;
    case 61:
      var value = new fix_pb.LocalTimeOnly;
      reader.readMessage(value,fix_pb.LocalTimeOnly.deserializeBinaryFromReader);
      msg.setUnderlyingMaturityTime(value);
      break;
    case 62:
      var value = /** @type {!proto.Common.UnderlyingPriceUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setUnderlyingPriceUnitOfMeasure(value);
      break;
    case 63:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingPriceUnitOfMeasureQty(value);
      break;
    case 64:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingUnitOfMeasureQty(value);
      break;
    case 65:
      var value = /** @type {!proto.Common.UnderlyingContractMultiplierUnitEnum} */ (reader.readEnum());
      msg.setUnderlyingContractMultiplierUnit(value);
      break;
    case 66:
      var value = /** @type {!proto.Common.UnderlyingFlowScheduleTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingFlowScheduleType(value);
      break;
    case 67:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setUnderlyingFlowScheduleTypeReserved100plus(value);
      break;
    case 68:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingAttachmentPoint(value);
      break;
    case 69:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingDetachmentPoint(value);
      break;
    case 70:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingNotionalPercentageOutstanding(value);
      break;
    case 71:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setUnderlyingOriginalNotionalPercentageOutstanding(value);
      break;
    case 72:
      var value = /** @type {!proto.Common.UnderlyingRestructuringTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingRestructuringType(value);
      break;
    case 73:
      var value = /** @type {!proto.Common.UnderlyingSeniorityEnum} */ (reader.readEnum());
      msg.setUnderlyingSeniority(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UnderlyingInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UnderlyingInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UnderlyingInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UnderlyingInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedUnderlyingIssuer();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedUnderlyingIssuerLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getEncodedUnderlyingSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEncodedUnderlyingSecurityDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      4,
      f
    );
  }
  f = message.getUnderlyingCfiCode();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getUnderlyingContractMultiplier();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingCountryOfIssue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getUnderlyingCouponPaymentDate();
  if (f !== 0) {
    writer.writeSfixed32(
      8,
      f
    );
  }
  f = message.getUnderlyingCouponRate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingCreditRating();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getUnderlyingFactor();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingInstrRegistry();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getUnderlyingIssueDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getUnderlyingIssuer();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getUnderlyingLocaleOfIssue();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getUnderlyingMaturityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      16,
      f
    );
  }
  f = message.getUnderlyingMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      17,
      f
    );
  }
  f = message.getUnderlyingOptAttribute_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      18,
      f
    );
  }
  f = message.getUnderlyingProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getUnderlyingPutOrCall();
  if (f !== 0) {
    writer.writeSfixed64(
      20,
      f
    );
  }
  f = message.getUnderlyingRedemptionDate();
  if (f !== 0) {
    writer.writeSfixed32(
      21,
      f
    );
  }
  f = message.getUnderlyingRepoCollateralSecurityType();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getUnderlyingRepurchaseRate();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingRepurchaseTerm();
  if (f !== 0) {
    writer.writeSfixed64(
      24,
      f
    );
  }
  f = message.getUnderlyingSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getUnderlyingSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getUnderlyingSecurityId();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getUnderlyingSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getUnderlyingSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      29,
      f
    );
  }
  f = message.getUnderlyingStateOrProvinceOfIssue();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getUnderlyingStrikePrice();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingSymbol();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getUnderlyingSymbolSfx();
  if (f !== 0.0) {
    writer.writeEnum(
      33,
      f
    );
  }
  f = message.getUndSecAltIdGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      34,
      f,
      proto.Common.UndSecAltIDGrp.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingAdjustedQuantity();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingAllocationPercent();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingCapValue();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingCashAmount();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingCashType();
  if (f !== 0.0) {
    writer.writeEnum(
      39,
      f
    );
  }
  f = message.getUnderlyingCpProgram();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getUnderlyingCpRegType();
  if (f.length > 0) {
    writer.writeString(
      41,
      f
    );
  }
  f = message.getUnderlyingCurrency();
  if (f.length > 0) {
    writer.writeString(
      42,
      f
    );
  }
  f = message.getUnderlyingCurrentValue();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingDirtyPrice();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingEndPrice();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingEndValue();
  if (f != null) {
    writer.writeMessage(
      46,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingFxRate();
  if (f != null) {
    writer.writeMessage(
      47,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingFxRateCalc();
  if (f !== 0.0) {
    writer.writeEnum(
      48,
      f
    );
  }
  f = message.getUnderlyingPx();
  if (f != null) {
    writer.writeMessage(
      49,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingQty();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      51,
      f
    );
  }
  f = message.getUnderlyingSettlMethod();
  if (f.length > 0) {
    writer.writeString(
      52,
      f
    );
  }
  f = message.getUnderlyingSettlementType();
  if (f !== 0.0) {
    writer.writeEnum(
      53,
      f
    );
  }
  f = message.getUnderlyingStartValue();
  if (f != null) {
    writer.writeMessage(
      54,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      55,
      f,
      proto.Common.UnderlyingStipulations.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingStrikeCurrency();
  if (f.length > 0) {
    writer.writeString(
      56,
      f
    );
  }
  f = message.getUnderlyingTimeUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      57,
      f
    );
  }
  f = message.getUnderlyingUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      58,
      f
    );
  }
  f = message.getUndlyInstrumentPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      59,
      f,
      proto.Common.UndlyInstrumentParties.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingExerciseStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      60,
      f
    );
  }
  f = message.getUnderlyingMaturityTime();
  if (f != null) {
    writer.writeMessage(
      61,
      f,
      fix_pb.LocalTimeOnly.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingPriceUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      62,
      f
    );
  }
  f = message.getUnderlyingPriceUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      63,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      64,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingContractMultiplierUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      65,
      f
    );
  }
  f = /** @type {!proto.Common.UnderlyingFlowScheduleTypeEnum} */ (jspb.Message.getField(message, 66));
  if (f != null) {
    writer.writeEnum(
      66,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 67));
  if (f != null) {
    writer.writeFixed32(
      67,
      f
    );
  }
  f = message.getUnderlyingAttachmentPoint();
  if (f != null) {
    writer.writeMessage(
      68,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingDetachmentPoint();
  if (f != null) {
    writer.writeMessage(
      69,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingNotionalPercentageOutstanding();
  if (f != null) {
    writer.writeMessage(
      70,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingOriginalNotionalPercentageOutstanding();
  if (f != null) {
    writer.writeMessage(
      71,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getUnderlyingRestructuringType();
  if (f !== 0.0) {
    writer.writeEnum(
      72,
      f
    );
  }
  f = message.getUnderlyingSeniority();
  if (f !== 0.0) {
    writer.writeEnum(
      73,
      f
    );
  }
};


/**
 * optional string encoded_underlying_issuer = 1;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getEncodedUnderlyingIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setEncodedUnderlyingIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_underlying_issuer_len = 2;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getEncodedUnderlyingIssuerLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setEncodedUnderlyingIssuerLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string encoded_underlying_security_desc = 3;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getEncodedUnderlyingSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setEncodedUnderlyingSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional sfixed64 encoded_underlying_security_desc_len = 4;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getEncodedUnderlyingSecurityDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setEncodedUnderlyingSecurityDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string underlying_cfi_code = 5;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCfiCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCfiCode = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional fix.Decimal64 underlying_contract_multiplier = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingContractMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingContractMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingContractMultiplier = function() {
  return this.setUnderlyingContractMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingContractMultiplier = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string underlying_country_of_issue = 7;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCountryOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCountryOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional sfixed32 underlying_coupon_payment_date = 8;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCouponPaymentDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCouponPaymentDate = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional fix.Decimal64 underlying_coupon_rate = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCouponRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCouponRate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingCouponRate = function() {
  return this.setUnderlyingCouponRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingCouponRate = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string underlying_credit_rating = 10;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCreditRating = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCreditRating = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional fix.Decimal64 underlying_factor = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFactor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingFactor = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingFactor = function() {
  return this.setUnderlyingFactor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingFactor = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string underlying_instr_registry = 12;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingInstrRegistry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingInstrRegistry = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional sfixed32 underlying_issue_date = 13;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingIssueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingIssueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional string underlying_issuer = 14;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string underlying_locale_of_issue = 15;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingLocaleOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingLocaleOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional sfixed32 underlying_maturity_date = 16;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingMaturityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingMaturityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional sfixed32 underlying_maturity_month_year = 17;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional bytes underlying_opt_attribute = 18;
 * @return {!(string|Uint8Array)}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingOptAttribute = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * optional bytes underlying_opt_attribute = 18;
 * This is a type-conversion wrapper around `getUnderlyingOptAttribute()`
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingOptAttribute_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getUnderlyingOptAttribute()));
};


/**
 * optional bytes underlying_opt_attribute = 18;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getUnderlyingOptAttribute()`
 * @return {!Uint8Array}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingOptAttribute_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getUnderlyingOptAttribute()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingOptAttribute = function(value) {
  return jspb.Message.setProto3BytesField(this, 18, value);
};


/**
 * optional UnderlyingProductEnum underlying_product = 19;
 * @return {!proto.Common.UnderlyingProductEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingProduct = function() {
  return /** @type {!proto.Common.UnderlyingProductEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.Common.UnderlyingProductEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional sfixed64 underlying_put_or_call = 20;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingPutOrCall = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingPutOrCall = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional sfixed32 underlying_redemption_date = 21;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingRedemptionDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingRedemptionDate = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string underlying_repo_collateral_security_type = 22;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingRepoCollateralSecurityType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingRepoCollateralSecurityType = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional fix.Decimal64 underlying_repurchase_rate = 23;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingRepurchaseRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 23));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingRepurchaseRate = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingRepurchaseRate = function() {
  return this.setUnderlyingRepurchaseRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingRepurchaseRate = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional sfixed64 underlying_repurchase_term = 24;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingRepurchaseTerm = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingRepurchaseTerm = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional string underlying_security_desc = 25;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string underlying_security_exchange = 26;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string underlying_security_id = 27;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional UnderlyingSecurityIDSourceEnum underlying_security_id_source = 28;
 * @return {!proto.Common.UnderlyingSecurityIDSourceEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecurityIdSource = function() {
  return /** @type {!proto.Common.UnderlyingSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.Common.UnderlyingSecurityIDSourceEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional UnderlyingSecurityTypeEnum underlying_security_type = 29;
 * @return {!proto.Common.UnderlyingSecurityTypeEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecurityType = function() {
  return /** @type {!proto.Common.UnderlyingSecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {!proto.Common.UnderlyingSecurityTypeEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 29, value);
};


/**
 * optional string underlying_state_or_province_of_issue = 30;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingStateOrProvinceOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingStateOrProvinceOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional fix.Decimal64 underlying_strike_price = 31;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingStrikePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 31));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingStrikePrice = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingStrikePrice = function() {
  return this.setUnderlyingStrikePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingStrikePrice = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional string underlying_symbol = 32;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional UnderlyingSymbolSfxEnum underlying_symbol_sfx = 33;
 * @return {!proto.Common.UnderlyingSymbolSfxEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSymbolSfx = function() {
  return /** @type {!proto.Common.UnderlyingSymbolSfxEnum} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {!proto.Common.UnderlyingSymbolSfxEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSymbolSfx = function(value) {
  return jspb.Message.setProto3EnumField(this, 33, value);
};


/**
 * repeated UndSecAltIDGrp und_sec_alt_id_grp = 34;
 * @return {!Array<!proto.Common.UndSecAltIDGrp>}
 */
proto.Common.UnderlyingInstrument.prototype.getUndSecAltIdGrpList = function() {
  return /** @type{!Array<!proto.Common.UndSecAltIDGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.UndSecAltIDGrp, 34));
};


/**
 * @param {!Array<!proto.Common.UndSecAltIDGrp>} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUndSecAltIdGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 34, value);
};


/**
 * @param {!proto.Common.UndSecAltIDGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndSecAltIDGrp}
 */
proto.Common.UnderlyingInstrument.prototype.addUndSecAltIdGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 34, opt_value, proto.Common.UndSecAltIDGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUndSecAltIdGrpList = function() {
  return this.setUndSecAltIdGrpList([]);
};


/**
 * optional fix.Decimal64 underlying_adjusted_quantity = 35;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingAdjustedQuantity = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 35));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingAdjustedQuantity = function(value) {
  return jspb.Message.setWrapperField(this, 35, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingAdjustedQuantity = function() {
  return this.setUnderlyingAdjustedQuantity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingAdjustedQuantity = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional fix.Decimal64 underlying_allocation_percent = 36;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingAllocationPercent = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 36));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingAllocationPercent = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingAllocationPercent = function() {
  return this.setUnderlyingAllocationPercent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingAllocationPercent = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional fix.Decimal64 underlying_cap_value = 37;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCapValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 37));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCapValue = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingCapValue = function() {
  return this.setUnderlyingCapValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingCapValue = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional fix.Decimal64 underlying_cash_amount = 38;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCashAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 38));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCashAmount = function(value) {
  return jspb.Message.setWrapperField(this, 38, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingCashAmount = function() {
  return this.setUnderlyingCashAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingCashAmount = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional UnderlyingCashTypeEnum underlying_cash_type = 39;
 * @return {!proto.Common.UnderlyingCashTypeEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCashType = function() {
  return /** @type {!proto.Common.UnderlyingCashTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 39, 0));
};


/**
 * @param {!proto.Common.UnderlyingCashTypeEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCashType = function(value) {
  return jspb.Message.setProto3EnumField(this, 39, value);
};


/**
 * optional string underlying_cp_program = 40;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCpProgram = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCpProgram = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional string underlying_cp_reg_type = 41;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCpRegType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 41, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCpRegType = function(value) {
  return jspb.Message.setProto3StringField(this, 41, value);
};


/**
 * optional string underlying_currency = 42;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 42, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 42, value);
};


/**
 * optional fix.Decimal64 underlying_current_value = 43;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingCurrentValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 43));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingCurrentValue = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingCurrentValue = function() {
  return this.setUnderlyingCurrentValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingCurrentValue = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional fix.Decimal64 underlying_dirty_price = 44;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingDirtyPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 44));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingDirtyPrice = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingDirtyPrice = function() {
  return this.setUnderlyingDirtyPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingDirtyPrice = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional fix.Decimal64 underlying_end_price = 45;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingEndPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 45));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingEndPrice = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingEndPrice = function() {
  return this.setUnderlyingEndPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingEndPrice = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional fix.Decimal64 underlying_end_value = 46;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingEndValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 46));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingEndValue = function(value) {
  return jspb.Message.setWrapperField(this, 46, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingEndValue = function() {
  return this.setUnderlyingEndValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingEndValue = function() {
  return jspb.Message.getField(this, 46) != null;
};


/**
 * optional fix.Decimal64 underlying_fx_rate = 47;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFxRate = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 47));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingFxRate = function(value) {
  return jspb.Message.setWrapperField(this, 47, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingFxRate = function() {
  return this.setUnderlyingFxRate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingFxRate = function() {
  return jspb.Message.getField(this, 47) != null;
};


/**
 * optional UnderlyingFXRateCalcEnum underlying_fx_rate_calc = 48;
 * @return {!proto.Common.UnderlyingFXRateCalcEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFxRateCalc = function() {
  return /** @type {!proto.Common.UnderlyingFXRateCalcEnum} */ (jspb.Message.getFieldWithDefault(this, 48, 0));
};


/**
 * @param {!proto.Common.UnderlyingFXRateCalcEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingFxRateCalc = function(value) {
  return jspb.Message.setProto3EnumField(this, 48, value);
};


/**
 * optional fix.Decimal64 underlying_px = 49;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 49));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingPx = function(value) {
  return jspb.Message.setWrapperField(this, 49, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingPx = function() {
  return this.setUnderlyingPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingPx = function() {
  return jspb.Message.getField(this, 49) != null;
};


/**
 * optional fix.Decimal64 underlying_qty = 50;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 50));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingQty = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingQty = function() {
  return this.setUnderlyingQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingQty = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional string underlying_security_sub_type = 51;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 51, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 51, value);
};


/**
 * optional string underlying_settl_method = 52;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSettlMethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSettlMethod = function(value) {
  return jspb.Message.setProto3StringField(this, 52, value);
};


/**
 * optional UnderlyingSettlementTypeEnum underlying_settlement_type = 53;
 * @return {!proto.Common.UnderlyingSettlementTypeEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSettlementType = function() {
  return /** @type {!proto.Common.UnderlyingSettlementTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 53, 0));
};


/**
 * @param {!proto.Common.UnderlyingSettlementTypeEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSettlementType = function(value) {
  return jspb.Message.setProto3EnumField(this, 53, value);
};


/**
 * optional fix.Decimal64 underlying_start_value = 54;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingStartValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 54));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingStartValue = function(value) {
  return jspb.Message.setWrapperField(this, 54, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingStartValue = function() {
  return this.setUnderlyingStartValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingStartValue = function() {
  return jspb.Message.getField(this, 54) != null;
};


/**
 * repeated UnderlyingStipulations underlying_stipulations = 55;
 * @return {!Array<!proto.Common.UnderlyingStipulations>}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingStipulationsList = function() {
  return /** @type{!Array<!proto.Common.UnderlyingStipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.UnderlyingStipulations, 55));
};


/**
 * @param {!Array<!proto.Common.UnderlyingStipulations>} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 55, value);
};


/**
 * @param {!proto.Common.UnderlyingStipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UnderlyingStipulations}
 */
proto.Common.UnderlyingInstrument.prototype.addUnderlyingStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 55, opt_value, proto.Common.UnderlyingStipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingStipulationsList = function() {
  return this.setUnderlyingStipulationsList([]);
};


/**
 * optional string underlying_strike_currency = 56;
 * @return {string}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingStrikeCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 56, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingStrikeCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 56, value);
};


/**
 * optional UnderlyingTimeUnitEnum underlying_time_unit = 57;
 * @return {!proto.Common.UnderlyingTimeUnitEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingTimeUnit = function() {
  return /** @type {!proto.Common.UnderlyingTimeUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 57, 0));
};


/**
 * @param {!proto.Common.UnderlyingTimeUnitEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingTimeUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 57, value);
};


/**
 * optional UnderlyingUnitOfMeasureEnum underlying_unit_of_measure = 58;
 * @return {!proto.Common.UnderlyingUnitOfMeasureEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingUnitOfMeasure = function() {
  return /** @type {!proto.Common.UnderlyingUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/**
 * @param {!proto.Common.UnderlyingUnitOfMeasureEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 58, value);
};


/**
 * repeated UndlyInstrumentParties undly_instrument_parties = 59;
 * @return {!Array<!proto.Common.UndlyInstrumentParties>}
 */
proto.Common.UnderlyingInstrument.prototype.getUndlyInstrumentPartiesList = function() {
  return /** @type{!Array<!proto.Common.UndlyInstrumentParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.UndlyInstrumentParties, 59));
};


/**
 * @param {!Array<!proto.Common.UndlyInstrumentParties>} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUndlyInstrumentPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 59, value);
};


/**
 * @param {!proto.Common.UndlyInstrumentParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndlyInstrumentParties}
 */
proto.Common.UnderlyingInstrument.prototype.addUndlyInstrumentParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 59, opt_value, proto.Common.UndlyInstrumentParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUndlyInstrumentPartiesList = function() {
  return this.setUndlyInstrumentPartiesList([]);
};


/**
 * optional UnderlyingExerciseStyleEnum underlying_exercise_style = 60;
 * @return {!proto.Common.UnderlyingExerciseStyleEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingExerciseStyle = function() {
  return /** @type {!proto.Common.UnderlyingExerciseStyleEnum} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {!proto.Common.UnderlyingExerciseStyleEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingExerciseStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 60, value);
};


/**
 * optional fix.LocalTimeOnly underlying_maturity_time = 61;
 * @return {?proto.fix.LocalTimeOnly}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingMaturityTime = function() {
  return /** @type{?proto.fix.LocalTimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.LocalTimeOnly, 61));
};


/**
 * @param {?proto.fix.LocalTimeOnly|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingMaturityTime = function(value) {
  return jspb.Message.setWrapperField(this, 61, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingMaturityTime = function() {
  return this.setUnderlyingMaturityTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingMaturityTime = function() {
  return jspb.Message.getField(this, 61) != null;
};


/**
 * optional UnderlyingPriceUnitOfMeasureEnum underlying_price_unit_of_measure = 62;
 * @return {!proto.Common.UnderlyingPriceUnitOfMeasureEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingPriceUnitOfMeasure = function() {
  return /** @type {!proto.Common.UnderlyingPriceUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 62, 0));
};


/**
 * @param {!proto.Common.UnderlyingPriceUnitOfMeasureEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingPriceUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 62, value);
};


/**
 * optional fix.Decimal64 underlying_price_unit_of_measure_qty = 63;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingPriceUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 63));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingPriceUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 63, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingPriceUnitOfMeasureQty = function() {
  return this.setUnderlyingPriceUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingPriceUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 63) != null;
};


/**
 * optional fix.Decimal64 underlying_unit_of_measure_qty = 64;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 64));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 64, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingUnitOfMeasureQty = function() {
  return this.setUnderlyingUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 64) != null;
};


/**
 * optional UnderlyingContractMultiplierUnitEnum underlying_contract_multiplier_unit = 65;
 * @return {!proto.Common.UnderlyingContractMultiplierUnitEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingContractMultiplierUnit = function() {
  return /** @type {!proto.Common.UnderlyingContractMultiplierUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 65, 0));
};


/**
 * @param {!proto.Common.UnderlyingContractMultiplierUnitEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingContractMultiplierUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 65, value);
};


/**
 * optional UnderlyingFlowScheduleTypeEnum underlying_flow_schedule_type = 66;
 * @return {!proto.Common.UnderlyingFlowScheduleTypeEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFlowScheduleType = function() {
  return /** @type {!proto.Common.UnderlyingFlowScheduleTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 66, 0));
};


/**
 * @param {!proto.Common.UnderlyingFlowScheduleTypeEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingFlowScheduleType = function(value) {
  return jspb.Message.setOneofField(this, 66, proto.Common.UnderlyingInstrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingFlowScheduleType = function() {
  return jspb.Message.setOneofField(this, 66, proto.Common.UnderlyingInstrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingFlowScheduleType = function() {
  return jspb.Message.getField(this, 66) != null;
};


/**
 * optional fixed32 underlying_flow_schedule_type_reserved100plus = 67;
 * @return {number}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingFlowScheduleTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 67, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingFlowScheduleTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 67, proto.Common.UnderlyingInstrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 67, proto.Common.UnderlyingInstrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.getField(this, 67) != null;
};


/**
 * optional fix.Decimal64 underlying_attachment_point = 68;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingAttachmentPoint = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 68));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingAttachmentPoint = function(value) {
  return jspb.Message.setWrapperField(this, 68, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingAttachmentPoint = function() {
  return this.setUnderlyingAttachmentPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingAttachmentPoint = function() {
  return jspb.Message.getField(this, 68) != null;
};


/**
 * optional fix.Decimal64 underlying_detachment_point = 69;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingDetachmentPoint = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 69));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingDetachmentPoint = function(value) {
  return jspb.Message.setWrapperField(this, 69, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingDetachmentPoint = function() {
  return this.setUnderlyingDetachmentPoint(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingDetachmentPoint = function() {
  return jspb.Message.getField(this, 69) != null;
};


/**
 * optional fix.Decimal64 underlying_notional_percentage_outstanding = 70;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingNotionalPercentageOutstanding = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 70));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingNotionalPercentageOutstanding = function(value) {
  return jspb.Message.setWrapperField(this, 70, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingNotionalPercentageOutstanding = function() {
  return this.setUnderlyingNotionalPercentageOutstanding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingNotionalPercentageOutstanding = function() {
  return jspb.Message.getField(this, 70) != null;
};


/**
 * optional fix.Decimal64 underlying_original_notional_percentage_outstanding = 71;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingOriginalNotionalPercentageOutstanding = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 71));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
*/
proto.Common.UnderlyingInstrument.prototype.setUnderlyingOriginalNotionalPercentageOutstanding = function(value) {
  return jspb.Message.setWrapperField(this, 71, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.clearUnderlyingOriginalNotionalPercentageOutstanding = function() {
  return this.setUnderlyingOriginalNotionalPercentageOutstanding(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UnderlyingInstrument.prototype.hasUnderlyingOriginalNotionalPercentageOutstanding = function() {
  return jspb.Message.getField(this, 71) != null;
};


/**
 * optional UnderlyingRestructuringTypeEnum underlying_restructuring_type = 72;
 * @return {!proto.Common.UnderlyingRestructuringTypeEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingRestructuringType = function() {
  return /** @type {!proto.Common.UnderlyingRestructuringTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 72, 0));
};


/**
 * @param {!proto.Common.UnderlyingRestructuringTypeEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingRestructuringType = function(value) {
  return jspb.Message.setProto3EnumField(this, 72, value);
};


/**
 * optional UnderlyingSeniorityEnum underlying_seniority = 73;
 * @return {!proto.Common.UnderlyingSeniorityEnum}
 */
proto.Common.UnderlyingInstrument.prototype.getUnderlyingSeniority = function() {
  return /** @type {!proto.Common.UnderlyingSeniorityEnum} */ (jspb.Message.getFieldWithDefault(this, 73, 0));
};


/**
 * @param {!proto.Common.UnderlyingSeniorityEnum} value
 * @return {!proto.Common.UnderlyingInstrument} returns this
 */
proto.Common.UnderlyingInstrument.prototype.setUnderlyingSeniority = function(value) {
  return jspb.Message.setProto3EnumField(this, 73, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.YieldData.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.YieldData.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.YieldData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.YieldData.toObject = function(includeInstance, msg) {
  var f, obj = {
    yield: (f = msg.getYield()) && fix_pb.Decimal64.toObject(includeInstance, f),
    yieldType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    yieldCalcDate: jspb.Message.getFieldWithDefault(msg, 3, 0),
    yieldRedemptionDate: jspb.Message.getFieldWithDefault(msg, 4, 0),
    yieldRedemptionPrice: (f = msg.getYieldRedemptionPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    yieldRedemptionPriceType: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.YieldData}
 */
proto.Common.YieldData.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.YieldData;
  return proto.Common.YieldData.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.YieldData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.YieldData}
 */
proto.Common.YieldData.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setYield(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.YieldTypeEnum} */ (reader.readEnum());
      msg.setYieldType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setYieldCalcDate(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setYieldRedemptionDate(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setYieldRedemptionPrice(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.YieldRedemptionPriceTypeEnum} */ (reader.readEnum());
      msg.setYieldRedemptionPriceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.YieldData.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.YieldData.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.YieldData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.YieldData.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getYield();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getYieldType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getYieldCalcDate();
  if (f !== 0) {
    writer.writeSfixed32(
      3,
      f
    );
  }
  f = message.getYieldRedemptionDate();
  if (f !== 0) {
    writer.writeSfixed32(
      4,
      f
    );
  }
  f = message.getYieldRedemptionPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getYieldRedemptionPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional fix.Decimal64 yield = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.YieldData.prototype.getYield = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.YieldData} returns this
*/
proto.Common.YieldData.prototype.setYield = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.clearYield = function() {
  return this.setYield(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.YieldData.prototype.hasYield = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional YieldTypeEnum yield_type = 2;
 * @return {!proto.Common.YieldTypeEnum}
 */
proto.Common.YieldData.prototype.getYieldType = function() {
  return /** @type {!proto.Common.YieldTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.YieldTypeEnum} value
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.setYieldType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional sfixed32 yield_calc_date = 3;
 * @return {number}
 */
proto.Common.YieldData.prototype.getYieldCalcDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.setYieldCalcDate = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional sfixed32 yield_redemption_date = 4;
 * @return {number}
 */
proto.Common.YieldData.prototype.getYieldRedemptionDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.setYieldRedemptionDate = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional fix.Decimal64 yield_redemption_price = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.YieldData.prototype.getYieldRedemptionPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.YieldData} returns this
*/
proto.Common.YieldData.prototype.setYieldRedemptionPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.clearYieldRedemptionPrice = function() {
  return this.setYieldRedemptionPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.YieldData.prototype.hasYieldRedemptionPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional YieldRedemptionPriceTypeEnum yield_redemption_price_type = 6;
 * @return {!proto.Common.YieldRedemptionPriceTypeEnum}
 */
proto.Common.YieldData.prototype.getYieldRedemptionPriceType = function() {
  return /** @type {!proto.Common.YieldRedemptionPriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.YieldRedemptionPriceTypeEnum} value
 * @return {!proto.Common.YieldData} returns this
 */
proto.Common.YieldData.prototype.setYieldRedemptionPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UnderlyingStipulations.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UnderlyingStipulations.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UnderlyingStipulations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UnderlyingStipulations.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingStipType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    underlyingStipValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UnderlyingStipulations}
 */
proto.Common.UnderlyingStipulations.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UnderlyingStipulations;
  return proto.Common.UnderlyingStipulations.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UnderlyingStipulations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UnderlyingStipulations}
 */
proto.Common.UnderlyingStipulations.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.UnderlyingStipTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingStipType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingStipValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UnderlyingStipulations.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UnderlyingStipulations.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UnderlyingStipulations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UnderlyingStipulations.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingStipType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUnderlyingStipValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional UnderlyingStipTypeEnum underlying_stip_type = 1;
 * @return {!proto.Common.UnderlyingStipTypeEnum}
 */
proto.Common.UnderlyingStipulations.prototype.getUnderlyingStipType = function() {
  return /** @type {!proto.Common.UnderlyingStipTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.UnderlyingStipTypeEnum} value
 * @return {!proto.Common.UnderlyingStipulations} returns this
 */
proto.Common.UnderlyingStipulations.prototype.setUnderlyingStipType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string underlying_stip_value = 2;
 * @return {string}
 */
proto.Common.UnderlyingStipulations.prototype.getUnderlyingStipValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UnderlyingStipulations} returns this
 */
proto.Common.UnderlyingStipulations.prototype.setUnderlyingStipValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.NestedParties2.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NestedParties2.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NestedParties2.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NestedParties2} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties2.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested2partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested2partyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nested2partyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nstdPtys2subGrpList: jspb.Message.toObjectList(msg.getNstdPtys2subGrpList(),
    proto.Common.NstdPtys2SubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NestedParties2}
 */
proto.Common.NestedParties2.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NestedParties2;
  return proto.Common.NestedParties2.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NestedParties2} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NestedParties2}
 */
proto.Common.NestedParties2.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested2partyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested2PartyIDSourceEnum} */ (reader.readEnum());
      msg.setNested2partyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.Nested2PartyRoleEnum} */ (reader.readEnum());
      msg.setNested2partyRole(value);
      break;
    case 4:
      var value = new proto.Common.NstdPtys2SubGrp;
      reader.readMessage(value,proto.Common.NstdPtys2SubGrp.deserializeBinaryFromReader);
      msg.addNstdPtys2subGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NestedParties2.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NestedParties2.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NestedParties2} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties2.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested2partyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested2partyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNested2partyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNstdPtys2subGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.NstdPtys2SubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string nested2party_id = 1;
 * @return {string}
 */
proto.Common.NestedParties2.prototype.getNested2partyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NestedParties2} returns this
 */
proto.Common.NestedParties2.prototype.setNested2partyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested2PartyIDSourceEnum nested2party_id_source = 2;
 * @return {!proto.Common.Nested2PartyIDSourceEnum}
 */
proto.Common.NestedParties2.prototype.getNested2partyIdSource = function() {
  return /** @type {!proto.Common.Nested2PartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested2PartyIDSourceEnum} value
 * @return {!proto.Common.NestedParties2} returns this
 */
proto.Common.NestedParties2.prototype.setNested2partyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Nested2PartyRoleEnum nested2party_role = 3;
 * @return {!proto.Common.Nested2PartyRoleEnum}
 */
proto.Common.NestedParties2.prototype.getNested2partyRole = function() {
  return /** @type {!proto.Common.Nested2PartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.Nested2PartyRoleEnum} value
 * @return {!proto.Common.NestedParties2} returns this
 */
proto.Common.NestedParties2.prototype.setNested2partyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated NstdPtys2SubGrp nstd_ptys2sub_grp = 4;
 * @return {!Array<!proto.Common.NstdPtys2SubGrp>}
 */
proto.Common.NestedParties2.prototype.getNstdPtys2subGrpList = function() {
  return /** @type{!Array<!proto.Common.NstdPtys2SubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NstdPtys2SubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.NstdPtys2SubGrp>} value
 * @return {!proto.Common.NestedParties2} returns this
*/
proto.Common.NestedParties2.prototype.setNstdPtys2subGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.NstdPtys2SubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NstdPtys2SubGrp}
 */
proto.Common.NestedParties2.prototype.addNstdPtys2subGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.NstdPtys2SubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.NestedParties2} returns this
 */
proto.Common.NestedParties2.prototype.clearNstdPtys2subGrpList = function() {
  return this.setNstdPtys2subGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.NestedParties3.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NestedParties3.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NestedParties3.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NestedParties3} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties3.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested3partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested3partyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nested3partyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nstdPtys3subGrpList: jspb.Message.toObjectList(msg.getNstdPtys3subGrpList(),
    proto.Common.NstdPtys3SubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NestedParties3}
 */
proto.Common.NestedParties3.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NestedParties3;
  return proto.Common.NestedParties3.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NestedParties3} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NestedParties3}
 */
proto.Common.NestedParties3.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested3partyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested3PartyIDSourceEnum} */ (reader.readEnum());
      msg.setNested3partyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.Nested3PartyRoleEnum} */ (reader.readEnum());
      msg.setNested3partyRole(value);
      break;
    case 4:
      var value = new proto.Common.NstdPtys3SubGrp;
      reader.readMessage(value,proto.Common.NstdPtys3SubGrp.deserializeBinaryFromReader);
      msg.addNstdPtys3subGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NestedParties3.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NestedParties3.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NestedParties3} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties3.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested3partyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested3partyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNested3partyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNstdPtys3subGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.NstdPtys3SubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string nested3party_id = 1;
 * @return {string}
 */
proto.Common.NestedParties3.prototype.getNested3partyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NestedParties3} returns this
 */
proto.Common.NestedParties3.prototype.setNested3partyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested3PartyIDSourceEnum nested3party_id_source = 2;
 * @return {!proto.Common.Nested3PartyIDSourceEnum}
 */
proto.Common.NestedParties3.prototype.getNested3partyIdSource = function() {
  return /** @type {!proto.Common.Nested3PartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested3PartyIDSourceEnum} value
 * @return {!proto.Common.NestedParties3} returns this
 */
proto.Common.NestedParties3.prototype.setNested3partyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Nested3PartyRoleEnum nested3party_role = 3;
 * @return {!proto.Common.Nested3PartyRoleEnum}
 */
proto.Common.NestedParties3.prototype.getNested3partyRole = function() {
  return /** @type {!proto.Common.Nested3PartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.Nested3PartyRoleEnum} value
 * @return {!proto.Common.NestedParties3} returns this
 */
proto.Common.NestedParties3.prototype.setNested3partyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated NstdPtys3SubGrp nstd_ptys3sub_grp = 4;
 * @return {!Array<!proto.Common.NstdPtys3SubGrp>}
 */
proto.Common.NestedParties3.prototype.getNstdPtys3subGrpList = function() {
  return /** @type{!Array<!proto.Common.NstdPtys3SubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NstdPtys3SubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.NstdPtys3SubGrp>} value
 * @return {!proto.Common.NestedParties3} returns this
*/
proto.Common.NestedParties3.prototype.setNstdPtys3subGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.NstdPtys3SubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NstdPtys3SubGrp}
 */
proto.Common.NestedParties3.prototype.addNstdPtys3subGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.NstdPtys3SubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.NestedParties3} returns this
 */
proto.Common.NestedParties3.prototype.clearNstdPtys3subGrpList = function() {
  return this.setNstdPtys3subGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ClrInstGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ClrInstGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ClrInstGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ClrInstGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    clearingInstruction: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ClrInstGrp}
 */
proto.Common.ClrInstGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ClrInstGrp;
  return proto.Common.ClrInstGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ClrInstGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ClrInstGrp}
 */
proto.Common.ClrInstGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.ClearingInstructionEnum} */ (reader.readEnum());
      msg.setClearingInstruction(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ClrInstGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ClrInstGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ClrInstGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ClrInstGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClearingInstruction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ClearingInstructionEnum clearing_instruction = 1;
 * @return {!proto.Common.ClearingInstructionEnum}
 */
proto.Common.ClrInstGrp.prototype.getClearingInstruction = function() {
  return /** @type {!proto.Common.ClearingInstructionEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.ClearingInstructionEnum} value
 * @return {!proto.Common.ClrInstGrp} returns this
 */
proto.Common.ClrInstGrp.prototype.setClearingInstruction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.CompIDReqGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.CompIDReqGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.CompIDReqGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CompIDReqGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    deskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    locationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refCompId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refSubId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.CompIDReqGrp}
 */
proto.Common.CompIDReqGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.CompIDReqGrp;
  return proto.Common.CompIDReqGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.CompIDReqGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.CompIDReqGrp}
 */
proto.Common.CompIDReqGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefCompId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefSubId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.CompIDReqGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.CompIDReqGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.CompIDReqGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CompIDReqGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefCompId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefSubId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string desk_id = 1;
 * @return {string}
 */
proto.Common.CompIDReqGrp.prototype.getDeskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDReqGrp} returns this
 */
proto.Common.CompIDReqGrp.prototype.setDeskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_id = 2;
 * @return {string}
 */
proto.Common.CompIDReqGrp.prototype.getLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDReqGrp} returns this
 */
proto.Common.CompIDReqGrp.prototype.setLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref_comp_id = 3;
 * @return {string}
 */
proto.Common.CompIDReqGrp.prototype.getRefCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDReqGrp} returns this
 */
proto.Common.CompIDReqGrp.prototype.setRefCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ref_sub_id = 4;
 * @return {string}
 */
proto.Common.CompIDReqGrp.prototype.getRefSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDReqGrp} returns this
 */
proto.Common.CompIDReqGrp.prototype.setRefSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.CompIDStatGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.CompIDStatGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.CompIDStatGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CompIDStatGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    deskId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    locationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    refCompId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refSubId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    statusText: jspb.Message.getFieldWithDefault(msg, 5, ""),
    statusValue: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.CompIDStatGrp}
 */
proto.Common.CompIDStatGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.CompIDStatGrp;
  return proto.Common.CompIDStatGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.CompIDStatGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.CompIDStatGrp}
 */
proto.Common.CompIDStatGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDeskId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefCompId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefSubId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusText(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.StatusValueEnum} */ (reader.readEnum());
      msg.setStatusValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.CompIDStatGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.CompIDStatGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.CompIDStatGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.CompIDStatGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeskId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLocationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRefCompId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefSubId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatusText();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatusValue();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
};


/**
 * optional string desk_id = 1;
 * @return {string}
 */
proto.Common.CompIDStatGrp.prototype.getDeskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setDeskId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string location_id = 2;
 * @return {string}
 */
proto.Common.CompIDStatGrp.prototype.getLocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setLocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string ref_comp_id = 3;
 * @return {string}
 */
proto.Common.CompIDStatGrp.prototype.getRefCompId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setRefCompId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string ref_sub_id = 4;
 * @return {string}
 */
proto.Common.CompIDStatGrp.prototype.getRefSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setRefSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string status_text = 5;
 * @return {string}
 */
proto.Common.CompIDStatGrp.prototype.getStatusText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setStatusText = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional StatusValueEnum status_value = 6;
 * @return {!proto.Common.StatusValueEnum}
 */
proto.Common.CompIDStatGrp.prototype.getStatusValue = function() {
  return /** @type {!proto.Common.StatusValueEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.StatusValueEnum} value
 * @return {!proto.Common.CompIDStatGrp} returns this
 */
proto.Common.CompIDStatGrp.prototype.setStatusValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ContAmtGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ContAmtGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ContAmtGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ContAmtGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    contAmtCurr: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contAmtType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    contAmtValue: (f = msg.getContAmtValue()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ContAmtGrp}
 */
proto.Common.ContAmtGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ContAmtGrp;
  return proto.Common.ContAmtGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ContAmtGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ContAmtGrp}
 */
proto.Common.ContAmtGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContAmtCurr(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.ContAmtTypeEnum} */ (reader.readEnum());
      msg.setContAmtType(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setContAmtValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ContAmtGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ContAmtGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ContAmtGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ContAmtGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContAmtCurr();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContAmtType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getContAmtValue();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional string cont_amt_curr = 1;
 * @return {string}
 */
proto.Common.ContAmtGrp.prototype.getContAmtCurr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.ContAmtGrp} returns this
 */
proto.Common.ContAmtGrp.prototype.setContAmtCurr = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ContAmtTypeEnum cont_amt_type = 2;
 * @return {!proto.Common.ContAmtTypeEnum}
 */
proto.Common.ContAmtGrp.prototype.getContAmtType = function() {
  return /** @type {!proto.Common.ContAmtTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.ContAmtTypeEnum} value
 * @return {!proto.Common.ContAmtGrp} returns this
 */
proto.Common.ContAmtGrp.prototype.setContAmtType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 cont_amt_value = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.ContAmtGrp.prototype.getContAmtValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.ContAmtGrp} returns this
*/
proto.Common.ContAmtGrp.prototype.setContAmtValue = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ContAmtGrp} returns this
 */
proto.Common.ContAmtGrp.prototype.clearContAmtValue = function() {
  return this.setContAmtValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ContAmtGrp.prototype.hasContAmtValue = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ContraGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ContraGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ContraGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ContraGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    contraBroker: jspb.Message.getFieldWithDefault(msg, 1, ""),
    contraLegRefId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contraTradeQty: (f = msg.getContraTradeQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    contraTradeTime: (f = msg.getContraTradeTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    contraTrader: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ContraGrp}
 */
proto.Common.ContraGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ContraGrp;
  return proto.Common.ContraGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ContraGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ContraGrp}
 */
proto.Common.ContraGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraBroker(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraLegRefId(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setContraTradeQty(value);
      break;
    case 4:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setContraTradeTime(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setContraTrader(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ContraGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ContraGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ContraGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ContraGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContraBroker();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getContraLegRefId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContraTradeQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getContraTradeTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getContraTrader();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string contra_broker = 1;
 * @return {string}
 */
proto.Common.ContraGrp.prototype.getContraBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.ContraGrp} returns this
 */
proto.Common.ContraGrp.prototype.setContraBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string contra_leg_ref_id = 2;
 * @return {string}
 */
proto.Common.ContraGrp.prototype.getContraLegRefId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.ContraGrp} returns this
 */
proto.Common.ContraGrp.prototype.setContraLegRefId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fix.Decimal64 contra_trade_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.ContraGrp.prototype.getContraTradeQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.ContraGrp} returns this
*/
proto.Common.ContraGrp.prototype.setContraTradeQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ContraGrp} returns this
 */
proto.Common.ContraGrp.prototype.clearContraTradeQty = function() {
  return this.setContraTradeQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ContraGrp.prototype.hasContraTradeQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Timestamp contra_trade_time = 4;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.ContraGrp.prototype.getContraTradeTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 4));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.ContraGrp} returns this
*/
proto.Common.ContraGrp.prototype.setContraTradeTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ContraGrp} returns this
 */
proto.Common.ContraGrp.prototype.clearContraTradeTime = function() {
  return this.setContraTradeTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ContraGrp.prototype.hasContraTradeTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string contra_trader = 5;
 * @return {string}
 */
proto.Common.ContraGrp.prototype.getContraTrader = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.ContraGrp} returns this
 */
proto.Common.ContraGrp.prototype.setContraTrader = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrument: (f = msg.getInstrument()) && proto.Common.Instrument.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtGrp}
 */
proto.Common.InstrmtGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtGrp;
  return proto.Common.InstrmtGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtGrp}
 */
proto.Common.InstrmtGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.Instrument;
      reader.readMessage(value,proto.Common.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.Instrument.serializeBinaryToWriter
    );
  }
};


/**
 * optional Instrument instrument = 1;
 * @return {?proto.Common.Instrument}
 */
proto.Common.InstrmtGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, proto.Common.Instrument, 1));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.Common.InstrmtGrp} returns this
*/
proto.Common.InstrmtGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtGrp} returns this
 */
proto.Common.InstrmtGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrmtLegExecGrp.repeatedFields_ = [14,19,21,23];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtLegExecGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtLegExecGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtLegExecGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegExecGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentLeg: (f = msg.getInstrumentLeg()) && proto.Common.InstrumentLeg.toObject(includeInstance, f),
    legCalculatedCcyLastQty: (f = msg.getLegCalculatedCcyLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legCoveredOrUncovered: jspb.Message.getFieldWithDefault(msg, 3, 0),
    legGrossTradeAmt: (f = msg.getLegGrossTradeAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legLastForwardPoints: (f = msg.getLegLastForwardPoints()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legLastPx: (f = msg.getLegLastPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legOrderQty: (f = msg.getLegOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legPositionEffect: jspb.Message.getFieldWithDefault(msg, 8, 0),
    legQty: (f = msg.getLegQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legRefId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    legSettlCurrency: jspb.Message.getFieldWithDefault(msg, 11, ""),
    legSettlDate: jspb.Message.getFieldWithDefault(msg, 12, 0),
    legSettlType: jspb.Message.getFieldWithDefault(msg, 13, 0),
    legStipulationsList: jspb.Message.toObjectList(msg.getLegStipulationsList(),
    proto.Common.LegStipulations.toObject, includeInstance),
    legSwapType: jspb.Message.getFieldWithDefault(msg, 15, 0),
    legAllocId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    legCurrencyRatio: (f = msg.getLegCurrencyRatio()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legDividendYield: (f = msg.getLegDividendYield()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legExecInstList: (f = jspb.Message.getRepeatedField(msg, 19)) == null ? undefined : f,
    legLastQty: (f = msg.getLegLastQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legPreAllocGrpList: jspb.Message.toObjectList(msg.getLegPreAllocGrpList(),
    proto.Common.LegPreAllocGrp.toObject, includeInstance),
    legVolatility: (f = msg.getLegVolatility()) && fix_pb.Decimal64.toObject(includeInstance, f),
    nestedParties3List: jspb.Message.toObjectList(msg.getNestedParties3List(),
    proto.Common.NestedParties3.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtLegExecGrp}
 */
proto.Common.InstrmtLegExecGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtLegExecGrp;
  return proto.Common.InstrmtLegExecGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtLegExecGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtLegExecGrp}
 */
proto.Common.InstrmtLegExecGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.InstrumentLeg;
      reader.readMessage(value,proto.Common.InstrumentLeg.deserializeBinaryFromReader);
      msg.setInstrumentLeg(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegCalculatedCcyLastQty(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.LegCoveredOrUncoveredEnum} */ (reader.readEnum());
      msg.setLegCoveredOrUncovered(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegGrossTradeAmt(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegLastForwardPoints(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegLastPx(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegOrderQty(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.LegPositionEffectEnum} */ (reader.readEnum());
      msg.setLegPositionEffect(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegQty(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegRefId(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSettlCurrency(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegSettlDate(value);
      break;
    case 13:
      var value = /** @type {!proto.Common.LegSettlTypeEnum} */ (reader.readEnum());
      msg.setLegSettlType(value);
      break;
    case 14:
      var value = new proto.Common.LegStipulations;
      reader.readMessage(value,proto.Common.LegStipulations.deserializeBinaryFromReader);
      msg.addLegStipulations(value);
      break;
    case 15:
      var value = /** @type {!proto.Common.LegSwapTypeEnum} */ (reader.readEnum());
      msg.setLegSwapType(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegAllocId(value);
      break;
    case 17:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegCurrencyRatio(value);
      break;
    case 18:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegDividendYield(value);
      break;
    case 19:
      var values = /** @type {!Array<!proto.Common.LegExecInstEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addLegExecInst(values[i]);
      }
      break;
    case 20:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegLastQty(value);
      break;
    case 21:
      var value = new proto.Common.LegPreAllocGrp;
      reader.readMessage(value,proto.Common.LegPreAllocGrp.deserializeBinaryFromReader);
      msg.addLegPreAllocGrp(value);
      break;
    case 22:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegVolatility(value);
      break;
    case 23:
      var value = new proto.Common.NestedParties3;
      reader.readMessage(value,proto.Common.NestedParties3.deserializeBinaryFromReader);
      msg.addNestedParties3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtLegExecGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtLegExecGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtLegExecGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegExecGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentLeg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.InstrumentLeg.serializeBinaryToWriter
    );
  }
  f = message.getLegCalculatedCcyLastQty();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegCoveredOrUncovered();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLegGrossTradeAmt();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegLastForwardPoints();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegLastPx();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegOrderQty();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegPositionEffect();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getLegQty();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegRefId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getLegSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLegSettlDate();
  if (f !== 0) {
    writer.writeSfixed32(
      12,
      f
    );
  }
  f = message.getLegSettlType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getLegStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.Common.LegStipulations.serializeBinaryToWriter
    );
  }
  f = message.getLegSwapType();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getLegAllocId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getLegCurrencyRatio();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegDividendYield();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegExecInstList();
  if (f.length > 0) {
    writer.writePackedEnum(
      19,
      f
    );
  }
  f = message.getLegLastQty();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegPreAllocGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      21,
      f,
      proto.Common.LegPreAllocGrp.serializeBinaryToWriter
    );
  }
  f = message.getLegVolatility();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNestedParties3List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      23,
      f,
      proto.Common.NestedParties3.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstrumentLeg instrument_leg = 1;
 * @return {?proto.Common.InstrumentLeg}
 */
proto.Common.InstrmtLegExecGrp.prototype.getInstrumentLeg = function() {
  return /** @type{?proto.Common.InstrumentLeg} */ (
    jspb.Message.getWrapperField(this, proto.Common.InstrumentLeg, 1));
};


/**
 * @param {?proto.Common.InstrumentLeg|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setInstrumentLeg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearInstrumentLeg = function() {
  return this.setInstrumentLeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasInstrumentLeg = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 leg_calculated_ccy_last_qty = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegCalculatedCcyLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegCalculatedCcyLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegCalculatedCcyLastQty = function() {
  return this.setLegCalculatedCcyLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegCalculatedCcyLastQty = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LegCoveredOrUncoveredEnum leg_covered_or_uncovered = 3;
 * @return {!proto.Common.LegCoveredOrUncoveredEnum}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegCoveredOrUncovered = function() {
  return /** @type {!proto.Common.LegCoveredOrUncoveredEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.LegCoveredOrUncoveredEnum} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegCoveredOrUncovered = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Decimal64 leg_gross_trade_amt = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegGrossTradeAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegGrossTradeAmt = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegGrossTradeAmt = function() {
  return this.setLegGrossTradeAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegGrossTradeAmt = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 leg_last_forward_points = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegLastForwardPoints = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegLastForwardPoints = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegLastForwardPoints = function() {
  return this.setLegLastForwardPoints(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegLastForwardPoints = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 leg_last_px = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegLastPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegLastPx = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegLastPx = function() {
  return this.setLegLastPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegLastPx = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fix.Decimal64 leg_order_qty = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegOrderQty = function() {
  return this.setLegOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegOrderQty = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional LegPositionEffectEnum leg_position_effect = 8;
 * @return {!proto.Common.LegPositionEffectEnum}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegPositionEffect = function() {
  return /** @type {!proto.Common.LegPositionEffectEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.LegPositionEffectEnum} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegPositionEffect = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional fix.Decimal64 leg_qty = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegQty = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegQty = function() {
  return this.setLegQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegQty = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string leg_ref_id = 10;
 * @return {string}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegRefId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegRefId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string leg_settl_currency = 11;
 * @return {string}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional sfixed32 leg_settl_date = 12;
 * @return {number}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegSettlDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegSettlDate = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional LegSettlTypeEnum leg_settl_type = 13;
 * @return {!proto.Common.LegSettlTypeEnum}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegSettlType = function() {
  return /** @type {!proto.Common.LegSettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.Common.LegSettlTypeEnum} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegSettlType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * repeated LegStipulations leg_stipulations = 14;
 * @return {!Array<!proto.Common.LegStipulations>}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegStipulationsList = function() {
  return /** @type{!Array<!proto.Common.LegStipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LegStipulations, 14));
};


/**
 * @param {!Array<!proto.Common.LegStipulations>} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.Common.LegStipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegStipulations}
 */
proto.Common.InstrmtLegExecGrp.prototype.addLegStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.Common.LegStipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegStipulationsList = function() {
  return this.setLegStipulationsList([]);
};


/**
 * optional LegSwapTypeEnum leg_swap_type = 15;
 * @return {!proto.Common.LegSwapTypeEnum}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegSwapType = function() {
  return /** @type {!proto.Common.LegSwapTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.Common.LegSwapTypeEnum} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegSwapType = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * optional string leg_alloc_id = 16;
 * @return {string}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional fix.Decimal64 leg_currency_ratio = 17;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegCurrencyRatio = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 17));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegCurrencyRatio = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegCurrencyRatio = function() {
  return this.setLegCurrencyRatio(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegCurrencyRatio = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional fix.Decimal64 leg_dividend_yield = 18;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegDividendYield = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 18));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegDividendYield = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegDividendYield = function() {
  return this.setLegDividendYield(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegDividendYield = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * repeated LegExecInstEnum leg_exec_inst = 19;
 * @return {!Array<!proto.Common.LegExecInstEnum>}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegExecInstList = function() {
  return /** @type {!Array<!proto.Common.LegExecInstEnum>} */ (jspb.Message.getRepeatedField(this, 19));
};


/**
 * @param {!Array<!proto.Common.LegExecInstEnum>} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.setLegExecInstList = function(value) {
  return jspb.Message.setField(this, 19, value || []);
};


/**
 * @param {!proto.Common.LegExecInstEnum} value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.addLegExecInst = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 19, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegExecInstList = function() {
  return this.setLegExecInstList([]);
};


/**
 * optional fix.Decimal64 leg_last_qty = 20;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegLastQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 20));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegLastQty = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegLastQty = function() {
  return this.setLegLastQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegLastQty = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * repeated LegPreAllocGrp leg_pre_alloc_grp = 21;
 * @return {!Array<!proto.Common.LegPreAllocGrp>}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegPreAllocGrpList = function() {
  return /** @type{!Array<!proto.Common.LegPreAllocGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LegPreAllocGrp, 21));
};


/**
 * @param {!Array<!proto.Common.LegPreAllocGrp>} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegPreAllocGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 21, value);
};


/**
 * @param {!proto.Common.LegPreAllocGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegPreAllocGrp}
 */
proto.Common.InstrmtLegExecGrp.prototype.addLegPreAllocGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.Common.LegPreAllocGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegPreAllocGrpList = function() {
  return this.setLegPreAllocGrpList([]);
};


/**
 * optional fix.Decimal64 leg_volatility = 22;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtLegExecGrp.prototype.getLegVolatility = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 22));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setLegVolatility = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearLegVolatility = function() {
  return this.setLegVolatility(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegExecGrp.prototype.hasLegVolatility = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * repeated NestedParties3 nested_parties3 = 23;
 * @return {!Array<!proto.Common.NestedParties3>}
 */
proto.Common.InstrmtLegExecGrp.prototype.getNestedParties3List = function() {
  return /** @type{!Array<!proto.Common.NestedParties3>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties3, 23));
};


/**
 * @param {!Array<!proto.Common.NestedParties3>} value
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
*/
proto.Common.InstrmtLegExecGrp.prototype.setNestedParties3List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 23, value);
};


/**
 * @param {!proto.Common.NestedParties3=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties3}
 */
proto.Common.InstrmtLegExecGrp.prototype.addNestedParties3 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.Common.NestedParties3, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegExecGrp} returns this
 */
proto.Common.InstrmtLegExecGrp.prototype.clearNestedParties3List = function() {
  return this.setNestedParties3List([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtLegGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtLegGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtLegGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentLeg: (f = msg.getInstrumentLeg()) && proto.Common.InstrumentLeg.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.Common.InstrmtLegGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtLegGrp;
  return proto.Common.InstrmtLegGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtLegGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.Common.InstrmtLegGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.InstrumentLeg;
      reader.readMessage(value,proto.Common.InstrumentLeg.deserializeBinaryFromReader);
      msg.setInstrumentLeg(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtLegGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtLegGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtLegGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentLeg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.InstrumentLeg.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstrumentLeg instrument_leg = 1;
 * @return {?proto.Common.InstrumentLeg}
 */
proto.Common.InstrmtLegGrp.prototype.getInstrumentLeg = function() {
  return /** @type{?proto.Common.InstrumentLeg} */ (
    jspb.Message.getWrapperField(this, proto.Common.InstrumentLeg, 1));
};


/**
 * @param {?proto.Common.InstrumentLeg|undefined} value
 * @return {!proto.Common.InstrmtLegGrp} returns this
*/
proto.Common.InstrmtLegGrp.prototype.setInstrumentLeg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegGrp} returns this
 */
proto.Common.InstrmtLegGrp.prototype.clearInstrumentLeg = function() {
  return this.setInstrumentLeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegGrp.prototype.hasInstrumentLeg = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrmtLegIOIGrp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtLegIOIGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtLegIOIGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtLegIOIGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegIOIGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentLeg: (f = msg.getInstrumentLeg()) && proto.Common.InstrumentLeg.toObject(includeInstance, f),
    legIoiQty: jspb.Message.getFieldWithDefault(msg, 2, 0),
    legStipulationsList: jspb.Message.toObjectList(msg.getLegStipulationsList(),
    proto.Common.LegStipulations.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtLegIOIGrp}
 */
proto.Common.InstrmtLegIOIGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtLegIOIGrp;
  return proto.Common.InstrmtLegIOIGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtLegIOIGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtLegIOIGrp}
 */
proto.Common.InstrmtLegIOIGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.InstrumentLeg;
      reader.readMessage(value,proto.Common.InstrumentLeg.deserializeBinaryFromReader);
      msg.setInstrumentLeg(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.LegIOIQtyEnum} */ (reader.readEnum());
      msg.setLegIoiQty(value);
      break;
    case 3:
      var value = new proto.Common.LegStipulations;
      reader.readMessage(value,proto.Common.LegStipulations.deserializeBinaryFromReader);
      msg.addLegStipulations(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtLegIOIGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtLegIOIGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtLegIOIGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegIOIGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentLeg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.InstrumentLeg.serializeBinaryToWriter
    );
  }
  f = message.getLegIoiQty();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLegStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.LegStipulations.serializeBinaryToWriter
    );
  }
};


/**
 * optional InstrumentLeg instrument_leg = 1;
 * @return {?proto.Common.InstrumentLeg}
 */
proto.Common.InstrmtLegIOIGrp.prototype.getInstrumentLeg = function() {
  return /** @type{?proto.Common.InstrumentLeg} */ (
    jspb.Message.getWrapperField(this, proto.Common.InstrumentLeg, 1));
};


/**
 * @param {?proto.Common.InstrumentLeg|undefined} value
 * @return {!proto.Common.InstrmtLegIOIGrp} returns this
*/
proto.Common.InstrmtLegIOIGrp.prototype.setInstrumentLeg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegIOIGrp} returns this
 */
proto.Common.InstrmtLegIOIGrp.prototype.clearInstrumentLeg = function() {
  return this.setInstrumentLeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegIOIGrp.prototype.hasInstrumentLeg = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LegIOIQtyEnum leg_ioi_qty = 2;
 * @return {!proto.Common.LegIOIQtyEnum}
 */
proto.Common.InstrmtLegIOIGrp.prototype.getLegIoiQty = function() {
  return /** @type {!proto.Common.LegIOIQtyEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.LegIOIQtyEnum} value
 * @return {!proto.Common.InstrmtLegIOIGrp} returns this
 */
proto.Common.InstrmtLegIOIGrp.prototype.setLegIoiQty = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated LegStipulations leg_stipulations = 3;
 * @return {!Array<!proto.Common.LegStipulations>}
 */
proto.Common.InstrmtLegIOIGrp.prototype.getLegStipulationsList = function() {
  return /** @type{!Array<!proto.Common.LegStipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LegStipulations, 3));
};


/**
 * @param {!Array<!proto.Common.LegStipulations>} value
 * @return {!proto.Common.InstrmtLegIOIGrp} returns this
*/
proto.Common.InstrmtLegIOIGrp.prototype.setLegStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.LegStipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegStipulations}
 */
proto.Common.InstrmtLegIOIGrp.prototype.addLegStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.LegStipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegIOIGrp} returns this
 */
proto.Common.InstrmtLegIOIGrp.prototype.clearLegStipulationsList = function() {
  return this.setLegStipulationsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrmtLegSecListGrp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtLegSecListGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtLegSecListGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtLegSecListGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegSecListGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentLeg: (f = msg.getInstrumentLeg()) && proto.Common.InstrumentLeg.toObject(includeInstance, f),
    legBenchmarkCurveData: (f = msg.getLegBenchmarkCurveData()) && proto.Common.LegBenchmarkCurveData.toObject(includeInstance, f),
    legSettlType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    legStipulationsList: jspb.Message.toObjectList(msg.getLegStipulationsList(),
    proto.Common.LegStipulations.toObject, includeInstance),
    legSwapType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtLegSecListGrp}
 */
proto.Common.InstrmtLegSecListGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtLegSecListGrp;
  return proto.Common.InstrmtLegSecListGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtLegSecListGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtLegSecListGrp}
 */
proto.Common.InstrmtLegSecListGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.InstrumentLeg;
      reader.readMessage(value,proto.Common.InstrumentLeg.deserializeBinaryFromReader);
      msg.setInstrumentLeg(value);
      break;
    case 2:
      var value = new proto.Common.LegBenchmarkCurveData;
      reader.readMessage(value,proto.Common.LegBenchmarkCurveData.deserializeBinaryFromReader);
      msg.setLegBenchmarkCurveData(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.LegSettlTypeEnum} */ (reader.readEnum());
      msg.setLegSettlType(value);
      break;
    case 4:
      var value = new proto.Common.LegStipulations;
      reader.readMessage(value,proto.Common.LegStipulations.deserializeBinaryFromReader);
      msg.addLegStipulations(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.LegSwapTypeEnum} */ (reader.readEnum());
      msg.setLegSwapType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtLegSecListGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtLegSecListGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtLegSecListGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtLegSecListGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentLeg();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.InstrumentLeg.serializeBinaryToWriter
    );
  }
  f = message.getLegBenchmarkCurveData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.Common.LegBenchmarkCurveData.serializeBinaryToWriter
    );
  }
  f = message.getLegSettlType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getLegStipulationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.LegStipulations.serializeBinaryToWriter
    );
  }
  f = message.getLegSwapType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional InstrumentLeg instrument_leg = 1;
 * @return {?proto.Common.InstrumentLeg}
 */
proto.Common.InstrmtLegSecListGrp.prototype.getInstrumentLeg = function() {
  return /** @type{?proto.Common.InstrumentLeg} */ (
    jspb.Message.getWrapperField(this, proto.Common.InstrumentLeg, 1));
};


/**
 * @param {?proto.Common.InstrumentLeg|undefined} value
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
*/
proto.Common.InstrmtLegSecListGrp.prototype.setInstrumentLeg = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
 */
proto.Common.InstrmtLegSecListGrp.prototype.clearInstrumentLeg = function() {
  return this.setInstrumentLeg(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegSecListGrp.prototype.hasInstrumentLeg = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional LegBenchmarkCurveData leg_benchmark_curve_data = 2;
 * @return {?proto.Common.LegBenchmarkCurveData}
 */
proto.Common.InstrmtLegSecListGrp.prototype.getLegBenchmarkCurveData = function() {
  return /** @type{?proto.Common.LegBenchmarkCurveData} */ (
    jspb.Message.getWrapperField(this, proto.Common.LegBenchmarkCurveData, 2));
};


/**
 * @param {?proto.Common.LegBenchmarkCurveData|undefined} value
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
*/
proto.Common.InstrmtLegSecListGrp.prototype.setLegBenchmarkCurveData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
 */
proto.Common.InstrmtLegSecListGrp.prototype.clearLegBenchmarkCurveData = function() {
  return this.setLegBenchmarkCurveData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtLegSecListGrp.prototype.hasLegBenchmarkCurveData = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional LegSettlTypeEnum leg_settl_type = 3;
 * @return {!proto.Common.LegSettlTypeEnum}
 */
proto.Common.InstrmtLegSecListGrp.prototype.getLegSettlType = function() {
  return /** @type {!proto.Common.LegSettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.LegSettlTypeEnum} value
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
 */
proto.Common.InstrmtLegSecListGrp.prototype.setLegSettlType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated LegStipulations leg_stipulations = 4;
 * @return {!Array<!proto.Common.LegStipulations>}
 */
proto.Common.InstrmtLegSecListGrp.prototype.getLegStipulationsList = function() {
  return /** @type{!Array<!proto.Common.LegStipulations>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LegStipulations, 4));
};


/**
 * @param {!Array<!proto.Common.LegStipulations>} value
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
*/
proto.Common.InstrmtLegSecListGrp.prototype.setLegStipulationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.LegStipulations=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LegStipulations}
 */
proto.Common.InstrmtLegSecListGrp.prototype.addLegStipulations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.LegStipulations, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
 */
proto.Common.InstrmtLegSecListGrp.prototype.clearLegStipulationsList = function() {
  return this.setLegStipulationsList([]);
};


/**
 * optional LegSwapTypeEnum leg_swap_type = 5;
 * @return {!proto.Common.LegSwapTypeEnum}
 */
proto.Common.InstrmtLegSecListGrp.prototype.getLegSwapType = function() {
  return /** @type {!proto.Common.LegSwapTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.LegSwapTypeEnum} value
 * @return {!proto.Common.InstrmtLegSecListGrp} returns this
 */
proto.Common.InstrmtLegSecListGrp.prototype.setLegSwapType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrmtMDReqGrp.repeatedFields_ = [2,9];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.InstrmtMDReqGrp.oneofGroups_ = [[7,8]];

/**
 * @enum {number}
 */
proto.Common.InstrmtMDReqGrp.SettlTypeUnionCase = {
  SETTL_TYPE_UNION_NOT_SET: 0,
  SETTL_TYPE: 7,
  SETTL_TYPE_TENOR: 8
};

/**
 * @return {proto.Common.InstrmtMDReqGrp.SettlTypeUnionCase}
 */
proto.Common.InstrmtMDReqGrp.prototype.getSettlTypeUnionCase = function() {
  return /** @type {proto.Common.InstrmtMDReqGrp.SettlTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.InstrmtMDReqGrp.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrmtMDReqGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrmtMDReqGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrmtMDReqGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtMDReqGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    currency: jspb.Message.getFieldWithDefault(msg, 1, ""),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    proto.Common.InstrmtLegGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && proto.Common.Instrument.toObject(includeInstance, f),
    mdEntrySize: (f = msg.getMdEntrySize()) && fix_pb.Decimal64.toObject(includeInstance, f),
    quoteType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    settlDate: jspb.Message.getFieldWithDefault(msg, 6, 0),
    settlType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    settlTypeTenor: (f = msg.getSettlTypeTenor()) && fix_pb.Tenor.toObject(includeInstance, f),
    undInstrmtGrpList: jspb.Message.toObjectList(msg.getUndInstrmtGrpList(),
    proto.Common.UndInstrmtGrp.toObject, includeInstance),
    mdStreamId: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrmtMDReqGrp}
 */
proto.Common.InstrmtMDReqGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrmtMDReqGrp;
  return proto.Common.InstrmtMDReqGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrmtMDReqGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrmtMDReqGrp}
 */
proto.Common.InstrmtMDReqGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 2:
      var value = new proto.Common.InstrmtLegGrp;
      reader.readMessage(value,proto.Common.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 3:
      var value = new proto.Common.Instrument;
      reader.readMessage(value,proto.Common.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMdEntrySize(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.QuoteTypeEnum} */ (reader.readEnum());
      msg.setQuoteType(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setSettlDate(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.SettlTypeEnum} */ (reader.readEnum());
      msg.setSettlType(value);
      break;
    case 8:
      var value = new fix_pb.Tenor;
      reader.readMessage(value,fix_pb.Tenor.deserializeBinaryFromReader);
      msg.setSettlTypeTenor(value);
      break;
    case 9:
      var value = new proto.Common.UndInstrmtGrp;
      reader.readMessage(value,proto.Common.UndInstrmtGrp.deserializeBinaryFromReader);
      msg.addUndInstrmtGrp(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMdStreamId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrmtMDReqGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrmtMDReqGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrmtMDReqGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrmtMDReqGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Common.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getMdEntrySize();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getQuoteType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getSettlDate();
  if (f !== 0) {
    writer.writeSfixed32(
      6,
      f
    );
  }
  f = /** @type {!proto.Common.SettlTypeEnum} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getSettlTypeTenor();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Tenor.serializeBinaryToWriter
    );
  }
  f = message.getUndInstrmtGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.Common.UndInstrmtGrp.serializeBinaryToWriter
    );
  }
  f = message.getMdStreamId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string currency = 1;
 * @return {string}
 */
proto.Common.InstrmtMDReqGrp.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated InstrmtLegGrp instrmt_leg_grp = 2;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.Common.InstrmtMDReqGrp.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.InstrmtLegGrp, 2));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
*/
proto.Common.InstrmtMDReqGrp.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.Common.InstrmtMDReqGrp.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Instrument instrument = 3;
 * @return {?proto.Common.Instrument}
 */
proto.Common.InstrmtMDReqGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, proto.Common.Instrument, 3));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
*/
proto.Common.InstrmtMDReqGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtMDReqGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Decimal64 md_entry_size = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.InstrmtMDReqGrp.prototype.getMdEntrySize = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
*/
proto.Common.InstrmtMDReqGrp.prototype.setMdEntrySize = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearMdEntrySize = function() {
  return this.setMdEntrySize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtMDReqGrp.prototype.hasMdEntrySize = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional QuoteTypeEnum quote_type = 5;
 * @return {!proto.Common.QuoteTypeEnum}
 */
proto.Common.InstrmtMDReqGrp.prototype.getQuoteType = function() {
  return /** @type {!proto.Common.QuoteTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.QuoteTypeEnum} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.setQuoteType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional sfixed32 settl_date = 6;
 * @return {number}
 */
proto.Common.InstrmtMDReqGrp.prototype.getSettlDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.setSettlDate = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional SettlTypeEnum settl_type = 7;
 * @return {!proto.Common.SettlTypeEnum}
 */
proto.Common.InstrmtMDReqGrp.prototype.getSettlType = function() {
  return /** @type {!proto.Common.SettlTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.SettlTypeEnum} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.setSettlType = function(value) {
  return jspb.Message.setOneofField(this, 7, proto.Common.InstrmtMDReqGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearSettlType = function() {
  return jspb.Message.setOneofField(this, 7, proto.Common.InstrmtMDReqGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtMDReqGrp.prototype.hasSettlType = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fix.Tenor settl_type_tenor = 8;
 * @return {?proto.fix.Tenor}
 */
proto.Common.InstrmtMDReqGrp.prototype.getSettlTypeTenor = function() {
  return /** @type{?proto.fix.Tenor} */ (
    jspb.Message.getWrapperField(this, fix_pb.Tenor, 8));
};


/**
 * @param {?proto.fix.Tenor|undefined} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
*/
proto.Common.InstrmtMDReqGrp.prototype.setSettlTypeTenor = function(value) {
  return jspb.Message.setOneofWrapperField(this, 8, proto.Common.InstrmtMDReqGrp.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearSettlTypeTenor = function() {
  return this.setSettlTypeTenor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.InstrmtMDReqGrp.prototype.hasSettlTypeTenor = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * repeated UndInstrmtGrp und_instrmt_grp = 9;
 * @return {!Array<!proto.Common.UndInstrmtGrp>}
 */
proto.Common.InstrmtMDReqGrp.prototype.getUndInstrmtGrpList = function() {
  return /** @type{!Array<!proto.Common.UndInstrmtGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.UndInstrmtGrp, 9));
};


/**
 * @param {!Array<!proto.Common.UndInstrmtGrp>} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
*/
proto.Common.InstrmtMDReqGrp.prototype.setUndInstrmtGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.Common.UndInstrmtGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.Common.InstrmtMDReqGrp.prototype.addUndInstrmtGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.Common.UndInstrmtGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.clearUndInstrmtGrpList = function() {
  return this.setUndInstrmtGrpList([]);
};


/**
 * optional string md_stream_id = 10;
 * @return {string}
 */
proto.Common.InstrmtMDReqGrp.prototype.getMdStreamId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrmtMDReqGrp} returns this
 */
proto.Common.InstrmtMDReqGrp.prototype.setMdStreamId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.LegPreAllocGrp.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LegPreAllocGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LegPreAllocGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LegPreAllocGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegPreAllocGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    legAllocAccount: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legAllocAcctIdSource: jspb.Message.getFieldWithDefault(msg, 2, ""),
    legAllocQty: (f = msg.getLegAllocQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    legIndividualAllocId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    nestedParties2List: jspb.Message.toObjectList(msg.getNestedParties2List(),
    proto.Common.NestedParties2.toObject, includeInstance),
    legAllocSettlCurrency: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LegPreAllocGrp}
 */
proto.Common.LegPreAllocGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LegPreAllocGrp;
  return proto.Common.LegPreAllocGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LegPreAllocGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LegPreAllocGrp}
 */
proto.Common.LegPreAllocGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegAllocAccount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegAllocAcctIdSource(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLegAllocQty(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegIndividualAllocId(value);
      break;
    case 5:
      var value = new proto.Common.NestedParties2;
      reader.readMessage(value,proto.Common.NestedParties2.deserializeBinaryFromReader);
      msg.addNestedParties2(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegAllocSettlCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LegPreAllocGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LegPreAllocGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LegPreAllocGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegPreAllocGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegAllocAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegAllocAcctIdSource();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLegAllocQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLegIndividualAllocId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getNestedParties2List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.Common.NestedParties2.serializeBinaryToWriter
    );
  }
  f = message.getLegAllocSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string leg_alloc_account = 1;
 * @return {string}
 */
proto.Common.LegPreAllocGrp.prototype.getLegAllocAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.setLegAllocAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string leg_alloc_acct_id_source = 2;
 * @return {string}
 */
proto.Common.LegPreAllocGrp.prototype.getLegAllocAcctIdSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.setLegAllocAcctIdSource = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional fix.Decimal64 leg_alloc_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.LegPreAllocGrp.prototype.getLegAllocQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
*/
proto.Common.LegPreAllocGrp.prototype.setLegAllocQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.clearLegAllocQty = function() {
  return this.setLegAllocQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.LegPreAllocGrp.prototype.hasLegAllocQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string leg_individual_alloc_id = 4;
 * @return {string}
 */
proto.Common.LegPreAllocGrp.prototype.getLegIndividualAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.setLegIndividualAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated NestedParties2 nested_parties2 = 5;
 * @return {!Array<!proto.Common.NestedParties2>}
 */
proto.Common.LegPreAllocGrp.prototype.getNestedParties2List = function() {
  return /** @type{!Array<!proto.Common.NestedParties2>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties2, 5));
};


/**
 * @param {!Array<!proto.Common.NestedParties2>} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
*/
proto.Common.LegPreAllocGrp.prototype.setNestedParties2List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Common.NestedParties2=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties2}
 */
proto.Common.LegPreAllocGrp.prototype.addNestedParties2 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Common.NestedParties2, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.clearNestedParties2List = function() {
  return this.setNestedParties2List([]);
};


/**
 * optional string leg_alloc_settl_currency = 6;
 * @return {string}
 */
proto.Common.LegPreAllocGrp.prototype.getLegAllocSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegPreAllocGrp} returns this
 */
proto.Common.LegPreAllocGrp.prototype.setLegAllocSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LinesOfTextGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LinesOfTextGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LinesOfTextGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LinesOfTextGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    text: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LinesOfTextGrp}
 */
proto.Common.LinesOfTextGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LinesOfTextGrp;
  return proto.Common.LinesOfTextGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LinesOfTextGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LinesOfTextGrp}
 */
proto.Common.LinesOfTextGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LinesOfTextGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LinesOfTextGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LinesOfTextGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LinesOfTextGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string encoded_text = 1;
 * @return {string}
 */
proto.Common.LinesOfTextGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LinesOfTextGrp} returns this
 */
proto.Common.LinesOfTextGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_text_len = 2;
 * @return {number}
 */
proto.Common.LinesOfTextGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.LinesOfTextGrp} returns this
 */
proto.Common.LinesOfTextGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string text = 3;
 * @return {string}
 */
proto.Common.LinesOfTextGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LinesOfTextGrp} returns this
 */
proto.Common.LinesOfTextGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MiscFeesGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MiscFeesGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MiscFeesGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MiscFeesGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    miscFeeAmt: (f = msg.getMiscFeeAmt()) && fix_pb.Decimal64.toObject(includeInstance, f),
    miscFeeBasis: jspb.Message.getFieldWithDefault(msg, 2, 0),
    miscFeeCurr: jspb.Message.getFieldWithDefault(msg, 3, ""),
    miscFeeType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MiscFeesGrp}
 */
proto.Common.MiscFeesGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MiscFeesGrp;
  return proto.Common.MiscFeesGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MiscFeesGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MiscFeesGrp}
 */
proto.Common.MiscFeesGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMiscFeeAmt(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.MiscFeeBasisEnum} */ (reader.readEnum());
      msg.setMiscFeeBasis(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMiscFeeCurr(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.MiscFeeTypeEnum} */ (reader.readEnum());
      msg.setMiscFeeType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MiscFeesGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MiscFeesGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MiscFeesGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MiscFeesGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMiscFeeAmt();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMiscFeeBasis();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMiscFeeCurr();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getMiscFeeType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional fix.Decimal64 misc_fee_amt = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.MiscFeesGrp.prototype.getMiscFeeAmt = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.MiscFeesGrp} returns this
*/
proto.Common.MiscFeesGrp.prototype.setMiscFeeAmt = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.MiscFeesGrp} returns this
 */
proto.Common.MiscFeesGrp.prototype.clearMiscFeeAmt = function() {
  return this.setMiscFeeAmt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.MiscFeesGrp.prototype.hasMiscFeeAmt = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional MiscFeeBasisEnum misc_fee_basis = 2;
 * @return {!proto.Common.MiscFeeBasisEnum}
 */
proto.Common.MiscFeesGrp.prototype.getMiscFeeBasis = function() {
  return /** @type {!proto.Common.MiscFeeBasisEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.MiscFeeBasisEnum} value
 * @return {!proto.Common.MiscFeesGrp} returns this
 */
proto.Common.MiscFeesGrp.prototype.setMiscFeeBasis = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string misc_fee_curr = 3;
 * @return {string}
 */
proto.Common.MiscFeesGrp.prototype.getMiscFeeCurr = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MiscFeesGrp} returns this
 */
proto.Common.MiscFeesGrp.prototype.setMiscFeeCurr = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional MiscFeeTypeEnum misc_fee_type = 4;
 * @return {!proto.Common.MiscFeeTypeEnum}
 */
proto.Common.MiscFeesGrp.prototype.getMiscFeeType = function() {
  return /** @type {!proto.Common.MiscFeeTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.MiscFeeTypeEnum} value
 * @return {!proto.Common.MiscFeesGrp} returns this
 */
proto.Common.MiscFeesGrp.prototype.setMiscFeeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.OrdAllocGrp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.OrdAllocGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.OrdAllocGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.OrdAllocGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrdAllocGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    clOrdId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    listId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    nestedParties2List: jspb.Message.toObjectList(msg.getNestedParties2List(),
    proto.Common.NestedParties2.toObject, includeInstance),
    orderAvgPx: (f = msg.getOrderAvgPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderBookingQty: (f = msg.getOrderBookingQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    orderQty: (f = msg.getOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    secondaryClOrdId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    secondaryOrderId: jspb.Message.getFieldWithDefault(msg, 9, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.OrdAllocGrp}
 */
proto.Common.OrdAllocGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.OrdAllocGrp;
  return proto.Common.OrdAllocGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.OrdAllocGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.OrdAllocGrp}
 */
proto.Common.OrdAllocGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setClOrdId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setListId(value);
      break;
    case 3:
      var value = new proto.Common.NestedParties2;
      reader.readMessage(value,proto.Common.NestedParties2.deserializeBinaryFromReader);
      msg.addNestedParties2(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderAvgPx(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderBookingQty(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryClOrdId(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrderId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.OrdAllocGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.OrdAllocGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.OrdAllocGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrdAllocGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getListId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getNestedParties2List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.NestedParties2.serializeBinaryToWriter
    );
  }
  f = message.getOrderAvgPx();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderBookingQty();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrderQty();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryClOrdId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSecondaryOrderId();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
};


/**
 * optional string cl_ord_id = 1;
 * @return {string}
 */
proto.Common.OrdAllocGrp.prototype.getClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.setClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string list_id = 2;
 * @return {string}
 */
proto.Common.OrdAllocGrp.prototype.getListId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.setListId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated NestedParties2 nested_parties2 = 3;
 * @return {!Array<!proto.Common.NestedParties2>}
 */
proto.Common.OrdAllocGrp.prototype.getNestedParties2List = function() {
  return /** @type{!Array<!proto.Common.NestedParties2>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties2, 3));
};


/**
 * @param {!Array<!proto.Common.NestedParties2>} value
 * @return {!proto.Common.OrdAllocGrp} returns this
*/
proto.Common.OrdAllocGrp.prototype.setNestedParties2List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.NestedParties2=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties2}
 */
proto.Common.OrdAllocGrp.prototype.addNestedParties2 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.NestedParties2, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.clearNestedParties2List = function() {
  return this.setNestedParties2List([]);
};


/**
 * optional fix.Decimal64 order_avg_px = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrdAllocGrp.prototype.getOrderAvgPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrdAllocGrp} returns this
*/
proto.Common.OrdAllocGrp.prototype.setOrderAvgPx = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.clearOrderAvgPx = function() {
  return this.setOrderAvgPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrdAllocGrp.prototype.hasOrderAvgPx = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 order_booking_qty = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrdAllocGrp.prototype.getOrderBookingQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrdAllocGrp} returns this
*/
proto.Common.OrdAllocGrp.prototype.setOrderBookingQty = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.clearOrderBookingQty = function() {
  return this.setOrderBookingQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrdAllocGrp.prototype.hasOrderBookingQty = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string order_id = 6;
 * @return {string}
 */
proto.Common.OrdAllocGrp.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional fix.Decimal64 order_qty = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.OrdAllocGrp.prototype.getOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.OrdAllocGrp} returns this
*/
proto.Common.OrdAllocGrp.prototype.setOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.clearOrderQty = function() {
  return this.setOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.OrdAllocGrp.prototype.hasOrderQty = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional string secondary_cl_ord_id = 8;
 * @return {string}
 */
proto.Common.OrdAllocGrp.prototype.getSecondaryClOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.setSecondaryClOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string secondary_order_id = 9;
 * @return {string}
 */
proto.Common.OrdAllocGrp.prototype.getSecondaryOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.OrdAllocGrp} returns this
 */
proto.Common.OrdAllocGrp.prototype.setSecondaryOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.PreAllocGrp.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PreAllocGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PreAllocGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PreAllocGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PreAllocGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    allocAccount: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allocAcctIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    allocQty: (f = msg.getAllocQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    allocSettlCurrency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    individualAllocId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    nestedPartiesList: jspb.Message.toObjectList(msg.getNestedPartiesList(),
    proto.Common.NestedParties.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PreAllocGrp}
 */
proto.Common.PreAllocGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PreAllocGrp;
  return proto.Common.PreAllocGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PreAllocGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PreAllocGrp}
 */
proto.Common.PreAllocGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocAccount(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.AllocAcctIDSourceEnum} */ (reader.readEnum());
      msg.setAllocAcctIdSource(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAllocQty(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocSettlCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndividualAllocId(value);
      break;
    case 6:
      var value = new proto.Common.NestedParties;
      reader.readMessage(value,proto.Common.NestedParties.deserializeBinaryFromReader);
      msg.addNestedParties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PreAllocGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PreAllocGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PreAllocGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PreAllocGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllocAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllocAcctIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAllocQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getAllocSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIndividualAllocId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNestedPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.Common.NestedParties.serializeBinaryToWriter
    );
  }
};


/**
 * optional string alloc_account = 1;
 * @return {string}
 */
proto.Common.PreAllocGrp.prototype.getAllocAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.setAllocAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AllocAcctIDSourceEnum alloc_acct_id_source = 2;
 * @return {!proto.Common.AllocAcctIDSourceEnum}
 */
proto.Common.PreAllocGrp.prototype.getAllocAcctIdSource = function() {
  return /** @type {!proto.Common.AllocAcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.AllocAcctIDSourceEnum} value
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.setAllocAcctIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 alloc_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PreAllocGrp.prototype.getAllocQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PreAllocGrp} returns this
*/
proto.Common.PreAllocGrp.prototype.setAllocQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.clearAllocQty = function() {
  return this.setAllocQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PreAllocGrp.prototype.hasAllocQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string alloc_settl_currency = 4;
 * @return {string}
 */
proto.Common.PreAllocGrp.prototype.getAllocSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.setAllocSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string individual_alloc_id = 5;
 * @return {string}
 */
proto.Common.PreAllocGrp.prototype.getIndividualAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.setIndividualAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated NestedParties nested_parties = 6;
 * @return {!Array<!proto.Common.NestedParties>}
 */
proto.Common.PreAllocGrp.prototype.getNestedPartiesList = function() {
  return /** @type{!Array<!proto.Common.NestedParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties, 6));
};


/**
 * @param {!Array<!proto.Common.NestedParties>} value
 * @return {!proto.Common.PreAllocGrp} returns this
*/
proto.Common.PreAllocGrp.prototype.setNestedPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Common.NestedParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties}
 */
proto.Common.PreAllocGrp.prototype.addNestedParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Common.NestedParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.PreAllocGrp} returns this
 */
proto.Common.PreAllocGrp.prototype.clearNestedPartiesList = function() {
  return this.setNestedPartiesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.PreAllocMlegGrp.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PreAllocMlegGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PreAllocMlegGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PreAllocMlegGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PreAllocMlegGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    allocAccount: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allocAcctIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    allocQty: (f = msg.getAllocQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    allocSettlCurrency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    individualAllocId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    nestedParties3List: jspb.Message.toObjectList(msg.getNestedParties3List(),
    proto.Common.NestedParties3.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PreAllocMlegGrp}
 */
proto.Common.PreAllocMlegGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PreAllocMlegGrp;
  return proto.Common.PreAllocMlegGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PreAllocMlegGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PreAllocMlegGrp}
 */
proto.Common.PreAllocMlegGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocAccount(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.AllocAcctIDSourceEnum} */ (reader.readEnum());
      msg.setAllocAcctIdSource(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAllocQty(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocSettlCurrency(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setIndividualAllocId(value);
      break;
    case 6:
      var value = new proto.Common.NestedParties3;
      reader.readMessage(value,proto.Common.NestedParties3.deserializeBinaryFromReader);
      msg.addNestedParties3(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PreAllocMlegGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PreAllocMlegGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PreAllocMlegGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PreAllocMlegGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAllocAccount();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllocAcctIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getAllocQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getAllocSettlCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getIndividualAllocId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getNestedParties3List();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.Common.NestedParties3.serializeBinaryToWriter
    );
  }
};


/**
 * optional string alloc_account = 1;
 * @return {string}
 */
proto.Common.PreAllocMlegGrp.prototype.getAllocAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.setAllocAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional AllocAcctIDSourceEnum alloc_acct_id_source = 2;
 * @return {!proto.Common.AllocAcctIDSourceEnum}
 */
proto.Common.PreAllocMlegGrp.prototype.getAllocAcctIdSource = function() {
  return /** @type {!proto.Common.AllocAcctIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.AllocAcctIDSourceEnum} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.setAllocAcctIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 alloc_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PreAllocMlegGrp.prototype.getAllocQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
*/
proto.Common.PreAllocMlegGrp.prototype.setAllocQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.clearAllocQty = function() {
  return this.setAllocQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PreAllocMlegGrp.prototype.hasAllocQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string alloc_settl_currency = 4;
 * @return {string}
 */
proto.Common.PreAllocMlegGrp.prototype.getAllocSettlCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.setAllocSettlCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string individual_alloc_id = 5;
 * @return {string}
 */
proto.Common.PreAllocMlegGrp.prototype.getIndividualAllocId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.setIndividualAllocId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated NestedParties3 nested_parties3 = 6;
 * @return {!Array<!proto.Common.NestedParties3>}
 */
proto.Common.PreAllocMlegGrp.prototype.getNestedParties3List = function() {
  return /** @type{!Array<!proto.Common.NestedParties3>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedParties3, 6));
};


/**
 * @param {!Array<!proto.Common.NestedParties3>} value
 * @return {!proto.Common.PreAllocMlegGrp} returns this
*/
proto.Common.PreAllocMlegGrp.prototype.setNestedParties3List = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Common.NestedParties3=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedParties3}
 */
proto.Common.PreAllocMlegGrp.prototype.addNestedParties3 = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Common.NestedParties3, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.PreAllocMlegGrp} returns this
 */
proto.Common.PreAllocMlegGrp.prototype.clearNestedParties3List = function() {
  return this.setNestedParties3List([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.RoutingGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.RoutingGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.RoutingGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RoutingGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    routingId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    routingType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.RoutingGrp}
 */
proto.Common.RoutingGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.RoutingGrp;
  return proto.Common.RoutingGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.RoutingGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.RoutingGrp}
 */
proto.Common.RoutingGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoutingId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.RoutingTypeEnum} */ (reader.readEnum());
      msg.setRoutingType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.RoutingGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.RoutingGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.RoutingGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RoutingGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoutingId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoutingType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string routing_id = 1;
 * @return {string}
 */
proto.Common.RoutingGrp.prototype.getRoutingId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RoutingGrp} returns this
 */
proto.Common.RoutingGrp.prototype.setRoutingId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RoutingTypeEnum routing_type = 2;
 * @return {!proto.Common.RoutingTypeEnum}
 */
proto.Common.RoutingGrp.prototype.getRoutingType = function() {
  return /** @type {!proto.Common.RoutingTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.RoutingTypeEnum} value
 * @return {!proto.Common.RoutingGrp} returns this
 */
proto.Common.RoutingGrp.prototype.setRoutingType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.TrdgSesGrp.oneofGroups_ = [[1,2],[3,4]];

/**
 * @enum {number}
 */
proto.Common.TrdgSesGrp.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 1,
  TRADING_SESSION_ID_RESERVED100PLUS: 2
};

/**
 * @return {proto.Common.TrdgSesGrp.TradingSessionIdUnionCase}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.Common.TrdgSesGrp.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdgSesGrp.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.Common.TrdgSesGrp.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 3,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 4
};

/**
 * @return {proto.Common.TrdgSesGrp.TradingSessionSubIdUnionCase}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.Common.TrdgSesGrp.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdgSesGrp.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TrdgSesGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TrdgSesGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TrdgSesGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdgSesGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 3, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TrdgSesGrp}
 */
proto.Common.TrdgSesGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TrdgSesGrp;
  return proto.Common.TrdgSesGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TrdgSesGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TrdgSesGrp}
 */
proto.Common.TrdgSesGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TrdgSesGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TrdgSesGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TrdgSesGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdgSesGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFixed32(
      2,
      f
    );
  }
  f = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFixed32(
      4,
      f
    );
  }
};


/**
 * optional TradingSessionIDEnum trading_session_id = 1;
 * @return {!proto.Common.TradingSessionIDEnum}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionId = function() {
  return /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.TradingSessionIDEnum} value
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.Common.TrdgSesGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 1, proto.Common.TrdgSesGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdgSesGrp.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 2;
 * @return {number}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.Common.TrdgSesGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 2, proto.Common.TrdgSesGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdgSesGrp.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 3;
 * @return {!proto.Common.TradingSessionSubIDEnum}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.TradingSessionSubIDEnum} value
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.Common.TrdgSesGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 3, proto.Common.TrdgSesGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdgSesGrp.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 4;
 * @return {number}
 */
proto.Common.TrdgSesGrp.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.Common.TrdgSesGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdgSesGrp} returns this
 */
proto.Common.TrdgSesGrp.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 4, proto.Common.TrdgSesGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdgSesGrp.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UndInstrmtGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UndInstrmtGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UndInstrmtGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndInstrmtGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingInstrument: (f = msg.getUnderlyingInstrument()) && proto.Common.UnderlyingInstrument.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.Common.UndInstrmtGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UndInstrmtGrp;
  return proto.Common.UndInstrmtGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UndInstrmtGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UndInstrmtGrp}
 */
proto.Common.UndInstrmtGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.UnderlyingInstrument;
      reader.readMessage(value,proto.Common.UnderlyingInstrument.deserializeBinaryFromReader);
      msg.setUnderlyingInstrument(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UndInstrmtGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UndInstrmtGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UndInstrmtGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndInstrmtGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingInstrument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.UnderlyingInstrument.serializeBinaryToWriter
    );
  }
};


/**
 * optional UnderlyingInstrument underlying_instrument = 1;
 * @return {?proto.Common.UnderlyingInstrument}
 */
proto.Common.UndInstrmtGrp.prototype.getUnderlyingInstrument = function() {
  return /** @type{?proto.Common.UnderlyingInstrument} */ (
    jspb.Message.getWrapperField(this, proto.Common.UnderlyingInstrument, 1));
};


/**
 * @param {?proto.Common.UnderlyingInstrument|undefined} value
 * @return {!proto.Common.UndInstrmtGrp} returns this
*/
proto.Common.UndInstrmtGrp.prototype.setUnderlyingInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.UndInstrmtGrp} returns this
 */
proto.Common.UndInstrmtGrp.prototype.clearUnderlyingInstrument = function() {
  return this.setUnderlyingInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.UndInstrmtGrp.prototype.hasUnderlyingInstrument = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.EvntGrp.oneofGroups_ = [[4,5]];

/**
 * @enum {number}
 */
proto.Common.EvntGrp.EventTypeUnionCase = {
  EVENT_TYPE_UNION_NOT_SET: 0,
  EVENT_TYPE: 4,
  EVENT_TYPE_RESERVED100PLUS: 5
};

/**
 * @return {proto.Common.EvntGrp.EventTypeUnionCase}
 */
proto.Common.EvntGrp.prototype.getEventTypeUnionCase = function() {
  return /** @type {proto.Common.EvntGrp.EventTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.EvntGrp.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.EvntGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.EvntGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.EvntGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.EvntGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    eventPx: (f = msg.getEventPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    eventText: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eventType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    eventTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 5, 0),
    eventTime: (f = msg.getEventTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.EvntGrp}
 */
proto.Common.EvntGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.EvntGrp;
  return proto.Common.EvntGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.EvntGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.EvntGrp}
 */
proto.Common.EvntGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEventDate(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setEventPx(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventText(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.EventTypeEnum} */ (reader.readEnum());
      msg.setEventType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setEventTypeReserved100plus(value);
      break;
    case 6:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEventTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.EvntGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.EvntGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.EvntGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.EvntGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventDate();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getEventPx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getEventText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = /** @type {!proto.Common.EventTypeEnum} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFixed32(
      5,
      f
    );
  }
  f = message.getEventTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional sfixed32 event_date = 1;
 * @return {number}
 */
proto.Common.EvntGrp.prototype.getEventDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.setEventDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional fix.Decimal64 event_px = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.EvntGrp.prototype.getEventPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.EvntGrp} returns this
*/
proto.Common.EvntGrp.prototype.setEventPx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.clearEventPx = function() {
  return this.setEventPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.EvntGrp.prototype.hasEventPx = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string event_text = 3;
 * @return {string}
 */
proto.Common.EvntGrp.prototype.getEventText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.setEventText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EventTypeEnum event_type = 4;
 * @return {!proto.Common.EventTypeEnum}
 */
proto.Common.EvntGrp.prototype.getEventType = function() {
  return /** @type {!proto.Common.EventTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.EventTypeEnum} value
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.setEventType = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.Common.EvntGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.clearEventType = function() {
  return jspb.Message.setOneofField(this, 4, proto.Common.EvntGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.EvntGrp.prototype.hasEventType = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fixed32 event_type_reserved100plus = 5;
 * @return {number}
 */
proto.Common.EvntGrp.prototype.getEventTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.setEventTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.Common.EvntGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.clearEventTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 5, proto.Common.EvntGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.EvntGrp.prototype.hasEventTypeReserved100plus = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Timestamp event_time = 6;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.EvntGrp.prototype.getEventTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 6));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.EvntGrp} returns this
*/
proto.Common.EvntGrp.prototype.setEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.EvntGrp} returns this
 */
proto.Common.EvntGrp.prototype.clearEventTime = function() {
  return this.setEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.EvntGrp.prototype.hasEventTime = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SecAltIDGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SecAltIDGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SecAltIDGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecAltIDGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityAltId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityAltIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SecAltIDGrp}
 */
proto.Common.SecAltIDGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SecAltIDGrp;
  return proto.Common.SecAltIDGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SecAltIDGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SecAltIDGrp}
 */
proto.Common.SecAltIDGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityAltId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.SecurityAltIDSourceEnum} */ (reader.readEnum());
      msg.setSecurityAltIdSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SecAltIDGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SecAltIDGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SecAltIDGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecAltIDGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityAltId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityAltIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string security_alt_id = 1;
 * @return {string}
 */
proto.Common.SecAltIDGrp.prototype.getSecurityAltId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SecAltIDGrp} returns this
 */
proto.Common.SecAltIDGrp.prototype.setSecurityAltId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SecurityAltIDSourceEnum security_alt_id_source = 2;
 * @return {!proto.Common.SecurityAltIDSourceEnum}
 */
proto.Common.SecAltIDGrp.prototype.getSecurityAltIdSource = function() {
  return /** @type {!proto.Common.SecurityAltIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.SecurityAltIDSourceEnum} value
 * @return {!proto.Common.SecAltIDGrp} returns this
 */
proto.Common.SecAltIDGrp.prototype.setSecurityAltIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LegSecAltIDGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LegSecAltIDGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LegSecAltIDGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegSecAltIDGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    legSecurityAltId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    legSecurityAltIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LegSecAltIDGrp}
 */
proto.Common.LegSecAltIDGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LegSecAltIDGrp;
  return proto.Common.LegSecAltIDGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LegSecAltIDGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LegSecAltIDGrp}
 */
proto.Common.LegSecAltIDGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegSecurityAltId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.LegSecurityAltIDSourceEnum} */ (reader.readEnum());
      msg.setLegSecurityAltIdSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LegSecAltIDGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LegSecAltIDGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LegSecAltIDGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LegSecAltIDGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegSecurityAltId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLegSecurityAltIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string leg_security_alt_id = 1;
 * @return {string}
 */
proto.Common.LegSecAltIDGrp.prototype.getLegSecurityAltId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.LegSecAltIDGrp} returns this
 */
proto.Common.LegSecAltIDGrp.prototype.setLegSecurityAltId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional LegSecurityAltIDSourceEnum leg_security_alt_id_source = 2;
 * @return {!proto.Common.LegSecurityAltIDSourceEnum}
 */
proto.Common.LegSecAltIDGrp.prototype.getLegSecurityAltIdSource = function() {
  return /** @type {!proto.Common.LegSecurityAltIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.LegSecurityAltIDSourceEnum} value
 * @return {!proto.Common.LegSecAltIDGrp} returns this
 */
proto.Common.LegSecAltIDGrp.prototype.setLegSecurityAltIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UndSecAltIDGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UndSecAltIDGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UndSecAltIDGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndSecAltIDGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingSecurityAltId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    underlyingSecurityAltIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UndSecAltIDGrp}
 */
proto.Common.UndSecAltIDGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UndSecAltIDGrp;
  return proto.Common.UndSecAltIDGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UndSecAltIDGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UndSecAltIDGrp}
 */
proto.Common.UndSecAltIDGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingSecurityAltId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.UnderlyingSecurityAltIDSourceEnum} */ (reader.readEnum());
      msg.setUnderlyingSecurityAltIdSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UndSecAltIDGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UndSecAltIDGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UndSecAltIDGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndSecAltIDGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingSecurityAltId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnderlyingSecurityAltIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string underlying_security_alt_id = 1;
 * @return {string}
 */
proto.Common.UndSecAltIDGrp.prototype.getUnderlyingSecurityAltId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UndSecAltIDGrp} returns this
 */
proto.Common.UndSecAltIDGrp.prototype.setUnderlyingSecurityAltId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UnderlyingSecurityAltIDSourceEnum underlying_security_alt_id_source = 2;
 * @return {!proto.Common.UnderlyingSecurityAltIDSourceEnum}
 */
proto.Common.UndSecAltIDGrp.prototype.getUnderlyingSecurityAltIdSource = function() {
  return /** @type {!proto.Common.UnderlyingSecurityAltIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.UnderlyingSecurityAltIDSourceEnum} value
 * @return {!proto.Common.UndSecAltIDGrp} returns this
 */
proto.Common.UndSecAltIDGrp.prototype.setUnderlyingSecurityAltIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.AttrbGrp.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.Common.AttrbGrp.InstrAttribTypeUnionCase = {
  INSTR_ATTRIB_TYPE_UNION_NOT_SET: 0,
  INSTR_ATTRIB_TYPE: 1,
  INSTR_ATTRIB_TYPE_RESERVED100PLUS: 2
};

/**
 * @return {proto.Common.AttrbGrp.InstrAttribTypeUnionCase}
 */
proto.Common.AttrbGrp.prototype.getInstrAttribTypeUnionCase = function() {
  return /** @type {proto.Common.AttrbGrp.InstrAttribTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.AttrbGrp.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.AttrbGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.AttrbGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.AttrbGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.AttrbGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrAttribType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    instrAttribTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    instrAttribValue: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.AttrbGrp}
 */
proto.Common.AttrbGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.AttrbGrp;
  return proto.Common.AttrbGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.AttrbGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.AttrbGrp}
 */
proto.Common.AttrbGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.InstrAttribTypeEnum} */ (reader.readEnum());
      msg.setInstrAttribType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setInstrAttribTypeReserved100plus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrAttribValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.AttrbGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.AttrbGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.AttrbGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.AttrbGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.Common.InstrAttribTypeEnum} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFixed32(
      2,
      f
    );
  }
  f = message.getInstrAttribValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional InstrAttribTypeEnum instr_attrib_type = 1;
 * @return {!proto.Common.InstrAttribTypeEnum}
 */
proto.Common.AttrbGrp.prototype.getInstrAttribType = function() {
  return /** @type {!proto.Common.InstrAttribTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.InstrAttribTypeEnum} value
 * @return {!proto.Common.AttrbGrp} returns this
 */
proto.Common.AttrbGrp.prototype.setInstrAttribType = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.Common.AttrbGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.AttrbGrp} returns this
 */
proto.Common.AttrbGrp.prototype.clearInstrAttribType = function() {
  return jspb.Message.setOneofField(this, 1, proto.Common.AttrbGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.AttrbGrp.prototype.hasInstrAttribType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 instr_attrib_type_reserved100plus = 2;
 * @return {number}
 */
proto.Common.AttrbGrp.prototype.getInstrAttribTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.AttrbGrp} returns this
 */
proto.Common.AttrbGrp.prototype.setInstrAttribTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.Common.AttrbGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.AttrbGrp} returns this
 */
proto.Common.AttrbGrp.prototype.clearInstrAttribTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 2, proto.Common.AttrbGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.AttrbGrp.prototype.hasInstrAttribTypeReserved100plus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string instr_attrib_value = 3;
 * @return {string}
 */
proto.Common.AttrbGrp.prototype.getInstrAttribValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.AttrbGrp} returns this
 */
proto.Common.AttrbGrp.prototype.setInstrAttribValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.DlvyInstGrp.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DlvyInstGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DlvyInstGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DlvyInstGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DlvyInstGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    dlvyInstType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    settlInstSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    settlPartiesList: jspb.Message.toObjectList(msg.getSettlPartiesList(),
    proto.Common.SettlParties.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DlvyInstGrp}
 */
proto.Common.DlvyInstGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DlvyInstGrp;
  return proto.Common.DlvyInstGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DlvyInstGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DlvyInstGrp}
 */
proto.Common.DlvyInstGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.DlvyInstTypeEnum} */ (reader.readEnum());
      msg.setDlvyInstType(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.SettlInstSourceEnum} */ (reader.readEnum());
      msg.setSettlInstSource(value);
      break;
    case 3:
      var value = new proto.Common.SettlParties;
      reader.readMessage(value,proto.Common.SettlParties.deserializeBinaryFromReader);
      msg.addSettlParties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DlvyInstGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DlvyInstGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DlvyInstGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DlvyInstGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDlvyInstType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSettlInstSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getSettlPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.SettlParties.serializeBinaryToWriter
    );
  }
};


/**
 * optional DlvyInstTypeEnum dlvy_inst_type = 1;
 * @return {!proto.Common.DlvyInstTypeEnum}
 */
proto.Common.DlvyInstGrp.prototype.getDlvyInstType = function() {
  return /** @type {!proto.Common.DlvyInstTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.DlvyInstTypeEnum} value
 * @return {!proto.Common.DlvyInstGrp} returns this
 */
proto.Common.DlvyInstGrp.prototype.setDlvyInstType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional SettlInstSourceEnum settl_inst_source = 2;
 * @return {!proto.Common.SettlInstSourceEnum}
 */
proto.Common.DlvyInstGrp.prototype.getSettlInstSource = function() {
  return /** @type {!proto.Common.SettlInstSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.SettlInstSourceEnum} value
 * @return {!proto.Common.DlvyInstGrp} returns this
 */
proto.Common.DlvyInstGrp.prototype.setSettlInstSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated SettlParties settl_parties = 3;
 * @return {!Array<!proto.Common.SettlParties>}
 */
proto.Common.DlvyInstGrp.prototype.getSettlPartiesList = function() {
  return /** @type{!Array<!proto.Common.SettlParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.SettlParties, 3));
};


/**
 * @param {!Array<!proto.Common.SettlParties>} value
 * @return {!proto.Common.DlvyInstGrp} returns this
*/
proto.Common.DlvyInstGrp.prototype.setSettlPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.SettlParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.SettlParties}
 */
proto.Common.DlvyInstGrp.prototype.addSettlParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.SettlParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DlvyInstGrp} returns this
 */
proto.Common.DlvyInstGrp.prototype.clearSettlPartiesList = function() {
  return this.setSettlPartiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SettlPtysSubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SettlPtysSubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SettlPtysSubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlPtysSubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    settlPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    settlPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SettlPtysSubGrp}
 */
proto.Common.SettlPtysSubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SettlPtysSubGrp;
  return proto.Common.SettlPtysSubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SettlPtysSubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SettlPtysSubGrp}
 */
proto.Common.SettlPtysSubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSettlPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.SettlPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setSettlPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SettlPtysSubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SettlPtysSubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SettlPtysSubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlPtysSubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettlPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSettlPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string settl_party_sub_id = 1;
 * @return {string}
 */
proto.Common.SettlPtysSubGrp.prototype.getSettlPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SettlPtysSubGrp} returns this
 */
proto.Common.SettlPtysSubGrp.prototype.setSettlPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional SettlPartySubIDTypeEnum settl_party_sub_id_type = 2;
 * @return {!proto.Common.SettlPartySubIDTypeEnum}
 */
proto.Common.SettlPtysSubGrp.prototype.getSettlPartySubIdType = function() {
  return /** @type {!proto.Common.SettlPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.SettlPartySubIDTypeEnum} value
 * @return {!proto.Common.SettlPtysSubGrp} returns this
 */
proto.Common.SettlPtysSubGrp.prototype.setSettlPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.PtysSubGrp.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.Common.PtysSubGrp.PartySubIdTypeUnionCase = {
  PARTY_SUB_ID_TYPE_UNION_NOT_SET: 0,
  PARTY_SUB_ID_TYPE: 2,
  PARTY_SUB_ID_TYPE_RESERVED4000PLUS: 3
};

/**
 * @return {proto.Common.PtysSubGrp.PartySubIdTypeUnionCase}
 */
proto.Common.PtysSubGrp.prototype.getPartySubIdTypeUnionCase = function() {
  return /** @type {proto.Common.PtysSubGrp.PartySubIdTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.PtysSubGrp.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PtysSubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PtysSubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PtysSubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PtysSubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    partySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    partySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    partySubIdTypeReserved4000plus: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PtysSubGrp}
 */
proto.Common.PtysSubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PtysSubGrp;
  return proto.Common.PtysSubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PtysSubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PtysSubGrp}
 */
proto.Common.PtysSubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.PartySubIDTypeEnum} */ (reader.readEnum());
      msg.setPartySubIdType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setPartySubIdTypeReserved4000plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PtysSubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PtysSubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PtysSubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PtysSubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.Common.PartySubIDTypeEnum} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFixed32(
      3,
      f
    );
  }
};


/**
 * optional string party_sub_id = 1;
 * @return {string}
 */
proto.Common.PtysSubGrp.prototype.getPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.PtysSubGrp} returns this
 */
proto.Common.PtysSubGrp.prototype.setPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional PartySubIDTypeEnum party_sub_id_type = 2;
 * @return {!proto.Common.PartySubIDTypeEnum}
 */
proto.Common.PtysSubGrp.prototype.getPartySubIdType = function() {
  return /** @type {!proto.Common.PartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.PartySubIDTypeEnum} value
 * @return {!proto.Common.PtysSubGrp} returns this
 */
proto.Common.PtysSubGrp.prototype.setPartySubIdType = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.Common.PtysSubGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.PtysSubGrp} returns this
 */
proto.Common.PtysSubGrp.prototype.clearPartySubIdType = function() {
  return jspb.Message.setOneofField(this, 2, proto.Common.PtysSubGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PtysSubGrp.prototype.hasPartySubIdType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fixed32 party_sub_id_type_reserved4000plus = 3;
 * @return {number}
 */
proto.Common.PtysSubGrp.prototype.getPartySubIdTypeReserved4000plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.PtysSubGrp} returns this
 */
proto.Common.PtysSubGrp.prototype.setPartySubIdTypeReserved4000plus = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.Common.PtysSubGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.PtysSubGrp} returns this
 */
proto.Common.PtysSubGrp.prototype.clearPartySubIdTypeReserved4000plus = function() {
  return jspb.Message.setOneofField(this, 3, proto.Common.PtysSubGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PtysSubGrp.prototype.hasPartySubIdTypeReserved4000plus = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NstdPtysSubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NstdPtysSubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NstdPtysSubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtysSubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    nestedPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nestedPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NstdPtysSubGrp}
 */
proto.Common.NstdPtysSubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NstdPtysSubGrp;
  return proto.Common.NstdPtysSubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NstdPtysSubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NstdPtysSubGrp}
 */
proto.Common.NstdPtysSubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNestedPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.NestedPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setNestedPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NstdPtysSubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NstdPtysSubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NstdPtysSubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtysSubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNestedPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNestedPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string nested_party_sub_id = 1;
 * @return {string}
 */
proto.Common.NstdPtysSubGrp.prototype.getNestedPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NstdPtysSubGrp} returns this
 */
proto.Common.NstdPtysSubGrp.prototype.setNestedPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional NestedPartySubIDTypeEnum nested_party_sub_id_type = 2;
 * @return {!proto.Common.NestedPartySubIDTypeEnum}
 */
proto.Common.NstdPtysSubGrp.prototype.getNestedPartySubIdType = function() {
  return /** @type {!proto.Common.NestedPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.NestedPartySubIDTypeEnum} value
 * @return {!proto.Common.NstdPtysSubGrp} returns this
 */
proto.Common.NstdPtysSubGrp.prototype.setNestedPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NstdPtys2SubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NstdPtys2SubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NstdPtys2SubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys2SubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested2partySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested2partySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NstdPtys2SubGrp}
 */
proto.Common.NstdPtys2SubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NstdPtys2SubGrp;
  return proto.Common.NstdPtys2SubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NstdPtys2SubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NstdPtys2SubGrp}
 */
proto.Common.NstdPtys2SubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested2partySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested2PartySubIDTypeEnum} */ (reader.readEnum());
      msg.setNested2partySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NstdPtys2SubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NstdPtys2SubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NstdPtys2SubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys2SubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested2partySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested2partySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string nested2party_sub_id = 1;
 * @return {string}
 */
proto.Common.NstdPtys2SubGrp.prototype.getNested2partySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NstdPtys2SubGrp} returns this
 */
proto.Common.NstdPtys2SubGrp.prototype.setNested2partySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested2PartySubIDTypeEnum nested2party_sub_id_type = 2;
 * @return {!proto.Common.Nested2PartySubIDTypeEnum}
 */
proto.Common.NstdPtys2SubGrp.prototype.getNested2partySubIdType = function() {
  return /** @type {!proto.Common.Nested2PartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested2PartySubIDTypeEnum} value
 * @return {!proto.Common.NstdPtys2SubGrp} returns this
 */
proto.Common.NstdPtys2SubGrp.prototype.setNested2partySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NstdPtys3SubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NstdPtys3SubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NstdPtys3SubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys3SubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested3partySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested3partySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NstdPtys3SubGrp}
 */
proto.Common.NstdPtys3SubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NstdPtys3SubGrp;
  return proto.Common.NstdPtys3SubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NstdPtys3SubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NstdPtys3SubGrp}
 */
proto.Common.NstdPtys3SubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested3partySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested3PartySubIDTypeEnum} */ (reader.readEnum());
      msg.setNested3partySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NstdPtys3SubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NstdPtys3SubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NstdPtys3SubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys3SubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested3partySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested3partySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string nested3party_sub_id = 1;
 * @return {string}
 */
proto.Common.NstdPtys3SubGrp.prototype.getNested3partySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NstdPtys3SubGrp} returns this
 */
proto.Common.NstdPtys3SubGrp.prototype.setNested3partySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested3PartySubIDTypeEnum nested3party_sub_id_type = 2;
 * @return {!proto.Common.Nested3PartySubIDTypeEnum}
 */
proto.Common.NstdPtys3SubGrp.prototype.getNested3partySubIdType = function() {
  return /** @type {!proto.Common.Nested3PartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested3PartySubIDTypeEnum} value
 * @return {!proto.Common.NstdPtys3SubGrp} returns this
 */
proto.Common.NstdPtys3SubGrp.prototype.setNested3partySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.StrategyParametersGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.StrategyParametersGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.StrategyParametersGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.StrategyParametersGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    strategyParameterName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    strategyParameterType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    strategyParameterValue: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.StrategyParametersGrp}
 */
proto.Common.StrategyParametersGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.StrategyParametersGrp;
  return proto.Common.StrategyParametersGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.StrategyParametersGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.StrategyParametersGrp}
 */
proto.Common.StrategyParametersGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategyParameterName(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.StrategyParameterTypeEnum} */ (reader.readEnum());
      msg.setStrategyParameterType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrategyParameterValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.StrategyParametersGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.StrategyParametersGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.StrategyParametersGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.StrategyParametersGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStrategyParameterName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStrategyParameterType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStrategyParameterValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string strategy_parameter_name = 1;
 * @return {string}
 */
proto.Common.StrategyParametersGrp.prototype.getStrategyParameterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.StrategyParametersGrp} returns this
 */
proto.Common.StrategyParametersGrp.prototype.setStrategyParameterName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional StrategyParameterTypeEnum strategy_parameter_type = 2;
 * @return {!proto.Common.StrategyParameterTypeEnum}
 */
proto.Common.StrategyParametersGrp.prototype.getStrategyParameterType = function() {
  return /** @type {!proto.Common.StrategyParameterTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.StrategyParameterTypeEnum} value
 * @return {!proto.Common.StrategyParametersGrp} returns this
 */
proto.Common.StrategyParametersGrp.prototype.setStrategyParameterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string strategy_parameter_value = 3;
 * @return {string}
 */
proto.Common.StrategyParametersGrp.prototype.getStrategyParameterValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.StrategyParametersGrp} returns this
 */
proto.Common.StrategyParametersGrp.prototype.setStrategyParameterValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.InstrumentParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrumentParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrumentParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrumentParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    instrumentPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    instrumentPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    instrumentPtysSubGrpList: jspb.Message.toObjectList(msg.getInstrumentPtysSubGrpList(),
    proto.Common.InstrumentPtysSubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrumentParties}
 */
proto.Common.InstrumentParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrumentParties;
  return proto.Common.InstrumentParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrumentParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrumentParties}
 */
proto.Common.InstrumentParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.InstrumentPartyIDSourceEnum} */ (reader.readEnum());
      msg.setInstrumentPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.InstrumentPartyRoleEnum} */ (reader.readEnum());
      msg.setInstrumentPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.InstrumentPtysSubGrp;
      reader.readMessage(value,proto.Common.InstrumentPtysSubGrp.deserializeBinaryFromReader);
      msg.addInstrumentPtysSubGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrumentParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrumentParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrumentParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstrumentPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getInstrumentPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getInstrumentPtysSubGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.InstrumentPtysSubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string instrument_party_id = 1;
 * @return {string}
 */
proto.Common.InstrumentParties.prototype.getInstrumentPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentParties} returns this
 */
proto.Common.InstrumentParties.prototype.setInstrumentPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InstrumentPartyIDSourceEnum instrument_party_id_source = 2;
 * @return {!proto.Common.InstrumentPartyIDSourceEnum}
 */
proto.Common.InstrumentParties.prototype.getInstrumentPartyIdSource = function() {
  return /** @type {!proto.Common.InstrumentPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.InstrumentPartyIDSourceEnum} value
 * @return {!proto.Common.InstrumentParties} returns this
 */
proto.Common.InstrumentParties.prototype.setInstrumentPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional InstrumentPartyRoleEnum instrument_party_role = 3;
 * @return {!proto.Common.InstrumentPartyRoleEnum}
 */
proto.Common.InstrumentParties.prototype.getInstrumentPartyRole = function() {
  return /** @type {!proto.Common.InstrumentPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.InstrumentPartyRoleEnum} value
 * @return {!proto.Common.InstrumentParties} returns this
 */
proto.Common.InstrumentParties.prototype.setInstrumentPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated InstrumentPtysSubGrp instrument_ptys_sub_grp = 4;
 * @return {!Array<!proto.Common.InstrumentPtysSubGrp>}
 */
proto.Common.InstrumentParties.prototype.getInstrumentPtysSubGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrumentPtysSubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.InstrumentPtysSubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.InstrumentPtysSubGrp>} value
 * @return {!proto.Common.InstrumentParties} returns this
*/
proto.Common.InstrumentParties.prototype.setInstrumentPtysSubGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.InstrumentPtysSubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrumentPtysSubGrp}
 */
proto.Common.InstrumentParties.prototype.addInstrumentPtysSubGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.InstrumentPtysSubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.InstrumentParties} returns this
 */
proto.Common.InstrumentParties.prototype.clearInstrumentPtysSubGrpList = function() {
  return this.setInstrumentPtysSubGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.InstrumentPtysSubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.InstrumentPtysSubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.InstrumentPtysSubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentPtysSubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    instrumentPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    instrumentPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.InstrumentPtysSubGrp}
 */
proto.Common.InstrumentPtysSubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.InstrumentPtysSubGrp;
  return proto.Common.InstrumentPtysSubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.InstrumentPtysSubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.InstrumentPtysSubGrp}
 */
proto.Common.InstrumentPtysSubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setInstrumentPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.InstrumentPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setInstrumentPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.InstrumentPtysSubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.InstrumentPtysSubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.InstrumentPtysSubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.InstrumentPtysSubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInstrumentPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstrumentPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string instrument_party_sub_id = 1;
 * @return {string}
 */
proto.Common.InstrumentPtysSubGrp.prototype.getInstrumentPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.InstrumentPtysSubGrp} returns this
 */
proto.Common.InstrumentPtysSubGrp.prototype.setInstrumentPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional InstrumentPartySubIDTypeEnum instrument_party_sub_id_type = 2;
 * @return {!proto.Common.InstrumentPartySubIDTypeEnum}
 */
proto.Common.InstrumentPtysSubGrp.prototype.getInstrumentPartySubIdType = function() {
  return /** @type {!proto.Common.InstrumentPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.InstrumentPartySubIDTypeEnum} value
 * @return {!proto.Common.InstrumentPtysSubGrp} returns this
 */
proto.Common.InstrumentPtysSubGrp.prototype.setInstrumentPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.UndlyInstrumentParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UndlyInstrumentParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UndlyInstrumentParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UndlyInstrumentParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndlyInstrumentParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingInstrumentPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    underlyingInstrumentPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    underlyingInstrumentPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    undlyInstrumentPtysSubGrpList: jspb.Message.toObjectList(msg.getUndlyInstrumentPtysSubGrpList(),
    proto.Common.UndlyInstrumentPtysSubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UndlyInstrumentParties}
 */
proto.Common.UndlyInstrumentParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UndlyInstrumentParties;
  return proto.Common.UndlyInstrumentParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UndlyInstrumentParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UndlyInstrumentParties}
 */
proto.Common.UndlyInstrumentParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingInstrumentPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.UnderlyingInstrumentPartyIDSourceEnum} */ (reader.readEnum());
      msg.setUnderlyingInstrumentPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.UnderlyingInstrumentPartyRoleEnum} */ (reader.readEnum());
      msg.setUnderlyingInstrumentPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.UndlyInstrumentPtysSubGrp;
      reader.readMessage(value,proto.Common.UndlyInstrumentPtysSubGrp.deserializeBinaryFromReader);
      msg.addUndlyInstrumentPtysSubGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UndlyInstrumentParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UndlyInstrumentParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UndlyInstrumentParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndlyInstrumentParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingInstrumentPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnderlyingInstrumentPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getUnderlyingInstrumentPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getUndlyInstrumentPtysSubGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.UndlyInstrumentPtysSubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string underlying_instrument_party_id = 1;
 * @return {string}
 */
proto.Common.UndlyInstrumentParties.prototype.getUnderlyingInstrumentPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UndlyInstrumentParties} returns this
 */
proto.Common.UndlyInstrumentParties.prototype.setUnderlyingInstrumentPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UnderlyingInstrumentPartyIDSourceEnum underlying_instrument_party_id_source = 2;
 * @return {!proto.Common.UnderlyingInstrumentPartyIDSourceEnum}
 */
proto.Common.UndlyInstrumentParties.prototype.getUnderlyingInstrumentPartyIdSource = function() {
  return /** @type {!proto.Common.UnderlyingInstrumentPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.UnderlyingInstrumentPartyIDSourceEnum} value
 * @return {!proto.Common.UndlyInstrumentParties} returns this
 */
proto.Common.UndlyInstrumentParties.prototype.setUnderlyingInstrumentPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional UnderlyingInstrumentPartyRoleEnum underlying_instrument_party_role = 3;
 * @return {!proto.Common.UnderlyingInstrumentPartyRoleEnum}
 */
proto.Common.UndlyInstrumentParties.prototype.getUnderlyingInstrumentPartyRole = function() {
  return /** @type {!proto.Common.UnderlyingInstrumentPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.UnderlyingInstrumentPartyRoleEnum} value
 * @return {!proto.Common.UndlyInstrumentParties} returns this
 */
proto.Common.UndlyInstrumentParties.prototype.setUnderlyingInstrumentPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated UndlyInstrumentPtysSubGrp undly_instrument_ptys_sub_grp = 4;
 * @return {!Array<!proto.Common.UndlyInstrumentPtysSubGrp>}
 */
proto.Common.UndlyInstrumentParties.prototype.getUndlyInstrumentPtysSubGrpList = function() {
  return /** @type{!Array<!proto.Common.UndlyInstrumentPtysSubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.UndlyInstrumentPtysSubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.UndlyInstrumentPtysSubGrp>} value
 * @return {!proto.Common.UndlyInstrumentParties} returns this
*/
proto.Common.UndlyInstrumentParties.prototype.setUndlyInstrumentPtysSubGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.UndlyInstrumentPtysSubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.UndlyInstrumentPtysSubGrp}
 */
proto.Common.UndlyInstrumentParties.prototype.addUndlyInstrumentPtysSubGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.UndlyInstrumentPtysSubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.UndlyInstrumentParties} returns this
 */
proto.Common.UndlyInstrumentParties.prototype.clearUndlyInstrumentPtysSubGrpList = function() {
  return this.setUndlyInstrumentPtysSubGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.UndlyInstrumentPtysSubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.UndlyInstrumentPtysSubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndlyInstrumentPtysSubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    underlyingInstrumentPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    underlyingInstrumentPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.UndlyInstrumentPtysSubGrp}
 */
proto.Common.UndlyInstrumentPtysSubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.UndlyInstrumentPtysSubGrp;
  return proto.Common.UndlyInstrumentPtysSubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.UndlyInstrumentPtysSubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.UndlyInstrumentPtysSubGrp}
 */
proto.Common.UndlyInstrumentPtysSubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUnderlyingInstrumentPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.UnderlyingInstrumentPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setUnderlyingInstrumentPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.UndlyInstrumentPtysSubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.UndlyInstrumentPtysSubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.UndlyInstrumentPtysSubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUnderlyingInstrumentPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUnderlyingInstrumentPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string underlying_instrument_party_sub_id = 1;
 * @return {string}
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.getUnderlyingInstrumentPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.UndlyInstrumentPtysSubGrp} returns this
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.setUnderlyingInstrumentPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional UnderlyingInstrumentPartySubIDTypeEnum underlying_instrument_party_sub_id_type = 2;
 * @return {!proto.Common.UnderlyingInstrumentPartySubIDTypeEnum}
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.getUnderlyingInstrumentPartySubIdType = function() {
  return /** @type {!proto.Common.UnderlyingInstrumentPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.UnderlyingInstrumentPartySubIDTypeEnum} value
 * @return {!proto.Common.UndlyInstrumentPtysSubGrp} returns this
 */
proto.Common.UndlyInstrumentPtysSubGrp.prototype.setUnderlyingInstrumentPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DisplayInstruction.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DisplayInstruction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DisplayInstruction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DisplayInstruction.toObject = function(includeInstance, msg) {
  var f, obj = {
    displayHighQty: (f = msg.getDisplayHighQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    displayLowQty: (f = msg.getDisplayLowQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    displayMethod: jspb.Message.getFieldWithDefault(msg, 3, 0),
    displayMinIncr: (f = msg.getDisplayMinIncr()) && fix_pb.Decimal64.toObject(includeInstance, f),
    displayQty: (f = msg.getDisplayQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    displayWhen: jspb.Message.getFieldWithDefault(msg, 6, 0),
    refreshQty: (f = msg.getRefreshQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    secondaryDisplayQty: (f = msg.getSecondaryDisplayQty()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DisplayInstruction}
 */
proto.Common.DisplayInstruction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DisplayInstruction;
  return proto.Common.DisplayInstruction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DisplayInstruction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DisplayInstruction}
 */
proto.Common.DisplayInstruction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDisplayHighQty(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDisplayLowQty(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.DisplayMethodEnum} */ (reader.readEnum());
      msg.setDisplayMethod(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDisplayMinIncr(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDisplayQty(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.DisplayWhenEnum} */ (reader.readEnum());
      msg.setDisplayWhen(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRefreshQty(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSecondaryDisplayQty(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DisplayInstruction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DisplayInstruction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DisplayInstruction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DisplayInstruction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDisplayHighQty();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDisplayLowQty();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDisplayMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDisplayMinIncr();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDisplayQty();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDisplayWhen();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRefreshQty();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryDisplayQty();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 display_high_qty = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getDisplayHighQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setDisplayHighQty = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearDisplayHighQty = function() {
  return this.setDisplayHighQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasDisplayHighQty = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 display_low_qty = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getDisplayLowQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setDisplayLowQty = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearDisplayLowQty = function() {
  return this.setDisplayLowQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasDisplayLowQty = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional DisplayMethodEnum display_method = 3;
 * @return {!proto.Common.DisplayMethodEnum}
 */
proto.Common.DisplayInstruction.prototype.getDisplayMethod = function() {
  return /** @type {!proto.Common.DisplayMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.DisplayMethodEnum} value
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.setDisplayMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Decimal64 display_min_incr = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getDisplayMinIncr = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setDisplayMinIncr = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearDisplayMinIncr = function() {
  return this.setDisplayMinIncr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasDisplayMinIncr = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 display_qty = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getDisplayQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setDisplayQty = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearDisplayQty = function() {
  return this.setDisplayQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasDisplayQty = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional DisplayWhenEnum display_when = 6;
 * @return {!proto.Common.DisplayWhenEnum}
 */
proto.Common.DisplayInstruction.prototype.getDisplayWhen = function() {
  return /** @type {!proto.Common.DisplayWhenEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.DisplayWhenEnum} value
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.setDisplayWhen = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional fix.Decimal64 refresh_qty = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getRefreshQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setRefreshQty = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearRefreshQty = function() {
  return this.setRefreshQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasRefreshQty = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fix.Decimal64 secondary_display_qty = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DisplayInstruction.prototype.getSecondaryDisplayQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DisplayInstruction} returns this
*/
proto.Common.DisplayInstruction.prototype.setSecondaryDisplayQty = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DisplayInstruction} returns this
 */
proto.Common.DisplayInstruction.prototype.clearSecondaryDisplayQty = function() {
  return this.setSecondaryDisplayQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DisplayInstruction.prototype.hasSecondaryDisplayQty = function() {
  return jspb.Message.getField(this, 8) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TriggeringInstruction.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TriggeringInstruction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TriggeringInstruction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TriggeringInstruction.toObject = function(includeInstance, msg) {
  var f, obj = {
    triggerAction: jspb.Message.getFieldWithDefault(msg, 1, 0),
    triggerNewPrice: (f = msg.getTriggerNewPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    triggerNewQty: (f = msg.getTriggerNewQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    triggerOrderType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    triggerPrice: (f = msg.getTriggerPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    triggerPriceDirection: jspb.Message.getFieldWithDefault(msg, 6, 0),
    triggerPriceType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    triggerPriceTypeScope: jspb.Message.getFieldWithDefault(msg, 8, 0),
    triggerSecurityDesc: jspb.Message.getFieldWithDefault(msg, 9, ""),
    triggerSecurityId: jspb.Message.getFieldWithDefault(msg, 10, ""),
    triggerSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 11, 0),
    triggerSymbol: jspb.Message.getFieldWithDefault(msg, 12, ""),
    triggerTradingSessionId: jspb.Message.getFieldWithDefault(msg, 13, ""),
    triggerTradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 14, ""),
    triggerType: jspb.Message.getFieldWithDefault(msg, 15, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TriggeringInstruction}
 */
proto.Common.TriggeringInstruction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TriggeringInstruction;
  return proto.Common.TriggeringInstruction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TriggeringInstruction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TriggeringInstruction}
 */
proto.Common.TriggeringInstruction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.TriggerActionEnum} */ (reader.readEnum());
      msg.setTriggerAction(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTriggerNewPrice(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTriggerNewQty(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.TriggerOrderTypeEnum} */ (reader.readEnum());
      msg.setTriggerOrderType(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTriggerPrice(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.TriggerPriceDirectionEnum} */ (reader.readEnum());
      msg.setTriggerPriceDirection(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.TriggerPriceTypeEnum} */ (reader.readEnum());
      msg.setTriggerPriceType(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.TriggerPriceTypeScopeEnum} */ (reader.readEnum());
      msg.setTriggerPriceTypeScope(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerSecurityDesc(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerSecurityId(value);
      break;
    case 11:
      var value = /** @type {!proto.Common.TriggerSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setTriggerSecurityIdSource(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerSymbol(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerTradingSessionId(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerTradingSessionSubId(value);
      break;
    case 15:
      var value = /** @type {!proto.Common.TriggerTypeEnum} */ (reader.readEnum());
      msg.setTriggerType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TriggeringInstruction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TriggeringInstruction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TriggeringInstruction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TriggeringInstruction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTriggerAction();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getTriggerNewPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTriggerNewQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTriggerOrderType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTriggerPrice();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTriggerPriceDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getTriggerPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getTriggerPriceTypeScope();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTriggerSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getTriggerSecurityId();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTriggerSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getTriggerSymbol();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getTriggerTradingSessionId();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getTriggerTradingSessionSubId();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getTriggerType();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
};


/**
 * optional TriggerActionEnum trigger_action = 1;
 * @return {!proto.Common.TriggerActionEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerAction = function() {
  return /** @type {!proto.Common.TriggerActionEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.TriggerActionEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional fix.Decimal64 trigger_new_price = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerNewPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TriggeringInstruction} returns this
*/
proto.Common.TriggeringInstruction.prototype.setTriggerNewPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.clearTriggerNewPrice = function() {
  return this.setTriggerNewPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TriggeringInstruction.prototype.hasTriggerNewPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 trigger_new_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerNewQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TriggeringInstruction} returns this
*/
proto.Common.TriggeringInstruction.prototype.setTriggerNewQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.clearTriggerNewQty = function() {
  return this.setTriggerNewQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TriggeringInstruction.prototype.hasTriggerNewQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TriggerOrderTypeEnum trigger_order_type = 4;
 * @return {!proto.Common.TriggerOrderTypeEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerOrderType = function() {
  return /** @type {!proto.Common.TriggerOrderTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.TriggerOrderTypeEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerOrderType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 trigger_price = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TriggeringInstruction} returns this
*/
proto.Common.TriggeringInstruction.prototype.setTriggerPrice = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.clearTriggerPrice = function() {
  return this.setTriggerPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TriggeringInstruction.prototype.hasTriggerPrice = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional TriggerPriceDirectionEnum trigger_price_direction = 6;
 * @return {!proto.Common.TriggerPriceDirectionEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerPriceDirection = function() {
  return /** @type {!proto.Common.TriggerPriceDirectionEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.TriggerPriceDirectionEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerPriceDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional TriggerPriceTypeEnum trigger_price_type = 7;
 * @return {!proto.Common.TriggerPriceTypeEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerPriceType = function() {
  return /** @type {!proto.Common.TriggerPriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.TriggerPriceTypeEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional TriggerPriceTypeScopeEnum trigger_price_type_scope = 8;
 * @return {!proto.Common.TriggerPriceTypeScopeEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerPriceTypeScope = function() {
  return /** @type {!proto.Common.TriggerPriceTypeScopeEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.TriggerPriceTypeScopeEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerPriceTypeScope = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string trigger_security_desc = 9;
 * @return {string}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string trigger_security_id = 10;
 * @return {string}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional TriggerSecurityIDSourceEnum trigger_security_id_source = 11;
 * @return {!proto.Common.TriggerSecurityIDSourceEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerSecurityIdSource = function() {
  return /** @type {!proto.Common.TriggerSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.Common.TriggerSecurityIDSourceEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string trigger_symbol = 12;
 * @return {string}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string trigger_trading_session_id = 13;
 * @return {string}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerTradingSessionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerTradingSessionId = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string trigger_trading_session_sub_id = 14;
 * @return {string}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerTradingSessionSubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerTradingSessionSubId = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional TriggerTypeEnum trigger_type = 15;
 * @return {!proto.Common.TriggerTypeEnum}
 */
proto.Common.TriggeringInstruction.prototype.getTriggerType = function() {
  return /** @type {!proto.Common.TriggerTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.Common.TriggerTypeEnum} value
 * @return {!proto.Common.TriggeringInstruction} returns this
 */
proto.Common.TriggeringInstruction.prototype.setTriggerType = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.RootParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.RootParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.RootParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.RootParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RootParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    rootPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    rootPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    rootSubPartiesList: jspb.Message.toObjectList(msg.getRootSubPartiesList(),
    proto.Common.RootSubParties.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.RootParties}
 */
proto.Common.RootParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.RootParties;
  return proto.Common.RootParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.RootParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.RootParties}
 */
proto.Common.RootParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.RootPartyIDSourceEnum} */ (reader.readEnum());
      msg.setRootPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.RootPartyRoleEnum} */ (reader.readEnum());
      msg.setRootPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.RootSubParties;
      reader.readMessage(value,proto.Common.RootSubParties.deserializeBinaryFromReader);
      msg.addRootSubParties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.RootParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.RootParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.RootParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RootParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRootPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRootPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getRootSubPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.RootSubParties.serializeBinaryToWriter
    );
  }
};


/**
 * optional string root_party_id = 1;
 * @return {string}
 */
proto.Common.RootParties.prototype.getRootPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RootParties} returns this
 */
proto.Common.RootParties.prototype.setRootPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RootPartyIDSourceEnum root_party_id_source = 2;
 * @return {!proto.Common.RootPartyIDSourceEnum}
 */
proto.Common.RootParties.prototype.getRootPartyIdSource = function() {
  return /** @type {!proto.Common.RootPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.RootPartyIDSourceEnum} value
 * @return {!proto.Common.RootParties} returns this
 */
proto.Common.RootParties.prototype.setRootPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional RootPartyRoleEnum root_party_role = 3;
 * @return {!proto.Common.RootPartyRoleEnum}
 */
proto.Common.RootParties.prototype.getRootPartyRole = function() {
  return /** @type {!proto.Common.RootPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.RootPartyRoleEnum} value
 * @return {!proto.Common.RootParties} returns this
 */
proto.Common.RootParties.prototype.setRootPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated RootSubParties root_sub_parties = 4;
 * @return {!Array<!proto.Common.RootSubParties>}
 */
proto.Common.RootParties.prototype.getRootSubPartiesList = function() {
  return /** @type{!Array<!proto.Common.RootSubParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.RootSubParties, 4));
};


/**
 * @param {!Array<!proto.Common.RootSubParties>} value
 * @return {!proto.Common.RootParties} returns this
*/
proto.Common.RootParties.prototype.setRootSubPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.RootSubParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.RootSubParties}
 */
proto.Common.RootParties.prototype.addRootSubParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.RootSubParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.RootParties} returns this
 */
proto.Common.RootParties.prototype.clearRootSubPartiesList = function() {
  return this.setRootSubPartiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.RootSubParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.RootSubParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.RootSubParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RootSubParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    rootPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    rootPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.RootSubParties}
 */
proto.Common.RootSubParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.RootSubParties;
  return proto.Common.RootSubParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.RootSubParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.RootSubParties}
 */
proto.Common.RootSubParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRootPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.RootPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setRootPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.RootSubParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.RootSubParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.RootSubParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RootSubParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRootPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRootPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string root_party_sub_id = 1;
 * @return {string}
 */
proto.Common.RootSubParties.prototype.getRootPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RootSubParties} returns this
 */
proto.Common.RootSubParties.prototype.setRootPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RootPartySubIDTypeEnum root_party_sub_id_type = 2;
 * @return {!proto.Common.RootPartySubIDTypeEnum}
 */
proto.Common.RootSubParties.prototype.getRootPartySubIdType = function() {
  return /** @type {!proto.Common.RootPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.RootPartySubIDTypeEnum} value
 * @return {!proto.Common.RootSubParties} returns this
 */
proto.Common.RootSubParties.prototype.setRootPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.TrdSessLstGrp.oneofGroups_ = [[13,16],[14,15],[17,18],[19,20]];

/**
 * @enum {number}
 */
proto.Common.TrdSessLstGrp.TradSesStatusUnionCase = {
  TRAD_SES_STATUS_UNION_NOT_SET: 0,
  TRAD_SES_STATUS: 13,
  TRAD_SES_STATUS_RESERVED100PLUS: 16
};

/**
 * @return {proto.Common.TrdSessLstGrp.TradSesStatusUnionCase}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatusUnionCase = function() {
  return /** @type {proto.Common.TrdSessLstGrp.TradSesStatusUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdSessLstGrp.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.Common.TrdSessLstGrp.TradSesStatusRejReasonUnionCase = {
  TRAD_SES_STATUS_REJ_REASON_UNION_NOT_SET: 0,
  TRAD_SES_STATUS_REJ_REASON: 14,
  TRAD_SES_STATUS_REJ_REASON_RESERVED100PLUS: 15
};

/**
 * @return {proto.Common.TrdSessLstGrp.TradSesStatusRejReasonUnionCase}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatusRejReasonUnionCase = function() {
  return /** @type {proto.Common.TrdSessLstGrp.TradSesStatusRejReasonUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdSessLstGrp.oneofGroups_[1]));
};

/**
 * @enum {number}
 */
proto.Common.TrdSessLstGrp.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 17,
  TRADING_SESSION_ID_RESERVED100PLUS: 18
};

/**
 * @return {proto.Common.TrdSessLstGrp.TradingSessionIdUnionCase}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.Common.TrdSessLstGrp.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdSessLstGrp.oneofGroups_[2]));
};

/**
 * @enum {number}
 */
proto.Common.TrdSessLstGrp.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 19,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 20
};

/**
 * @return {proto.Common.TrdSessLstGrp.TradingSessionSubIdUnionCase}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.Common.TrdSessLstGrp.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TrdSessLstGrp.oneofGroups_[3]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TrdSessLstGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TrdSessLstGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TrdSessLstGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdSessLstGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    encodedText: jspb.Message.getFieldWithDefault(msg, 1, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityExchange: jspb.Message.getFieldWithDefault(msg, 3, ""),
    text: jspb.Message.getFieldWithDefault(msg, 4, ""),
    totalVolumeTraded: (f = msg.getTotalVolumeTraded()) && fix_pb.Decimal64.toObject(includeInstance, f),
    tradSesCloseTime: (f = msg.getTradSesCloseTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    tradSesEndTime: (f = msg.getTradSesEndTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    tradSesMethod: jspb.Message.getFieldWithDefault(msg, 8, 0),
    tradSesMode: jspb.Message.getFieldWithDefault(msg, 9, 0),
    tradSesOpenTime: (f = msg.getTradSesOpenTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    tradSesPreCloseTime: (f = msg.getTradSesPreCloseTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    tradSesStartTime: (f = msg.getTradSesStartTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    tradSesStatus: jspb.Message.getFieldWithDefault(msg, 13, 0),
    tradSesStatusReserved100plus: jspb.Message.getFieldWithDefault(msg, 16, 0),
    tradSesStatusRejReason: jspb.Message.getFieldWithDefault(msg, 14, 0),
    tradSesStatusRejReasonReserved100plus: jspb.Message.getFieldWithDefault(msg, 15, 0),
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 17, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 18, 0),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 19, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 20, 0),
    unsolicitedIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 21, false),
    marketId: jspb.Message.getFieldWithDefault(msg, 22, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 23, ""),
    tradingSessionDesc: jspb.Message.getFieldWithDefault(msg, 24, ""),
    tradingSessionRules: (f = msg.getTradingSessionRules()) && proto.Common.TradingSessionRules.toObject(includeInstance, f),
    tradSesUpdateAction: jspb.Message.getFieldWithDefault(msg, 26, 0),
    transactTime: (f = msg.getTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TrdSessLstGrp}
 */
proto.Common.TrdSessLstGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TrdSessLstGrp;
  return proto.Common.TrdSessLstGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TrdSessLstGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TrdSessLstGrp}
 */
proto.Common.TrdSessLstGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityExchange(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTotalVolumeTraded(value);
      break;
    case 6:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradSesCloseTime(value);
      break;
    case 7:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradSesEndTime(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.TradSesMethodEnum} */ (reader.readEnum());
      msg.setTradSesMethod(value);
      break;
    case 9:
      var value = /** @type {!proto.Common.TradSesModeEnum} */ (reader.readEnum());
      msg.setTradSesMode(value);
      break;
    case 10:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradSesOpenTime(value);
      break;
    case 11:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradSesPreCloseTime(value);
      break;
    case 12:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTradSesStartTime(value);
      break;
    case 13:
      var value = /** @type {!proto.Common.TradSesStatusEnum} */ (reader.readEnum());
      msg.setTradSesStatus(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradSesStatusReserved100plus(value);
      break;
    case 14:
      var value = /** @type {!proto.Common.TradSesStatusRejReasonEnum} */ (reader.readEnum());
      msg.setTradSesStatusRejReason(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradSesStatusRejReasonReserved100plus(value);
      break;
    case 17:
      var value = /** @type {!proto.Common.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 19:
      var value = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    case 21:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUnsolicitedIndicator(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingSessionDesc(value);
      break;
    case 25:
      var value = new proto.Common.TradingSessionRules;
      reader.readMessage(value,proto.Common.TradingSessionRules.deserializeBinaryFromReader);
      msg.setTradingSessionRules(value);
      break;
    case 26:
      var value = /** @type {!proto.Common.TradSesUpdateActionEnum} */ (reader.readEnum());
      msg.setTradSesUpdateAction(value);
      break;
    case 27:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TrdSessLstGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TrdSessLstGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TrdSessLstGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TrdSessLstGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTotalVolumeTraded();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTradSesCloseTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTradSesEndTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTradSesMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getTradSesMode();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getTradSesOpenTime();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTradSesPreCloseTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getTradSesStartTime();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.Common.TradSesStatusEnum} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeFixed32(
      16,
      f
    );
  }
  f = /** @type {!proto.Common.TradSesStatusRejReasonEnum} */ (jspb.Message.getField(message, 14));
  if (f != null) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 15));
  if (f != null) {
    writer.writeFixed32(
      15,
      f
    );
  }
  f = /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 18));
  if (f != null) {
    writer.writeFixed32(
      18,
      f
    );
  }
  f = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 19));
  if (f != null) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 20));
  if (f != null) {
    writer.writeFixed32(
      20,
      f
    );
  }
  f = message.getUnsolicitedIndicator();
  if (f) {
    writer.writeBool(
      21,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getTradingSessionDesc();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getTradingSessionRules();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.Common.TradingSessionRules.serializeBinaryToWriter
    );
  }
  f = message.getTradSesUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      26,
      f
    );
  }
  f = message.getTransactTime();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string encoded_text = 1;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 encoded_text_len = 2;
 * @return {number}
 */
proto.Common.TrdSessLstGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string security_exchange = 3;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional fix.Decimal64 total_volume_traded = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TrdSessLstGrp.prototype.getTotalVolumeTraded = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTotalVolumeTraded = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTotalVolumeTraded = function() {
  return this.setTotalVolumeTraded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTotalVolumeTraded = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Timestamp trad_ses_close_time = 6;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesCloseTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 6));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradSesCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesCloseTime = function() {
  return this.setTradSesCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesCloseTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fix.Timestamp trad_ses_end_time = 7;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesEndTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 7));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradSesEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesEndTime = function() {
  return this.setTradSesEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesEndTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional TradSesMethodEnum trad_ses_method = 8;
 * @return {!proto.Common.TradSesMethodEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesMethod = function() {
  return /** @type {!proto.Common.TradSesMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.TradSesMethodEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional TradSesModeEnum trad_ses_mode = 9;
 * @return {!proto.Common.TradSesModeEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesMode = function() {
  return /** @type {!proto.Common.TradSesModeEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.Common.TradSesModeEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesMode = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional fix.Timestamp trad_ses_open_time = 10;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesOpenTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 10));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradSesOpenTime = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesOpenTime = function() {
  return this.setTradSesOpenTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesOpenTime = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional fix.Timestamp trad_ses_pre_close_time = 11;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesPreCloseTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 11));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradSesPreCloseTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesPreCloseTime = function() {
  return this.setTradSesPreCloseTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesPreCloseTime = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional fix.Timestamp trad_ses_start_time = 12;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStartTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 12));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradSesStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesStartTime = function() {
  return this.setTradSesStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesStartTime = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional TradSesStatusEnum trad_ses_status = 13;
 * @return {!proto.Common.TradSesStatusEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatus = function() {
  return /** @type {!proto.Common.TradSesStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.Common.TradSesStatusEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesStatus = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.Common.TrdSessLstGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesStatus = function() {
  return jspb.Message.setOneofField(this, 13, proto.Common.TrdSessLstGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesStatus = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional fixed32 trad_ses_status_reserved100plus = 16;
 * @return {number}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatusReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesStatusReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 16, proto.Common.TrdSessLstGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesStatusReserved100plus = function() {
  return jspb.Message.setOneofField(this, 16, proto.Common.TrdSessLstGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesStatusReserved100plus = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional TradSesStatusRejReasonEnum trad_ses_status_rej_reason = 14;
 * @return {!proto.Common.TradSesStatusRejReasonEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatusRejReason = function() {
  return /** @type {!proto.Common.TradSesStatusRejReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.Common.TradSesStatusRejReasonEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesStatusRejReason = function(value) {
  return jspb.Message.setOneofField(this, 14, proto.Common.TrdSessLstGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesStatusRejReason = function() {
  return jspb.Message.setOneofField(this, 14, proto.Common.TrdSessLstGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesStatusRejReason = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional fixed32 trad_ses_status_rej_reason_reserved100plus = 15;
 * @return {number}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesStatusRejReasonReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesStatusRejReasonReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 15, proto.Common.TrdSessLstGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradSesStatusRejReasonReserved100plus = function() {
  return jspb.Message.setOneofField(this, 15, proto.Common.TrdSessLstGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradSesStatusRejReasonReserved100plus = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional TradingSessionIDEnum trading_session_id = 17;
 * @return {!proto.Common.TradingSessionIDEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionId = function() {
  return /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.Common.TradingSessionIDEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 17, proto.Common.TrdSessLstGrp.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 17, proto.Common.TrdSessLstGrp.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 18;
 * @return {number}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 18, proto.Common.TrdSessLstGrp.oneofGroups_[2], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 18, proto.Common.TrdSessLstGrp.oneofGroups_[2], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 19;
 * @return {!proto.Common.TradingSessionSubIDEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.Common.TradingSessionSubIDEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 19, proto.Common.TrdSessLstGrp.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 19, proto.Common.TrdSessLstGrp.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 20;
 * @return {number}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 20, proto.Common.TrdSessLstGrp.oneofGroups_[3], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 20, proto.Common.TrdSessLstGrp.oneofGroups_[3], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional bool unsolicited_indicator = 21;
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.getUnsolicitedIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 21, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setUnsolicitedIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 21, value);
};


/**
 * optional string market_id = 22;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string market_segment_id = 23;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string trading_session_desc = 24;
 * @return {string}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradingSessionDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional TradingSessionRules trading_session_rules = 25;
 * @return {?proto.Common.TradingSessionRules}
 */
proto.Common.TrdSessLstGrp.prototype.getTradingSessionRules = function() {
  return /** @type{?proto.Common.TradingSessionRules} */ (
    jspb.Message.getWrapperField(this, proto.Common.TradingSessionRules, 25));
};


/**
 * @param {?proto.Common.TradingSessionRules|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTradingSessionRules = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTradingSessionRules = function() {
  return this.setTradingSessionRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTradingSessionRules = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional TradSesUpdateActionEnum trad_ses_update_action = 26;
 * @return {!proto.Common.TradSesUpdateActionEnum}
 */
proto.Common.TrdSessLstGrp.prototype.getTradSesUpdateAction = function() {
  return /** @type {!proto.Common.TradSesUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {!proto.Common.TradSesUpdateActionEnum} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.setTradSesUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 26, value);
};


/**
 * optional fix.Timestamp transact_time = 27;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.TrdSessLstGrp.prototype.getTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 27));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.TrdSessLstGrp} returns this
*/
proto.Common.TrdSessLstGrp.prototype.setTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 27, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TrdSessLstGrp} returns this
 */
proto.Common.TrdSessLstGrp.prototype.clearTransactTime = function() {
  return this.setTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TrdSessLstGrp.prototype.hasTransactTime = function() {
  return jspb.Message.getField(this, 27) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MsgTypeGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MsgTypeGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MsgTypeGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MsgTypeGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    msgDirection: jspb.Message.getFieldWithDefault(msg, 1, 0),
    refApplVerId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    refCstmApplVerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    refMsgType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    defaultVerIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    refApplExtId: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MsgTypeGrp}
 */
proto.Common.MsgTypeGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MsgTypeGrp;
  return proto.Common.MsgTypeGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MsgTypeGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MsgTypeGrp}
 */
proto.Common.MsgTypeGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.MsgDirectionEnum} */ (reader.readEnum());
      msg.setMsgDirection(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.RefApplVerIDEnum} */ (reader.readEnum());
      msg.setRefApplVerId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRefCstmApplVerId(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.RefMsgTypeEnum} */ (reader.readEnum());
      msg.setRefMsgType(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDefaultVerIndicator(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setRefApplExtId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MsgTypeGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MsgTypeGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MsgTypeGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MsgTypeGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMsgDirection();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRefApplVerId();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getRefCstmApplVerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRefMsgType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getDefaultVerIndicator();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getRefApplExtId();
  if (f !== 0) {
    writer.writeSfixed64(
      6,
      f
    );
  }
};


/**
 * optional MsgDirectionEnum msg_direction = 1;
 * @return {!proto.Common.MsgDirectionEnum}
 */
proto.Common.MsgTypeGrp.prototype.getMsgDirection = function() {
  return /** @type {!proto.Common.MsgDirectionEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.MsgDirectionEnum} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setMsgDirection = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional RefApplVerIDEnum ref_appl_ver_id = 2;
 * @return {!proto.Common.RefApplVerIDEnum}
 */
proto.Common.MsgTypeGrp.prototype.getRefApplVerId = function() {
  return /** @type {!proto.Common.RefApplVerIDEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.RefApplVerIDEnum} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setRefApplVerId = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string ref_cstm_appl_ver_id = 3;
 * @return {string}
 */
proto.Common.MsgTypeGrp.prototype.getRefCstmApplVerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setRefCstmApplVerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional RefMsgTypeEnum ref_msg_type = 4;
 * @return {!proto.Common.RefMsgTypeEnum}
 */
proto.Common.MsgTypeGrp.prototype.getRefMsgType = function() {
  return /** @type {!proto.Common.RefMsgTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.RefMsgTypeEnum} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setRefMsgType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional bool default_ver_indicator = 5;
 * @return {boolean}
 */
proto.Common.MsgTypeGrp.prototype.getDefaultVerIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setDefaultVerIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional sfixed64 ref_appl_ext_id = 6;
 * @return {number}
 */
proto.Common.MsgTypeGrp.prototype.getRefApplExtId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.MsgTypeGrp} returns this
 */
proto.Common.MsgTypeGrp.prototype.setRefApplExtId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.SecurityTradingRules.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SecurityTradingRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SecurityTradingRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SecurityTradingRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecurityTradingRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    baseTradingRules: (f = msg.getBaseTradingRules()) && proto.Common.BaseTradingRules.toObject(includeInstance, f),
    nestedInstrumentAttributeList: jspb.Message.toObjectList(msg.getNestedInstrumentAttributeList(),
    proto.Common.NestedInstrumentAttribute.toObject, includeInstance),
    tradingSessionRulesGrpList: jspb.Message.toObjectList(msg.getTradingSessionRulesGrpList(),
    proto.Common.TradingSessionRulesGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SecurityTradingRules}
 */
proto.Common.SecurityTradingRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SecurityTradingRules;
  return proto.Common.SecurityTradingRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SecurityTradingRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SecurityTradingRules}
 */
proto.Common.SecurityTradingRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.BaseTradingRules;
      reader.readMessage(value,proto.Common.BaseTradingRules.deserializeBinaryFromReader);
      msg.setBaseTradingRules(value);
      break;
    case 2:
      var value = new proto.Common.NestedInstrumentAttribute;
      reader.readMessage(value,proto.Common.NestedInstrumentAttribute.deserializeBinaryFromReader);
      msg.addNestedInstrumentAttribute(value);
      break;
    case 3:
      var value = new proto.Common.TradingSessionRulesGrp;
      reader.readMessage(value,proto.Common.TradingSessionRulesGrp.deserializeBinaryFromReader);
      msg.addTradingSessionRulesGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SecurityTradingRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SecurityTradingRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SecurityTradingRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecurityTradingRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBaseTradingRules();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.BaseTradingRules.serializeBinaryToWriter
    );
  }
  f = message.getNestedInstrumentAttributeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.NestedInstrumentAttribute.serializeBinaryToWriter
    );
  }
  f = message.getTradingSessionRulesGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.TradingSessionRulesGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional BaseTradingRules base_trading_rules = 1;
 * @return {?proto.Common.BaseTradingRules}
 */
proto.Common.SecurityTradingRules.prototype.getBaseTradingRules = function() {
  return /** @type{?proto.Common.BaseTradingRules} */ (
    jspb.Message.getWrapperField(this, proto.Common.BaseTradingRules, 1));
};


/**
 * @param {?proto.Common.BaseTradingRules|undefined} value
 * @return {!proto.Common.SecurityTradingRules} returns this
*/
proto.Common.SecurityTradingRules.prototype.setBaseTradingRules = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SecurityTradingRules} returns this
 */
proto.Common.SecurityTradingRules.prototype.clearBaseTradingRules = function() {
  return this.setBaseTradingRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SecurityTradingRules.prototype.hasBaseTradingRules = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated NestedInstrumentAttribute nested_instrument_attribute = 2;
 * @return {!Array<!proto.Common.NestedInstrumentAttribute>}
 */
proto.Common.SecurityTradingRules.prototype.getNestedInstrumentAttributeList = function() {
  return /** @type{!Array<!proto.Common.NestedInstrumentAttribute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NestedInstrumentAttribute, 2));
};


/**
 * @param {!Array<!proto.Common.NestedInstrumentAttribute>} value
 * @return {!proto.Common.SecurityTradingRules} returns this
*/
proto.Common.SecurityTradingRules.prototype.setNestedInstrumentAttributeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.NestedInstrumentAttribute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NestedInstrumentAttribute}
 */
proto.Common.SecurityTradingRules.prototype.addNestedInstrumentAttribute = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.NestedInstrumentAttribute, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.SecurityTradingRules} returns this
 */
proto.Common.SecurityTradingRules.prototype.clearNestedInstrumentAttributeList = function() {
  return this.setNestedInstrumentAttributeList([]);
};


/**
 * repeated TradingSessionRulesGrp trading_session_rules_grp = 3;
 * @return {!Array<!proto.Common.TradingSessionRulesGrp>}
 */
proto.Common.SecurityTradingRules.prototype.getTradingSessionRulesGrpList = function() {
  return /** @type{!Array<!proto.Common.TradingSessionRulesGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.TradingSessionRulesGrp, 3));
};


/**
 * @param {!Array<!proto.Common.TradingSessionRulesGrp>} value
 * @return {!proto.Common.SecurityTradingRules} returns this
*/
proto.Common.SecurityTradingRules.prototype.setTradingSessionRulesGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.TradingSessionRulesGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TradingSessionRulesGrp}
 */
proto.Common.SecurityTradingRules.prototype.addTradingSessionRulesGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.TradingSessionRulesGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.SecurityTradingRules} returns this
 */
proto.Common.SecurityTradingRules.prototype.clearTradingSessionRulesGrpList = function() {
  return this.setTradingSessionRulesGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.SettlDetails.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SettlDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SettlDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SettlDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    settlObligSource: jspb.Message.getFieldWithDefault(msg, 1, 0),
    settlPartiesList: jspb.Message.toObjectList(msg.getSettlPartiesList(),
    proto.Common.SettlParties.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SettlDetails}
 */
proto.Common.SettlDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SettlDetails;
  return proto.Common.SettlDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SettlDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SettlDetails}
 */
proto.Common.SettlDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.SettlObligSourceEnum} */ (reader.readEnum());
      msg.setSettlObligSource(value);
      break;
    case 2:
      var value = new proto.Common.SettlParties;
      reader.readMessage(value,proto.Common.SettlParties.deserializeBinaryFromReader);
      msg.addSettlParties(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SettlDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SettlDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SettlDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SettlDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSettlObligSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getSettlPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.SettlParties.serializeBinaryToWriter
    );
  }
};


/**
 * optional SettlObligSourceEnum settl_oblig_source = 1;
 * @return {!proto.Common.SettlObligSourceEnum}
 */
proto.Common.SettlDetails.prototype.getSettlObligSource = function() {
  return /** @type {!proto.Common.SettlObligSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.SettlObligSourceEnum} value
 * @return {!proto.Common.SettlDetails} returns this
 */
proto.Common.SettlDetails.prototype.setSettlObligSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * repeated SettlParties settl_parties = 2;
 * @return {!Array<!proto.Common.SettlParties>}
 */
proto.Common.SettlDetails.prototype.getSettlPartiesList = function() {
  return /** @type{!Array<!proto.Common.SettlParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.SettlParties, 2));
};


/**
 * @param {!Array<!proto.Common.SettlParties>} value
 * @return {!proto.Common.SettlDetails} returns this
*/
proto.Common.SettlDetails.prototype.setSettlPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.SettlParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.SettlParties}
 */
proto.Common.SettlDetails.prototype.addSettlParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.SettlParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.SettlDetails} returns this
 */
proto.Common.SettlDetails.prototype.clearSettlPartiesList = function() {
  return this.setSettlPartiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SecurityXML.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SecurityXML.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SecurityXML} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecurityXML.toObject = function(includeInstance, msg) {
  var f, obj = {
    securityXml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    securityXmlLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    securityXmlSchema: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SecurityXML}
 */
proto.Common.SecurityXML.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SecurityXML;
  return proto.Common.SecurityXML.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SecurityXML} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SecurityXML}
 */
proto.Common.SecurityXML.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityXml(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setSecurityXmlLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityXmlSchema(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SecurityXML.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SecurityXML.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SecurityXML} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecurityXML.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecurityXml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSecurityXmlLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getSecurityXmlSchema();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string security_xml = 1;
 * @return {string}
 */
proto.Common.SecurityXML.prototype.getSecurityXml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SecurityXML} returns this
 */
proto.Common.SecurityXML.prototype.setSecurityXml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 security_xml_len = 2;
 * @return {number}
 */
proto.Common.SecurityXML.prototype.getSecurityXmlLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.SecurityXML} returns this
 */
proto.Common.SecurityXML.prototype.setSecurityXmlLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string security_xml_schema = 3;
 * @return {string}
 */
proto.Common.SecurityXML.prototype.getSecurityXmlSchema = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.SecurityXML} returns this
 */
proto.Common.SecurityXML.prototype.setSecurityXmlSchema = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TickRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TickRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TickRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TickRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    endTickPriceRange: (f = msg.getEndTickPriceRange()) && fix_pb.Decimal64.toObject(includeInstance, f),
    startTickPriceRange: (f = msg.getStartTickPriceRange()) && fix_pb.Decimal64.toObject(includeInstance, f),
    tickIncrement: (f = msg.getTickIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    tickRuleType: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TickRules}
 */
proto.Common.TickRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TickRules;
  return proto.Common.TickRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TickRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TickRules}
 */
proto.Common.TickRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setEndTickPriceRange(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStartTickPriceRange(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTickIncrement(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.TickRuleTypeEnum} */ (reader.readEnum());
      msg.setTickRuleType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TickRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TickRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TickRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TickRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndTickPriceRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStartTickPriceRange();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTickIncrement();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTickRuleType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
};


/**
 * optional fix.Decimal64 end_tick_price_range = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TickRules.prototype.getEndTickPriceRange = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TickRules} returns this
*/
proto.Common.TickRules.prototype.setEndTickPriceRange = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TickRules} returns this
 */
proto.Common.TickRules.prototype.clearEndTickPriceRange = function() {
  return this.setEndTickPriceRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TickRules.prototype.hasEndTickPriceRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 start_tick_price_range = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TickRules.prototype.getStartTickPriceRange = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TickRules} returns this
*/
proto.Common.TickRules.prototype.setStartTickPriceRange = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TickRules} returns this
 */
proto.Common.TickRules.prototype.clearStartTickPriceRange = function() {
  return this.setStartTickPriceRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TickRules.prototype.hasStartTickPriceRange = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 tick_increment = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.TickRules.prototype.getTickIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.TickRules} returns this
*/
proto.Common.TickRules.prototype.setTickIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TickRules} returns this
 */
proto.Common.TickRules.prototype.clearTickIncrement = function() {
  return this.setTickIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TickRules.prototype.hasTickIncrement = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TickRuleTypeEnum tick_rule_type = 4;
 * @return {!proto.Common.TickRuleTypeEnum}
 */
proto.Common.TickRules.prototype.getTickRuleType = function() {
  return /** @type {!proto.Common.TickRuleTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.TickRuleTypeEnum} value
 * @return {!proto.Common.TickRules} returns this
 */
proto.Common.TickRules.prototype.setTickRuleType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.StrikeRules.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.StrikeRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.StrikeRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.StrikeRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.StrikeRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    endStrikePxRange: (f = msg.getEndStrikePxRange()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maturityRulesList: jspb.Message.toObjectList(msg.getMaturityRulesList(),
    proto.Common.MaturityRules.toObject, includeInstance),
    startStrikePxRange: (f = msg.getStartStrikePxRange()) && fix_pb.Decimal64.toObject(includeInstance, f),
    strikeExerciseStyle: jspb.Message.getFieldWithDefault(msg, 4, 0),
    strikeIncrement: (f = msg.getStrikeIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    strikeRuleId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.StrikeRules}
 */
proto.Common.StrikeRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.StrikeRules;
  return proto.Common.StrikeRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.StrikeRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.StrikeRules}
 */
proto.Common.StrikeRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setEndStrikePxRange(value);
      break;
    case 2:
      var value = new proto.Common.MaturityRules;
      reader.readMessage(value,proto.Common.MaturityRules.deserializeBinaryFromReader);
      msg.addMaturityRules(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStartStrikePxRange(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.StrikeExerciseStyleEnum} */ (reader.readEnum());
      msg.setStrikeExerciseStyle(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStrikeIncrement(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStrikeRuleId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.StrikeRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.StrikeRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.StrikeRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.StrikeRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndStrikePxRange();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaturityRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.MaturityRules.serializeBinaryToWriter
    );
  }
  f = message.getStartStrikePxRange();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStrikeExerciseStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getStrikeIncrement();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStrikeRuleId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional fix.Decimal64 end_strike_px_range = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.StrikeRules.prototype.getEndStrikePxRange = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.StrikeRules} returns this
*/
proto.Common.StrikeRules.prototype.setEndStrikePxRange = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.clearEndStrikePxRange = function() {
  return this.setEndStrikePxRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.StrikeRules.prototype.hasEndStrikePxRange = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated MaturityRules maturity_rules = 2;
 * @return {!Array<!proto.Common.MaturityRules>}
 */
proto.Common.StrikeRules.prototype.getMaturityRulesList = function() {
  return /** @type{!Array<!proto.Common.MaturityRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.MaturityRules, 2));
};


/**
 * @param {!Array<!proto.Common.MaturityRules>} value
 * @return {!proto.Common.StrikeRules} returns this
*/
proto.Common.StrikeRules.prototype.setMaturityRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.MaturityRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MaturityRules}
 */
proto.Common.StrikeRules.prototype.addMaturityRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.MaturityRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.clearMaturityRulesList = function() {
  return this.setMaturityRulesList([]);
};


/**
 * optional fix.Decimal64 start_strike_px_range = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.StrikeRules.prototype.getStartStrikePxRange = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.StrikeRules} returns this
*/
proto.Common.StrikeRules.prototype.setStartStrikePxRange = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.clearStartStrikePxRange = function() {
  return this.setStartStrikePxRange(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.StrikeRules.prototype.hasStartStrikePxRange = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional StrikeExerciseStyleEnum strike_exercise_style = 4;
 * @return {!proto.Common.StrikeExerciseStyleEnum}
 */
proto.Common.StrikeRules.prototype.getStrikeExerciseStyle = function() {
  return /** @type {!proto.Common.StrikeExerciseStyleEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.StrikeExerciseStyleEnum} value
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.setStrikeExerciseStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 strike_increment = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.StrikeRules.prototype.getStrikeIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.StrikeRules} returns this
*/
proto.Common.StrikeRules.prototype.setStrikeIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.clearStrikeIncrement = function() {
  return this.setStrikeIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.StrikeRules.prototype.hasStrikeIncrement = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string strike_rule_id = 6;
 * @return {string}
 */
proto.Common.StrikeRules.prototype.getStrikeRuleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.StrikeRules} returns this
 */
proto.Common.StrikeRules.prototype.setStrikeRuleId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MaturityRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MaturityRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MaturityRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MaturityRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    endMaturityMonthYear: jspb.Message.getFieldWithDefault(msg, 1, 0),
    maturityMonthYearFormat: jspb.Message.getFieldWithDefault(msg, 2, 0),
    maturityMonthYearIncrement: jspb.Message.getFieldWithDefault(msg, 3, 0),
    maturityMonthYearIncrementUnits: jspb.Message.getFieldWithDefault(msg, 4, 0),
    maturityRuleId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    startMaturityMonthYear: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MaturityRules}
 */
proto.Common.MaturityRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MaturityRules;
  return proto.Common.MaturityRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MaturityRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MaturityRules}
 */
proto.Common.MaturityRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEndMaturityMonthYear(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.MaturityMonthYearFormatEnum} */ (reader.readEnum());
      msg.setMaturityMonthYearFormat(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaturityMonthYearIncrement(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.MaturityMonthYearIncrementUnitsEnum} */ (reader.readEnum());
      msg.setMaturityMonthYearIncrementUnits(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMaturityRuleId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setStartMaturityMonthYear(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MaturityRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MaturityRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MaturityRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MaturityRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEndMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getMaturityMonthYearFormat();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMaturityMonthYearIncrement();
  if (f !== 0) {
    writer.writeSfixed64(
      3,
      f
    );
  }
  f = message.getMaturityMonthYearIncrementUnits();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getMaturityRuleId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStartMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      6,
      f
    );
  }
};


/**
 * optional sfixed32 end_maturity_month_year = 1;
 * @return {number}
 */
proto.Common.MaturityRules.prototype.getEndMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setEndMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MaturityMonthYearFormatEnum maturity_month_year_format = 2;
 * @return {!proto.Common.MaturityMonthYearFormatEnum}
 */
proto.Common.MaturityRules.prototype.getMaturityMonthYearFormat = function() {
  return /** @type {!proto.Common.MaturityMonthYearFormatEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.MaturityMonthYearFormatEnum} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setMaturityMonthYearFormat = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional sfixed64 maturity_month_year_increment = 3;
 * @return {number}
 */
proto.Common.MaturityRules.prototype.getMaturityMonthYearIncrement = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setMaturityMonthYearIncrement = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional MaturityMonthYearIncrementUnitsEnum maturity_month_year_increment_units = 4;
 * @return {!proto.Common.MaturityMonthYearIncrementUnitsEnum}
 */
proto.Common.MaturityRules.prototype.getMaturityMonthYearIncrementUnits = function() {
  return /** @type {!proto.Common.MaturityMonthYearIncrementUnitsEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.MaturityMonthYearIncrementUnitsEnum} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setMaturityMonthYearIncrementUnits = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string maturity_rule_id = 5;
 * @return {string}
 */
proto.Common.MaturityRules.prototype.getMaturityRuleId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setMaturityRuleId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional sfixed32 start_maturity_month_year = 6;
 * @return {number}
 */
proto.Common.MaturityRules.prototype.getStartMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.MaturityRules} returns this
 */
proto.Common.MaturityRules.prototype.setStartMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.SecondaryPriceLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.SecondaryPriceLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.SecondaryPriceLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecondaryPriceLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
    secondaryHighLimitPrice: (f = msg.getSecondaryHighLimitPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    secondaryLowLimitPrice: (f = msg.getSecondaryLowLimitPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    secondaryPriceLimitType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    secondaryTradingReferencePrice: (f = msg.getSecondaryTradingReferencePrice()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.SecondaryPriceLimits}
 */
proto.Common.SecondaryPriceLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.SecondaryPriceLimits;
  return proto.Common.SecondaryPriceLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.SecondaryPriceLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.SecondaryPriceLimits}
 */
proto.Common.SecondaryPriceLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSecondaryHighLimitPrice(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSecondaryLowLimitPrice(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.SecondaryPriceLimitTypeEnum} */ (reader.readEnum());
      msg.setSecondaryPriceLimitType(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setSecondaryTradingReferencePrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.SecondaryPriceLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.SecondaryPriceLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.SecondaryPriceLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.SecondaryPriceLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSecondaryHighLimitPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryLowLimitPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSecondaryPriceLimitType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getSecondaryTradingReferencePrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 secondary_high_limit_price = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.SecondaryPriceLimits.prototype.getSecondaryHighLimitPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.SecondaryPriceLimits} returns this
*/
proto.Common.SecondaryPriceLimits.prototype.setSecondaryHighLimitPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SecondaryPriceLimits} returns this
 */
proto.Common.SecondaryPriceLimits.prototype.clearSecondaryHighLimitPrice = function() {
  return this.setSecondaryHighLimitPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SecondaryPriceLimits.prototype.hasSecondaryHighLimitPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 secondary_low_limit_price = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.SecondaryPriceLimits.prototype.getSecondaryLowLimitPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.SecondaryPriceLimits} returns this
*/
proto.Common.SecondaryPriceLimits.prototype.setSecondaryLowLimitPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SecondaryPriceLimits} returns this
 */
proto.Common.SecondaryPriceLimits.prototype.clearSecondaryLowLimitPrice = function() {
  return this.setSecondaryLowLimitPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SecondaryPriceLimits.prototype.hasSecondaryLowLimitPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SecondaryPriceLimitTypeEnum secondary_price_limit_type = 3;
 * @return {!proto.Common.SecondaryPriceLimitTypeEnum}
 */
proto.Common.SecondaryPriceLimits.prototype.getSecondaryPriceLimitType = function() {
  return /** @type {!proto.Common.SecondaryPriceLimitTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.SecondaryPriceLimitTypeEnum} value
 * @return {!proto.Common.SecondaryPriceLimits} returns this
 */
proto.Common.SecondaryPriceLimits.prototype.setSecondaryPriceLimitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Decimal64 secondary_trading_reference_price = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.SecondaryPriceLimits.prototype.getSecondaryTradingReferencePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.SecondaryPriceLimits} returns this
*/
proto.Common.SecondaryPriceLimits.prototype.setSecondaryTradingReferencePrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.SecondaryPriceLimits} returns this
 */
proto.Common.SecondaryPriceLimits.prototype.clearSecondaryTradingReferencePrice = function() {
  return this.setSecondaryTradingReferencePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.SecondaryPriceLimits.prototype.hasSecondaryTradingReferencePrice = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.PriceLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.PriceLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.PriceLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PriceLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
    highLimitPrice: (f = msg.getHighLimitPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    lowLimitPrice: (f = msg.getLowLimitPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceLimitType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    tradingReferencePrice: (f = msg.getTradingReferencePrice()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.PriceLimits}
 */
proto.Common.PriceLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.PriceLimits;
  return proto.Common.PriceLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.PriceLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.PriceLimits}
 */
proto.Common.PriceLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setHighLimitPrice(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setLowLimitPrice(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.PriceLimitTypeEnum} */ (reader.readEnum());
      msg.setPriceLimitType(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setTradingReferencePrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.PriceLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.PriceLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.PriceLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.PriceLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHighLimitPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getLowLimitPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceLimitType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getTradingReferencePrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 high_limit_price = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PriceLimits.prototype.getHighLimitPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PriceLimits} returns this
*/
proto.Common.PriceLimits.prototype.setHighLimitPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PriceLimits} returns this
 */
proto.Common.PriceLimits.prototype.clearHighLimitPrice = function() {
  return this.setHighLimitPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PriceLimits.prototype.hasHighLimitPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 low_limit_price = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PriceLimits.prototype.getLowLimitPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PriceLimits} returns this
*/
proto.Common.PriceLimits.prototype.setLowLimitPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PriceLimits} returns this
 */
proto.Common.PriceLimits.prototype.clearLowLimitPrice = function() {
  return this.setLowLimitPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PriceLimits.prototype.hasLowLimitPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional PriceLimitTypeEnum price_limit_type = 3;
 * @return {!proto.Common.PriceLimitTypeEnum}
 */
proto.Common.PriceLimits.prototype.getPriceLimitType = function() {
  return /** @type {!proto.Common.PriceLimitTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.PriceLimitTypeEnum} value
 * @return {!proto.Common.PriceLimits} returns this
 */
proto.Common.PriceLimits.prototype.setPriceLimitType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional fix.Decimal64 trading_reference_price = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.PriceLimits.prototype.getTradingReferencePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.PriceLimits} returns this
*/
proto.Common.PriceLimits.prototype.setTradingReferencePrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.PriceLimits} returns this
 */
proto.Common.PriceLimits.prototype.clearTradingReferencePrice = function() {
  return this.setTradingReferencePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.PriceLimits.prototype.hasTradingReferencePrice = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MarketDataFeedTypes.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MarketDataFeedTypes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MarketDataFeedTypes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MarketDataFeedTypes.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketDepth: jspb.Message.getFieldWithDefault(msg, 1, 0),
    mdBookType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    mdFeedType: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MarketDataFeedTypes}
 */
proto.Common.MarketDataFeedTypes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MarketDataFeedTypes;
  return proto.Common.MarketDataFeedTypes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MarketDataFeedTypes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MarketDataFeedTypes}
 */
proto.Common.MarketDataFeedTypes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMarketDepth(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.MDBookTypeEnum} */ (reader.readEnum());
      msg.setMdBookType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMdFeedType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MarketDataFeedTypes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MarketDataFeedTypes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MarketDataFeedTypes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MarketDataFeedTypes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketDepth();
  if (f !== 0) {
    writer.writeSfixed64(
      1,
      f
    );
  }
  f = message.getMdBookType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getMdFeedType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional sfixed64 market_depth = 1;
 * @return {number}
 */
proto.Common.MarketDataFeedTypes.prototype.getMarketDepth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.MarketDataFeedTypes} returns this
 */
proto.Common.MarketDataFeedTypes.prototype.setMarketDepth = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional MDBookTypeEnum md_book_type = 2;
 * @return {!proto.Common.MDBookTypeEnum}
 */
proto.Common.MarketDataFeedTypes.prototype.getMdBookType = function() {
  return /** @type {!proto.Common.MDBookTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.MDBookTypeEnum} value
 * @return {!proto.Common.MarketDataFeedTypes} returns this
 */
proto.Common.MarketDataFeedTypes.prototype.setMdBookType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string md_feed_type = 3;
 * @return {string}
 */
proto.Common.MarketDataFeedTypes.prototype.getMdFeedType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MarketDataFeedTypes} returns this
 */
proto.Common.MarketDataFeedTypes.prototype.setMdFeedType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.LotTypeRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.LotTypeRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.LotTypeRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LotTypeRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    lotType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    minLotSize: (f = msg.getMinLotSize()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.LotTypeRules}
 */
proto.Common.LotTypeRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.LotTypeRules;
  return proto.Common.LotTypeRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.LotTypeRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.LotTypeRules}
 */
proto.Common.LotTypeRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.LotTypeEnum} */ (reader.readEnum());
      msg.setLotType(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinLotSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.LotTypeRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.LotTypeRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.LotTypeRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.LotTypeRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLotType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getMinLotSize();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional LotTypeEnum lot_type = 1;
 * @return {!proto.Common.LotTypeEnum}
 */
proto.Common.LotTypeRules.prototype.getLotType = function() {
  return /** @type {!proto.Common.LotTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.LotTypeEnum} value
 * @return {!proto.Common.LotTypeRules} returns this
 */
proto.Common.LotTypeRules.prototype.setLotType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional fix.Decimal64 min_lot_size = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.LotTypeRules.prototype.getMinLotSize = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.LotTypeRules} returns this
*/
proto.Common.LotTypeRules.prototype.setMinLotSize = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.LotTypeRules} returns this
 */
proto.Common.LotTypeRules.prototype.clearMinLotSize = function() {
  return this.setMinLotSize(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.LotTypeRules.prototype.hasMinLotSize = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MatchRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MatchRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MatchRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MatchRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    matchAlgorithm: jspb.Message.getFieldWithDefault(msg, 1, ""),
    matchType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MatchRules}
 */
proto.Common.MatchRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MatchRules;
  return proto.Common.MatchRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MatchRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MatchRules}
 */
proto.Common.MatchRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMatchAlgorithm(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.MatchTypeEnum} */ (reader.readEnum());
      msg.setMatchType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MatchRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MatchRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MatchRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MatchRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMatchAlgorithm();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMatchType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string match_algorithm = 1;
 * @return {string}
 */
proto.Common.MatchRules.prototype.getMatchAlgorithm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MatchRules} returns this
 */
proto.Common.MatchRules.prototype.setMatchAlgorithm = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional MatchTypeEnum match_type = 2;
 * @return {!proto.Common.MatchTypeEnum}
 */
proto.Common.MatchRules.prototype.getMatchType = function() {
  return /** @type {!proto.Common.MatchTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.MatchTypeEnum} value
 * @return {!proto.Common.MatchRules} returns this
 */
proto.Common.MatchRules.prototype.setMatchType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ExecInstRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ExecInstRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ExecInstRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ExecInstRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    execInstValue: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ExecInstRules}
 */
proto.Common.ExecInstRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ExecInstRules;
  return proto.Common.ExecInstRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ExecInstRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ExecInstRules}
 */
proto.Common.ExecInstRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.ExecInstValueEnum} */ (reader.readEnum());
      msg.setExecInstValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ExecInstRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ExecInstRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ExecInstRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ExecInstRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExecInstValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ExecInstValueEnum exec_inst_value = 1;
 * @return {!proto.Common.ExecInstValueEnum}
 */
proto.Common.ExecInstRules.prototype.getExecInstValue = function() {
  return /** @type {!proto.Common.ExecInstValueEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.ExecInstValueEnum} value
 * @return {!proto.Common.ExecInstRules} returns this
 */
proto.Common.ExecInstRules.prototype.setExecInstValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TimeInForceRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TimeInForceRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TimeInForceRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TimeInForceRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    timeInForce: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TimeInForceRules}
 */
proto.Common.TimeInForceRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TimeInForceRules;
  return proto.Common.TimeInForceRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TimeInForceRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TimeInForceRules}
 */
proto.Common.TimeInForceRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.TimeInForceEnum} */ (reader.readEnum());
      msg.setTimeInForce(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TimeInForceRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TimeInForceRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TimeInForceRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TimeInForceRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimeInForce();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional TimeInForceEnum time_in_force = 1;
 * @return {!proto.Common.TimeInForceEnum}
 */
proto.Common.TimeInForceRules.prototype.getTimeInForce = function() {
  return /** @type {!proto.Common.TimeInForceEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.TimeInForceEnum} value
 * @return {!proto.Common.TimeInForceRules} returns this
 */
proto.Common.TimeInForceRules.prototype.setTimeInForce = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.OrdTypeRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.OrdTypeRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.OrdTypeRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrdTypeRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordType: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.OrdTypeRules}
 */
proto.Common.OrdTypeRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.OrdTypeRules;
  return proto.Common.OrdTypeRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.OrdTypeRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.OrdTypeRules}
 */
proto.Common.OrdTypeRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.OrdTypeEnum} */ (reader.readEnum());
      msg.setOrdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.OrdTypeRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.OrdTypeRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.OrdTypeRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.OrdTypeRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional OrdTypeEnum ord_type = 1;
 * @return {!proto.Common.OrdTypeEnum}
 */
proto.Common.OrdTypeRules.prototype.getOrdType = function() {
  return /** @type {!proto.Common.OrdTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.OrdTypeEnum} value
 * @return {!proto.Common.OrdTypeRules} returns this
 */
proto.Common.OrdTypeRules.prototype.setOrdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.TradingSessionRules.repeatedFields_ = [1,2,3,4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TradingSessionRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TradingSessionRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TradingSessionRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TradingSessionRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    execInstRulesList: jspb.Message.toObjectList(msg.getExecInstRulesList(),
    proto.Common.ExecInstRules.toObject, includeInstance),
    marketDataFeedTypesList: jspb.Message.toObjectList(msg.getMarketDataFeedTypesList(),
    proto.Common.MarketDataFeedTypes.toObject, includeInstance),
    matchRulesList: jspb.Message.toObjectList(msg.getMatchRulesList(),
    proto.Common.MatchRules.toObject, includeInstance),
    ordTypeRulesList: jspb.Message.toObjectList(msg.getOrdTypeRulesList(),
    proto.Common.OrdTypeRules.toObject, includeInstance),
    timeInForceRulesList: jspb.Message.toObjectList(msg.getTimeInForceRulesList(),
    proto.Common.TimeInForceRules.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TradingSessionRules}
 */
proto.Common.TradingSessionRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TradingSessionRules;
  return proto.Common.TradingSessionRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TradingSessionRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TradingSessionRules}
 */
proto.Common.TradingSessionRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.ExecInstRules;
      reader.readMessage(value,proto.Common.ExecInstRules.deserializeBinaryFromReader);
      msg.addExecInstRules(value);
      break;
    case 2:
      var value = new proto.Common.MarketDataFeedTypes;
      reader.readMessage(value,proto.Common.MarketDataFeedTypes.deserializeBinaryFromReader);
      msg.addMarketDataFeedTypes(value);
      break;
    case 3:
      var value = new proto.Common.MatchRules;
      reader.readMessage(value,proto.Common.MatchRules.deserializeBinaryFromReader);
      msg.addMatchRules(value);
      break;
    case 4:
      var value = new proto.Common.OrdTypeRules;
      reader.readMessage(value,proto.Common.OrdTypeRules.deserializeBinaryFromReader);
      msg.addOrdTypeRules(value);
      break;
    case 5:
      var value = new proto.Common.TimeInForceRules;
      reader.readMessage(value,proto.Common.TimeInForceRules.deserializeBinaryFromReader);
      msg.addTimeInForceRules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TradingSessionRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TradingSessionRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TradingSessionRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TradingSessionRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExecInstRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Common.ExecInstRules.serializeBinaryToWriter
    );
  }
  f = message.getMarketDataFeedTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.MarketDataFeedTypes.serializeBinaryToWriter
    );
  }
  f = message.getMatchRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.MatchRules.serializeBinaryToWriter
    );
  }
  f = message.getOrdTypeRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.OrdTypeRules.serializeBinaryToWriter
    );
  }
  f = message.getTimeInForceRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.Common.TimeInForceRules.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ExecInstRules exec_inst_rules = 1;
 * @return {!Array<!proto.Common.ExecInstRules>}
 */
proto.Common.TradingSessionRules.prototype.getExecInstRulesList = function() {
  return /** @type{!Array<!proto.Common.ExecInstRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.ExecInstRules, 1));
};


/**
 * @param {!Array<!proto.Common.ExecInstRules>} value
 * @return {!proto.Common.TradingSessionRules} returns this
*/
proto.Common.TradingSessionRules.prototype.setExecInstRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Common.ExecInstRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ExecInstRules}
 */
proto.Common.TradingSessionRules.prototype.addExecInstRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Common.ExecInstRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TradingSessionRules} returns this
 */
proto.Common.TradingSessionRules.prototype.clearExecInstRulesList = function() {
  return this.setExecInstRulesList([]);
};


/**
 * repeated MarketDataFeedTypes market_data_feed_types = 2;
 * @return {!Array<!proto.Common.MarketDataFeedTypes>}
 */
proto.Common.TradingSessionRules.prototype.getMarketDataFeedTypesList = function() {
  return /** @type{!Array<!proto.Common.MarketDataFeedTypes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.MarketDataFeedTypes, 2));
};


/**
 * @param {!Array<!proto.Common.MarketDataFeedTypes>} value
 * @return {!proto.Common.TradingSessionRules} returns this
*/
proto.Common.TradingSessionRules.prototype.setMarketDataFeedTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.MarketDataFeedTypes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MarketDataFeedTypes}
 */
proto.Common.TradingSessionRules.prototype.addMarketDataFeedTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.MarketDataFeedTypes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TradingSessionRules} returns this
 */
proto.Common.TradingSessionRules.prototype.clearMarketDataFeedTypesList = function() {
  return this.setMarketDataFeedTypesList([]);
};


/**
 * repeated MatchRules match_rules = 3;
 * @return {!Array<!proto.Common.MatchRules>}
 */
proto.Common.TradingSessionRules.prototype.getMatchRulesList = function() {
  return /** @type{!Array<!proto.Common.MatchRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.MatchRules, 3));
};


/**
 * @param {!Array<!proto.Common.MatchRules>} value
 * @return {!proto.Common.TradingSessionRules} returns this
*/
proto.Common.TradingSessionRules.prototype.setMatchRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.MatchRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MatchRules}
 */
proto.Common.TradingSessionRules.prototype.addMatchRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.MatchRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TradingSessionRules} returns this
 */
proto.Common.TradingSessionRules.prototype.clearMatchRulesList = function() {
  return this.setMatchRulesList([]);
};


/**
 * repeated OrdTypeRules ord_type_rules = 4;
 * @return {!Array<!proto.Common.OrdTypeRules>}
 */
proto.Common.TradingSessionRules.prototype.getOrdTypeRulesList = function() {
  return /** @type{!Array<!proto.Common.OrdTypeRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.OrdTypeRules, 4));
};


/**
 * @param {!Array<!proto.Common.OrdTypeRules>} value
 * @return {!proto.Common.TradingSessionRules} returns this
*/
proto.Common.TradingSessionRules.prototype.setOrdTypeRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.OrdTypeRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.OrdTypeRules}
 */
proto.Common.TradingSessionRules.prototype.addOrdTypeRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.OrdTypeRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TradingSessionRules} returns this
 */
proto.Common.TradingSessionRules.prototype.clearOrdTypeRulesList = function() {
  return this.setOrdTypeRulesList([]);
};


/**
 * repeated TimeInForceRules time_in_force_rules = 5;
 * @return {!Array<!proto.Common.TimeInForceRules>}
 */
proto.Common.TradingSessionRules.prototype.getTimeInForceRulesList = function() {
  return /** @type{!Array<!proto.Common.TimeInForceRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.TimeInForceRules, 5));
};


/**
 * @param {!Array<!proto.Common.TimeInForceRules>} value
 * @return {!proto.Common.TradingSessionRules} returns this
*/
proto.Common.TradingSessionRules.prototype.setTimeInForceRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Common.TimeInForceRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TimeInForceRules}
 */
proto.Common.TradingSessionRules.prototype.addTimeInForceRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Common.TimeInForceRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.TradingSessionRules} returns this
 */
proto.Common.TradingSessionRules.prototype.clearTimeInForceRulesList = function() {
  return this.setTimeInForceRulesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.TradingSessionRulesGrp.oneofGroups_ = [[1,2],[4,5]];

/**
 * @enum {number}
 */
proto.Common.TradingSessionRulesGrp.TradingSessionIdUnionCase = {
  TRADING_SESSION_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_ID: 1,
  TRADING_SESSION_ID_RESERVED100PLUS: 2
};

/**
 * @return {proto.Common.TradingSessionRulesGrp.TradingSessionIdUnionCase}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionIdUnionCase = function() {
  return /** @type {proto.Common.TradingSessionRulesGrp.TradingSessionIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TradingSessionRulesGrp.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.Common.TradingSessionRulesGrp.TradingSessionSubIdUnionCase = {
  TRADING_SESSION_SUB_ID_UNION_NOT_SET: 0,
  TRADING_SESSION_SUB_ID: 4,
  TRADING_SESSION_SUB_ID_RESERVED100PLUS: 5
};

/**
 * @return {proto.Common.TradingSessionRulesGrp.TradingSessionSubIdUnionCase}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionSubIdUnionCase = function() {
  return /** @type {proto.Common.TradingSessionRulesGrp.TradingSessionSubIdUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.TradingSessionRulesGrp.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TradingSessionRulesGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TradingSessionRulesGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TradingSessionRulesGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TradingSessionRulesGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    tradingSessionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tradingSessionIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 2, 0),
    tradingSessionRules: (f = msg.getTradingSessionRules()) && proto.Common.TradingSessionRules.toObject(includeInstance, f),
    tradingSessionSubId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    tradingSessionSubIdReserved100plus: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TradingSessionRulesGrp}
 */
proto.Common.TradingSessionRulesGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TradingSessionRulesGrp;
  return proto.Common.TradingSessionRulesGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TradingSessionRulesGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TradingSessionRulesGrp}
 */
proto.Common.TradingSessionRulesGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.TradingSessionIDEnum} */ (reader.readEnum());
      msg.setTradingSessionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionIdReserved100plus(value);
      break;
    case 3:
      var value = new proto.Common.TradingSessionRules;
      reader.readMessage(value,proto.Common.TradingSessionRules.deserializeBinaryFromReader);
      msg.setTradingSessionRules(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (reader.readEnum());
      msg.setTradingSessionSubId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setTradingSessionSubIdReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TradingSessionRulesGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TradingSessionRulesGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TradingSessionRulesGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TradingSessionRulesGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFixed32(
      2,
      f
    );
  }
  f = message.getTradingSessionRules();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Common.TradingSessionRules.serializeBinaryToWriter
    );
  }
  f = /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeFixed32(
      5,
      f
    );
  }
};


/**
 * optional TradingSessionIDEnum trading_session_id = 1;
 * @return {!proto.Common.TradingSessionIDEnum}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionId = function() {
  return /** @type {!proto.Common.TradingSessionIDEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.TradingSessionIDEnum} value
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.setTradingSessionId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.Common.TradingSessionRulesGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.clearTradingSessionId = function() {
  return jspb.Message.setOneofField(this, 1, proto.Common.TradingSessionRulesGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TradingSessionRulesGrp.prototype.hasTradingSessionId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fixed32 trading_session_id_reserved100plus = 2;
 * @return {number}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.setTradingSessionIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.Common.TradingSessionRulesGrp.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.clearTradingSessionIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 2, proto.Common.TradingSessionRulesGrp.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TradingSessionRulesGrp.prototype.hasTradingSessionIdReserved100plus = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional TradingSessionRules trading_session_rules = 3;
 * @return {?proto.Common.TradingSessionRules}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionRules = function() {
  return /** @type{?proto.Common.TradingSessionRules} */ (
    jspb.Message.getWrapperField(this, proto.Common.TradingSessionRules, 3));
};


/**
 * @param {?proto.Common.TradingSessionRules|undefined} value
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
*/
proto.Common.TradingSessionRulesGrp.prototype.setTradingSessionRules = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.clearTradingSessionRules = function() {
  return this.setTradingSessionRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TradingSessionRulesGrp.prototype.hasTradingSessionRules = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional TradingSessionSubIDEnum trading_session_sub_id = 4;
 * @return {!proto.Common.TradingSessionSubIDEnum}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionSubId = function() {
  return /** @type {!proto.Common.TradingSessionSubIDEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.TradingSessionSubIDEnum} value
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.setTradingSessionSubId = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.Common.TradingSessionRulesGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.clearTradingSessionSubId = function() {
  return jspb.Message.setOneofField(this, 4, proto.Common.TradingSessionRulesGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TradingSessionRulesGrp.prototype.hasTradingSessionSubId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fixed32 trading_session_sub_id_reserved100plus = 5;
 * @return {number}
 */
proto.Common.TradingSessionRulesGrp.prototype.getTradingSessionSubIdReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.setTradingSessionSubIdReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 5, proto.Common.TradingSessionRulesGrp.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.TradingSessionRulesGrp} returns this
 */
proto.Common.TradingSessionRulesGrp.prototype.clearTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.setOneofField(this, 5, proto.Common.TradingSessionRulesGrp.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.TradingSessionRulesGrp.prototype.hasTradingSessionSubIdReserved100plus = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.BaseTradingRules.repeatedFields_ = [3,12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.BaseTradingRules.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.BaseTradingRules.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.BaseTradingRules} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.BaseTradingRules.toObject = function(includeInstance, msg) {
  var f, obj = {
    expirationCycle: jspb.Message.getFieldWithDefault(msg, 1, 0),
    impliedMarketIndicator: jspb.Message.getFieldWithDefault(msg, 2, 0),
    lotTypeRulesList: jspb.Message.toObjectList(msg.getLotTypeRulesList(),
    proto.Common.LotTypeRules.toObject, includeInstance),
    maxPriceVariation: (f = msg.getMaxPriceVariation()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxTradeVol: (f = msg.getMaxTradeVol()) && fix_pb.Decimal64.toObject(includeInstance, f),
    minTradeVol: (f = msg.getMinTradeVol()) && fix_pb.Decimal64.toObject(includeInstance, f),
    multilegModel: jspb.Message.getFieldWithDefault(msg, 7, 0),
    multilegPriceMethod: jspb.Message.getFieldWithDefault(msg, 8, 0),
    priceLimits: (f = msg.getPriceLimits()) && proto.Common.PriceLimits.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 10, 0),
    roundLot: (f = msg.getRoundLot()) && fix_pb.Decimal64.toObject(includeInstance, f),
    tickRulesList: jspb.Message.toObjectList(msg.getTickRulesList(),
    proto.Common.TickRules.toObject, includeInstance),
    tradingCurrency: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.BaseTradingRules}
 */
proto.Common.BaseTradingRules.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.BaseTradingRules;
  return proto.Common.BaseTradingRules.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.BaseTradingRules} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.BaseTradingRules}
 */
proto.Common.BaseTradingRules.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.ExpirationCycleEnum} */ (reader.readEnum());
      msg.setExpirationCycle(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.ImpliedMarketIndicatorEnum} */ (reader.readEnum());
      msg.setImpliedMarketIndicator(value);
      break;
    case 3:
      var value = new proto.Common.LotTypeRules;
      reader.readMessage(value,proto.Common.LotTypeRules.deserializeBinaryFromReader);
      msg.addLotTypeRules(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxPriceVariation(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxTradeVol(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinTradeVol(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.MultilegModelEnum} */ (reader.readEnum());
      msg.setMultilegModel(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.MultilegPriceMethodEnum} */ (reader.readEnum());
      msg.setMultilegPriceMethod(value);
      break;
    case 9:
      var value = new proto.Common.PriceLimits;
      reader.readMessage(value,proto.Common.PriceLimits.deserializeBinaryFromReader);
      msg.setPriceLimits(value);
      break;
    case 10:
      var value = /** @type {!proto.Common.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 11:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRoundLot(value);
      break;
    case 12:
      var value = new proto.Common.TickRules;
      reader.readMessage(value,proto.Common.TickRules.deserializeBinaryFromReader);
      msg.addTickRules(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setTradingCurrency(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.BaseTradingRules.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.BaseTradingRules.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.BaseTradingRules} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.BaseTradingRules.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpirationCycle();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getImpliedMarketIndicator();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getLotTypeRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.LotTypeRules.serializeBinaryToWriter
    );
  }
  f = message.getMaxPriceVariation();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxTradeVol();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMinTradeVol();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMultilegModel();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getMultilegPriceMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getPriceLimits();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.Common.PriceLimits.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getRoundLot();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getTickRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.Common.TickRules.serializeBinaryToWriter
    );
  }
  f = message.getTradingCurrency();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional ExpirationCycleEnum expiration_cycle = 1;
 * @return {!proto.Common.ExpirationCycleEnum}
 */
proto.Common.BaseTradingRules.prototype.getExpirationCycle = function() {
  return /** @type {!proto.Common.ExpirationCycleEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.ExpirationCycleEnum} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setExpirationCycle = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional ImpliedMarketIndicatorEnum implied_market_indicator = 2;
 * @return {!proto.Common.ImpliedMarketIndicatorEnum}
 */
proto.Common.BaseTradingRules.prototype.getImpliedMarketIndicator = function() {
  return /** @type {!proto.Common.ImpliedMarketIndicatorEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.ImpliedMarketIndicatorEnum} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setImpliedMarketIndicator = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * repeated LotTypeRules lot_type_rules = 3;
 * @return {!Array<!proto.Common.LotTypeRules>}
 */
proto.Common.BaseTradingRules.prototype.getLotTypeRulesList = function() {
  return /** @type{!Array<!proto.Common.LotTypeRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.LotTypeRules, 3));
};


/**
 * @param {!Array<!proto.Common.LotTypeRules>} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setLotTypeRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.LotTypeRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.LotTypeRules}
 */
proto.Common.BaseTradingRules.prototype.addLotTypeRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.LotTypeRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearLotTypeRulesList = function() {
  return this.setLotTypeRulesList([]);
};


/**
 * optional fix.Decimal64 max_price_variation = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.BaseTradingRules.prototype.getMaxPriceVariation = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setMaxPriceVariation = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearMaxPriceVariation = function() {
  return this.setMaxPriceVariation(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.BaseTradingRules.prototype.hasMaxPriceVariation = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 max_trade_vol = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.BaseTradingRules.prototype.getMaxTradeVol = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setMaxTradeVol = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearMaxTradeVol = function() {
  return this.setMaxTradeVol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.BaseTradingRules.prototype.hasMaxTradeVol = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 min_trade_vol = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.BaseTradingRules.prototype.getMinTradeVol = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setMinTradeVol = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearMinTradeVol = function() {
  return this.setMinTradeVol(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.BaseTradingRules.prototype.hasMinTradeVol = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional MultilegModelEnum multileg_model = 7;
 * @return {!proto.Common.MultilegModelEnum}
 */
proto.Common.BaseTradingRules.prototype.getMultilegModel = function() {
  return /** @type {!proto.Common.MultilegModelEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.MultilegModelEnum} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setMultilegModel = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional MultilegPriceMethodEnum multileg_price_method = 8;
 * @return {!proto.Common.MultilegPriceMethodEnum}
 */
proto.Common.BaseTradingRules.prototype.getMultilegPriceMethod = function() {
  return /** @type {!proto.Common.MultilegPriceMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.MultilegPriceMethodEnum} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setMultilegPriceMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional PriceLimits price_limits = 9;
 * @return {?proto.Common.PriceLimits}
 */
proto.Common.BaseTradingRules.prototype.getPriceLimits = function() {
  return /** @type{?proto.Common.PriceLimits} */ (
    jspb.Message.getWrapperField(this, proto.Common.PriceLimits, 9));
};


/**
 * @param {?proto.Common.PriceLimits|undefined} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setPriceLimits = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearPriceLimits = function() {
  return this.setPriceLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.BaseTradingRules.prototype.hasPriceLimits = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional PriceTypeEnum price_type = 10;
 * @return {!proto.Common.PriceTypeEnum}
 */
proto.Common.BaseTradingRules.prototype.getPriceType = function() {
  return /** @type {!proto.Common.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.Common.PriceTypeEnum} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional fix.Decimal64 round_lot = 11;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.BaseTradingRules.prototype.getRoundLot = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 11));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setRoundLot = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearRoundLot = function() {
  return this.setRoundLot(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.BaseTradingRules.prototype.hasRoundLot = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * repeated TickRules tick_rules = 12;
 * @return {!Array<!proto.Common.TickRules>}
 */
proto.Common.BaseTradingRules.prototype.getTickRulesList = function() {
  return /** @type{!Array<!proto.Common.TickRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.TickRules, 12));
};


/**
 * @param {!Array<!proto.Common.TickRules>} value
 * @return {!proto.Common.BaseTradingRules} returns this
*/
proto.Common.BaseTradingRules.prototype.setTickRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.Common.TickRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.TickRules}
 */
proto.Common.BaseTradingRules.prototype.addTickRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.Common.TickRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.clearTickRulesList = function() {
  return this.setTickRulesList([]);
};


/**
 * optional string trading_currency = 13;
 * @return {string}
 */
proto.Common.BaseTradingRules.prototype.getTradingCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.BaseTradingRules} returns this
 */
proto.Common.BaseTradingRules.prototype.setTradingCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.MarketSegmentGrp.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.MarketSegmentGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.MarketSegmentGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.MarketSegmentGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MarketSegmentGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    marketId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    marketSegmentId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    securityTradingRules: (f = msg.getSecurityTradingRules()) && proto.Common.SecurityTradingRules.toObject(includeInstance, f),
    strikeRulesList: jspb.Message.toObjectList(msg.getStrikeRulesList(),
    proto.Common.StrikeRules.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.MarketSegmentGrp}
 */
proto.Common.MarketSegmentGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.MarketSegmentGrp;
  return proto.Common.MarketSegmentGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.MarketSegmentGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.MarketSegmentGrp}
 */
proto.Common.MarketSegmentGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketSegmentId(value);
      break;
    case 3:
      var value = new proto.Common.SecurityTradingRules;
      reader.readMessage(value,proto.Common.SecurityTradingRules.deserializeBinaryFromReader);
      msg.setSecurityTradingRules(value);
      break;
    case 4:
      var value = new proto.Common.StrikeRules;
      reader.readMessage(value,proto.Common.StrikeRules.deserializeBinaryFromReader);
      msg.addStrikeRules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.MarketSegmentGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.MarketSegmentGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.MarketSegmentGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.MarketSegmentGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMarketSegmentId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSecurityTradingRules();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.Common.SecurityTradingRules.serializeBinaryToWriter
    );
  }
  f = message.getStrikeRulesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.StrikeRules.serializeBinaryToWriter
    );
  }
};


/**
 * optional string market_id = 1;
 * @return {string}
 */
proto.Common.MarketSegmentGrp.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MarketSegmentGrp} returns this
 */
proto.Common.MarketSegmentGrp.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string market_segment_id = 2;
 * @return {string}
 */
proto.Common.MarketSegmentGrp.prototype.getMarketSegmentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.MarketSegmentGrp} returns this
 */
proto.Common.MarketSegmentGrp.prototype.setMarketSegmentId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional SecurityTradingRules security_trading_rules = 3;
 * @return {?proto.Common.SecurityTradingRules}
 */
proto.Common.MarketSegmentGrp.prototype.getSecurityTradingRules = function() {
  return /** @type{?proto.Common.SecurityTradingRules} */ (
    jspb.Message.getWrapperField(this, proto.Common.SecurityTradingRules, 3));
};


/**
 * @param {?proto.Common.SecurityTradingRules|undefined} value
 * @return {!proto.Common.MarketSegmentGrp} returns this
*/
proto.Common.MarketSegmentGrp.prototype.setSecurityTradingRules = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.MarketSegmentGrp} returns this
 */
proto.Common.MarketSegmentGrp.prototype.clearSecurityTradingRules = function() {
  return this.setSecurityTradingRules(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.MarketSegmentGrp.prototype.hasSecurityTradingRules = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated StrikeRules strike_rules = 4;
 * @return {!Array<!proto.Common.StrikeRules>}
 */
proto.Common.MarketSegmentGrp.prototype.getStrikeRulesList = function() {
  return /** @type{!Array<!proto.Common.StrikeRules>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.StrikeRules, 4));
};


/**
 * @param {!Array<!proto.Common.StrikeRules>} value
 * @return {!proto.Common.MarketSegmentGrp} returns this
*/
proto.Common.MarketSegmentGrp.prototype.setStrikeRulesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.StrikeRules=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.StrikeRules}
 */
proto.Common.MarketSegmentGrp.prototype.addStrikeRules = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.StrikeRules, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.MarketSegmentGrp} returns this
 */
proto.Common.MarketSegmentGrp.prototype.clearStrikeRulesList = function() {
  return this.setStrikeRulesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeInstrumentPartySubIDsGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeInstrumentPartySubIDsGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeInstrumentPartySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    derivativeInstrumentPartySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeInstrumentPartySubIDsGrp}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeInstrumentPartySubIDsGrp;
  return proto.Common.DerivativeInstrumentPartySubIDsGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeInstrumentPartySubIDsGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeInstrumentPartySubIDsGrp}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeInstrumentPartySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.DerivativeInstrumentPartySubIDTypeEnum} */ (reader.readEnum());
      msg.setDerivativeInstrumentPartySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeInstrumentPartySubIDsGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeInstrumentPartySubIDsGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeInstrumentPartySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDerivativeInstrumentPartySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string derivative_instrument_party_sub_id = 1;
 * @return {string}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.getDerivativeInstrumentPartySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrumentPartySubIDsGrp} returns this
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.setDerivativeInstrumentPartySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DerivativeInstrumentPartySubIDTypeEnum derivative_instrument_party_sub_id_type = 2;
 * @return {!proto.Common.DerivativeInstrumentPartySubIDTypeEnum}
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.getDerivativeInstrumentPartySubIdType = function() {
  return /** @type {!proto.Common.DerivativeInstrumentPartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DerivativeInstrumentPartySubIDTypeEnum} value
 * @return {!proto.Common.DerivativeInstrumentPartySubIDsGrp} returns this
 */
proto.Common.DerivativeInstrumentPartySubIDsGrp.prototype.setDerivativeInstrumentPartySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.DerivativeInstrumentParties.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeInstrumentParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeInstrumentParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeInstrumentParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeInstrumentPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    derivativeInstrumentPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    derivativeInstrumentPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    derivativeInstrumentPartySubIdsGrpList: jspb.Message.toObjectList(msg.getDerivativeInstrumentPartySubIdsGrpList(),
    proto.Common.DerivativeInstrumentPartySubIDsGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeInstrumentParties}
 */
proto.Common.DerivativeInstrumentParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeInstrumentParties;
  return proto.Common.DerivativeInstrumentParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeInstrumentParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeInstrumentParties}
 */
proto.Common.DerivativeInstrumentParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeInstrumentPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.DerivativeInstrumentPartyIDSourceEnum} */ (reader.readEnum());
      msg.setDerivativeInstrumentPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.DerivativeInstrumentPartyRoleEnum} */ (reader.readEnum());
      msg.setDerivativeInstrumentPartyRole(value);
      break;
    case 4:
      var value = new proto.Common.DerivativeInstrumentPartySubIDsGrp;
      reader.readMessage(value,proto.Common.DerivativeInstrumentPartySubIDsGrp.deserializeBinaryFromReader);
      msg.addDerivativeInstrumentPartySubIdsGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeInstrumentParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeInstrumentParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeInstrumentParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeInstrumentPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDerivativeInstrumentPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getDerivativeInstrumentPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getDerivativeInstrumentPartySubIdsGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.DerivativeInstrumentPartySubIDsGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string derivative_instrument_party_id = 1;
 * @return {string}
 */
proto.Common.DerivativeInstrumentParties.prototype.getDerivativeInstrumentPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrumentParties} returns this
 */
proto.Common.DerivativeInstrumentParties.prototype.setDerivativeInstrumentPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DerivativeInstrumentPartyIDSourceEnum derivative_instrument_party_id_source = 2;
 * @return {!proto.Common.DerivativeInstrumentPartyIDSourceEnum}
 */
proto.Common.DerivativeInstrumentParties.prototype.getDerivativeInstrumentPartyIdSource = function() {
  return /** @type {!proto.Common.DerivativeInstrumentPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DerivativeInstrumentPartyIDSourceEnum} value
 * @return {!proto.Common.DerivativeInstrumentParties} returns this
 */
proto.Common.DerivativeInstrumentParties.prototype.setDerivativeInstrumentPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional DerivativeInstrumentPartyRoleEnum derivative_instrument_party_role = 3;
 * @return {!proto.Common.DerivativeInstrumentPartyRoleEnum}
 */
proto.Common.DerivativeInstrumentParties.prototype.getDerivativeInstrumentPartyRole = function() {
  return /** @type {!proto.Common.DerivativeInstrumentPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.DerivativeInstrumentPartyRoleEnum} value
 * @return {!proto.Common.DerivativeInstrumentParties} returns this
 */
proto.Common.DerivativeInstrumentParties.prototype.setDerivativeInstrumentPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated DerivativeInstrumentPartySubIDsGrp derivative_instrument_party_sub_ids_grp = 4;
 * @return {!Array<!proto.Common.DerivativeInstrumentPartySubIDsGrp>}
 */
proto.Common.DerivativeInstrumentParties.prototype.getDerivativeInstrumentPartySubIdsGrpList = function() {
  return /** @type{!Array<!proto.Common.DerivativeInstrumentPartySubIDsGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DerivativeInstrumentPartySubIDsGrp, 4));
};


/**
 * @param {!Array<!proto.Common.DerivativeInstrumentPartySubIDsGrp>} value
 * @return {!proto.Common.DerivativeInstrumentParties} returns this
*/
proto.Common.DerivativeInstrumentParties.prototype.setDerivativeInstrumentPartySubIdsGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.DerivativeInstrumentPartySubIDsGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DerivativeInstrumentPartySubIDsGrp}
 */
proto.Common.DerivativeInstrumentParties.prototype.addDerivativeInstrumentPartySubIdsGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.DerivativeInstrumentPartySubIDsGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeInstrumentParties} returns this
 */
proto.Common.DerivativeInstrumentParties.prototype.clearDerivativeInstrumentPartySubIdsGrpList = function() {
  return this.setDerivativeInstrumentPartySubIdsGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeInstrumentAttribute.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeInstrumentAttribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeInstrumentAttribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentAttribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeInstrAttribType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    derivativeInstrAttribValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeInstrumentAttribute}
 */
proto.Common.DerivativeInstrumentAttribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeInstrumentAttribute;
  return proto.Common.DerivativeInstrumentAttribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeInstrumentAttribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeInstrumentAttribute}
 */
proto.Common.DerivativeInstrumentAttribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.DerivativeInstrAttribTypeEnum} */ (reader.readEnum());
      msg.setDerivativeInstrAttribType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeInstrAttribValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeInstrumentAttribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeInstrumentAttribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeInstrumentAttribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrumentAttribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeInstrAttribType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getDerivativeInstrAttribValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional DerivativeInstrAttribTypeEnum derivative_instr_attrib_type = 1;
 * @return {!proto.Common.DerivativeInstrAttribTypeEnum}
 */
proto.Common.DerivativeInstrumentAttribute.prototype.getDerivativeInstrAttribType = function() {
  return /** @type {!proto.Common.DerivativeInstrAttribTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.DerivativeInstrAttribTypeEnum} value
 * @return {!proto.Common.DerivativeInstrumentAttribute} returns this
 */
proto.Common.DerivativeInstrumentAttribute.prototype.setDerivativeInstrAttribType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string derivative_instr_attrib_value = 2;
 * @return {string}
 */
proto.Common.DerivativeInstrumentAttribute.prototype.getDerivativeInstrAttribValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrumentAttribute} returns this
 */
proto.Common.DerivativeInstrumentAttribute.prototype.setDerivativeInstrAttribValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NestedInstrumentAttribute.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NestedInstrumentAttribute.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NestedInstrumentAttribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedInstrumentAttribute.toObject = function(includeInstance, msg) {
  var f, obj = {
    nestedInstrAttribType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    nestedInstrAttribValue: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NestedInstrumentAttribute}
 */
proto.Common.NestedInstrumentAttribute.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NestedInstrumentAttribute;
  return proto.Common.NestedInstrumentAttribute.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NestedInstrumentAttribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NestedInstrumentAttribute}
 */
proto.Common.NestedInstrumentAttribute.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.NestedInstrAttribTypeEnum} */ (reader.readEnum());
      msg.setNestedInstrAttribType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNestedInstrAttribValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NestedInstrumentAttribute.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NestedInstrumentAttribute.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NestedInstrumentAttribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedInstrumentAttribute.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNestedInstrAttribType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getNestedInstrAttribValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional NestedInstrAttribTypeEnum nested_instr_attrib_type = 1;
 * @return {!proto.Common.NestedInstrAttribTypeEnum}
 */
proto.Common.NestedInstrumentAttribute.prototype.getNestedInstrAttribType = function() {
  return /** @type {!proto.Common.NestedInstrAttribTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.NestedInstrAttribTypeEnum} value
 * @return {!proto.Common.NestedInstrumentAttribute} returns this
 */
proto.Common.NestedInstrumentAttribute.prototype.setNestedInstrAttribType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string nested_instr_attrib_value = 2;
 * @return {string}
 */
proto.Common.NestedInstrumentAttribute.prototype.getNestedInstrAttribValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NestedInstrumentAttribute} returns this
 */
proto.Common.NestedInstrumentAttribute.prototype.setNestedInstrAttribValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.DerivativeInstrument.repeatedFields_ = [11,16,36];

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.Common.DerivativeInstrument.oneofGroups_ = [[60,61]];

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrument.DerivativeFlowScheduleTypeUnionCase = {
  DERIVATIVE_FLOW_SCHEDULE_TYPE_UNION_NOT_SET: 0,
  DERIVATIVE_FLOW_SCHEDULE_TYPE: 60,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_RESERVED100PLUS: 61
};

/**
 * @return {proto.Common.DerivativeInstrument.DerivativeFlowScheduleTypeUnionCase}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeFlowScheduleTypeUnionCase = function() {
  return /** @type {proto.Common.DerivativeInstrument.DerivativeFlowScheduleTypeUnionCase} */(jspb.Message.computeOneofCase(this, proto.Common.DerivativeInstrument.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeInstrument.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeInstrument.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeInstrument} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrument.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivFlexProductEligibilityIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    derivativeCapPrice: (f = msg.getDerivativeCapPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeCfiCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    derivativeContractMultiplier: (f = msg.getDerivativeContractMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeContractSettlMonth: jspb.Message.getFieldWithDefault(msg, 5, 0),
    derivativeCountryOfIssue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    derivativeEncodedIssuer: jspb.Message.getFieldWithDefault(msg, 7, ""),
    derivativeEncodedIssuerLen: jspb.Message.getFieldWithDefault(msg, 8, 0),
    derivativeEncodedSecurityDesc: jspb.Message.getFieldWithDefault(msg, 9, ""),
    derivativeEncodedSecurityDescLen: jspb.Message.getFieldWithDefault(msg, 10, 0),
    derivativeEventsGrpList: jspb.Message.toObjectList(msg.getDerivativeEventsGrpList(),
    proto.Common.DerivativeEventsGrp.toObject, includeInstance),
    derivativeExerciseStyle: jspb.Message.getFieldWithDefault(msg, 12, 0),
    derivativeFloorPrice: (f = msg.getDerivativeFloorPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeInstrRegistry: jspb.Message.getFieldWithDefault(msg, 14, ""),
    derivativeInstrmtAssignmentMethod: jspb.Message.getFieldWithDefault(msg, 15, 0),
    derivativeInstrumentPartiesList: jspb.Message.toObjectList(msg.getDerivativeInstrumentPartiesList(),
    proto.Common.DerivativeInstrumentParties.toObject, includeInstance),
    derivativeIssueDate: jspb.Message.getFieldWithDefault(msg, 17, 0),
    derivativeIssuer: jspb.Message.getFieldWithDefault(msg, 18, ""),
    derivativeListMethod: jspb.Message.getFieldWithDefault(msg, 19, 0),
    derivativeLocaleOfIssue: jspb.Message.getFieldWithDefault(msg, 20, ""),
    derivativeMaturityDate: jspb.Message.getFieldWithDefault(msg, 21, 0),
    derivativeMaturityMonthYear: jspb.Message.getFieldWithDefault(msg, 22, 0),
    derivativeMaturityTime: (f = msg.getDerivativeMaturityTime()) && fix_pb.LocalTimeOnly.toObject(includeInstance, f),
    derivativeMinPriceIncrement: (f = msg.getDerivativeMinPriceIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeMinPriceIncrementAmount: (f = msg.getDerivativeMinPriceIncrementAmount()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeNtPositionLimit: jspb.Message.getFieldWithDefault(msg, 26, 0),
    derivativeOptAttribute: msg.getDerivativeOptAttribute_asB64(),
    derivativeOptPayAmount: (f = msg.getDerivativeOptPayAmount()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativePositionLimit: jspb.Message.getFieldWithDefault(msg, 29, 0),
    derivativePriceQuoteMethod: jspb.Message.getFieldWithDefault(msg, 30, 0),
    derivativePriceUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 31, 0),
    derivativePriceUnitOfMeasureQty: (f = msg.getDerivativePriceUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeProduct: jspb.Message.getFieldWithDefault(msg, 33, 0),
    derivativeProductComplex: jspb.Message.getFieldWithDefault(msg, 34, ""),
    derivativePutOrCall: jspb.Message.getFieldWithDefault(msg, 35, 0),
    derivativeSecurityAltIdGrpList: jspb.Message.toObjectList(msg.getDerivativeSecurityAltIdGrpList(),
    proto.Common.DerivativeSecurityAltIDGrp.toObject, includeInstance),
    derivativeSecurityDesc: jspb.Message.getFieldWithDefault(msg, 37, ""),
    derivativeSecurityExchange: jspb.Message.getFieldWithDefault(msg, 38, ""),
    derivativeSecurityGroup: jspb.Message.getFieldWithDefault(msg, 39, ""),
    derivativeSecurityId: jspb.Message.getFieldWithDefault(msg, 40, ""),
    derivativeSecurityIdSource: jspb.Message.getFieldWithDefault(msg, 41, 0),
    derivativeSecurityStatus: jspb.Message.getFieldWithDefault(msg, 42, 0),
    derivativeSecuritySubType: jspb.Message.getFieldWithDefault(msg, 43, ""),
    derivativeSecurityType: jspb.Message.getFieldWithDefault(msg, 44, 0),
    derivativeSecurityXml: (f = msg.getDerivativeSecurityXml()) && proto.Common.DerivativeSecurityXML.toObject(includeInstance, f),
    derivativeSettlMethod: jspb.Message.getFieldWithDefault(msg, 46, 0),
    derivativeSettleOnOpenFlag: jspb.Message.getFieldWithDefault(msg, 47, ""),
    derivativeStateOrProvinceOfIssue: jspb.Message.getFieldWithDefault(msg, 48, ""),
    derivativeStrikeCurrency: jspb.Message.getFieldWithDefault(msg, 49, ""),
    derivativeStrikeMultiplier: (f = msg.getDerivativeStrikeMultiplier()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeStrikePrice: (f = msg.getDerivativeStrikePrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeStrikeValue: (f = msg.getDerivativeStrikeValue()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeSymbol: jspb.Message.getFieldWithDefault(msg, 53, ""),
    derivativeSymbolSfx: jspb.Message.getFieldWithDefault(msg, 54, 0),
    derivativeTimeUnit: jspb.Message.getFieldWithDefault(msg, 55, 0),
    derivativeUnitOfMeasure: jspb.Message.getFieldWithDefault(msg, 56, 0),
    derivativeUnitOfMeasureQty: (f = msg.getDerivativeUnitOfMeasureQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeValuationMethod: jspb.Message.getFieldWithDefault(msg, 58, 0),
    derivativeContractMultiplierUnit: jspb.Message.getFieldWithDefault(msg, 59, 0),
    derivativeFlowScheduleType: jspb.Message.getFieldWithDefault(msg, 60, 0),
    derivativeFlowScheduleTypeReserved100plus: jspb.Message.getFieldWithDefault(msg, 61, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeInstrument}
 */
proto.Common.DerivativeInstrument.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeInstrument;
  return proto.Common.DerivativeInstrument.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeInstrument} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeInstrument}
 */
proto.Common.DerivativeInstrument.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDerivFlexProductEligibilityIndicator(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeCapPrice(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeCfiCode(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeContractMultiplier(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDerivativeContractSettlMonth(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeCountryOfIssue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeEncodedIssuer(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDerivativeEncodedIssuerLen(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeEncodedSecurityDesc(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDerivativeEncodedSecurityDescLen(value);
      break;
    case 11:
      var value = new proto.Common.DerivativeEventsGrp;
      reader.readMessage(value,proto.Common.DerivativeEventsGrp.deserializeBinaryFromReader);
      msg.addDerivativeEventsGrp(value);
      break;
    case 12:
      var value = /** @type {!proto.Common.DerivativeExerciseStyleEnum} */ (reader.readEnum());
      msg.setDerivativeExerciseStyle(value);
      break;
    case 13:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeFloorPrice(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeInstrRegistry(value);
      break;
    case 15:
      var value = /** @type {!proto.Common.DerivativeInstrmtAssignmentMethodEnum} */ (reader.readEnum());
      msg.setDerivativeInstrmtAssignmentMethod(value);
      break;
    case 16:
      var value = new proto.Common.DerivativeInstrumentParties;
      reader.readMessage(value,proto.Common.DerivativeInstrumentParties.deserializeBinaryFromReader);
      msg.addDerivativeInstrumentParties(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDerivativeIssueDate(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeIssuer(value);
      break;
    case 19:
      var value = /** @type {!proto.Common.DerivativeListMethodEnum} */ (reader.readEnum());
      msg.setDerivativeListMethod(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeLocaleOfIssue(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDerivativeMaturityDate(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDerivativeMaturityMonthYear(value);
      break;
    case 23:
      var value = new fix_pb.LocalTimeOnly;
      reader.readMessage(value,fix_pb.LocalTimeOnly.deserializeBinaryFromReader);
      msg.setDerivativeMaturityTime(value);
      break;
    case 24:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeMinPriceIncrement(value);
      break;
    case 25:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeMinPriceIncrementAmount(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDerivativeNtPositionLimit(value);
      break;
    case 27:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setDerivativeOptAttribute(value);
      break;
    case 28:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeOptPayAmount(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDerivativePositionLimit(value);
      break;
    case 30:
      var value = /** @type {!proto.Common.DerivativePriceQuoteMethodEnum} */ (reader.readEnum());
      msg.setDerivativePriceQuoteMethod(value);
      break;
    case 31:
      var value = /** @type {!proto.Common.DerivativePriceUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setDerivativePriceUnitOfMeasure(value);
      break;
    case 32:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativePriceUnitOfMeasureQty(value);
      break;
    case 33:
      var value = /** @type {!proto.Common.DerivativeProductEnum} */ (reader.readEnum());
      msg.setDerivativeProduct(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeProductComplex(value);
      break;
    case 35:
      var value = /** @type {!proto.Common.DerivativePutOrCallEnum} */ (reader.readEnum());
      msg.setDerivativePutOrCall(value);
      break;
    case 36:
      var value = new proto.Common.DerivativeSecurityAltIDGrp;
      reader.readMessage(value,proto.Common.DerivativeSecurityAltIDGrp.deserializeBinaryFromReader);
      msg.addDerivativeSecurityAltIdGrp(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityDesc(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityExchange(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityGroup(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityId(value);
      break;
    case 41:
      var value = /** @type {!proto.Common.DerivativeSecurityIDSourceEnum} */ (reader.readEnum());
      msg.setDerivativeSecurityIdSource(value);
      break;
    case 42:
      var value = /** @type {!proto.Common.DerivativeSecurityStatusEnum} */ (reader.readEnum());
      msg.setDerivativeSecurityStatus(value);
      break;
    case 43:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecuritySubType(value);
      break;
    case 44:
      var value = /** @type {!proto.Common.DerivativeSecurityTypeEnum} */ (reader.readEnum());
      msg.setDerivativeSecurityType(value);
      break;
    case 45:
      var value = new proto.Common.DerivativeSecurityXML;
      reader.readMessage(value,proto.Common.DerivativeSecurityXML.deserializeBinaryFromReader);
      msg.setDerivativeSecurityXml(value);
      break;
    case 46:
      var value = /** @type {!proto.Common.DerivativeSettlMethodEnum} */ (reader.readEnum());
      msg.setDerivativeSettlMethod(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSettleOnOpenFlag(value);
      break;
    case 48:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeStateOrProvinceOfIssue(value);
      break;
    case 49:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeStrikeCurrency(value);
      break;
    case 50:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeStrikeMultiplier(value);
      break;
    case 51:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeStrikePrice(value);
      break;
    case 52:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeStrikeValue(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSymbol(value);
      break;
    case 54:
      var value = /** @type {!proto.Common.DerivativeSymbolSfxEnum} */ (reader.readEnum());
      msg.setDerivativeSymbolSfx(value);
      break;
    case 55:
      var value = /** @type {!proto.Common.DerivativeTimeUnitEnum} */ (reader.readEnum());
      msg.setDerivativeTimeUnit(value);
      break;
    case 56:
      var value = /** @type {!proto.Common.DerivativeUnitOfMeasureEnum} */ (reader.readEnum());
      msg.setDerivativeUnitOfMeasure(value);
      break;
    case 57:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeUnitOfMeasureQty(value);
      break;
    case 58:
      var value = /** @type {!proto.Common.DerivativeValuationMethodEnum} */ (reader.readEnum());
      msg.setDerivativeValuationMethod(value);
      break;
    case 59:
      var value = /** @type {!proto.Common.DerivativeContractMultiplierUnitEnum} */ (reader.readEnum());
      msg.setDerivativeContractMultiplierUnit(value);
      break;
    case 60:
      var value = /** @type {!proto.Common.DerivativeFlowScheduleTypeEnum} */ (reader.readEnum());
      msg.setDerivativeFlowScheduleType(value);
      break;
    case 61:
      var value = /** @type {number} */ (reader.readFixed32());
      msg.setDerivativeFlowScheduleTypeReserved100plus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeInstrument.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeInstrument.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeInstrument} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeInstrument.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivFlexProductEligibilityIndicator();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getDerivativeCapPrice();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeCfiCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDerivativeContractMultiplier();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeContractSettlMonth();
  if (f !== 0) {
    writer.writeSfixed32(
      5,
      f
    );
  }
  f = message.getDerivativeCountryOfIssue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDerivativeEncodedIssuer();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getDerivativeEncodedIssuerLen();
  if (f !== 0) {
    writer.writeSfixed64(
      8,
      f
    );
  }
  f = message.getDerivativeEncodedSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDerivativeEncodedSecurityDescLen();
  if (f !== 0) {
    writer.writeSfixed64(
      10,
      f
    );
  }
  f = message.getDerivativeEventsGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.Common.DerivativeEventsGrp.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeExerciseStyle();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getDerivativeFloorPrice();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeInstrRegistry();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getDerivativeInstrmtAssignmentMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      15,
      f
    );
  }
  f = message.getDerivativeInstrumentPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      16,
      f,
      proto.Common.DerivativeInstrumentParties.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeIssueDate();
  if (f !== 0) {
    writer.writeSfixed32(
      17,
      f
    );
  }
  f = message.getDerivativeIssuer();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getDerivativeListMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getDerivativeLocaleOfIssue();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getDerivativeMaturityDate();
  if (f !== 0) {
    writer.writeSfixed32(
      21,
      f
    );
  }
  f = message.getDerivativeMaturityMonthYear();
  if (f !== 0) {
    writer.writeSfixed32(
      22,
      f
    );
  }
  f = message.getDerivativeMaturityTime();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      fix_pb.LocalTimeOnly.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeMinPriceIncrement();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeMinPriceIncrementAmount();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeNtPositionLimit();
  if (f !== 0) {
    writer.writeSfixed64(
      26,
      f
    );
  }
  f = message.getDerivativeOptAttribute_asU8();
  if (f.length > 0) {
    writer.writeBytes(
      27,
      f
    );
  }
  f = message.getDerivativeOptPayAmount();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativePositionLimit();
  if (f !== 0) {
    writer.writeSfixed64(
      29,
      f
    );
  }
  f = message.getDerivativePriceQuoteMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      30,
      f
    );
  }
  f = message.getDerivativePriceUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      31,
      f
    );
  }
  f = message.getDerivativePriceUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeProduct();
  if (f !== 0.0) {
    writer.writeEnum(
      33,
      f
    );
  }
  f = message.getDerivativeProductComplex();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getDerivativePutOrCall();
  if (f !== 0.0) {
    writer.writeEnum(
      35,
      f
    );
  }
  f = message.getDerivativeSecurityAltIdGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      36,
      f,
      proto.Common.DerivativeSecurityAltIDGrp.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeSecurityDesc();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getDerivativeSecurityExchange();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getDerivativeSecurityGroup();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getDerivativeSecurityId();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getDerivativeSecurityIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      41,
      f
    );
  }
  f = message.getDerivativeSecurityStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      42,
      f
    );
  }
  f = message.getDerivativeSecuritySubType();
  if (f.length > 0) {
    writer.writeString(
      43,
      f
    );
  }
  f = message.getDerivativeSecurityType();
  if (f !== 0.0) {
    writer.writeEnum(
      44,
      f
    );
  }
  f = message.getDerivativeSecurityXml();
  if (f != null) {
    writer.writeMessage(
      45,
      f,
      proto.Common.DerivativeSecurityXML.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeSettlMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      46,
      f
    );
  }
  f = message.getDerivativeSettleOnOpenFlag();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getDerivativeStateOrProvinceOfIssue();
  if (f.length > 0) {
    writer.writeString(
      48,
      f
    );
  }
  f = message.getDerivativeStrikeCurrency();
  if (f.length > 0) {
    writer.writeString(
      49,
      f
    );
  }
  f = message.getDerivativeStrikeMultiplier();
  if (f != null) {
    writer.writeMessage(
      50,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeStrikePrice();
  if (f != null) {
    writer.writeMessage(
      51,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeStrikeValue();
  if (f != null) {
    writer.writeMessage(
      52,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeSymbol();
  if (f.length > 0) {
    writer.writeString(
      53,
      f
    );
  }
  f = message.getDerivativeSymbolSfx();
  if (f !== 0.0) {
    writer.writeEnum(
      54,
      f
    );
  }
  f = message.getDerivativeTimeUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      55,
      f
    );
  }
  f = message.getDerivativeUnitOfMeasure();
  if (f !== 0.0) {
    writer.writeEnum(
      56,
      f
    );
  }
  f = message.getDerivativeUnitOfMeasureQty();
  if (f != null) {
    writer.writeMessage(
      57,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeValuationMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      58,
      f
    );
  }
  f = message.getDerivativeContractMultiplierUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      59,
      f
    );
  }
  f = /** @type {!proto.Common.DerivativeFlowScheduleTypeEnum} */ (jspb.Message.getField(message, 60));
  if (f != null) {
    writer.writeEnum(
      60,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 61));
  if (f != null) {
    writer.writeFixed32(
      61,
      f
    );
  }
};


/**
 * optional bool deriv_flex_product_eligibility_indicator = 1;
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.getDerivFlexProductEligibilityIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivFlexProductEligibilityIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional fix.Decimal64 derivative_cap_price = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeCapPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeCapPrice = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeCapPrice = function() {
  return this.setDerivativeCapPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeCapPrice = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string derivative_cfi_code = 3;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeCfiCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeCfiCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fix.Decimal64 derivative_contract_multiplier = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeContractMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeContractMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeContractMultiplier = function() {
  return this.setDerivativeContractMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeContractMultiplier = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional sfixed32 derivative_contract_settl_month = 5;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeContractSettlMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeContractSettlMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string derivative_country_of_issue = 6;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeCountryOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeCountryOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string derivative_encoded_issuer = 7;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeEncodedIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeEncodedIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional sfixed64 derivative_encoded_issuer_len = 8;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeEncodedIssuerLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeEncodedIssuerLen = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string derivative_encoded_security_desc = 9;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeEncodedSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeEncodedSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional sfixed64 derivative_encoded_security_desc_len = 10;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeEncodedSecurityDescLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeEncodedSecurityDescLen = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * repeated DerivativeEventsGrp derivative_events_grp = 11;
 * @return {!Array<!proto.Common.DerivativeEventsGrp>}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeEventsGrpList = function() {
  return /** @type{!Array<!proto.Common.DerivativeEventsGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DerivativeEventsGrp, 11));
};


/**
 * @param {!Array<!proto.Common.DerivativeEventsGrp>} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeEventsGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.Common.DerivativeEventsGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DerivativeEventsGrp}
 */
proto.Common.DerivativeInstrument.prototype.addDerivativeEventsGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.Common.DerivativeEventsGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeEventsGrpList = function() {
  return this.setDerivativeEventsGrpList([]);
};


/**
 * optional DerivativeExerciseStyleEnum derivative_exercise_style = 12;
 * @return {!proto.Common.DerivativeExerciseStyleEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeExerciseStyle = function() {
  return /** @type {!proto.Common.DerivativeExerciseStyleEnum} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.Common.DerivativeExerciseStyleEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeExerciseStyle = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional fix.Decimal64 derivative_floor_price = 13;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeFloorPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 13));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeFloorPrice = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeFloorPrice = function() {
  return this.setDerivativeFloorPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeFloorPrice = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional string derivative_instr_registry = 14;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeInstrRegistry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeInstrRegistry = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional DerivativeInstrmtAssignmentMethodEnum derivative_instrmt_assignment_method = 15;
 * @return {!proto.Common.DerivativeInstrmtAssignmentMethodEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeInstrmtAssignmentMethod = function() {
  return /** @type {!proto.Common.DerivativeInstrmtAssignmentMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {!proto.Common.DerivativeInstrmtAssignmentMethodEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeInstrmtAssignmentMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 15, value);
};


/**
 * repeated DerivativeInstrumentParties derivative_instrument_parties = 16;
 * @return {!Array<!proto.Common.DerivativeInstrumentParties>}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeInstrumentPartiesList = function() {
  return /** @type{!Array<!proto.Common.DerivativeInstrumentParties>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DerivativeInstrumentParties, 16));
};


/**
 * @param {!Array<!proto.Common.DerivativeInstrumentParties>} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeInstrumentPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 16, value);
};


/**
 * @param {!proto.Common.DerivativeInstrumentParties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DerivativeInstrumentParties}
 */
proto.Common.DerivativeInstrument.prototype.addDerivativeInstrumentParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.Common.DerivativeInstrumentParties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeInstrumentPartiesList = function() {
  return this.setDerivativeInstrumentPartiesList([]);
};


/**
 * optional sfixed32 derivative_issue_date = 17;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeIssueDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeIssueDate = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional string derivative_issuer = 18;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeIssuer = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeIssuer = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional DerivativeListMethodEnum derivative_list_method = 19;
 * @return {!proto.Common.DerivativeListMethodEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeListMethod = function() {
  return /** @type {!proto.Common.DerivativeListMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.Common.DerivativeListMethodEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeListMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional string derivative_locale_of_issue = 20;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeLocaleOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeLocaleOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional sfixed32 derivative_maturity_date = 21;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeMaturityDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeMaturityDate = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional sfixed32 derivative_maturity_month_year = 22;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeMaturityMonthYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeMaturityMonthYear = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional fix.LocalTimeOnly derivative_maturity_time = 23;
 * @return {?proto.fix.LocalTimeOnly}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeMaturityTime = function() {
  return /** @type{?proto.fix.LocalTimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.LocalTimeOnly, 23));
};


/**
 * @param {?proto.fix.LocalTimeOnly|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeMaturityTime = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeMaturityTime = function() {
  return this.setDerivativeMaturityTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeMaturityTime = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional fix.Decimal64 derivative_min_price_increment = 24;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeMinPriceIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 24));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeMinPriceIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeMinPriceIncrement = function() {
  return this.setDerivativeMinPriceIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeMinPriceIncrement = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional fix.Decimal64 derivative_min_price_increment_amount = 25;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeMinPriceIncrementAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 25));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeMinPriceIncrementAmount = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeMinPriceIncrementAmount = function() {
  return this.setDerivativeMinPriceIncrementAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeMinPriceIncrementAmount = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional sfixed64 derivative_nt_position_limit = 26;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeNtPositionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeNtPositionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional bytes derivative_opt_attribute = 27;
 * @return {!(string|Uint8Array)}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeOptAttribute = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * optional bytes derivative_opt_attribute = 27;
 * This is a type-conversion wrapper around `getDerivativeOptAttribute()`
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeOptAttribute_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getDerivativeOptAttribute()));
};


/**
 * optional bytes derivative_opt_attribute = 27;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDerivativeOptAttribute()`
 * @return {!Uint8Array}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeOptAttribute_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getDerivativeOptAttribute()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeOptAttribute = function(value) {
  return jspb.Message.setProto3BytesField(this, 27, value);
};


/**
 * optional fix.Decimal64 derivative_opt_pay_amount = 28;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeOptPayAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 28));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeOptPayAmount = function(value) {
  return jspb.Message.setWrapperField(this, 28, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeOptPayAmount = function() {
  return this.setDerivativeOptPayAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeOptPayAmount = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional sfixed64 derivative_position_limit = 29;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativePositionLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativePositionLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional DerivativePriceQuoteMethodEnum derivative_price_quote_method = 30;
 * @return {!proto.Common.DerivativePriceQuoteMethodEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativePriceQuoteMethod = function() {
  return /** @type {!proto.Common.DerivativePriceQuoteMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {!proto.Common.DerivativePriceQuoteMethodEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativePriceQuoteMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 30, value);
};


/**
 * optional DerivativePriceUnitOfMeasureEnum derivative_price_unit_of_measure = 31;
 * @return {!proto.Common.DerivativePriceUnitOfMeasureEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativePriceUnitOfMeasure = function() {
  return /** @type {!proto.Common.DerivativePriceUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {!proto.Common.DerivativePriceUnitOfMeasureEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativePriceUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 31, value);
};


/**
 * optional fix.Decimal64 derivative_price_unit_of_measure_qty = 32;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativePriceUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 32));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativePriceUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativePriceUnitOfMeasureQty = function() {
  return this.setDerivativePriceUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativePriceUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional DerivativeProductEnum derivative_product = 33;
 * @return {!proto.Common.DerivativeProductEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeProduct = function() {
  return /** @type {!proto.Common.DerivativeProductEnum} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {!proto.Common.DerivativeProductEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeProduct = function(value) {
  return jspb.Message.setProto3EnumField(this, 33, value);
};


/**
 * optional string derivative_product_complex = 34;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeProductComplex = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeProductComplex = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional DerivativePutOrCallEnum derivative_put_or_call = 35;
 * @return {!proto.Common.DerivativePutOrCallEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativePutOrCall = function() {
  return /** @type {!proto.Common.DerivativePutOrCallEnum} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {!proto.Common.DerivativePutOrCallEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativePutOrCall = function(value) {
  return jspb.Message.setProto3EnumField(this, 35, value);
};


/**
 * repeated DerivativeSecurityAltIDGrp derivative_security_alt_id_grp = 36;
 * @return {!Array<!proto.Common.DerivativeSecurityAltIDGrp>}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityAltIdGrpList = function() {
  return /** @type{!Array<!proto.Common.DerivativeSecurityAltIDGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DerivativeSecurityAltIDGrp, 36));
};


/**
 * @param {!Array<!proto.Common.DerivativeSecurityAltIDGrp>} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityAltIdGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 36, value);
};


/**
 * @param {!proto.Common.DerivativeSecurityAltIDGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DerivativeSecurityAltIDGrp}
 */
proto.Common.DerivativeInstrument.prototype.addDerivativeSecurityAltIdGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 36, opt_value, proto.Common.DerivativeSecurityAltIDGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeSecurityAltIdGrpList = function() {
  return this.setDerivativeSecurityAltIdGrpList([]);
};


/**
 * optional string derivative_security_desc = 37;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityDesc = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityDesc = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string derivative_security_exchange = 38;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string derivative_security_group = 39;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityGroup = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityGroup = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string derivative_security_id = 40;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional DerivativeSecurityIDSourceEnum derivative_security_id_source = 41;
 * @return {!proto.Common.DerivativeSecurityIDSourceEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityIdSource = function() {
  return /** @type {!proto.Common.DerivativeSecurityIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {!proto.Common.DerivativeSecurityIDSourceEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 41, value);
};


/**
 * optional DerivativeSecurityStatusEnum derivative_security_status = 42;
 * @return {!proto.Common.DerivativeSecurityStatusEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityStatus = function() {
  return /** @type {!proto.Common.DerivativeSecurityStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {!proto.Common.DerivativeSecurityStatusEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 42, value);
};


/**
 * optional string derivative_security_sub_type = 43;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecuritySubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 43, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecuritySubType = function(value) {
  return jspb.Message.setProto3StringField(this, 43, value);
};


/**
 * optional DerivativeSecurityTypeEnum derivative_security_type = 44;
 * @return {!proto.Common.DerivativeSecurityTypeEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityType = function() {
  return /** @type {!proto.Common.DerivativeSecurityTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {!proto.Common.DerivativeSecurityTypeEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityType = function(value) {
  return jspb.Message.setProto3EnumField(this, 44, value);
};


/**
 * optional DerivativeSecurityXML derivative_security_xml = 45;
 * @return {?proto.Common.DerivativeSecurityXML}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSecurityXml = function() {
  return /** @type{?proto.Common.DerivativeSecurityXML} */ (
    jspb.Message.getWrapperField(this, proto.Common.DerivativeSecurityXML, 45));
};


/**
 * @param {?proto.Common.DerivativeSecurityXML|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeSecurityXml = function(value) {
  return jspb.Message.setWrapperField(this, 45, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeSecurityXml = function() {
  return this.setDerivativeSecurityXml(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeSecurityXml = function() {
  return jspb.Message.getField(this, 45) != null;
};


/**
 * optional DerivativeSettlMethodEnum derivative_settl_method = 46;
 * @return {!proto.Common.DerivativeSettlMethodEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSettlMethod = function() {
  return /** @type {!proto.Common.DerivativeSettlMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {!proto.Common.DerivativeSettlMethodEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSettlMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 46, value);
};


/**
 * optional string derivative_settle_on_open_flag = 47;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSettleOnOpenFlag = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSettleOnOpenFlag = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string derivative_state_or_province_of_issue = 48;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeStateOrProvinceOfIssue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 48, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeStateOrProvinceOfIssue = function(value) {
  return jspb.Message.setProto3StringField(this, 48, value);
};


/**
 * optional string derivative_strike_currency = 49;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeStrikeCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 49, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeStrikeCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 49, value);
};


/**
 * optional fix.Decimal64 derivative_strike_multiplier = 50;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeStrikeMultiplier = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 50));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeStrikeMultiplier = function(value) {
  return jspb.Message.setWrapperField(this, 50, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeStrikeMultiplier = function() {
  return this.setDerivativeStrikeMultiplier(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeStrikeMultiplier = function() {
  return jspb.Message.getField(this, 50) != null;
};


/**
 * optional fix.Decimal64 derivative_strike_price = 51;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeStrikePrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 51));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeStrikePrice = function(value) {
  return jspb.Message.setWrapperField(this, 51, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeStrikePrice = function() {
  return this.setDerivativeStrikePrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeStrikePrice = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional fix.Decimal64 derivative_strike_value = 52;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeStrikeValue = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 52));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeStrikeValue = function(value) {
  return jspb.Message.setWrapperField(this, 52, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeStrikeValue = function() {
  return this.setDerivativeStrikeValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeStrikeValue = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional string derivative_symbol = 53;
 * @return {string}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 53, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 53, value);
};


/**
 * optional DerivativeSymbolSfxEnum derivative_symbol_sfx = 54;
 * @return {!proto.Common.DerivativeSymbolSfxEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeSymbolSfx = function() {
  return /** @type {!proto.Common.DerivativeSymbolSfxEnum} */ (jspb.Message.getFieldWithDefault(this, 54, 0));
};


/**
 * @param {!proto.Common.DerivativeSymbolSfxEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeSymbolSfx = function(value) {
  return jspb.Message.setProto3EnumField(this, 54, value);
};


/**
 * optional DerivativeTimeUnitEnum derivative_time_unit = 55;
 * @return {!proto.Common.DerivativeTimeUnitEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeTimeUnit = function() {
  return /** @type {!proto.Common.DerivativeTimeUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 55, 0));
};


/**
 * @param {!proto.Common.DerivativeTimeUnitEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeTimeUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 55, value);
};


/**
 * optional DerivativeUnitOfMeasureEnum derivative_unit_of_measure = 56;
 * @return {!proto.Common.DerivativeUnitOfMeasureEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeUnitOfMeasure = function() {
  return /** @type {!proto.Common.DerivativeUnitOfMeasureEnum} */ (jspb.Message.getFieldWithDefault(this, 56, 0));
};


/**
 * @param {!proto.Common.DerivativeUnitOfMeasureEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeUnitOfMeasure = function(value) {
  return jspb.Message.setProto3EnumField(this, 56, value);
};


/**
 * optional fix.Decimal64 derivative_unit_of_measure_qty = 57;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeUnitOfMeasureQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 57));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeInstrument} returns this
*/
proto.Common.DerivativeInstrument.prototype.setDerivativeUnitOfMeasureQty = function(value) {
  return jspb.Message.setWrapperField(this, 57, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeUnitOfMeasureQty = function() {
  return this.setDerivativeUnitOfMeasureQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeUnitOfMeasureQty = function() {
  return jspb.Message.getField(this, 57) != null;
};


/**
 * optional DerivativeValuationMethodEnum derivative_valuation_method = 58;
 * @return {!proto.Common.DerivativeValuationMethodEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeValuationMethod = function() {
  return /** @type {!proto.Common.DerivativeValuationMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 58, 0));
};


/**
 * @param {!proto.Common.DerivativeValuationMethodEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeValuationMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 58, value);
};


/**
 * optional DerivativeContractMultiplierUnitEnum derivative_contract_multiplier_unit = 59;
 * @return {!proto.Common.DerivativeContractMultiplierUnitEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeContractMultiplierUnit = function() {
  return /** @type {!proto.Common.DerivativeContractMultiplierUnitEnum} */ (jspb.Message.getFieldWithDefault(this, 59, 0));
};


/**
 * @param {!proto.Common.DerivativeContractMultiplierUnitEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeContractMultiplierUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 59, value);
};


/**
 * optional DerivativeFlowScheduleTypeEnum derivative_flow_schedule_type = 60;
 * @return {!proto.Common.DerivativeFlowScheduleTypeEnum}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeFlowScheduleType = function() {
  return /** @type {!proto.Common.DerivativeFlowScheduleTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 60, 0));
};


/**
 * @param {!proto.Common.DerivativeFlowScheduleTypeEnum} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeFlowScheduleType = function(value) {
  return jspb.Message.setOneofField(this, 60, proto.Common.DerivativeInstrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeFlowScheduleType = function() {
  return jspb.Message.setOneofField(this, 60, proto.Common.DerivativeInstrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeFlowScheduleType = function() {
  return jspb.Message.getField(this, 60) != null;
};


/**
 * optional fixed32 derivative_flow_schedule_type_reserved100plus = 61;
 * @return {number}
 */
proto.Common.DerivativeInstrument.prototype.getDerivativeFlowScheduleTypeReserved100plus = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 61, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.setDerivativeFlowScheduleTypeReserved100plus = function(value) {
  return jspb.Message.setOneofField(this, 61, proto.Common.DerivativeInstrument.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.Common.DerivativeInstrument} returns this
 */
proto.Common.DerivativeInstrument.prototype.clearDerivativeFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.setOneofField(this, 61, proto.Common.DerivativeInstrument.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeInstrument.prototype.hasDerivativeFlowScheduleTypeReserved100plus = function() {
  return jspb.Message.getField(this, 61) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeSecurityAltIDGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeSecurityAltIDGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityAltIDGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeSecurityAltId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    derivativeSecurityAltIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeSecurityAltIDGrp}
 */
proto.Common.DerivativeSecurityAltIDGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeSecurityAltIDGrp;
  return proto.Common.DerivativeSecurityAltIDGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeSecurityAltIDGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeSecurityAltIDGrp}
 */
proto.Common.DerivativeSecurityAltIDGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityAltId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.DerivativeSecurityAltIDSourceEnum} */ (reader.readEnum());
      msg.setDerivativeSecurityAltIdSource(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeSecurityAltIDGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeSecurityAltIDGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityAltIDGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeSecurityAltId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDerivativeSecurityAltIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string derivative_security_alt_id = 1;
 * @return {string}
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.getDerivativeSecurityAltId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeSecurityAltIDGrp} returns this
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.setDerivativeSecurityAltId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional DerivativeSecurityAltIDSourceEnum derivative_security_alt_id_source = 2;
 * @return {!proto.Common.DerivativeSecurityAltIDSourceEnum}
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.getDerivativeSecurityAltIdSource = function() {
  return /** @type {!proto.Common.DerivativeSecurityAltIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.DerivativeSecurityAltIDSourceEnum} value
 * @return {!proto.Common.DerivativeSecurityAltIDGrp} returns this
 */
proto.Common.DerivativeSecurityAltIDGrp.prototype.setDerivativeSecurityAltIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeEventsGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeEventsGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeEventsGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeEventsGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeEventDate: jspb.Message.getFieldWithDefault(msg, 1, 0),
    derivativeEventPx: (f = msg.getDerivativeEventPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    derivativeEventText: jspb.Message.getFieldWithDefault(msg, 3, ""),
    derivativeEventTime: (f = msg.getDerivativeEventTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    derivativeEventType: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeEventsGrp}
 */
proto.Common.DerivativeEventsGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeEventsGrp;
  return proto.Common.DerivativeEventsGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeEventsGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeEventsGrp}
 */
proto.Common.DerivativeEventsGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setDerivativeEventDate(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setDerivativeEventPx(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeEventText(value);
      break;
    case 4:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDerivativeEventTime(value);
      break;
    case 5:
      var value = /** @type {!proto.Common.DerivativeEventTypeEnum} */ (reader.readEnum());
      msg.setDerivativeEventType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeEventsGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeEventsGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeEventsGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeEventsGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeEventDate();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getDerivativeEventPx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeEventText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDerivativeEventTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional sfixed32 derivative_event_date = 1;
 * @return {number}
 */
proto.Common.DerivativeEventsGrp.prototype.getDerivativeEventDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeEventsGrp} returns this
 */
proto.Common.DerivativeEventsGrp.prototype.setDerivativeEventDate = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional fix.Decimal64 derivative_event_px = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.DerivativeEventsGrp.prototype.getDerivativeEventPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.DerivativeEventsGrp} returns this
*/
proto.Common.DerivativeEventsGrp.prototype.setDerivativeEventPx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeEventsGrp} returns this
 */
proto.Common.DerivativeEventsGrp.prototype.clearDerivativeEventPx = function() {
  return this.setDerivativeEventPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeEventsGrp.prototype.hasDerivativeEventPx = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string derivative_event_text = 3;
 * @return {string}
 */
proto.Common.DerivativeEventsGrp.prototype.getDerivativeEventText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeEventsGrp} returns this
 */
proto.Common.DerivativeEventsGrp.prototype.setDerivativeEventText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional fix.Timestamp derivative_event_time = 4;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.DerivativeEventsGrp.prototype.getDerivativeEventTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 4));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.DerivativeEventsGrp} returns this
*/
proto.Common.DerivativeEventsGrp.prototype.setDerivativeEventTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeEventsGrp} returns this
 */
proto.Common.DerivativeEventsGrp.prototype.clearDerivativeEventTime = function() {
  return this.setDerivativeEventTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeEventsGrp.prototype.hasDerivativeEventTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional DerivativeEventTypeEnum derivative_event_type = 5;
 * @return {!proto.Common.DerivativeEventTypeEnum}
 */
proto.Common.DerivativeEventsGrp.prototype.getDerivativeEventType = function() {
  return /** @type {!proto.Common.DerivativeEventTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.Common.DerivativeEventTypeEnum} value
 * @return {!proto.Common.DerivativeEventsGrp} returns this
 */
proto.Common.DerivativeEventsGrp.prototype.setDerivativeEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.DerivativeSecurityDefinition.repeatedFields_ = [2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeSecurityDefinition.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeSecurityDefinition.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeSecurityDefinition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityDefinition.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeInstrument: (f = msg.getDerivativeInstrument()) && proto.Common.DerivativeInstrument.toObject(includeInstance, f),
    derivativeInstrumentAttributeList: jspb.Message.toObjectList(msg.getDerivativeInstrumentAttributeList(),
    proto.Common.DerivativeInstrumentAttribute.toObject, includeInstance),
    marketSegmentGrpList: jspb.Message.toObjectList(msg.getMarketSegmentGrpList(),
    proto.Common.MarketSegmentGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeSecurityDefinition}
 */
proto.Common.DerivativeSecurityDefinition.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeSecurityDefinition;
  return proto.Common.DerivativeSecurityDefinition.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeSecurityDefinition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeSecurityDefinition}
 */
proto.Common.DerivativeSecurityDefinition.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.DerivativeInstrument;
      reader.readMessage(value,proto.Common.DerivativeInstrument.deserializeBinaryFromReader);
      msg.setDerivativeInstrument(value);
      break;
    case 2:
      var value = new proto.Common.DerivativeInstrumentAttribute;
      reader.readMessage(value,proto.Common.DerivativeInstrumentAttribute.deserializeBinaryFromReader);
      msg.addDerivativeInstrumentAttribute(value);
      break;
    case 3:
      var value = new proto.Common.MarketSegmentGrp;
      reader.readMessage(value,proto.Common.MarketSegmentGrp.deserializeBinaryFromReader);
      msg.addMarketSegmentGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeSecurityDefinition.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeSecurityDefinition.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeSecurityDefinition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityDefinition.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeInstrument();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.Common.DerivativeInstrument.serializeBinaryToWriter
    );
  }
  f = message.getDerivativeInstrumentAttributeList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.Common.DerivativeInstrumentAttribute.serializeBinaryToWriter
    );
  }
  f = message.getMarketSegmentGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.Common.MarketSegmentGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional DerivativeInstrument derivative_instrument = 1;
 * @return {?proto.Common.DerivativeInstrument}
 */
proto.Common.DerivativeSecurityDefinition.prototype.getDerivativeInstrument = function() {
  return /** @type{?proto.Common.DerivativeInstrument} */ (
    jspb.Message.getWrapperField(this, proto.Common.DerivativeInstrument, 1));
};


/**
 * @param {?proto.Common.DerivativeInstrument|undefined} value
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
*/
proto.Common.DerivativeSecurityDefinition.prototype.setDerivativeInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
 */
proto.Common.DerivativeSecurityDefinition.prototype.clearDerivativeInstrument = function() {
  return this.setDerivativeInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.DerivativeSecurityDefinition.prototype.hasDerivativeInstrument = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated DerivativeInstrumentAttribute derivative_instrument_attribute = 2;
 * @return {!Array<!proto.Common.DerivativeInstrumentAttribute>}
 */
proto.Common.DerivativeSecurityDefinition.prototype.getDerivativeInstrumentAttributeList = function() {
  return /** @type{!Array<!proto.Common.DerivativeInstrumentAttribute>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.DerivativeInstrumentAttribute, 2));
};


/**
 * @param {!Array<!proto.Common.DerivativeInstrumentAttribute>} value
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
*/
proto.Common.DerivativeSecurityDefinition.prototype.setDerivativeInstrumentAttributeList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.Common.DerivativeInstrumentAttribute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.DerivativeInstrumentAttribute}
 */
proto.Common.DerivativeSecurityDefinition.prototype.addDerivativeInstrumentAttribute = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.Common.DerivativeInstrumentAttribute, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
 */
proto.Common.DerivativeSecurityDefinition.prototype.clearDerivativeInstrumentAttributeList = function() {
  return this.setDerivativeInstrumentAttributeList([]);
};


/**
 * repeated MarketSegmentGrp market_segment_grp = 3;
 * @return {!Array<!proto.Common.MarketSegmentGrp>}
 */
proto.Common.DerivativeSecurityDefinition.prototype.getMarketSegmentGrpList = function() {
  return /** @type{!Array<!proto.Common.MarketSegmentGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.MarketSegmentGrp, 3));
};


/**
 * @param {!Array<!proto.Common.MarketSegmentGrp>} value
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
*/
proto.Common.DerivativeSecurityDefinition.prototype.setMarketSegmentGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Common.MarketSegmentGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.MarketSegmentGrp}
 */
proto.Common.DerivativeSecurityDefinition.prototype.addMarketSegmentGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Common.MarketSegmentGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.DerivativeSecurityDefinition} returns this
 */
proto.Common.DerivativeSecurityDefinition.prototype.clearMarketSegmentGrpList = function() {
  return this.setMarketSegmentGrpList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.RelSymDerivSecUpdGrp.repeatedFields_ = [1,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.RelSymDerivSecUpdGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.RelSymDerivSecUpdGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RelSymDerivSecUpdGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    corporateActionList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    encodedText: jspb.Message.getFieldWithDefault(msg, 3, ""),
    encodedTextLen: jspb.Message.getFieldWithDefault(msg, 4, 0),
    instrmtLegGrpList: jspb.Message.toObjectList(msg.getInstrmtLegGrpList(),
    proto.Common.InstrmtLegGrp.toObject, includeInstance),
    instrument: (f = msg.getInstrument()) && proto.Common.Instrument.toObject(includeInstance, f),
    instrumentExtension: (f = msg.getInstrumentExtension()) && proto.Common.InstrumentExtension.toObject(includeInstance, f),
    listUpdateAction: jspb.Message.getFieldWithDefault(msg, 8, 0),
    secondaryPriceLimits: (f = msg.getSecondaryPriceLimits()) && proto.Common.SecondaryPriceLimits.toObject(includeInstance, f),
    text: jspb.Message.getFieldWithDefault(msg, 10, ""),
    relSymTransactTime: (f = msg.getRelSymTransactTime()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.RelSymDerivSecUpdGrp}
 */
proto.Common.RelSymDerivSecUpdGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.RelSymDerivSecUpdGrp;
  return proto.Common.RelSymDerivSecUpdGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.RelSymDerivSecUpdGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.RelSymDerivSecUpdGrp}
 */
proto.Common.RelSymDerivSecUpdGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.Common.CorporateActionEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addCorporateAction(values[i]);
      }
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEncodedText(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setEncodedTextLen(value);
      break;
    case 5:
      var value = new proto.Common.InstrmtLegGrp;
      reader.readMessage(value,proto.Common.InstrmtLegGrp.deserializeBinaryFromReader);
      msg.addInstrmtLegGrp(value);
      break;
    case 6:
      var value = new proto.Common.Instrument;
      reader.readMessage(value,proto.Common.Instrument.deserializeBinaryFromReader);
      msg.setInstrument(value);
      break;
    case 7:
      var value = new proto.Common.InstrumentExtension;
      reader.readMessage(value,proto.Common.InstrumentExtension.deserializeBinaryFromReader);
      msg.setInstrumentExtension(value);
      break;
    case 8:
      var value = /** @type {!proto.Common.ListUpdateActionEnum} */ (reader.readEnum());
      msg.setListUpdateAction(value);
      break;
    case 9:
      var value = new proto.Common.SecondaryPriceLimits;
      reader.readMessage(value,proto.Common.SecondaryPriceLimits.deserializeBinaryFromReader);
      msg.setSecondaryPriceLimits(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 11:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setRelSymTransactTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.RelSymDerivSecUpdGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.RelSymDerivSecUpdGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RelSymDerivSecUpdGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorporateActionList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEncodedText();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEncodedTextLen();
  if (f !== 0) {
    writer.writeSfixed64(
      4,
      f
    );
  }
  f = message.getInstrmtLegGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.Common.InstrmtLegGrp.serializeBinaryToWriter
    );
  }
  f = message.getInstrument();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.Common.Instrument.serializeBinaryToWriter
    );
  }
  f = message.getInstrumentExtension();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.Common.InstrumentExtension.serializeBinaryToWriter
    );
  }
  f = message.getListUpdateAction();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getSecondaryPriceLimits();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.Common.SecondaryPriceLimits.serializeBinaryToWriter
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getRelSymTransactTime();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CorporateActionEnum corporate_action = 1;
 * @return {!Array<!proto.Common.CorporateActionEnum>}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getCorporateActionList = function() {
  return /** @type {!Array<!proto.Common.CorporateActionEnum>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.Common.CorporateActionEnum>} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setCorporateActionList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.Common.CorporateActionEnum} value
 * @param {number=} opt_index
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.addCorporateAction = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearCorporateActionList = function() {
  return this.setCorporateActionList([]);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string encoded_text = 3;
 * @return {string}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getEncodedText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setEncodedText = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional sfixed64 encoded_text_len = 4;
 * @return {number}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getEncodedTextLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setEncodedTextLen = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated InstrmtLegGrp instrmt_leg_grp = 5;
 * @return {!Array<!proto.Common.InstrmtLegGrp>}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getInstrmtLegGrpList = function() {
  return /** @type{!Array<!proto.Common.InstrmtLegGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.InstrmtLegGrp, 5));
};


/**
 * @param {!Array<!proto.Common.InstrmtLegGrp>} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
*/
proto.Common.RelSymDerivSecUpdGrp.prototype.setInstrmtLegGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Common.InstrmtLegGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.InstrmtLegGrp}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.addInstrmtLegGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Common.InstrmtLegGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearInstrmtLegGrpList = function() {
  return this.setInstrmtLegGrpList([]);
};


/**
 * optional Instrument instrument = 6;
 * @return {?proto.Common.Instrument}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getInstrument = function() {
  return /** @type{?proto.Common.Instrument} */ (
    jspb.Message.getWrapperField(this, proto.Common.Instrument, 6));
};


/**
 * @param {?proto.Common.Instrument|undefined} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
*/
proto.Common.RelSymDerivSecUpdGrp.prototype.setInstrument = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearInstrument = function() {
  return this.setInstrument(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.hasInstrument = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional InstrumentExtension instrument_extension = 7;
 * @return {?proto.Common.InstrumentExtension}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getInstrumentExtension = function() {
  return /** @type{?proto.Common.InstrumentExtension} */ (
    jspb.Message.getWrapperField(this, proto.Common.InstrumentExtension, 7));
};


/**
 * @param {?proto.Common.InstrumentExtension|undefined} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
*/
proto.Common.RelSymDerivSecUpdGrp.prototype.setInstrumentExtension = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearInstrumentExtension = function() {
  return this.setInstrumentExtension(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.hasInstrumentExtension = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ListUpdateActionEnum list_update_action = 8;
 * @return {!proto.Common.ListUpdateActionEnum}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getListUpdateAction = function() {
  return /** @type {!proto.Common.ListUpdateActionEnum} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.Common.ListUpdateActionEnum} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setListUpdateAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional SecondaryPriceLimits secondary_price_limits = 9;
 * @return {?proto.Common.SecondaryPriceLimits}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getSecondaryPriceLimits = function() {
  return /** @type{?proto.Common.SecondaryPriceLimits} */ (
    jspb.Message.getWrapperField(this, proto.Common.SecondaryPriceLimits, 9));
};


/**
 * @param {?proto.Common.SecondaryPriceLimits|undefined} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
*/
proto.Common.RelSymDerivSecUpdGrp.prototype.setSecondaryPriceLimits = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearSecondaryPriceLimits = function() {
  return this.setSecondaryPriceLimits(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.hasSecondaryPriceLimits = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional string text = 10;
 * @return {string}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional fix.Timestamp rel_sym_transact_time = 11;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.getRelSymTransactTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 11));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
*/
proto.Common.RelSymDerivSecUpdGrp.prototype.setRelSymTransactTime = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.RelSymDerivSecUpdGrp} returns this
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.clearRelSymTransactTime = function() {
  return this.setRelSymTransactTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.RelSymDerivSecUpdGrp.prototype.hasRelSymTransactTime = function() {
  return jspb.Message.getField(this, 11) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.DerivativeSecurityXML.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.DerivativeSecurityXML.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.DerivativeSecurityXML} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityXML.toObject = function(includeInstance, msg) {
  var f, obj = {
    derivativeSecurityXml: jspb.Message.getFieldWithDefault(msg, 1, ""),
    derivativeSecurityXmlLen: jspb.Message.getFieldWithDefault(msg, 2, 0),
    derivativeSecurityXmlSchema: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.DerivativeSecurityXML}
 */
proto.Common.DerivativeSecurityXML.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.DerivativeSecurityXML;
  return proto.Common.DerivativeSecurityXML.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.DerivativeSecurityXML} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.DerivativeSecurityXML}
 */
proto.Common.DerivativeSecurityXML.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityXml(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setDerivativeSecurityXmlLen(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setDerivativeSecurityXmlSchema(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.DerivativeSecurityXML.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.DerivativeSecurityXML.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.DerivativeSecurityXML} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.DerivativeSecurityXML.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDerivativeSecurityXml();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDerivativeSecurityXmlLen();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getDerivativeSecurityXmlSchema();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string derivative_security_xml = 1;
 * @return {string}
 */
proto.Common.DerivativeSecurityXML.prototype.getDerivativeSecurityXml = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeSecurityXML} returns this
 */
proto.Common.DerivativeSecurityXML.prototype.setDerivativeSecurityXml = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 derivative_security_xml_len = 2;
 * @return {number}
 */
proto.Common.DerivativeSecurityXML.prototype.getDerivativeSecurityXmlLen = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.DerivativeSecurityXML} returns this
 */
proto.Common.DerivativeSecurityXML.prototype.setDerivativeSecurityXmlLen = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string derivative_security_xml_schema = 3;
 * @return {string}
 */
proto.Common.DerivativeSecurityXML.prototype.getDerivativeSecurityXmlSchema = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.DerivativeSecurityXML} returns this
 */
proto.Common.DerivativeSecurityXML.prototype.setDerivativeSecurityXmlSchema = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ApplicationSequenceControl.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ApplicationSequenceControl.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ApplicationSequenceControl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ApplicationSequenceControl.toObject = function(includeInstance, msg) {
  var f, obj = {
    applId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    applLastSeqNum: jspb.Message.getFieldWithDefault(msg, 2, 0),
    applResendFlag: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    applSeqNum: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ApplicationSequenceControl}
 */
proto.Common.ApplicationSequenceControl.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ApplicationSequenceControl;
  return proto.Common.ApplicationSequenceControl.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ApplicationSequenceControl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ApplicationSequenceControl}
 */
proto.Common.ApplicationSequenceControl.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setApplLastSeqNum(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApplResendFlag(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setApplSeqNum(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ApplicationSequenceControl.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ApplicationSequenceControl.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ApplicationSequenceControl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ApplicationSequenceControl.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getApplId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getApplLastSeqNum();
  if (f !== 0) {
    writer.writeSfixed64(
      2,
      f
    );
  }
  f = message.getApplResendFlag();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getApplSeqNum();
  if (f !== 0) {
    writer.writeSfixed64(
      4,
      f
    );
  }
};


/**
 * optional string appl_id = 1;
 * @return {string}
 */
proto.Common.ApplicationSequenceControl.prototype.getApplId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.ApplicationSequenceControl} returns this
 */
proto.Common.ApplicationSequenceControl.prototype.setApplId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional sfixed64 appl_last_seq_num = 2;
 * @return {number}
 */
proto.Common.ApplicationSequenceControl.prototype.getApplLastSeqNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.ApplicationSequenceControl} returns this
 */
proto.Common.ApplicationSequenceControl.prototype.setApplLastSeqNum = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional bool appl_resend_flag = 3;
 * @return {boolean}
 */
proto.Common.ApplicationSequenceControl.prototype.getApplResendFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.Common.ApplicationSequenceControl} returns this
 */
proto.Common.ApplicationSequenceControl.prototype.setApplResendFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional sfixed64 appl_seq_num = 4;
 * @return {number}
 */
proto.Common.ApplicationSequenceControl.prototype.getApplSeqNum = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.Common.ApplicationSequenceControl} returns this
 */
proto.Common.ApplicationSequenceControl.prototype.setApplSeqNum = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NstdPtys4SubGrp.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NstdPtys4SubGrp.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NstdPtys4SubGrp} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys4SubGrp.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested4partySubId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested4partySubIdType: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NstdPtys4SubGrp}
 */
proto.Common.NstdPtys4SubGrp.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NstdPtys4SubGrp;
  return proto.Common.NstdPtys4SubGrp.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NstdPtys4SubGrp} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NstdPtys4SubGrp}
 */
proto.Common.NstdPtys4SubGrp.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested4partySubId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested4PartySubIDTypeEnum} */ (reader.readEnum());
      msg.setNested4partySubIdType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NstdPtys4SubGrp.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NstdPtys4SubGrp.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NstdPtys4SubGrp} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NstdPtys4SubGrp.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested4partySubId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested4partySubIdType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional string nested4party_sub_id = 1;
 * @return {string}
 */
proto.Common.NstdPtys4SubGrp.prototype.getNested4partySubId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NstdPtys4SubGrp} returns this
 */
proto.Common.NstdPtys4SubGrp.prototype.setNested4partySubId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested4PartySubIDTypeEnum nested4party_sub_id_type = 2;
 * @return {!proto.Common.Nested4PartySubIDTypeEnum}
 */
proto.Common.NstdPtys4SubGrp.prototype.getNested4partySubIdType = function() {
  return /** @type {!proto.Common.Nested4PartySubIDTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested4PartySubIDTypeEnum} value
 * @return {!proto.Common.NstdPtys4SubGrp} returns this
 */
proto.Common.NstdPtys4SubGrp.prototype.setNested4partySubIdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.NestedParties4.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.NestedParties4.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.NestedParties4.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.NestedParties4} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties4.toObject = function(includeInstance, msg) {
  var f, obj = {
    nested4partyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    nested4partyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    nested4partyRole: jspb.Message.getFieldWithDefault(msg, 3, 0),
    nstdPtys4subGrpList: jspb.Message.toObjectList(msg.getNstdPtys4subGrpList(),
    proto.Common.NstdPtys4SubGrp.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.NestedParties4}
 */
proto.Common.NestedParties4.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.NestedParties4;
  return proto.Common.NestedParties4.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.NestedParties4} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.NestedParties4}
 */
proto.Common.NestedParties4.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNested4partyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.Nested4PartyIDSourceEnum} */ (reader.readEnum());
      msg.setNested4partyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.Nested4PartyRoleEnum} */ (reader.readEnum());
      msg.setNested4partyRole(value);
      break;
    case 4:
      var value = new proto.Common.NstdPtys4SubGrp;
      reader.readMessage(value,proto.Common.NstdPtys4SubGrp.deserializeBinaryFromReader);
      msg.addNstdPtys4subGrp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.NestedParties4.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.NestedParties4.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.NestedParties4} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.NestedParties4.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getNested4partyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getNested4partyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getNested4partyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNstdPtys4subGrpList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.Common.NstdPtys4SubGrp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string nested4party_id = 1;
 * @return {string}
 */
proto.Common.NestedParties4.prototype.getNested4partyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.NestedParties4} returns this
 */
proto.Common.NestedParties4.prototype.setNested4partyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional Nested4PartyIDSourceEnum nested4party_id_source = 2;
 * @return {!proto.Common.Nested4PartyIDSourceEnum}
 */
proto.Common.NestedParties4.prototype.getNested4partyIdSource = function() {
  return /** @type {!proto.Common.Nested4PartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.Nested4PartyIDSourceEnum} value
 * @return {!proto.Common.NestedParties4} returns this
 */
proto.Common.NestedParties4.prototype.setNested4partyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional Nested4PartyRoleEnum nested4party_role = 3;
 * @return {!proto.Common.Nested4PartyRoleEnum}
 */
proto.Common.NestedParties4.prototype.getNested4partyRole = function() {
  return /** @type {!proto.Common.Nested4PartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.Nested4PartyRoleEnum} value
 * @return {!proto.Common.NestedParties4} returns this
 */
proto.Common.NestedParties4.prototype.setNested4partyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated NstdPtys4SubGrp nstd_ptys4sub_grp = 4;
 * @return {!Array<!proto.Common.NstdPtys4SubGrp>}
 */
proto.Common.NestedParties4.prototype.getNstdPtys4subGrpList = function() {
  return /** @type{!Array<!proto.Common.NstdPtys4SubGrp>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.NstdPtys4SubGrp, 4));
};


/**
 * @param {!Array<!proto.Common.NstdPtys4SubGrp>} value
 * @return {!proto.Common.NestedParties4} returns this
*/
proto.Common.NestedParties4.prototype.setNstdPtys4subGrpList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.Common.NstdPtys4SubGrp=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.NstdPtys4SubGrp}
 */
proto.Common.NestedParties4.prototype.addNstdPtys4subGrp = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.Common.NstdPtys4SubGrp, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.NestedParties4} returns this
 */
proto.Common.NestedParties4.prototype.clearNstdPtys4subGrpList = function() {
  return this.setNstdPtys4subGrpList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.RateSource.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.RateSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.RateSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RateSource.toObject = function(includeInstance, msg) {
  var f, obj = {
    rateSource: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rateSourceType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    referencePage: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.RateSource}
 */
proto.Common.RateSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.RateSource;
  return proto.Common.RateSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.RateSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.RateSource}
 */
proto.Common.RateSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.Common.RateSourceEnum} */ (reader.readEnum());
      msg.setRateSource(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.RateSourceTypeEnum} */ (reader.readEnum());
      msg.setRateSourceType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferencePage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.RateSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.RateSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.RateSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.RateSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRateSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRateSourceType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getReferencePage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional RateSourceEnum rate_source = 1;
 * @return {!proto.Common.RateSourceEnum}
 */
proto.Common.RateSource.prototype.getRateSource = function() {
  return /** @type {!proto.Common.RateSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.Common.RateSourceEnum} value
 * @return {!proto.Common.RateSource} returns this
 */
proto.Common.RateSource.prototype.setRateSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional RateSourceTypeEnum rate_source_type = 2;
 * @return {!proto.Common.RateSourceTypeEnum}
 */
proto.Common.RateSource.prototype.getRateSourceType = function() {
  return /** @type {!proto.Common.RateSourceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.RateSourceTypeEnum} value
 * @return {!proto.Common.RateSource} returns this
 */
proto.Common.RateSource.prototype.setRateSourceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string reference_page = 3;
 * @return {string}
 */
proto.Common.RateSource.prototype.getReferencePage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.RateSource} returns this
 */
proto.Common.RateSource.prototype.setReferencePage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.TargetParties.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.TargetParties.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.TargetParties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TargetParties.toObject = function(includeInstance, msg) {
  var f, obj = {
    targetPartyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    targetPartyIdSource: jspb.Message.getFieldWithDefault(msg, 2, 0),
    targetPartyRole: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.TargetParties}
 */
proto.Common.TargetParties.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.TargetParties;
  return proto.Common.TargetParties.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.TargetParties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.TargetParties}
 */
proto.Common.TargetParties.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetPartyId(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.TargetPartyIDSourceEnum} */ (reader.readEnum());
      msg.setTargetPartyIdSource(value);
      break;
    case 3:
      var value = /** @type {!proto.Common.TargetPartyRoleEnum} */ (reader.readEnum());
      msg.setTargetPartyRole(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.TargetParties.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.TargetParties.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.TargetParties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.TargetParties.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTargetPartyId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTargetPartyIdSource();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getTargetPartyRole();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional string target_party_id = 1;
 * @return {string}
 */
proto.Common.TargetParties.prototype.getTargetPartyId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.Common.TargetParties} returns this
 */
proto.Common.TargetParties.prototype.setTargetPartyId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional TargetPartyIDSourceEnum target_party_id_source = 2;
 * @return {!proto.Common.TargetPartyIDSourceEnum}
 */
proto.Common.TargetParties.prototype.getTargetPartyIdSource = function() {
  return /** @type {!proto.Common.TargetPartyIDSourceEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.TargetPartyIDSourceEnum} value
 * @return {!proto.Common.TargetParties} returns this
 */
proto.Common.TargetParties.prototype.setTargetPartyIdSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional TargetPartyRoleEnum target_party_role = 3;
 * @return {!proto.Common.TargetPartyRoleEnum}
 */
proto.Common.TargetParties.prototype.getTargetPartyRole = function() {
  return /** @type {!proto.Common.TargetPartyRoleEnum} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.Common.TargetPartyRoleEnum} value
 * @return {!proto.Common.TargetParties} returns this
 */
proto.Common.TargetParties.prototype.setTargetPartyRole = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.ComplexEvents.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ComplexEvents.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ComplexEvents.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ComplexEvents} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEvents.toObject = function(includeInstance, msg) {
  var f, obj = {
    complexEventDatesList: jspb.Message.toObjectList(msg.getComplexEventDatesList(),
    proto.Common.ComplexEventDates.toObject, includeInstance),
    complexEventCondition: jspb.Message.getFieldWithDefault(msg, 2, 0),
    complexEventPrice: (f = msg.getComplexEventPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    complexEventPriceBoundaryMethod: jspb.Message.getFieldWithDefault(msg, 4, 0),
    complexEventPriceBoundaryPrecision: (f = msg.getComplexEventPriceBoundaryPrecision()) && fix_pb.Decimal64.toObject(includeInstance, f),
    complexEventPriceTimeType: jspb.Message.getFieldWithDefault(msg, 6, 0),
    complexEventType: jspb.Message.getFieldWithDefault(msg, 7, 0),
    complexOptPayoutAmount: (f = msg.getComplexOptPayoutAmount()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ComplexEvents}
 */
proto.Common.ComplexEvents.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ComplexEvents;
  return proto.Common.ComplexEvents.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ComplexEvents} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ComplexEvents}
 */
proto.Common.ComplexEvents.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.ComplexEventDates;
      reader.readMessage(value,proto.Common.ComplexEventDates.deserializeBinaryFromReader);
      msg.addComplexEventDates(value);
      break;
    case 2:
      var value = /** @type {!proto.Common.ComplexEventConditionEnum} */ (reader.readEnum());
      msg.setComplexEventCondition(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setComplexEventPrice(value);
      break;
    case 4:
      var value = /** @type {!proto.Common.ComplexEventPriceBoundaryMethodEnum} */ (reader.readEnum());
      msg.setComplexEventPriceBoundaryMethod(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setComplexEventPriceBoundaryPrecision(value);
      break;
    case 6:
      var value = /** @type {!proto.Common.ComplexEventPriceTimeTypeEnum} */ (reader.readEnum());
      msg.setComplexEventPriceTimeType(value);
      break;
    case 7:
      var value = /** @type {!proto.Common.ComplexEventTypeEnum} */ (reader.readEnum());
      msg.setComplexEventType(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setComplexOptPayoutAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ComplexEvents.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ComplexEvents.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ComplexEvents} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEvents.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplexEventDatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Common.ComplexEventDates.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventCondition();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getComplexEventPrice();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventPriceBoundaryMethod();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getComplexEventPriceBoundaryPrecision();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventPriceTimeType();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getComplexEventType();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getComplexOptPayoutAmount();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ComplexEventDates complex_event_dates = 1;
 * @return {!Array<!proto.Common.ComplexEventDates>}
 */
proto.Common.ComplexEvents.prototype.getComplexEventDatesList = function() {
  return /** @type{!Array<!proto.Common.ComplexEventDates>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.ComplexEventDates, 1));
};


/**
 * @param {!Array<!proto.Common.ComplexEventDates>} value
 * @return {!proto.Common.ComplexEvents} returns this
*/
proto.Common.ComplexEvents.prototype.setComplexEventDatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Common.ComplexEventDates=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ComplexEventDates}
 */
proto.Common.ComplexEvents.prototype.addComplexEventDates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Common.ComplexEventDates, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.clearComplexEventDatesList = function() {
  return this.setComplexEventDatesList([]);
};


/**
 * optional ComplexEventConditionEnum complex_event_condition = 2;
 * @return {!proto.Common.ComplexEventConditionEnum}
 */
proto.Common.ComplexEvents.prototype.getComplexEventCondition = function() {
  return /** @type {!proto.Common.ComplexEventConditionEnum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.Common.ComplexEventConditionEnum} value
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.setComplexEventCondition = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional fix.Decimal64 complex_event_price = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.ComplexEvents.prototype.getComplexEventPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.ComplexEvents} returns this
*/
proto.Common.ComplexEvents.prototype.setComplexEventPrice = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.clearComplexEventPrice = function() {
  return this.setComplexEventPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEvents.prototype.hasComplexEventPrice = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional ComplexEventPriceBoundaryMethodEnum complex_event_price_boundary_method = 4;
 * @return {!proto.Common.ComplexEventPriceBoundaryMethodEnum}
 */
proto.Common.ComplexEvents.prototype.getComplexEventPriceBoundaryMethod = function() {
  return /** @type {!proto.Common.ComplexEventPriceBoundaryMethodEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.Common.ComplexEventPriceBoundaryMethodEnum} value
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.setComplexEventPriceBoundaryMethod = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 complex_event_price_boundary_precision = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.ComplexEvents.prototype.getComplexEventPriceBoundaryPrecision = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.ComplexEvents} returns this
*/
proto.Common.ComplexEvents.prototype.setComplexEventPriceBoundaryPrecision = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.clearComplexEventPriceBoundaryPrecision = function() {
  return this.setComplexEventPriceBoundaryPrecision(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEvents.prototype.hasComplexEventPriceBoundaryPrecision = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional ComplexEventPriceTimeTypeEnum complex_event_price_time_type = 6;
 * @return {!proto.Common.ComplexEventPriceTimeTypeEnum}
 */
proto.Common.ComplexEvents.prototype.getComplexEventPriceTimeType = function() {
  return /** @type {!proto.Common.ComplexEventPriceTimeTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.Common.ComplexEventPriceTimeTypeEnum} value
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.setComplexEventPriceTimeType = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional ComplexEventTypeEnum complex_event_type = 7;
 * @return {!proto.Common.ComplexEventTypeEnum}
 */
proto.Common.ComplexEvents.prototype.getComplexEventType = function() {
  return /** @type {!proto.Common.ComplexEventTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.Common.ComplexEventTypeEnum} value
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.setComplexEventType = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional fix.Decimal64 complex_opt_payout_amount = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.Common.ComplexEvents.prototype.getComplexOptPayoutAmount = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.Common.ComplexEvents} returns this
*/
proto.Common.ComplexEvents.prototype.setComplexOptPayoutAmount = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEvents} returns this
 */
proto.Common.ComplexEvents.prototype.clearComplexOptPayoutAmount = function() {
  return this.setComplexOptPayoutAmount(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEvents.prototype.hasComplexOptPayoutAmount = function() {
  return jspb.Message.getField(this, 8) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.Common.ComplexEventDates.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ComplexEventDates.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ComplexEventDates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ComplexEventDates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEventDates.toObject = function(includeInstance, msg) {
  var f, obj = {
    complexEventTimesList: jspb.Message.toObjectList(msg.getComplexEventTimesList(),
    proto.Common.ComplexEventTimes.toObject, includeInstance),
    complexEventEndDate: (f = msg.getComplexEventEndDate()) && fix_pb.Timestamp.toObject(includeInstance, f),
    complexEventStartDate: (f = msg.getComplexEventStartDate()) && fix_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ComplexEventDates}
 */
proto.Common.ComplexEventDates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ComplexEventDates;
  return proto.Common.ComplexEventDates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ComplexEventDates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ComplexEventDates}
 */
proto.Common.ComplexEventDates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.Common.ComplexEventTimes;
      reader.readMessage(value,proto.Common.ComplexEventTimes.deserializeBinaryFromReader);
      msg.addComplexEventTimes(value);
      break;
    case 2:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setComplexEventEndDate(value);
      break;
    case 3:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setComplexEventStartDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ComplexEventDates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ComplexEventDates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ComplexEventDates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEventDates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplexEventTimesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.Common.ComplexEventTimes.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventEndDate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventStartDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ComplexEventTimes complex_event_times = 1;
 * @return {!Array<!proto.Common.ComplexEventTimes>}
 */
proto.Common.ComplexEventDates.prototype.getComplexEventTimesList = function() {
  return /** @type{!Array<!proto.Common.ComplexEventTimes>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.Common.ComplexEventTimes, 1));
};


/**
 * @param {!Array<!proto.Common.ComplexEventTimes>} value
 * @return {!proto.Common.ComplexEventDates} returns this
*/
proto.Common.ComplexEventDates.prototype.setComplexEventTimesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.Common.ComplexEventTimes=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.ComplexEventTimes}
 */
proto.Common.ComplexEventDates.prototype.addComplexEventTimes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.Common.ComplexEventTimes, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.Common.ComplexEventDates} returns this
 */
proto.Common.ComplexEventDates.prototype.clearComplexEventTimesList = function() {
  return this.setComplexEventTimesList([]);
};


/**
 * optional fix.Timestamp complex_event_end_date = 2;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.ComplexEventDates.prototype.getComplexEventEndDate = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 2));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.ComplexEventDates} returns this
*/
proto.Common.ComplexEventDates.prototype.setComplexEventEndDate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEventDates} returns this
 */
proto.Common.ComplexEventDates.prototype.clearComplexEventEndDate = function() {
  return this.setComplexEventEndDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEventDates.prototype.hasComplexEventEndDate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Timestamp complex_event_start_date = 3;
 * @return {?proto.fix.Timestamp}
 */
proto.Common.ComplexEventDates.prototype.getComplexEventStartDate = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 3));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.Common.ComplexEventDates} returns this
*/
proto.Common.ComplexEventDates.prototype.setComplexEventStartDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEventDates} returns this
 */
proto.Common.ComplexEventDates.prototype.clearComplexEventStartDate = function() {
  return this.setComplexEventStartDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEventDates.prototype.hasComplexEventStartDate = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.Common.ComplexEventTimes.prototype.toObject = function(opt_includeInstance) {
  return proto.Common.ComplexEventTimes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.Common.ComplexEventTimes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEventTimes.toObject = function(includeInstance, msg) {
  var f, obj = {
    complexEventEndTime: (f = msg.getComplexEventEndTime()) && fix_pb.TimeOnly.toObject(includeInstance, f),
    complexEventStartTime: (f = msg.getComplexEventStartTime()) && fix_pb.TimeOnly.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.Common.ComplexEventTimes}
 */
proto.Common.ComplexEventTimes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.Common.ComplexEventTimes;
  return proto.Common.ComplexEventTimes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.Common.ComplexEventTimes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.Common.ComplexEventTimes}
 */
proto.Common.ComplexEventTimes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.TimeOnly;
      reader.readMessage(value,fix_pb.TimeOnly.deserializeBinaryFromReader);
      msg.setComplexEventEndTime(value);
      break;
    case 2:
      var value = new fix_pb.TimeOnly;
      reader.readMessage(value,fix_pb.TimeOnly.deserializeBinaryFromReader);
      msg.setComplexEventStartTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.Common.ComplexEventTimes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.Common.ComplexEventTimes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.Common.ComplexEventTimes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.Common.ComplexEventTimes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getComplexEventEndTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.TimeOnly.serializeBinaryToWriter
    );
  }
  f = message.getComplexEventStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.TimeOnly.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.TimeOnly complex_event_end_time = 1;
 * @return {?proto.fix.TimeOnly}
 */
proto.Common.ComplexEventTimes.prototype.getComplexEventEndTime = function() {
  return /** @type{?proto.fix.TimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.TimeOnly, 1));
};


/**
 * @param {?proto.fix.TimeOnly|undefined} value
 * @return {!proto.Common.ComplexEventTimes} returns this
*/
proto.Common.ComplexEventTimes.prototype.setComplexEventEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEventTimes} returns this
 */
proto.Common.ComplexEventTimes.prototype.clearComplexEventEndTime = function() {
  return this.setComplexEventEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEventTimes.prototype.hasComplexEventEndTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.TimeOnly complex_event_start_time = 2;
 * @return {?proto.fix.TimeOnly}
 */
proto.Common.ComplexEventTimes.prototype.getComplexEventStartTime = function() {
  return /** @type{?proto.fix.TimeOnly} */ (
    jspb.Message.getWrapperField(this, fix_pb.TimeOnly, 2));
};


/**
 * @param {?proto.fix.TimeOnly|undefined} value
 * @return {!proto.Common.ComplexEventTimes} returns this
*/
proto.Common.ComplexEventTimes.prototype.setComplexEventStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.Common.ComplexEventTimes} returns this
 */
proto.Common.ComplexEventTimes.prototype.clearComplexEventStartTime = function() {
  return this.setComplexEventStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.Common.ComplexEventTimes.prototype.hasComplexEventStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.Common.CommTypeEnum = {
  COMM_TYPE_UNSPECIFIED: 0,
  COMM_TYPE_ABSOLUTE: 1,
  COMM_TYPE_PERCENT: 2,
  COMM_TYPE_PER_UNIT: 3,
  COMM_TYPE_PERCENTAGE_WAIVED_CASH_DISCOUNT: 4,
  COMM_TYPE_PERCENTAGE_WAIVED_ENHANCED_UNITS: 5,
  COMM_TYPE_POINTS_PER_BOND_OR_CONTRACT: 6
};

/**
 * @enum {number}
 */
proto.Common.FundRenewWaivEnum = {
  FUND_RENEW_WAIV_UNSPECIFIED: 0,
  FUND_RENEW_WAIV_NO: 1,
  FUND_RENEW_WAIV_YES: 2
};

/**
 * @enum {number}
 */
proto.Common.DiscretionInstEnum = {
  DISCRETION_INST_UNSPECIFIED: 0,
  DISCRETION_INST_RELATED_TO_DISPLAYED_PRICE: 1,
  DISCRETION_INST_RELATED_TO_LAST_TRADE_PRICE: 2,
  DISCRETION_INST_RELATED_TO_LOCAL_PRIMARY_PRICE: 3,
  DISCRETION_INST_RELATED_TO_MARKET_PRICE: 4,
  DISCRETION_INST_RELATED_TO_MIDPOINT_PRICE: 5,
  DISCRETION_INST_RELATED_TO_PRIMARY_PRICE: 6,
  DISCRETION_INST_RELATED_TO_VWAP: 7,
  DISCRETION_INST_AVERAGE_PRICE_GUARANTEE: 8
};

/**
 * @enum {number}
 */
proto.Common.DiscretionMoveTypeEnum = {
  DISCRETION_MOVE_TYPE_UNSPECIFIED: 0,
  DISCRETION_MOVE_TYPE_FIXED: 1,
  DISCRETION_MOVE_TYPE_FLOATING: 2
};

/**
 * @enum {number}
 */
proto.Common.DiscretionOffsetTypeEnum = {
  DISCRETION_OFFSET_TYPE_UNSPECIFIED: 0,
  DISCRETION_OFFSET_TYPE_BASIS_POINTS: 1,
  DISCRETION_OFFSET_TYPE_PRICE: 2,
  DISCRETION_OFFSET_TYPE_PRICE_TIER: 3,
  DISCRETION_OFFSET_TYPE_TICKS: 4
};

/**
 * @enum {number}
 */
proto.Common.DiscretionLimitTypeEnum = {
  DISCRETION_LIMIT_TYPE_UNSPECIFIED: 0,
  DISCRETION_LIMIT_TYPE_OR_BETTER: 1,
  DISCRETION_LIMIT_TYPE_OR_WORSE: 2,
  DISCRETION_LIMIT_TYPE_STRICT: 3
};

/**
 * @enum {number}
 */
proto.Common.DiscretionRoundDirectionEnum = {
  DISCRETION_ROUND_DIRECTION_UNSPECIFIED: 0,
  DISCRETION_ROUND_DIRECTION_MORE_AGGRESSIVE: 1,
  DISCRETION_ROUND_DIRECTION_MORE_PASSIVE: 2
};

/**
 * @enum {number}
 */
proto.Common.DiscretionScopeEnum = {
  DISCRETION_SCOPE_UNSPECIFIED: 0,
  DISCRETION_SCOPE_GLOBAL: 1,
  DISCRETION_SCOPE_LOCAL: 2,
  DISCRETION_SCOPE_NATIONAL: 3,
  DISCRETION_SCOPE_NATIONAL_EXCLUDING_LOCAL: 4
};

/**
 * @enum {number}
 */
proto.Common.TerminationTypeEnum = {
  TERMINATION_TYPE_UNSPECIFIED: 0,
  TERMINATION_TYPE_FLEXIBLE: 1,
  TERMINATION_TYPE_OPEN: 2,
  TERMINATION_TYPE_OVERNIGHT: 3,
  TERMINATION_TYPE_TERM: 4
};

/**
 * @enum {number}
 */
proto.Common.DeliveryTypeEnum = {
  DELIVERY_TYPE_UNSPECIFIED: 0,
  DELIVERY_TYPE_FREE: 1,
  DELIVERY_TYPE_HOLD_IN_CUSTODY: 2,
  DELIVERY_TYPE_TRI_PARTY: 3,
  DELIVERY_TYPE_VERSUS_PAYMENT: 4
};

/**
 * @enum {number}
 */
proto.Common.SymbolSfxEnum = {
  SYMBOL_SFX_UNSPECIFIED: 0,
  SYMBOL_SFX_EUCP_WITH_LUMP_SUM_INTEREST: 1,
  SYMBOL_SFX_WHEN_ISSUED: 2
};

/**
 * @enum {number}
 */
proto.Common.SecurityIDSourceEnum = {
  SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  SECURITY_ID_SOURCE_CUSIP: 1,
  SECURITY_ID_SOURCE_QUIK: 2,
  SECURITY_ID_SOURCE_SEDOL: 3,
  SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  SECURITY_ID_SOURCE_RIC_CODE: 5,
  SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  SECURITY_ID_SOURCE_BELGIAN: 10,
  SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  SECURITY_ID_SOURCE_COMMON: 12,
  SECURITY_ID_SOURCE_DUTCH: 13,
  SECURITY_ID_SOURCE_SICOVAM: 14,
  SECURITY_ID_SOURCE_VALOREN: 15,
  SECURITY_ID_SOURCE_WERTPAPIER: 16,
  SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.ProductEnum = {
  PRODUCT_UNSPECIFIED: 0,
  PRODUCT_AGENCY: 1,
  PRODUCT_COMMODITY: 2,
  PRODUCT_CORPORATE: 3,
  PRODUCT_CURRENCY: 4,
  PRODUCT_EQUITY: 5,
  PRODUCT_GOVERNMENT: 6,
  PRODUCT_INDEX: 7,
  PRODUCT_LOAN: 8,
  PRODUCT_MONEYMARKET: 9,
  PRODUCT_MORTGAGE: 10,
  PRODUCT_MUNICIPAL: 11,
  PRODUCT_OTHER: 12,
  PRODUCT_FINANCING: 13
};

/**
 * @enum {number}
 */
proto.Common.SecurityTypeEnum = {
  SECURITY_TYPE_UNSPECIFIED: 0,
  SECURITY_TYPE_BANKERS_ACCEPTANCE: 1,
  SECURITY_TYPE_CERTIFICATE_OF_DEPOSIT: 2,
  SECURITY_TYPE_COLLATERALIZED_MORTGAGE_OBLIGATION: 3,
  SECURITY_TYPE_COMMERCIAL_PAPER: 4,
  SECURITY_TYPE_COMMON_STOCK: 5,
  SECURITY_TYPE_CORPORATE_BOND: 6,
  SECURITY_TYPE_CORPORATE_PRIVATE_PLACEMENT: 7,
  SECURITY_TYPE_FOREIGN_EXCHANGE_CONTRACT: 8,
  SECURITY_TYPE_FUTURE: 9,
  SECURITY_TYPE_MISCELLANEOUS_PASS_THROUGH: 10,
  SECURITY_TYPE_MORTGAGE_INTEREST_ONLY: 11,
  SECURITY_TYPE_MORTGAGE_PRINCIPAL_ONLY: 12,
  SECURITY_TYPE_MORTGAGE_PRIVATE_PLACEMENT: 13,
  SECURITY_TYPE_MUTUAL_FUND: 14,
  SECURITY_TYPE_NO_SECURITY_TYPE: 15,
  SECURITY_TYPE_OPTION: 16,
  SECURITY_TYPE_PREFERRED_STOCK: 17,
  SECURITY_TYPE_TIME_DEPOSIT: 18,
  SECURITY_TYPE_US_TREASURY_BILL_OLD: 19,
  SECURITY_TYPE_WARRANT: 20,
  SECURITY_TYPE_CONVERTIBLE_BOND: 21,
  SECURITY_TYPE_IOETTEMORTGAGE: 22,
  SECURITY_TYPE_WILDCARD: 23,
  SECURITY_TYPE_AMENDED: 24,
  SECURITY_TYPE_ASSET_BACKED_SECURITIES: 25,
  SECURITY_TYPE_BANK_NOTES: 26,
  SECURITY_TYPE_BILL_OF_EXCHANGES: 27,
  SECURITY_TYPE_BRADY_BOND: 28,
  SECURITY_TYPE_BRIDGE_LOAN: 29,
  SECURITY_TYPE_CALL_LOANS: 30,
  SECURITY_TYPE_CERTIFICATE_OF_OBLIGATION: 31,
  SECURITY_TYPE_CERTIFICATE_OF_PARTICIPATION: 32,
  SECURITY_TYPE_CORP: 33,
  SECURITY_TYPE_DEBTOR_IN_POSSESSION: 34,
  SECURITY_TYPE_DEFAULTED: 35,
  SECURITY_TYPE_DEPOSIT_NOTES: 36,
  SECURITY_TYPE_DUAL_CURRENCY: 37,
  SECURITY_TYPE_EXTENDED_COMM_NOTE: 38,
  SECURITY_TYPE_FEDERAL_AGENCY_COUPON: 39,
  SECURITY_TYPE_FEDERAL_AGENCY_DISCOUNT_NOTE: 40,
  SECURITY_TYPE_GENERAL_OBLIGATION_BONDS: 41,
  SECURITY_TYPE_INDEXED_LINKED: 42,
  SECURITY_TYPE_INTEREST_STRIP_FROM_ANY_BOND_OR_NOTE: 43,
  SECURITY_TYPE_LETTER_OF_CREDIT: 44,
  SECURITY_TYPE_LIQUIDITY_NOTE: 45,
  SECURITY_TYPE_MANDATORY_TENDER: 46,
  SECURITY_TYPE_MATURED: 47,
  SECURITY_TYPE_MEDIUM_TERM_NOTES: 48,
  SECURITY_TYPE_MORTGAGE_BACKED_SECURITIES: 49,
  SECURITY_TYPE_MULTILEG_INSTRUMENT: 50,
  SECURITY_TYPE_OTHER_ANTICIPATION_NOTES: 51,
  SECURITY_TYPE_OVERNIGHT: 52,
  SECURITY_TYPE_PLAZOS_FIJOS: 53,
  SECURITY_TYPE_PRINCIPAL_STRIP_FROM_ANON_CALLABLE_BOND_OR_NOTE: 54,
  SECURITY_TYPE_PRINCIPAL_STRIP_OF_ACALLABLE_BOND_OR_NOTE: 55,
  SECURITY_TYPE_PRIVATE_EXPORT_FUNDING: 56,
  SECURITY_TYPE_PROMISSORY_NOTE: 57,
  SECURITY_TYPE_REPLACED: 58,
  SECURITY_TYPE_RETIRED: 59,
  SECURITY_TYPE_REVENUE_ANTICIPATION_NOTE: 60,
  SECURITY_TYPE_REVENUE_BONDS: 61,
  SECURITY_TYPE_REVOLVER: 62,
  SECURITY_TYPE_REVOLVER_LOAN: 63,
  SECURITY_TYPE_SHORT_TERM_LOAN_NOTE: 64,
  SECURITY_TYPE_SPECIAL_ASSESSMENT: 65,
  SECURITY_TYPE_SPECIAL_OBLIGATION: 66,
  SECURITY_TYPE_SPECIAL_TAX: 67,
  SECURITY_TYPE_STRUCTURED_NOTES: 68,
  SECURITY_TYPE_SWING_LINE_FACILITY: 69,
  SECURITY_TYPE_TAX_ALLOCATION: 70,
  SECURITY_TYPE_TAX_ANTICIPATION_NOTE: 71,
  SECURITY_TYPE_TAX_EXEMPT_COMMERCIAL_PAPER: 72,
  SECURITY_TYPE_TAX_REVENUE_ANTICIPATION_NOTE: 73,
  SECURITY_TYPE_TERM_LOAN: 74,
  SECURITY_TYPE_TO_BE_ANNOUNCED: 75,
  SECURITY_TYPE_TREASURY_INFLATION_PROTECTED_SECURITIES: 76,
  SECURITY_TYPE_US_TREASURY_BOND: 77,
  SECURITY_TYPE_US_TREASURY_NOTE_OLD: 78,
  SECURITY_TYPE_VARIABLE_RATE_DEMAND_NOTE: 79,
  SECURITY_TYPE_WITHDRAWN: 80,
  SECURITY_TYPE_YANKEE_CORPORATE_BOND: 81,
  SECURITY_TYPE_BUY_SELLBACK: 82,
  SECURITY_TYPE_EURO_CERTIFICATE_OF_DEPOSIT: 83,
  SECURITY_TYPE_EURO_COMMERCIAL_PAPER: 84,
  SECURITY_TYPE_EURO_CORPORATE_BOND: 85,
  SECURITY_TYPE_EURO_SOVEREIGNS: 86,
  SECURITY_TYPE_EURO_SUPRANATIONAL_COUPONS: 87,
  SECURITY_TYPE_FORWARD: 88,
  SECURITY_TYPE_PFANDBRIEFE: 89,
  SECURITY_TYPE_REPURCHASE: 90,
  SECURITY_TYPE_SECURITIES_LOAN: 91,
  SECURITY_TYPE_SECURITIES_PLEDGE: 92,
  SECURITY_TYPE_USD_SUPRANATIONAL_COUPONS: 93,
  SECURITY_TYPE_US_TREASURY_BILL: 94,
  SECURITY_TYPE_US_TREASURY_NOTE: 95,
  SECURITY_TYPE_YANKEE_CERTIFICATE_OF_DEPOSIT: 96,
  SECURITY_TYPE_OPTIONS_ON_FUTURES: 97,
  SECURITY_TYPE_OPTIONS_ON_PHYSICAL: 98,
  SECURITY_TYPE_CASH: 99,
  SECURITY_TYPE_OPTIONS_ON_COMBO: 100,
  SECURITY_TYPE_INTEREST_RATE_SWAP: 101,
  SECURITY_TYPE_BANK_DEPOSITORY_NOTE: 102,
  SECURITY_TYPE_CANADIAN_MONEY_MARKETS: 103,
  SECURITY_TYPE_CANADIAN_MORTGAGE_BONDS: 104,
  SECURITY_TYPE_CANADIAN_PROVINCIAL_BONDS: 105,
  SECURITY_TYPE_CANADIAN_TREASURY_BILLS: 106,
  SECURITY_TYPE_CANADIAN_TREASURY_NOTES: 107,
  SECURITY_TYPE_CREDIT_DEFAULT_SWAP: 108,
  SECURITY_TYPE_EURO_CORPORATE_FLOATING_RATE_NOTES: 109,
  SECURITY_TYPE_SECURED_LIQUIDITY_NOTE: 110,
  SECURITY_TYPE_TAXABLE_MUNICIPAL_CP: 111,
  SECURITY_TYPE_TERM_LIQUIDITY_NOTE: 112,
  SECURITY_TYPE_TREASURY_BILL: 113,
  SECURITY_TYPE_US_CORPORATE_FLOATING_RATE_NOTES: 114,
  SECURITY_TYPE_FX_FORWARD: 115,
  SECURITY_TYPE_FX_SPOT: 116,
  SECURITY_TYPE_FX_SWAP: 117,
  SECURITY_TYPE_NON_DELIVERABLE_FORWARD: 118
};

/**
 * @enum {number}
 */
proto.Common.SecurityStatusEnum = {
  SECURITY_STATUS_UNSPECIFIED: 0,
  SECURITY_STATUS_ACTIVE: 1,
  SECURITY_STATUS_INACTIVE: 2
};

/**
 * @enum {number}
 */
proto.Common.RestructuringTypeEnum = {
  RESTRUCTURING_TYPE_UNSPECIFIED: 0,
  RESTRUCTURING_TYPE_FULL_RESTRUCTURING: 1,
  RESTRUCTURING_TYPE_MODIFIED_MOD_RESTRUCTURING: 2,
  RESTRUCTURING_TYPE_MODIFIED_RESTRUCTURING: 3,
  RESTRUCTURING_TYPE_NO_RESTRUCTURING_SPECIFIED: 4
};

/**
 * @enum {number}
 */
proto.Common.SeniorityEnum = {
  SENIORITY_UNSPECIFIED: 0,
  SENIORITY_SENIOR: 1,
  SENIORITY_SENIOR_SECURED: 2,
  SENIORITY_SUBORDINATED: 3
};

/**
 * @enum {number}
 */
proto.Common.StrikePriceDeterminationMethodEnum = {
  STRIKE_PRICE_DETERMINATION_METHOD_UNSPECIFIED: 0,
  STRIKE_PRICE_DETERMINATION_METHOD_FIXED_STRIKE: 1,
  STRIKE_PRICE_DETERMINATION_METHOD_STRIKE_SET_AT_EXPIRATION: 2,
  STRIKE_PRICE_DETERMINATION_METHOD_STRIKE_SET_TO_AVERAGE_ACROSS_LIFE: 3,
  STRIKE_PRICE_DETERMINATION_METHOD_STRIKE_SET_TO_OPTIMAL_VALUE: 4
};

/**
 * @enum {number}
 */
proto.Common.StrikePriceBoundaryMethodEnum = {
  STRIKE_PRICE_BOUNDARY_METHOD_UNSPECIFIED: 0,
  STRIKE_PRICE_BOUNDARY_METHOD_EQUAL: 1,
  STRIKE_PRICE_BOUNDARY_METHOD_GREATER_THAN: 2,
  STRIKE_PRICE_BOUNDARY_METHOD_GREATER_THAN_OR_EQUAL: 3,
  STRIKE_PRICE_BOUNDARY_METHOD_LESS_THAN: 4,
  STRIKE_PRICE_BOUNDARY_METHOD_LESS_THAN_OR_EQUAL: 5
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingPriceDeterminationMethodEnum = {
  UNDERLYING_PRICE_DETERMINATION_METHOD_UNSPECIFIED: 0,
  UNDERLYING_PRICE_DETERMINATION_METHOD_AVERAGE_VALUE: 1,
  UNDERLYING_PRICE_DETERMINATION_METHOD_OPTIMAL_VALUE: 2,
  UNDERLYING_PRICE_DETERMINATION_METHOD_REGULAR: 3,
  UNDERLYING_PRICE_DETERMINATION_METHOD_SPECIAL_REFERENCE: 4
};

/**
 * @enum {number}
 */
proto.Common.ContractMultiplierUnitEnum = {
  CONTRACT_MULTIPLIER_UNIT_UNSPECIFIED: 0,
  CONTRACT_MULTIPLIER_UNIT_DAYS: 1,
  CONTRACT_MULTIPLIER_UNIT_HOURS: 2,
  CONTRACT_MULTIPLIER_UNIT_SHARES: 3
};

/**
 * @enum {number}
 */
proto.Common.FlowScheduleTypeEnum = {
  FLOW_SCHEDULE_TYPE_UNSPECIFIED: 0,
  FLOW_SCHEDULE_TYPE_NERC_CALENDAR_ALL_DAYS_IN_MONTH: 1,
  FLOW_SCHEDULE_TYPE_NERC_EASTERN_OFF_PEAK: 2,
  FLOW_SCHEDULE_TYPE_NERC_EASTERN_PEAK: 3,
  FLOW_SCHEDULE_TYPE_NERC_WESTERN_OFF_PEAK: 4,
  FLOW_SCHEDULE_TYPE_NERC_WESTERN_PEAK: 5
};

/**
 * @enum {number}
 */
proto.Common.UnitOfMeasureEnum = {
  UNIT_OF_MEASURE_UNSPECIFIED: 0,
  UNIT_OF_MEASURE_BARRELS: 1,
  UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  UNIT_OF_MEASURE_BUSHELS: 3,
  UNIT_OF_MEASURE_GALLONS: 4,
  UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  UNIT_OF_MEASURE_METRIC_TONS: 6,
  UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  UNIT_OF_MEASURE_POUNDS: 9,
  UNIT_OF_MEASURE_TONS: 10,
  UNIT_OF_MEASURE_TROY_OUNCES: 11,
  UNIT_OF_MEASURE_USDOLLARS: 12,
  UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.PriceUnitOfMeasureEnum = {
  PRICE_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  PRICE_UNIT_OF_MEASURE_BARRELS: 1,
  PRICE_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  PRICE_UNIT_OF_MEASURE_BUSHELS: 3,
  PRICE_UNIT_OF_MEASURE_GALLONS: 4,
  PRICE_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  PRICE_UNIT_OF_MEASURE_METRIC_TONS: 6,
  PRICE_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  PRICE_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  PRICE_UNIT_OF_MEASURE_POUNDS: 9,
  PRICE_UNIT_OF_MEASURE_TONS: 10,
  PRICE_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  PRICE_UNIT_OF_MEASURE_USDOLLARS: 12,
  PRICE_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.SettlMethodEnum = {
  SETTL_METHOD_UNSPECIFIED: 0,
  SETTL_METHOD_CASH_SETTLEMENT_REQUIRED: 1,
  SETTL_METHOD_PHYSICAL_SETTLEMENT_REQUIRED: 2
};

/**
 * @enum {number}
 */
proto.Common.ExerciseStyleEnum = {
  EXERCISE_STYLE_UNSPECIFIED: 0,
  EXERCISE_STYLE_AMERICAN: 1,
  EXERCISE_STYLE_BERMUDA: 2,
  EXERCISE_STYLE_EUROPEAN: 3
};

/**
 * @enum {number}
 */
proto.Common.OptPayoutTypeEnum = {
  OPT_PAYOUT_TYPE_UNSPECIFIED: 0,
  OPT_PAYOUT_TYPE_BINARY: 1,
  OPT_PAYOUT_TYPE_CAPPED: 2,
  OPT_PAYOUT_TYPE_VANILLA: 3
};

/**
 * @enum {number}
 */
proto.Common.PriceQuoteMethodEnum = {
  PRICE_QUOTE_METHOD_UNSPECIFIED: 0,
  PRICE_QUOTE_METHOD_INDEX: 1,
  PRICE_QUOTE_METHOD_INTEREST_RATE_INDEX: 2,
  PRICE_QUOTE_METHOD_STANDARD: 3,
  PRICE_QUOTE_METHOD_PERCENT_OF_PAR: 4
};

/**
 * @enum {number}
 */
proto.Common.ValuationMethodEnum = {
  VALUATION_METHOD_UNSPECIFIED: 0,
  VALUATION_METHOD_FUTURES_STYLE_MARK_TO_MARKET: 1,
  VALUATION_METHOD_FUTURES_STYLE_WITH_AN_ATTACHED_CASH_ADJUSTMENT: 2,
  VALUATION_METHOD_PREMIUM_STYLE: 3,
  VALUATION_METHOD_CDS_IN_DELIVERY_USE_RECOVERY_RATE_TO_CALCULATE: 4,
  VALUATION_METHOD_CDS_STYLE_COLLATERALIZATION: 5
};

/**
 * @enum {number}
 */
proto.Common.ListMethodEnum = {
  LIST_METHOD_UNSPECIFIED: 0,
  LIST_METHOD_PRE_LISTED_ONLY: 1,
  LIST_METHOD_USER_REQUESTED: 2
};

/**
 * @enum {number}
 */
proto.Common.PutOrCallEnum = {
  PUT_OR_CALL_UNSPECIFIED: 0,
  PUT_OR_CALL_CALL: 1,
  PUT_OR_CALL_PUT: 2
};

/**
 * @enum {number}
 */
proto.Common.TimeUnitEnum = {
  TIME_UNIT_UNSPECIFIED: 0,
  TIME_UNIT_DAY: 1,
  TIME_UNIT_HOUR: 2,
  TIME_UNIT_MINUTE: 3,
  TIME_UNIT_MONTH: 4,
  TIME_UNIT_SECOND: 5,
  TIME_UNIT_WEEK: 6,
  TIME_UNIT_YEAR: 7
};

/**
 * @enum {number}
 */
proto.Common.CPProgramEnum = {
  CP_PROGRAM_UNSPECIFIED: 0,
  CP_PROGRAM_OTHER: 1,
  CP_PROGRAM_PROGRAM3A3: 2,
  CP_PROGRAM_PROGRAM42: 3
};

/**
 * @enum {number}
 */
proto.Common.DeliveryFormEnum = {
  DELIVERY_FORM_UNSPECIFIED: 0,
  DELIVERY_FORM_BEARER: 1,
  DELIVERY_FORM_BOOK_ENTRY: 2
};

/**
 * @enum {number}
 */
proto.Common.LegSymbolSfxEnum = {
  LEG_SYMBOL_SFX_UNSPECIFIED: 0,
  LEG_SYMBOL_SFX_EUCP_WITH_LUMP_SUM_INTEREST: 1,
  LEG_SYMBOL_SFX_WHEN_ISSUED: 2
};

/**
 * @enum {number}
 */
proto.Common.LegSecurityIDSourceEnum = {
  LEG_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  LEG_SECURITY_ID_SOURCE_CUSIP: 1,
  LEG_SECURITY_ID_SOURCE_QUIK: 2,
  LEG_SECURITY_ID_SOURCE_SEDOL: 3,
  LEG_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  LEG_SECURITY_ID_SOURCE_RIC_CODE: 5,
  LEG_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  LEG_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  LEG_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  LEG_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  LEG_SECURITY_ID_SOURCE_BELGIAN: 10,
  LEG_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  LEG_SECURITY_ID_SOURCE_COMMON: 12,
  LEG_SECURITY_ID_SOURCE_DUTCH: 13,
  LEG_SECURITY_ID_SOURCE_SICOVAM: 14,
  LEG_SECURITY_ID_SOURCE_VALOREN: 15,
  LEG_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  LEG_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  LEG_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  LEG_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  LEG_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  LEG_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  LEG_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.LegProductEnum = {
  LEG_PRODUCT_UNSPECIFIED: 0,
  LEG_PRODUCT_AGENCY: 1,
  LEG_PRODUCT_COMMODITY: 2,
  LEG_PRODUCT_CORPORATE: 3,
  LEG_PRODUCT_CURRENCY: 4,
  LEG_PRODUCT_EQUITY: 5,
  LEG_PRODUCT_GOVERNMENT: 6,
  LEG_PRODUCT_INDEX: 7,
  LEG_PRODUCT_LOAN: 8,
  LEG_PRODUCT_MONEYMARKET: 9,
  LEG_PRODUCT_MORTGAGE: 10,
  LEG_PRODUCT_MUNICIPAL: 11,
  LEG_PRODUCT_OTHER: 12,
  LEG_PRODUCT_FINANCING: 13
};

/**
 * @enum {number}
 */
proto.Common.LegSecurityTypeEnum = {
  LEG_SECURITY_TYPE_UNSPECIFIED: 0,
  LEG_SECURITY_TYPE_BANKERS_ACCEPTANCE: 1,
  LEG_SECURITY_TYPE_CERTIFICATE_OF_DEPOSIT: 2,
  LEG_SECURITY_TYPE_COLLATERALIZED_MORTGAGE_OBLIGATION: 3,
  LEG_SECURITY_TYPE_COMMERCIAL_PAPER: 4,
  LEG_SECURITY_TYPE_COMMON_STOCK: 5,
  LEG_SECURITY_TYPE_CORPORATE_BOND: 6,
  LEG_SECURITY_TYPE_CORPORATE_PRIVATE_PLACEMENT: 7,
  LEG_SECURITY_TYPE_FOREIGN_EXCHANGE_CONTRACT: 8,
  LEG_SECURITY_TYPE_FUTURE: 9,
  LEG_SECURITY_TYPE_MISCELLANEOUS_PASS_THROUGH: 10,
  LEG_SECURITY_TYPE_MORTGAGE_INTEREST_ONLY: 11,
  LEG_SECURITY_TYPE_MORTGAGE_PRINCIPAL_ONLY: 12,
  LEG_SECURITY_TYPE_MORTGAGE_PRIVATE_PLACEMENT: 13,
  LEG_SECURITY_TYPE_MUTUAL_FUND: 14,
  LEG_SECURITY_TYPE_NO_SECURITY_TYPE: 15,
  LEG_SECURITY_TYPE_OPTION: 16,
  LEG_SECURITY_TYPE_PREFERRED_STOCK: 17,
  LEG_SECURITY_TYPE_TIME_DEPOSIT: 18,
  LEG_SECURITY_TYPE_US_TREASURY_BILL_OLD: 19,
  LEG_SECURITY_TYPE_WARRANT: 20,
  LEG_SECURITY_TYPE_CONVERTIBLE_BOND: 21,
  LEG_SECURITY_TYPE_IOETTEMORTGAGE: 22,
  LEG_SECURITY_TYPE_WILDCARD: 23,
  LEG_SECURITY_TYPE_AMENDED: 24,
  LEG_SECURITY_TYPE_ASSET_BACKED_SECURITIES: 25,
  LEG_SECURITY_TYPE_BANK_NOTES: 26,
  LEG_SECURITY_TYPE_BILL_OF_EXCHANGES: 27,
  LEG_SECURITY_TYPE_BRADY_BOND: 28,
  LEG_SECURITY_TYPE_BRIDGE_LOAN: 29,
  LEG_SECURITY_TYPE_CALL_LOANS: 30,
  LEG_SECURITY_TYPE_CERTIFICATE_OF_OBLIGATION: 31,
  LEG_SECURITY_TYPE_CERTIFICATE_OF_PARTICIPATION: 32,
  LEG_SECURITY_TYPE_CORP: 33,
  LEG_SECURITY_TYPE_DEBTOR_IN_POSSESSION: 34,
  LEG_SECURITY_TYPE_DEFAULTED: 35,
  LEG_SECURITY_TYPE_DEPOSIT_NOTES: 36,
  LEG_SECURITY_TYPE_DUAL_CURRENCY: 37,
  LEG_SECURITY_TYPE_EXTENDED_COMM_NOTE: 38,
  LEG_SECURITY_TYPE_FEDERAL_AGENCY_COUPON: 39,
  LEG_SECURITY_TYPE_FEDERAL_AGENCY_DISCOUNT_NOTE: 40,
  LEG_SECURITY_TYPE_GENERAL_OBLIGATION_BONDS: 41,
  LEG_SECURITY_TYPE_INDEXED_LINKED: 42,
  LEG_SECURITY_TYPE_INTEREST_STRIP_FROM_ANY_BOND_OR_NOTE: 43,
  LEG_SECURITY_TYPE_LETTER_OF_CREDIT: 44,
  LEG_SECURITY_TYPE_LIQUIDITY_NOTE: 45,
  LEG_SECURITY_TYPE_MANDATORY_TENDER: 46,
  LEG_SECURITY_TYPE_MATURED: 47,
  LEG_SECURITY_TYPE_MEDIUM_TERM_NOTES: 48,
  LEG_SECURITY_TYPE_MORTGAGE_BACKED_SECURITIES: 49,
  LEG_SECURITY_TYPE_MULTILEG_INSTRUMENT: 50,
  LEG_SECURITY_TYPE_OTHER_ANTICIPATION_NOTES: 51,
  LEG_SECURITY_TYPE_OVERNIGHT: 52,
  LEG_SECURITY_TYPE_PLAZOS_FIJOS: 53,
  LEG_SECURITY_TYPE_PRINCIPAL_STRIP_FROM_ANON_CALLABLE_BOND_OR_NOTE: 54,
  LEG_SECURITY_TYPE_PRINCIPAL_STRIP_OF_ACALLABLE_BOND_OR_NOTE: 55,
  LEG_SECURITY_TYPE_PRIVATE_EXPORT_FUNDING: 56,
  LEG_SECURITY_TYPE_PROMISSORY_NOTE: 57,
  LEG_SECURITY_TYPE_REPLACED: 58,
  LEG_SECURITY_TYPE_RETIRED: 59,
  LEG_SECURITY_TYPE_REVENUE_ANTICIPATION_NOTE: 60,
  LEG_SECURITY_TYPE_REVENUE_BONDS: 61,
  LEG_SECURITY_TYPE_REVOLVER: 62,
  LEG_SECURITY_TYPE_REVOLVER_LOAN: 63,
  LEG_SECURITY_TYPE_SHORT_TERM_LOAN_NOTE: 64,
  LEG_SECURITY_TYPE_SPECIAL_ASSESSMENT: 65,
  LEG_SECURITY_TYPE_SPECIAL_OBLIGATION: 66,
  LEG_SECURITY_TYPE_SPECIAL_TAX: 67,
  LEG_SECURITY_TYPE_STRUCTURED_NOTES: 68,
  LEG_SECURITY_TYPE_SWING_LINE_FACILITY: 69,
  LEG_SECURITY_TYPE_TAX_ALLOCATION: 70,
  LEG_SECURITY_TYPE_TAX_ANTICIPATION_NOTE: 71,
  LEG_SECURITY_TYPE_TAX_EXEMPT_COMMERCIAL_PAPER: 72,
  LEG_SECURITY_TYPE_TAX_REVENUE_ANTICIPATION_NOTE: 73,
  LEG_SECURITY_TYPE_TERM_LOAN: 74,
  LEG_SECURITY_TYPE_TO_BE_ANNOUNCED: 75,
  LEG_SECURITY_TYPE_TREASURY_INFLATION_PROTECTED_SECURITIES: 76,
  LEG_SECURITY_TYPE_US_TREASURY_BOND: 77,
  LEG_SECURITY_TYPE_US_TREASURY_NOTE_OLD: 78,
  LEG_SECURITY_TYPE_VARIABLE_RATE_DEMAND_NOTE: 79,
  LEG_SECURITY_TYPE_WITHDRAWN: 80,
  LEG_SECURITY_TYPE_YANKEE_CORPORATE_BOND: 81,
  LEG_SECURITY_TYPE_BUY_SELLBACK: 82,
  LEG_SECURITY_TYPE_EURO_CERTIFICATE_OF_DEPOSIT: 83,
  LEG_SECURITY_TYPE_EURO_COMMERCIAL_PAPER: 84,
  LEG_SECURITY_TYPE_EURO_CORPORATE_BOND: 85,
  LEG_SECURITY_TYPE_EURO_SOVEREIGNS: 86,
  LEG_SECURITY_TYPE_EURO_SUPRANATIONAL_COUPONS: 87,
  LEG_SECURITY_TYPE_FORWARD: 88,
  LEG_SECURITY_TYPE_PFANDBRIEFE: 89,
  LEG_SECURITY_TYPE_REPURCHASE: 90,
  LEG_SECURITY_TYPE_SECURITIES_LOAN: 91,
  LEG_SECURITY_TYPE_SECURITIES_PLEDGE: 92,
  LEG_SECURITY_TYPE_USD_SUPRANATIONAL_COUPONS: 93,
  LEG_SECURITY_TYPE_US_TREASURY_BILL: 94,
  LEG_SECURITY_TYPE_US_TREASURY_NOTE: 95,
  LEG_SECURITY_TYPE_YANKEE_CERTIFICATE_OF_DEPOSIT: 96,
  LEG_SECURITY_TYPE_OPTIONS_ON_FUTURES: 97,
  LEG_SECURITY_TYPE_OPTIONS_ON_PHYSICAL: 98,
  LEG_SECURITY_TYPE_CASH: 99,
  LEG_SECURITY_TYPE_OPTIONS_ON_COMBO: 100,
  LEG_SECURITY_TYPE_INTEREST_RATE_SWAP: 101,
  LEG_SECURITY_TYPE_BANK_DEPOSITORY_NOTE: 102,
  LEG_SECURITY_TYPE_CANADIAN_MONEY_MARKETS: 103,
  LEG_SECURITY_TYPE_CANADIAN_MORTGAGE_BONDS: 104,
  LEG_SECURITY_TYPE_CANADIAN_PROVINCIAL_BONDS: 105,
  LEG_SECURITY_TYPE_CANADIAN_TREASURY_BILLS: 106,
  LEG_SECURITY_TYPE_CANADIAN_TREASURY_NOTES: 107,
  LEG_SECURITY_TYPE_CREDIT_DEFAULT_SWAP: 108,
  LEG_SECURITY_TYPE_EURO_CORPORATE_FLOATING_RATE_NOTES: 109,
  LEG_SECURITY_TYPE_SECURED_LIQUIDITY_NOTE: 110,
  LEG_SECURITY_TYPE_TAXABLE_MUNICIPAL_CP: 111,
  LEG_SECURITY_TYPE_TERM_LIQUIDITY_NOTE: 112,
  LEG_SECURITY_TYPE_TREASURY_BILL: 113,
  LEG_SECURITY_TYPE_US_CORPORATE_FLOATING_RATE_NOTES: 114,
  LEG_SECURITY_TYPE_FX_FORWARD: 115,
  LEG_SECURITY_TYPE_FX_SPOT: 116,
  LEG_SECURITY_TYPE_FX_SWAP: 117,
  LEG_SECURITY_TYPE_NON_DELIVERABLE_FORWARD: 118
};

/**
 * @enum {number}
 */
proto.Common.LegContractMultiplierUnitEnum = {
  LEG_CONTRACT_MULTIPLIER_UNIT_UNSPECIFIED: 0,
  LEG_CONTRACT_MULTIPLIER_UNIT_DAYS: 1,
  LEG_CONTRACT_MULTIPLIER_UNIT_HOURS: 2,
  LEG_CONTRACT_MULTIPLIER_UNIT_SHARES: 3
};

/**
 * @enum {number}
 */
proto.Common.LegFlowScheduleTypeEnum = {
  LEG_FLOW_SCHEDULE_TYPE_UNSPECIFIED: 0,
  LEG_FLOW_SCHEDULE_TYPE_NERC_CALENDAR_ALL_DAYS_IN_MONTH: 1,
  LEG_FLOW_SCHEDULE_TYPE_NERC_EASTERN_OFF_PEAK: 2,
  LEG_FLOW_SCHEDULE_TYPE_NERC_EASTERN_PEAK: 3,
  LEG_FLOW_SCHEDULE_TYPE_NERC_WESTERN_OFF_PEAK: 4,
  LEG_FLOW_SCHEDULE_TYPE_NERC_WESTERN_PEAK: 5
};

/**
 * @enum {number}
 */
proto.Common.LegUnitOfMeasureEnum = {
  LEG_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  LEG_UNIT_OF_MEASURE_BARRELS: 1,
  LEG_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  LEG_UNIT_OF_MEASURE_BUSHELS: 3,
  LEG_UNIT_OF_MEASURE_GALLONS: 4,
  LEG_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  LEG_UNIT_OF_MEASURE_METRIC_TONS: 6,
  LEG_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  LEG_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  LEG_UNIT_OF_MEASURE_POUNDS: 9,
  LEG_UNIT_OF_MEASURE_TONS: 10,
  LEG_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  LEG_UNIT_OF_MEASURE_USDOLLARS: 12,
  LEG_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.LegPriceUnitOfMeasureEnum = {
  LEG_PRICE_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  LEG_PRICE_UNIT_OF_MEASURE_BARRELS: 1,
  LEG_PRICE_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  LEG_PRICE_UNIT_OF_MEASURE_BUSHELS: 3,
  LEG_PRICE_UNIT_OF_MEASURE_GALLONS: 4,
  LEG_PRICE_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  LEG_PRICE_UNIT_OF_MEASURE_METRIC_TONS: 6,
  LEG_PRICE_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  LEG_PRICE_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  LEG_PRICE_UNIT_OF_MEASURE_POUNDS: 9,
  LEG_PRICE_UNIT_OF_MEASURE_TONS: 10,
  LEG_PRICE_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  LEG_PRICE_UNIT_OF_MEASURE_USDOLLARS: 12,
  LEG_PRICE_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.LegTimeUnitEnum = {
  LEG_TIME_UNIT_UNSPECIFIED: 0,
  LEG_TIME_UNIT_DAY: 1,
  LEG_TIME_UNIT_HOUR: 2,
  LEG_TIME_UNIT_MINUTE: 3,
  LEG_TIME_UNIT_MONTH: 4,
  LEG_TIME_UNIT_SECOND: 5,
  LEG_TIME_UNIT_WEEK: 6,
  LEG_TIME_UNIT_YEAR: 7
};

/**
 * @enum {number}
 */
proto.Common.LegExerciseStyleEnum = {
  LEG_EXERCISE_STYLE_UNSPECIFIED: 0,
  LEG_EXERCISE_STYLE_AMERICAN: 1,
  LEG_EXERCISE_STYLE_BERMUDA: 2,
  LEG_EXERCISE_STYLE_EUROPEAN: 3
};

/**
 * @enum {number}
 */
proto.Common.LegSideEnum = {
  LEG_SIDE_UNSPECIFIED: 0,
  LEG_SIDE_BUY: 1,
  LEG_SIDE_BUY_MINUS: 2,
  LEG_SIDE_SELL: 3,
  LEG_SIDE_SELL_PLUS: 4,
  LEG_SIDE_SELL_SHORT: 5,
  LEG_SIDE_SELL_SHORT_EXEMPT: 6,
  LEG_SIDE_CROSS: 7,
  LEG_SIDE_UNDISCLOSED: 8,
  LEG_SIDE_CROSS_SHORT: 9,
  LEG_SIDE_AS_DEFINED: 10,
  LEG_SIDE_CROSS_SHORT_EXEMPT: 11,
  LEG_SIDE_OPPOSITE: 12,
  LEG_SIDE_BORROW: 13,
  LEG_SIDE_LEND: 14,
  LEG_SIDE_REDEEM: 15,
  LEG_SIDE_SUBSCRIBE: 16
};

/**
 * @enum {number}
 */
proto.Common.LegBenchmarkCurveNameEnum = {
  LEG_BENCHMARK_CURVE_NAME_UNSPECIFIED: 0,
  LEG_BENCHMARK_CURVE_NAME_EURIBOR: 1,
  LEG_BENCHMARK_CURVE_NAME_FUTURE_SWAP: 2,
  LEG_BENCHMARK_CURVE_NAME_LIBID: 3,
  LEG_BENCHMARK_CURVE_NAME_LIBOR: 4,
  LEG_BENCHMARK_CURVE_NAME_MUNI_AAA: 5,
  LEG_BENCHMARK_CURVE_NAME_OTHER: 6,
  LEG_BENCHMARK_CURVE_NAME_PFANDBRIEFE: 7,
  LEG_BENCHMARK_CURVE_NAME_SWAP: 8,
  LEG_BENCHMARK_CURVE_NAME_TREASURY: 9,
  LEG_BENCHMARK_CURVE_NAME_EONIA: 10,
  LEG_BENCHMARK_CURVE_NAME_EUREPO: 11,
  LEG_BENCHMARK_CURVE_NAME_SONIA: 12
};

/**
 * @enum {number}
 */
proto.Common.LegStipulationTypeEnum = {
  LEG_STIPULATION_TYPE_UNSPECIFIED: 0,
  LEG_STIPULATION_TYPE_ABSOLUTE_PREPAYMENT_SPEED: 1,
  LEG_STIPULATION_TYPE_CONSTANT_PREPAYMENT_PENALTY: 2,
  LEG_STIPULATION_TYPE_CONSTANT_PREPAYMENT_RATE: 3,
  LEG_STIPULATION_TYPE_CONSTANT_PREPAYMENT_YIELD: 4,
  LEG_STIPULATION_TYPE_FINAL_CP_ROF_HOME_EQUITY_PREPAYMENT_CURVE: 5,
  LEG_STIPULATION_TYPE_GEOGRAPHICS: 6,
  LEG_STIPULATION_TYPE_ISSUE_DATE: 7,
  LEG_STIPULATION_TYPE_LOT_VARIANCE: 8,
  LEG_STIPULATION_TYPE_MATURITY_YEAR_AND_MONTH: 9,
  LEG_STIPULATION_TYPE_MONTHLY_PREPAYMENT_RATE: 10,
  LEG_STIPULATION_TYPE_NUMBER_OF_PIECES: 11,
  LEG_STIPULATION_TYPE_PERCENT_OF_BMAPREPAYMENT_CURVE: 12,
  LEG_STIPULATION_TYPE_PERCENT_OF_MANUFACTURED_HOUSING_PREPAYMENT_CURVE: 13,
  LEG_STIPULATION_TYPE_PERCENT_OF_PROSPECTUS_PREPAYMENT_CURVE: 14,
  LEG_STIPULATION_TYPE_POOLS_MAXIMUM: 15,
  LEG_STIPULATION_TYPE_POOLS_PER_LOT: 16,
  LEG_STIPULATION_TYPE_POOLS_PER_MILLION: 17,
  LEG_STIPULATION_TYPE_POOLS_PER_TRADE: 18,
  LEG_STIPULATION_TYPE_PRODUCTION_YEAR: 19,
  LEG_STIPULATION_TYPE_SINGLE_MONTHLY_MORTALITY: 20,
  LEG_STIPULATION_TYPE_TRADE_VARIANCE: 21,
  LEG_STIPULATION_TYPE_WEIGHTED_AVERAGE_COUPON: 22,
  LEG_STIPULATION_TYPE_WEIGHTED_AVERAGE_LIFE_COUPON: 23,
  LEG_STIPULATION_TYPE_WEIGHTED_AVERAGE_LOAN_AGE: 24,
  LEG_STIPULATION_TYPE_WEIGHTED_AVERAGE_MATURITY: 25,
  LEG_STIPULATION_TYPE_ALTERNATIVE_MINIMUM_TAX: 26,
  LEG_STIPULATION_TYPE_AUTO_REINVESTMENT: 27,
  LEG_STIPULATION_TYPE_BANK_QUALIFIED: 28,
  LEG_STIPULATION_TYPE_BARGAIN_CONDITIONS: 29,
  LEG_STIPULATION_TYPE_BENCHMARK_PRICE_SOURCE: 30,
  LEG_STIPULATION_TYPE_CALL_PROTECTION: 31,
  LEG_STIPULATION_TYPE_COUPON_RANGE: 32,
  LEG_STIPULATION_TYPE_CUSTOM_START: 33,
  LEG_STIPULATION_TYPE_EXPLICIT_LOT_IDENTIFIER: 34,
  LEG_STIPULATION_TYPE_FREEFORM_TEXT: 35,
  LEG_STIPULATION_TYPE_INSURED: 36,
  LEG_STIPULATION_TYPE_ISO_CURRENCY_CODE: 37,
  LEG_STIPULATION_TYPE_ISSUER: 38,
  LEG_STIPULATION_TYPE_ISSUE_SIZE_RANGE: 39,
  LEG_STIPULATION_TYPE_LOOKBACK_DAYS: 40,
  LEG_STIPULATION_TYPE_MARKET_SECTOR: 41,
  LEG_STIPULATION_TYPE_MATURITY_RANGE: 42,
  LEG_STIPULATION_TYPE_MAXIMUM_SUBSTITUTIONS: 43,
  LEG_STIPULATION_TYPE_MINIMUM_DENOMINATION: 44,
  LEG_STIPULATION_TYPE_MINIMUM_INCREMENT: 45,
  LEG_STIPULATION_TYPE_MINIMUM_QUANTITY: 46,
  LEG_STIPULATION_TYPE_PAYMENT_FREQUENCY: 47,
  LEG_STIPULATION_TYPE_PRICE_RANGE: 48,
  LEG_STIPULATION_TYPE_PRICING_FREQUENCY: 49,
  LEG_STIPULATION_TYPE_PURPOSE: 50,
  LEG_STIPULATION_TYPE_RATING_SOURCE_AND_RANGE: 51,
  LEG_STIPULATION_TYPE_RESTRICTED: 52,
  LEG_STIPULATION_TYPE_SECURITY_TYPE_INCLUDED_OR_EXCLUDED: 53,
  LEG_STIPULATION_TYPE_STRUCTURE: 54,
  LEG_STIPULATION_TYPE_SUBSTITUTIONS_FREQUENCY: 55,
  LEG_STIPULATION_TYPE_SUBSTITUTIONS_LEFT: 56,
  LEG_STIPULATION_TYPE_TYPE_OF_REDEMPTION: 57,
  LEG_STIPULATION_TYPE_VALUATION_DISCOUNT: 58,
  LEG_STIPULATION_TYPE_WHOLE_POOL: 59,
  LEG_STIPULATION_TYPE_YIELD_RANGE: 60,
  LEG_STIPULATION_TYPE_AVAILABLE_OFFER_QUANTITY_TO_BE_SHOWN_TO_THE_STREET: 61,
  LEG_STIPULATION_TYPE_AVERAGE_FICOSCORE: 62,
  LEG_STIPULATION_TYPE_AVERAGE_LOAN_SIZE: 63,
  LEG_STIPULATION_TYPE_BROKER_CREDIT: 64,
  LEG_STIPULATION_TYPE_BROKER_SALES_CREDIT_OVERRIDE: 65,
  LEG_STIPULATION_TYPE_DISCOUNT_RATE: 66,
  LEG_STIPULATION_TYPE_INTEREST_OF_ROLLING_OR_CLOSING_TRADE: 67,
  LEG_STIPULATION_TYPE_MAXIMUM_LOAN_BALANCE: 68,
  LEG_STIPULATION_TYPE_MAXIMUM_ORDER_SIZE: 69,
  LEG_STIPULATION_TYPE_OFFER_PRICE_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 70,
  LEG_STIPULATION_TYPE_OFFER_QUANTITY_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 71,
  LEG_STIPULATION_TYPE_ORDER_QUANTITY_INCREMENT: 72,
  LEG_STIPULATION_TYPE_POOL_IDENTIFIER: 73,
  LEG_STIPULATION_TYPE_PRIMARY_OR_SECONDARY_MARKET_INDICATOR: 74,
  LEG_STIPULATION_TYPE_PRINCIPAL_OF_ROLLING_OR_CLOSING_TRADE: 75,
  LEG_STIPULATION_TYPE_REFERENCE_TO_ROLLING_OR_CLOSING_TRADE: 76,
  LEG_STIPULATION_TYPE_THE_MINIMUM_RESIDUAL_OFFER_QUANTITY: 77,
  LEG_STIPULATION_TYPE_TRADER_CREDIT: 78,
  LEG_STIPULATION_TYPE_TYPE_OF_ROLL_TRADE: 79,
  LEG_STIPULATION_TYPE_YIELD_TO_MATURITY: 80
};

/**
 * @enum {number}
 */
proto.Common.NestedPartyIDSourceEnum = {
  NESTED_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  NESTED_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  NESTED_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  NESTED_PARTY_ID_SOURCE_BIC: 3,
  NESTED_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  NESTED_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  NESTED_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  NESTED_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  NESTED_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  NESTED_PARTY_ID_SOURCE_PROPRIETARY: 9,
  NESTED_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  NESTED_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  NESTED_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  NESTED_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  NESTED_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  NESTED_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  NESTED_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  NESTED_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  NESTED_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.NestedPartyRoleEnum = {
  NESTED_PARTY_ROLE_UNSPECIFIED: 0,
  NESTED_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  NESTED_PARTY_ROLE_CLEARING_FIRM: 2,
  NESTED_PARTY_ROLE_CLIENT_ID: 3,
  NESTED_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  NESTED_PARTY_ROLE_CONTRA_FIRM: 5,
  NESTED_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  NESTED_PARTY_ROLE_ENTERING_FIRM: 7,
  NESTED_PARTY_ROLE_EXECUTING_FIRM: 8,
  NESTED_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  NESTED_PARTY_ROLE_EXECUTING_TRADER: 10,
  NESTED_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  NESTED_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  NESTED_PARTY_ROLE_INTRODUCING_FIRM: 13,
  NESTED_PARTY_ROLE_INVESTOR_ID: 14,
  NESTED_PARTY_ROLE_LOCATE: 15,
  NESTED_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  NESTED_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  NESTED_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  NESTED_PARTY_ROLE_SPONSORING_FIRM: 19,
  NESTED_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  NESTED_PARTY_ROLE_AGENT: 21,
  NESTED_PARTY_ROLE_BENEFICIARY: 22,
  NESTED_PARTY_ROLE_BUYER: 23,
  NESTED_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  NESTED_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  NESTED_PARTY_ROLE_CONTRA_TRADER: 26,
  NESTED_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  NESTED_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  NESTED_PARTY_ROLE_CUSTODIAN: 29,
  NESTED_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  NESTED_PARTY_ROLE_ENTERING_TRADER: 31,
  NESTED_PARTY_ROLE_EXCHANGE: 32,
  NESTED_PARTY_ROLE_INTERESTED_PARTY: 33,
  NESTED_PARTY_ROLE_INTERMEDIARY: 34,
  NESTED_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  NESTED_PARTY_ROLE_POSITION_ACCOUNT: 36,
  NESTED_PARTY_ROLE_REGULATORY_BODY: 37,
  NESTED_PARTY_ROLE_SUB_CUSTODIAN: 38,
  NESTED_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  NESTED_PARTY_ROLE_INTRODUCING_BROKER: 40,
  NESTED_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  NESTED_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  NESTED_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  NESTED_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  NESTED_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  NESTED_PARTY_ROLE_ASSET_MANAGER: 46,
  NESTED_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  NESTED_PARTY_ROLE_FOREIGN_FIRM: 48,
  NESTED_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  NESTED_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  NESTED_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  NESTED_PARTY_ROLE_SENDER_LOCATION: 52,
  NESTED_PARTY_ROLE_SESSION_ID: 53,
  NESTED_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  NESTED_PARTY_ROLE_TRADER_MNEMONIC: 55,
  NESTED_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  NESTED_PARTY_ROLE_ENTERING_UNIT: 57,
  NESTED_PARTY_ROLE_EXECUTING_UNIT: 58,
  NESTED_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  NESTED_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  NESTED_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  NESTED_PARTY_ROLE_DESK_ID: 62,
  NESTED_PARTY_ROLE_EXECUTION_VENUE: 63,
  NESTED_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  NESTED_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  NESTED_PARTY_ROLE_INVESTMENT_FIRM: 66,
  NESTED_PARTY_ROLE_LOCATION_ID: 67,
  NESTED_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  NESTED_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  NESTED_PARTY_ROLE_MARKET_MAKER: 70,
  NESTED_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  NESTED_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  NESTED_PARTY_ROLE_REGULATED_MARKET: 73,
  NESTED_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  NESTED_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  NESTED_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  NESTED_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  NESTED_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  NESTED_PARTY_ROLE_PRIME_BROKER: 79,
  NESTED_PARTY_ROLE_STEP_OUT_FIRM: 80,
  NESTED_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  NESTED_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  NESTED_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  NESTED_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.RoundingDirectionEnum = {
  ROUNDING_DIRECTION_UNSPECIFIED: 0,
  ROUNDING_DIRECTION_ROUND_DOWN: 1,
  ROUNDING_DIRECTION_ROUND_TO_NEAREST: 2,
  ROUNDING_DIRECTION_ROUND_UP: 3
};

/**
 * @enum {number}
 */
proto.Common.PartyIDSourceEnum = {
  PARTY_ID_SOURCE_UNSPECIFIED: 0,
  PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  PARTY_ID_SOURCE_BIC: 3,
  PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  PARTY_ID_SOURCE_PROPRIETARY: 9,
  PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  PARTY_ID_SOURCE_ISITCACRONYM: 17,
  PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.PartyRoleEnum = {
  PARTY_ROLE_UNSPECIFIED: 0,
  PARTY_ROLE_BROKER_OF_CREDIT: 1,
  PARTY_ROLE_CLEARING_FIRM: 2,
  PARTY_ROLE_CLIENT_ID: 3,
  PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  PARTY_ROLE_CONTRA_FIRM: 5,
  PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  PARTY_ROLE_ENTERING_FIRM: 7,
  PARTY_ROLE_EXECUTING_FIRM: 8,
  PARTY_ROLE_EXECUTING_SYSTEM: 9,
  PARTY_ROLE_EXECUTING_TRADER: 10,
  PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  PARTY_ROLE_INTRODUCING_FIRM: 13,
  PARTY_ROLE_INVESTOR_ID: 14,
  PARTY_ROLE_LOCATE: 15,
  PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  PARTY_ROLE_SPONSORING_FIRM: 19,
  PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  PARTY_ROLE_AGENT: 21,
  PARTY_ROLE_BENEFICIARY: 22,
  PARTY_ROLE_BUYER: 23,
  PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  PARTY_ROLE_CONTRA_TRADER: 26,
  PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  PARTY_ROLE_CUSTODIAN: 29,
  PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  PARTY_ROLE_ENTERING_TRADER: 31,
  PARTY_ROLE_EXCHANGE: 32,
  PARTY_ROLE_INTERESTED_PARTY: 33,
  PARTY_ROLE_INTERMEDIARY: 34,
  PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  PARTY_ROLE_POSITION_ACCOUNT: 36,
  PARTY_ROLE_REGULATORY_BODY: 37,
  PARTY_ROLE_SUB_CUSTODIAN: 38,
  PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  PARTY_ROLE_INTRODUCING_BROKER: 40,
  PARTY_ROLE_CONTRA_EXCHANGE: 41,
  PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  PARTY_ROLE_ASSET_MANAGER: 46,
  PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  PARTY_ROLE_FOREIGN_FIRM: 48,
  PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  PARTY_ROLE_SENDER_LOCATION: 52,
  PARTY_ROLE_SESSION_ID: 53,
  PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  PARTY_ROLE_TRADER_MNEMONIC: 55,
  PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  PARTY_ROLE_ENTERING_UNIT: 57,
  PARTY_ROLE_EXECUTING_UNIT: 58,
  PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  PARTY_ROLE_DESK_ID: 62,
  PARTY_ROLE_EXECUTION_VENUE: 63,
  PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  PARTY_ROLE_INVESTMENT_FIRM: 66,
  PARTY_ROLE_LOCATION_ID: 67,
  PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  PARTY_ROLE_MARKET_DATA_MARKET: 69,
  PARTY_ROLE_MARKET_MAKER: 70,
  PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  PARTY_ROLE_REGULATED_MARKET: 73,
  PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  PARTY_ROLE_REPORT_ORIGINATOR: 75,
  PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  PARTY_ROLE_ALLOCATION_ENTITY: 77,
  PARTY_ROLE_BROKER_CLEARING_ID: 78,
  PARTY_ROLE_PRIME_BROKER: 79,
  PARTY_ROLE_STEP_OUT_FIRM: 80,
  PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  PARTY_ROLE_CLEARING_ACCOUNT: 83,
  PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.PegPriceTypeEnum = {
  PEG_PRICE_TYPE_UNSPECIFIED: 0,
  PEG_PRICE_TYPE_LAST_PEG: 1,
  PEG_PRICE_TYPE_MARKET_PEG: 2,
  PEG_PRICE_TYPE_MID_PRICE_PEG: 3,
  PEG_PRICE_TYPE_OPENING_PEG: 4,
  PEG_PRICE_TYPE_PEG_TO_LIMIT_PRICE: 5,
  PEG_PRICE_TYPE_PEG_TO_VWAP: 6,
  PEG_PRICE_TYPE_PRIMARY_PEG: 7,
  PEG_PRICE_TYPE_TRAILING_STOP_PEG: 8
};

/**
 * @enum {number}
 */
proto.Common.PegMoveTypeEnum = {
  PEG_MOVE_TYPE_UNSPECIFIED: 0,
  PEG_MOVE_TYPE_FIXED: 1,
  PEG_MOVE_TYPE_FLOATING: 2
};

/**
 * @enum {number}
 */
proto.Common.PegOffsetTypeEnum = {
  PEG_OFFSET_TYPE_UNSPECIFIED: 0,
  PEG_OFFSET_TYPE_BASIS_POINTS: 1,
  PEG_OFFSET_TYPE_PRICE: 2,
  PEG_OFFSET_TYPE_PRICE_TIER: 3,
  PEG_OFFSET_TYPE_TICKS: 4
};

/**
 * @enum {number}
 */
proto.Common.PegLimitTypeEnum = {
  PEG_LIMIT_TYPE_UNSPECIFIED: 0,
  PEG_LIMIT_TYPE_OR_BETTER: 1,
  PEG_LIMIT_TYPE_OR_WORSE: 2,
  PEG_LIMIT_TYPE_STRICT: 3
};

/**
 * @enum {number}
 */
proto.Common.PegRoundDirectionEnum = {
  PEG_ROUND_DIRECTION_UNSPECIFIED: 0,
  PEG_ROUND_DIRECTION_MORE_AGGRESSIVE: 1,
  PEG_ROUND_DIRECTION_MORE_PASSIVE: 2
};

/**
 * @enum {number}
 */
proto.Common.PegScopeEnum = {
  PEG_SCOPE_UNSPECIFIED: 0,
  PEG_SCOPE_GLOBAL: 1,
  PEG_SCOPE_LOCAL: 2,
  PEG_SCOPE_NATIONAL: 3,
  PEG_SCOPE_NATIONAL_EXCLUDING_LOCAL: 4
};

/**
 * @enum {number}
 */
proto.Common.PegSecurityIDSourceEnum = {
  PEG_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  PEG_SECURITY_ID_SOURCE_CUSIP: 1,
  PEG_SECURITY_ID_SOURCE_QUIK: 2,
  PEG_SECURITY_ID_SOURCE_SEDOL: 3,
  PEG_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  PEG_SECURITY_ID_SOURCE_RIC_CODE: 5,
  PEG_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  PEG_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  PEG_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  PEG_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  PEG_SECURITY_ID_SOURCE_BELGIAN: 10,
  PEG_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  PEG_SECURITY_ID_SOURCE_COMMON: 12,
  PEG_SECURITY_ID_SOURCE_DUTCH: 13,
  PEG_SECURITY_ID_SOURCE_SICOVAM: 14,
  PEG_SECURITY_ID_SOURCE_VALOREN: 15,
  PEG_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  PEG_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  PEG_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  PEG_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  PEG_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  PEG_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  PEG_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.PosAmtTypeEnum = {
  POS_AMT_TYPE_UNSPECIFIED: 0,
  POS_AMT_TYPE_CASH_AMOUNT: 1,
  POS_AMT_TYPE_CASH_RESIDUAL_AMOUNT: 2,
  POS_AMT_TYPE_FINAL_MARK_TO_MARKET_AMOUNT: 3,
  POS_AMT_TYPE_INCREMENTAL_MARK_TO_MARKET_AMOUNT: 4,
  POS_AMT_TYPE_PREMIUM_AMOUNT: 5,
  POS_AMT_TYPE_START_OF_DAY_MARK_TO_MARKET_AMOUNT: 6,
  POS_AMT_TYPE_TRADE_VARIATION_AMOUNT: 7,
  POS_AMT_TYPE_VALUE_ADJUSTED_AMOUNT: 8,
  POS_AMT_TYPE_SETTLEMENT_VALUE: 9,
  POS_AMT_TYPE_ACCRUED_COUPON_AMOUNT: 10,
  POS_AMT_TYPE_COLLATERALIZED_MARK_TO_MARKET: 11,
  POS_AMT_TYPE_COMPENSATION_AMOUNT: 12,
  POS_AMT_TYPE_COUPON_AMOUNT: 13,
  POS_AMT_TYPE_INCREMENTAL_ACCRUED_COUPON: 14,
  POS_AMT_TYPE_INCREMENTAL_COLLATERALIZED_MARK_TO_MARKET: 15,
  POS_AMT_TYPE_INITIAL_TRADE_COUPON_AMOUNT: 16,
  POS_AMT_TYPE_TOTAL_BANKED_AMOUNT: 17,
  POS_AMT_TYPE_TOTAL_COLLATERALIZED_AMOUNT: 18
};

/**
 * @enum {number}
 */
proto.Common.PosTypeEnum = {
  POS_TYPE_UNSPECIFIED: 0,
  POS_TYPE_ADJUSTMENT_QTY: 1,
  POS_TYPE_ALLOCATION_TRADE_QTY: 2,
  POS_TYPE_AS_OF_TRADE_QTY: 3,
  POS_TYPE_CROSS_MARGIN_QTY: 4,
  POS_TYPE_DELIVERY_QTY: 5,
  POS_TYPE_ELECTRONIC_TRADE_QTY: 6,
  POS_TYPE_END_OF_DAY_QTY: 7,
  POS_TYPE_INTEGRAL_SPLIT: 8,
  POS_TYPE_INTER_SPREAD_QTY: 9,
  POS_TYPE_INTRA_SPREAD_QTY: 10,
  POS_TYPE_OPTION_ASSIGNMENT: 11,
  POS_TYPE_OPTION_EXERCISE_QTY: 12,
  POS_TYPE_PIT_TRADE_QTY: 13,
  POS_TYPE_START_OF_DAY_QTY: 14,
  POS_TYPE_TOTAL_TRANSACTION_QTY: 15,
  POS_TYPE_TRANSACTION_FROM_ASSIGNMENT: 16,
  POS_TYPE_TRANSACTION_FROM_EXERCISE: 17,
  POS_TYPE_TRANSACTION_QUANTITY: 18,
  POS_TYPE_TRANSFER_TRADE_QTY: 19,
  POS_TYPE_CORPORATE_ACTION_ADJUSTMENT: 20,
  POS_TYPE_RECEIVE_QUANTITY: 21,
  POS_TYPE_DELIVERY_NOTICE_QTY: 22,
  POS_TYPE_EXCHANGE_FOR_PHYSICAL_QTY: 23,
  POS_TYPE_PRIVATELY_NEGOTIATED_TRADE_QTY: 24,
  POS_TYPE_NET_DELTA_QTY: 25,
  POS_TYPE_CREDIT_EVENT_ADJUSTMENT: 26,
  POS_TYPE_SUCCESSION_EVENT_ADJUSTMENT: 27
};

/**
 * @enum {number}
 */
proto.Common.PosQtyStatusEnum = {
  POS_QTY_STATUS_UNSPECIFIED: 0,
  POS_QTY_STATUS_ACCEPTED: 1,
  POS_QTY_STATUS_REJECTED: 2,
  POS_QTY_STATUS_SUBMITTED: 3
};

/**
 * @enum {number}
 */
proto.Common.SettlDeliveryTypeEnum = {
  SETTL_DELIVERY_TYPE_UNSPECIFIED: 0,
  SETTL_DELIVERY_TYPE_FREE: 1,
  SETTL_DELIVERY_TYPE_HOLD_IN_CUSTODY: 2,
  SETTL_DELIVERY_TYPE_TRI_PARTY: 3,
  SETTL_DELIVERY_TYPE_VERSUS: 4
};

/**
 * @enum {number}
 */
proto.Common.StandInstDbTypeEnum = {
  STAND_INST_DB_TYPE_UNSPECIFIED: 0,
  STAND_INST_DB_TYPE_AGLOBAL_CUSTODIAN: 1,
  STAND_INST_DB_TYPE_DTCSID: 2,
  STAND_INST_DB_TYPE_OTHER: 3,
  STAND_INST_DB_TYPE_THOMSON_ALERT: 4,
  STAND_INST_DB_TYPE_ACCOUNT_NET: 5
};

/**
 * @enum {number}
 */
proto.Common.SettlPartyIDSourceEnum = {
  SETTL_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  SETTL_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  SETTL_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  SETTL_PARTY_ID_SOURCE_BIC: 3,
  SETTL_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  SETTL_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  SETTL_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  SETTL_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  SETTL_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  SETTL_PARTY_ID_SOURCE_PROPRIETARY: 9,
  SETTL_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  SETTL_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  SETTL_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  SETTL_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  SETTL_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  SETTL_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  SETTL_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  SETTL_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  SETTL_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.SettlPartyRoleEnum = {
  SETTL_PARTY_ROLE_UNSPECIFIED: 0,
  SETTL_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  SETTL_PARTY_ROLE_CLEARING_FIRM: 2,
  SETTL_PARTY_ROLE_CLIENT_ID: 3,
  SETTL_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  SETTL_PARTY_ROLE_CONTRA_FIRM: 5,
  SETTL_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  SETTL_PARTY_ROLE_ENTERING_FIRM: 7,
  SETTL_PARTY_ROLE_EXECUTING_FIRM: 8,
  SETTL_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  SETTL_PARTY_ROLE_EXECUTING_TRADER: 10,
  SETTL_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  SETTL_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  SETTL_PARTY_ROLE_INTRODUCING_FIRM: 13,
  SETTL_PARTY_ROLE_INVESTOR_ID: 14,
  SETTL_PARTY_ROLE_LOCATE: 15,
  SETTL_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  SETTL_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  SETTL_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  SETTL_PARTY_ROLE_SPONSORING_FIRM: 19,
  SETTL_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  SETTL_PARTY_ROLE_AGENT: 21,
  SETTL_PARTY_ROLE_BENEFICIARY: 22,
  SETTL_PARTY_ROLE_BUYER: 23,
  SETTL_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  SETTL_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  SETTL_PARTY_ROLE_CONTRA_TRADER: 26,
  SETTL_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  SETTL_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  SETTL_PARTY_ROLE_CUSTODIAN: 29,
  SETTL_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  SETTL_PARTY_ROLE_ENTERING_TRADER: 31,
  SETTL_PARTY_ROLE_EXCHANGE: 32,
  SETTL_PARTY_ROLE_INTERESTED_PARTY: 33,
  SETTL_PARTY_ROLE_INTERMEDIARY: 34,
  SETTL_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  SETTL_PARTY_ROLE_POSITION_ACCOUNT: 36,
  SETTL_PARTY_ROLE_REGULATORY_BODY: 37,
  SETTL_PARTY_ROLE_SUB_CUSTODIAN: 38,
  SETTL_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  SETTL_PARTY_ROLE_INTRODUCING_BROKER: 40,
  SETTL_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  SETTL_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  SETTL_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  SETTL_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  SETTL_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  SETTL_PARTY_ROLE_ASSET_MANAGER: 46,
  SETTL_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  SETTL_PARTY_ROLE_FOREIGN_FIRM: 48,
  SETTL_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  SETTL_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  SETTL_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  SETTL_PARTY_ROLE_SENDER_LOCATION: 52,
  SETTL_PARTY_ROLE_SESSION_ID: 53,
  SETTL_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  SETTL_PARTY_ROLE_TRADER_MNEMONIC: 55,
  SETTL_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  SETTL_PARTY_ROLE_ENTERING_UNIT: 57,
  SETTL_PARTY_ROLE_EXECUTING_UNIT: 58,
  SETTL_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  SETTL_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  SETTL_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  SETTL_PARTY_ROLE_DESK_ID: 62,
  SETTL_PARTY_ROLE_EXECUTION_VENUE: 63,
  SETTL_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  SETTL_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  SETTL_PARTY_ROLE_INVESTMENT_FIRM: 66,
  SETTL_PARTY_ROLE_LOCATION_ID: 67,
  SETTL_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  SETTL_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  SETTL_PARTY_ROLE_MARKET_MAKER: 70,
  SETTL_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  SETTL_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  SETTL_PARTY_ROLE_REGULATED_MARKET: 73,
  SETTL_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  SETTL_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  SETTL_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  SETTL_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  SETTL_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  SETTL_PARTY_ROLE_PRIME_BROKER: 79,
  SETTL_PARTY_ROLE_STEP_OUT_FIRM: 80,
  SETTL_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  SETTL_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  SETTL_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  SETTL_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.BenchmarkCurveNameEnum = {
  BENCHMARK_CURVE_NAME_UNSPECIFIED: 0,
  BENCHMARK_CURVE_NAME_EURIBOR: 1,
  BENCHMARK_CURVE_NAME_FUTURE_SWAP: 2,
  BENCHMARK_CURVE_NAME_LIBID: 3,
  BENCHMARK_CURVE_NAME_LIBOR: 4,
  BENCHMARK_CURVE_NAME_MUNI_AAA: 5,
  BENCHMARK_CURVE_NAME_OTHER: 6,
  BENCHMARK_CURVE_NAME_PFANDBRIEFE: 7,
  BENCHMARK_CURVE_NAME_SWAP: 8,
  BENCHMARK_CURVE_NAME_TREASURY: 9,
  BENCHMARK_CURVE_NAME_EONIA: 10,
  BENCHMARK_CURVE_NAME_EUREPO: 11,
  BENCHMARK_CURVE_NAME_SONIA: 12
};

/**
 * @enum {number}
 */
proto.Common.BenchmarkPriceTypeEnum = {
  BENCHMARK_PRICE_TYPE_UNSPECIFIED: 0,
  BENCHMARK_PRICE_TYPE_FIXED_AMOUNT: 1,
  BENCHMARK_PRICE_TYPE_PERCENTAGE: 2,
  BENCHMARK_PRICE_TYPE_PER_UNIT: 3,
  BENCHMARK_PRICE_TYPE_DISCOUNT: 4,
  BENCHMARK_PRICE_TYPE_PREMIUM: 5,
  BENCHMARK_PRICE_TYPE_SPREAD: 6,
  BENCHMARK_PRICE_TYPE_TEDPRICE: 7,
  BENCHMARK_PRICE_TYPE_TEDYIELD: 8,
  BENCHMARK_PRICE_TYPE_FIXED_CABINET_TRADE_PRICE: 9,
  BENCHMARK_PRICE_TYPE_VARIABLE_CABINET_TRADE_PRICE: 10,
  BENCHMARK_PRICE_TYPE_YIELD: 11,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_EIGHTS: 12,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_FOURTHS: 13,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_HALFS: 14,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_ONE_TWENTY_EIGHTS: 15,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_SIXTEENTHS: 16,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_SIXTY_FORTHS: 17,
  BENCHMARK_PRICE_TYPE_PRODUCT_TICKS_IN_THIRTY_SECONDS: 18
};

/**
 * @enum {number}
 */
proto.Common.BenchmarkSecurityIDSourceEnum = {
  BENCHMARK_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  BENCHMARK_SECURITY_ID_SOURCE_CUSIP: 1,
  BENCHMARK_SECURITY_ID_SOURCE_QUIK: 2,
  BENCHMARK_SECURITY_ID_SOURCE_SEDOL: 3,
  BENCHMARK_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  BENCHMARK_SECURITY_ID_SOURCE_RIC_CODE: 5,
  BENCHMARK_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  BENCHMARK_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  BENCHMARK_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  BENCHMARK_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  BENCHMARK_SECURITY_ID_SOURCE_BELGIAN: 10,
  BENCHMARK_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  BENCHMARK_SECURITY_ID_SOURCE_COMMON: 12,
  BENCHMARK_SECURITY_ID_SOURCE_DUTCH: 13,
  BENCHMARK_SECURITY_ID_SOURCE_SICOVAM: 14,
  BENCHMARK_SECURITY_ID_SOURCE_VALOREN: 15,
  BENCHMARK_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  BENCHMARK_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  BENCHMARK_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  BENCHMARK_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  BENCHMARK_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  BENCHMARK_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  BENCHMARK_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.StipulationTypeEnum = {
  STIPULATION_TYPE_UNSPECIFIED: 0,
  STIPULATION_TYPE_ABSOLUTE_PREPAYMENT_SPEED: 1,
  STIPULATION_TYPE_CONSTANT_PREPAYMENT_PENALTY: 2,
  STIPULATION_TYPE_CONSTANT_PREPAYMENT_RATE: 3,
  STIPULATION_TYPE_CONSTANT_PREPAYMENT_YIELD: 4,
  STIPULATION_TYPE_FINAL_CP_ROF_HOME_EQUITY_PREPAYMENT_CURVE: 5,
  STIPULATION_TYPE_GEOGRAPHICS: 6,
  STIPULATION_TYPE_ISSUE_DATE: 7,
  STIPULATION_TYPE_LOT_VARIANCE: 8,
  STIPULATION_TYPE_MATURITY_YEAR_AND_MONTH: 9,
  STIPULATION_TYPE_MONTHLY_PREPAYMENT_RATE: 10,
  STIPULATION_TYPE_NUMBER_OF_PIECES: 11,
  STIPULATION_TYPE_PERCENT_OF_BMAPREPAYMENT_CURVE: 12,
  STIPULATION_TYPE_PERCENT_OF_MANUFACTURED_HOUSING_PREPAYMENT_CURVE: 13,
  STIPULATION_TYPE_PERCENT_OF_PROSPECTUS_PREPAYMENT_CURVE: 14,
  STIPULATION_TYPE_POOLS_MAXIMUM: 15,
  STIPULATION_TYPE_POOLS_PER_LOT: 16,
  STIPULATION_TYPE_POOLS_PER_MILLION: 17,
  STIPULATION_TYPE_POOLS_PER_TRADE: 18,
  STIPULATION_TYPE_PRODUCTION_YEAR: 19,
  STIPULATION_TYPE_SINGLE_MONTHLY_MORTALITY: 20,
  STIPULATION_TYPE_TRADE_VARIANCE: 21,
  STIPULATION_TYPE_WEIGHTED_AVERAGE_COUPON: 22,
  STIPULATION_TYPE_WEIGHTED_AVERAGE_LIFE_COUPON: 23,
  STIPULATION_TYPE_WEIGHTED_AVERAGE_LOAN_AGE: 24,
  STIPULATION_TYPE_WEIGHTED_AVERAGE_MATURITY: 25,
  STIPULATION_TYPE_ALTERNATIVE_MINIMUM_TAX: 26,
  STIPULATION_TYPE_AUTO_REINVESTMENT: 27,
  STIPULATION_TYPE_BANK_QUALIFIED: 28,
  STIPULATION_TYPE_BARGAIN_CONDITIONS: 29,
  STIPULATION_TYPE_BENCHMARK_PRICE_SOURCE: 30,
  STIPULATION_TYPE_CALL_PROTECTION: 31,
  STIPULATION_TYPE_COUPON_RANGE: 32,
  STIPULATION_TYPE_CUSTOM_START: 33,
  STIPULATION_TYPE_EXPLICIT_LOT_IDENTIFIER: 34,
  STIPULATION_TYPE_FREEFORM_TEXT: 35,
  STIPULATION_TYPE_INSURED: 36,
  STIPULATION_TYPE_ISO_CURRENCY_CODE: 37,
  STIPULATION_TYPE_ISSUER: 38,
  STIPULATION_TYPE_ISSUE_SIZE_RANGE: 39,
  STIPULATION_TYPE_LOOKBACK_DAYS: 40,
  STIPULATION_TYPE_MARKET_SECTOR: 41,
  STIPULATION_TYPE_MATURITY_RANGE: 42,
  STIPULATION_TYPE_MAXIMUM_SUBSTITUTIONS: 43,
  STIPULATION_TYPE_MINIMUM_DENOMINATION: 44,
  STIPULATION_TYPE_MINIMUM_INCREMENT: 45,
  STIPULATION_TYPE_MINIMUM_QUANTITY: 46,
  STIPULATION_TYPE_PAYMENT_FREQUENCY: 47,
  STIPULATION_TYPE_PRICE_RANGE: 48,
  STIPULATION_TYPE_PRICING_FREQUENCY: 49,
  STIPULATION_TYPE_PURPOSE: 50,
  STIPULATION_TYPE_RATING_SOURCE_AND_RANGE: 51,
  STIPULATION_TYPE_RESTRICTED: 52,
  STIPULATION_TYPE_SECURITY_TYPE_INCLUDED_OR_EXCLUDED: 53,
  STIPULATION_TYPE_STRUCTURE: 54,
  STIPULATION_TYPE_SUBSTITUTIONS_FREQUENCY: 55,
  STIPULATION_TYPE_SUBSTITUTIONS_LEFT: 56,
  STIPULATION_TYPE_TYPE_OF_REDEMPTION: 57,
  STIPULATION_TYPE_VALUATION_DISCOUNT: 58,
  STIPULATION_TYPE_WHOLE_POOL: 59,
  STIPULATION_TYPE_YIELD_RANGE: 60,
  STIPULATION_TYPE_AVAILABLE_OFFER_QUANTITY_TO_BE_SHOWN_TO_THE_STREET: 61,
  STIPULATION_TYPE_AVERAGE_FICOSCORE: 62,
  STIPULATION_TYPE_AVERAGE_LOAN_SIZE: 63,
  STIPULATION_TYPE_BROKER_CREDIT: 64,
  STIPULATION_TYPE_BROKER_SALES_CREDIT_OVERRIDE: 65,
  STIPULATION_TYPE_DISCOUNT_RATE: 66,
  STIPULATION_TYPE_INTEREST_OF_ROLLING_OR_CLOSING_TRADE: 67,
  STIPULATION_TYPE_MAXIMUM_LOAN_BALANCE: 68,
  STIPULATION_TYPE_MAXIMUM_ORDER_SIZE: 69,
  STIPULATION_TYPE_OFFER_PRICE_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 70,
  STIPULATION_TYPE_OFFER_QUANTITY_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 71,
  STIPULATION_TYPE_ORDER_QUANTITY_INCREMENT: 72,
  STIPULATION_TYPE_POOL_IDENTIFIER: 73,
  STIPULATION_TYPE_PRIMARY_OR_SECONDARY_MARKET_INDICATOR: 74,
  STIPULATION_TYPE_PRINCIPAL_OF_ROLLING_OR_CLOSING_TRADE: 75,
  STIPULATION_TYPE_REFERENCE_TO_ROLLING_OR_CLOSING_TRADE: 76,
  STIPULATION_TYPE_THE_MINIMUM_RESIDUAL_OFFER_QUANTITY: 77,
  STIPULATION_TYPE_TRADER_CREDIT: 78,
  STIPULATION_TYPE_TYPE_OF_ROLL_TRADE: 79,
  STIPULATION_TYPE_YIELD_TO_MATURITY: 80
};

/**
 * @enum {number}
 */
proto.Common.TrdRegTimestampTypeEnum = {
  TRD_REG_TIMESTAMP_TYPE_UNSPECIFIED: 0,
  TRD_REG_TIMESTAMP_TYPE_BROKER_EXECUTION: 1,
  TRD_REG_TIMESTAMP_TYPE_BROKER_RECEIPT: 2,
  TRD_REG_TIMESTAMP_TYPE_EXECUTION_TIME: 3,
  TRD_REG_TIMESTAMP_TYPE_TIME_IN: 4,
  TRD_REG_TIMESTAMP_TYPE_TIME_OUT: 5,
  TRD_REG_TIMESTAMP_TYPE_DESK_RECEIPT: 6,
  TRD_REG_TIMESTAMP_TYPE_SUBMISSION_TO_CLEARING: 7
};

/**
 * @enum {number}
 */
proto.Common.DeskTypeEnum = {
  DESK_TYPE_UNSPECIFIED: 0,
  DESK_TYPE_AGENCY: 1,
  DESK_TYPE_ARBITRAGE: 2,
  DESK_TYPE_DERIVATIVES: 3,
  DESK_TYPE_INSTITUTIONAL: 4,
  DESK_TYPE_INTERNATIONAL: 5,
  DESK_TYPE_OTHER: 6,
  DESK_TYPE_PREFERRED_TRADING: 7,
  DESK_TYPE_PROGRAM_TRADING: 8,
  DESK_TYPE_PROPRIETARY: 9,
  DESK_TYPE_SALES: 10,
  DESK_TYPE_TRADING: 11
};

/**
 * @enum {number}
 */
proto.Common.DeskTypeSourceEnum = {
  DESK_TYPE_SOURCE_UNSPECIFIED: 0,
  DESK_TYPE_SOURCE_NASDOATS: 1
};

/**
 * @enum {number}
 */
proto.Common.DeskOrderHandlingInstEnum = {
  DESK_ORDER_HANDLING_INST_UNSPECIFIED: 0,
  DESK_ORDER_HANDLING_INST_ADD_ON_ORDER: 1,
  DESK_ORDER_HANDLING_INST_ALL_OR_NONE: 2,
  DESK_ORDER_HANDLING_INST_CASH_NOT_HELD: 3,
  DESK_ORDER_HANDLING_INST_DIRECTED_ORDER: 4,
  DESK_ORDER_HANDLING_INST_EXCHANGE_FOR_PHYSICAL_TRANSACTION: 5,
  DESK_ORDER_HANDLING_INST_FILL_OR_KILL: 6,
  DESK_ORDER_HANDLING_INST_IMBALANCE_ONLY: 7,
  DESK_ORDER_HANDLING_INST_IMMEDIATE_OR_CANCEL: 8,
  DESK_ORDER_HANDLING_INST_LIMIT_ON_CLOSE: 9,
  DESK_ORDER_HANDLING_INST_LIMIT_ON_OPEN: 10,
  DESK_ORDER_HANDLING_INST_MARKET_AT_CLOSE: 11,
  DESK_ORDER_HANDLING_INST_MARKET_AT_OPEN: 12,
  DESK_ORDER_HANDLING_INST_MARKET_ON_CLOSE: 13,
  DESK_ORDER_HANDLING_INST_MARKET_ON_OPEN: 14,
  DESK_ORDER_HANDLING_INST_MINIMUM_QUANTITY: 15,
  DESK_ORDER_HANDLING_INST_NOT_HELD: 16,
  DESK_ORDER_HANDLING_INST_OVER_THE_DAY: 17,
  DESK_ORDER_HANDLING_INST_PEGGED: 18,
  DESK_ORDER_HANDLING_INST_RESERVE_SIZE_ORDER: 19,
  DESK_ORDER_HANDLING_INST_SCALE: 20,
  DESK_ORDER_HANDLING_INST_STOP_STOCK_TRANSACTION: 21,
  DESK_ORDER_HANDLING_INST_TIME_ORDER: 22,
  DESK_ORDER_HANDLING_INST_TRAILING_STOP: 23,
  DESK_ORDER_HANDLING_INST_WORK: 24
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSymbolSfxEnum = {
  UNDERLYING_SYMBOL_SFX_UNSPECIFIED: 0,
  UNDERLYING_SYMBOL_SFX_EUCP_WITH_LUMP_SUM_INTEREST: 1,
  UNDERLYING_SYMBOL_SFX_WHEN_ISSUED: 2
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSecurityIDSourceEnum = {
  UNDERLYING_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  UNDERLYING_SECURITY_ID_SOURCE_CUSIP: 1,
  UNDERLYING_SECURITY_ID_SOURCE_QUIK: 2,
  UNDERLYING_SECURITY_ID_SOURCE_SEDOL: 3,
  UNDERLYING_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  UNDERLYING_SECURITY_ID_SOURCE_RIC_CODE: 5,
  UNDERLYING_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  UNDERLYING_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  UNDERLYING_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  UNDERLYING_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  UNDERLYING_SECURITY_ID_SOURCE_BELGIAN: 10,
  UNDERLYING_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  UNDERLYING_SECURITY_ID_SOURCE_COMMON: 12,
  UNDERLYING_SECURITY_ID_SOURCE_DUTCH: 13,
  UNDERLYING_SECURITY_ID_SOURCE_SICOVAM: 14,
  UNDERLYING_SECURITY_ID_SOURCE_VALOREN: 15,
  UNDERLYING_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  UNDERLYING_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  UNDERLYING_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  UNDERLYING_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  UNDERLYING_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  UNDERLYING_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  UNDERLYING_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingProductEnum = {
  UNDERLYING_PRODUCT_UNSPECIFIED: 0,
  UNDERLYING_PRODUCT_AGENCY: 1,
  UNDERLYING_PRODUCT_COMMODITY: 2,
  UNDERLYING_PRODUCT_CORPORATE: 3,
  UNDERLYING_PRODUCT_CURRENCY: 4,
  UNDERLYING_PRODUCT_EQUITY: 5,
  UNDERLYING_PRODUCT_GOVERNMENT: 6,
  UNDERLYING_PRODUCT_INDEX: 7,
  UNDERLYING_PRODUCT_LOAN: 8,
  UNDERLYING_PRODUCT_MONEYMARKET: 9,
  UNDERLYING_PRODUCT_MORTGAGE: 10,
  UNDERLYING_PRODUCT_MUNICIPAL: 11,
  UNDERLYING_PRODUCT_OTHER: 12,
  UNDERLYING_PRODUCT_FINANCING: 13
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSecurityTypeEnum = {
  UNDERLYING_SECURITY_TYPE_UNSPECIFIED: 0,
  UNDERLYING_SECURITY_TYPE_BANKERS_ACCEPTANCE: 1,
  UNDERLYING_SECURITY_TYPE_CERTIFICATE_OF_DEPOSIT: 2,
  UNDERLYING_SECURITY_TYPE_COLLATERALIZED_MORTGAGE_OBLIGATION: 3,
  UNDERLYING_SECURITY_TYPE_COMMERCIAL_PAPER: 4,
  UNDERLYING_SECURITY_TYPE_COMMON_STOCK: 5,
  UNDERLYING_SECURITY_TYPE_CORPORATE_BOND: 6,
  UNDERLYING_SECURITY_TYPE_CORPORATE_PRIVATE_PLACEMENT: 7,
  UNDERLYING_SECURITY_TYPE_FOREIGN_EXCHANGE_CONTRACT: 8,
  UNDERLYING_SECURITY_TYPE_FUTURE: 9,
  UNDERLYING_SECURITY_TYPE_MISCELLANEOUS_PASS_THROUGH: 10,
  UNDERLYING_SECURITY_TYPE_MORTGAGE_INTEREST_ONLY: 11,
  UNDERLYING_SECURITY_TYPE_MORTGAGE_PRINCIPAL_ONLY: 12,
  UNDERLYING_SECURITY_TYPE_MORTGAGE_PRIVATE_PLACEMENT: 13,
  UNDERLYING_SECURITY_TYPE_MUTUAL_FUND: 14,
  UNDERLYING_SECURITY_TYPE_NO_SECURITY_TYPE: 15,
  UNDERLYING_SECURITY_TYPE_OPTION: 16,
  UNDERLYING_SECURITY_TYPE_PREFERRED_STOCK: 17,
  UNDERLYING_SECURITY_TYPE_TIME_DEPOSIT: 18,
  UNDERLYING_SECURITY_TYPE_US_TREASURY_BILL_OLD: 19,
  UNDERLYING_SECURITY_TYPE_WARRANT: 20,
  UNDERLYING_SECURITY_TYPE_CONVERTIBLE_BOND: 21,
  UNDERLYING_SECURITY_TYPE_IOETTEMORTGAGE: 22,
  UNDERLYING_SECURITY_TYPE_WILDCARD: 23,
  UNDERLYING_SECURITY_TYPE_AMENDED: 24,
  UNDERLYING_SECURITY_TYPE_ASSET_BACKED_SECURITIES: 25,
  UNDERLYING_SECURITY_TYPE_BANK_NOTES: 26,
  UNDERLYING_SECURITY_TYPE_BILL_OF_EXCHANGES: 27,
  UNDERLYING_SECURITY_TYPE_BRADY_BOND: 28,
  UNDERLYING_SECURITY_TYPE_BRIDGE_LOAN: 29,
  UNDERLYING_SECURITY_TYPE_CALL_LOANS: 30,
  UNDERLYING_SECURITY_TYPE_CERTIFICATE_OF_OBLIGATION: 31,
  UNDERLYING_SECURITY_TYPE_CERTIFICATE_OF_PARTICIPATION: 32,
  UNDERLYING_SECURITY_TYPE_CORP: 33,
  UNDERLYING_SECURITY_TYPE_DEBTOR_IN_POSSESSION: 34,
  UNDERLYING_SECURITY_TYPE_DEFAULTED: 35,
  UNDERLYING_SECURITY_TYPE_DEPOSIT_NOTES: 36,
  UNDERLYING_SECURITY_TYPE_DUAL_CURRENCY: 37,
  UNDERLYING_SECURITY_TYPE_EXTENDED_COMM_NOTE: 38,
  UNDERLYING_SECURITY_TYPE_FEDERAL_AGENCY_COUPON: 39,
  UNDERLYING_SECURITY_TYPE_FEDERAL_AGENCY_DISCOUNT_NOTE: 40,
  UNDERLYING_SECURITY_TYPE_GENERAL_OBLIGATION_BONDS: 41,
  UNDERLYING_SECURITY_TYPE_INDEXED_LINKED: 42,
  UNDERLYING_SECURITY_TYPE_INTEREST_STRIP_FROM_ANY_BOND_OR_NOTE: 43,
  UNDERLYING_SECURITY_TYPE_LETTER_OF_CREDIT: 44,
  UNDERLYING_SECURITY_TYPE_LIQUIDITY_NOTE: 45,
  UNDERLYING_SECURITY_TYPE_MANDATORY_TENDER: 46,
  UNDERLYING_SECURITY_TYPE_MATURED: 47,
  UNDERLYING_SECURITY_TYPE_MEDIUM_TERM_NOTES: 48,
  UNDERLYING_SECURITY_TYPE_MORTGAGE_BACKED_SECURITIES: 49,
  UNDERLYING_SECURITY_TYPE_MULTILEG_INSTRUMENT: 50,
  UNDERLYING_SECURITY_TYPE_OTHER_ANTICIPATION_NOTES: 51,
  UNDERLYING_SECURITY_TYPE_OVERNIGHT: 52,
  UNDERLYING_SECURITY_TYPE_PLAZOS_FIJOS: 53,
  UNDERLYING_SECURITY_TYPE_PRINCIPAL_STRIP_FROM_ANON_CALLABLE_BOND_OR_NOTE: 54,
  UNDERLYING_SECURITY_TYPE_PRINCIPAL_STRIP_OF_ACALLABLE_BOND_OR_NOTE: 55,
  UNDERLYING_SECURITY_TYPE_PRIVATE_EXPORT_FUNDING: 56,
  UNDERLYING_SECURITY_TYPE_PROMISSORY_NOTE: 57,
  UNDERLYING_SECURITY_TYPE_REPLACED: 58,
  UNDERLYING_SECURITY_TYPE_RETIRED: 59,
  UNDERLYING_SECURITY_TYPE_REVENUE_ANTICIPATION_NOTE: 60,
  UNDERLYING_SECURITY_TYPE_REVENUE_BONDS: 61,
  UNDERLYING_SECURITY_TYPE_REVOLVER: 62,
  UNDERLYING_SECURITY_TYPE_REVOLVER_LOAN: 63,
  UNDERLYING_SECURITY_TYPE_SHORT_TERM_LOAN_NOTE: 64,
  UNDERLYING_SECURITY_TYPE_SPECIAL_ASSESSMENT: 65,
  UNDERLYING_SECURITY_TYPE_SPECIAL_OBLIGATION: 66,
  UNDERLYING_SECURITY_TYPE_SPECIAL_TAX: 67,
  UNDERLYING_SECURITY_TYPE_STRUCTURED_NOTES: 68,
  UNDERLYING_SECURITY_TYPE_SWING_LINE_FACILITY: 69,
  UNDERLYING_SECURITY_TYPE_TAX_ALLOCATION: 70,
  UNDERLYING_SECURITY_TYPE_TAX_ANTICIPATION_NOTE: 71,
  UNDERLYING_SECURITY_TYPE_TAX_EXEMPT_COMMERCIAL_PAPER: 72,
  UNDERLYING_SECURITY_TYPE_TAX_REVENUE_ANTICIPATION_NOTE: 73,
  UNDERLYING_SECURITY_TYPE_TERM_LOAN: 74,
  UNDERLYING_SECURITY_TYPE_TO_BE_ANNOUNCED: 75,
  UNDERLYING_SECURITY_TYPE_TREASURY_INFLATION_PROTECTED_SECURITIES: 76,
  UNDERLYING_SECURITY_TYPE_US_TREASURY_BOND: 77,
  UNDERLYING_SECURITY_TYPE_US_TREASURY_NOTE_OLD: 78,
  UNDERLYING_SECURITY_TYPE_VARIABLE_RATE_DEMAND_NOTE: 79,
  UNDERLYING_SECURITY_TYPE_WITHDRAWN: 80,
  UNDERLYING_SECURITY_TYPE_YANKEE_CORPORATE_BOND: 81,
  UNDERLYING_SECURITY_TYPE_BUY_SELLBACK: 82,
  UNDERLYING_SECURITY_TYPE_EURO_CERTIFICATE_OF_DEPOSIT: 83,
  UNDERLYING_SECURITY_TYPE_EURO_COMMERCIAL_PAPER: 84,
  UNDERLYING_SECURITY_TYPE_EURO_CORPORATE_BOND: 85,
  UNDERLYING_SECURITY_TYPE_EURO_SOVEREIGNS: 86,
  UNDERLYING_SECURITY_TYPE_EURO_SUPRANATIONAL_COUPONS: 87,
  UNDERLYING_SECURITY_TYPE_FORWARD: 88,
  UNDERLYING_SECURITY_TYPE_PFANDBRIEFE: 89,
  UNDERLYING_SECURITY_TYPE_REPURCHASE: 90,
  UNDERLYING_SECURITY_TYPE_SECURITIES_LOAN: 91,
  UNDERLYING_SECURITY_TYPE_SECURITIES_PLEDGE: 92,
  UNDERLYING_SECURITY_TYPE_USD_SUPRANATIONAL_COUPONS: 93,
  UNDERLYING_SECURITY_TYPE_US_TREASURY_BILL: 94,
  UNDERLYING_SECURITY_TYPE_US_TREASURY_NOTE: 95,
  UNDERLYING_SECURITY_TYPE_YANKEE_CERTIFICATE_OF_DEPOSIT: 96,
  UNDERLYING_SECURITY_TYPE_OPTIONS_ON_FUTURES: 97,
  UNDERLYING_SECURITY_TYPE_OPTIONS_ON_PHYSICAL: 98,
  UNDERLYING_SECURITY_TYPE_CASH: 99,
  UNDERLYING_SECURITY_TYPE_OPTIONS_ON_COMBO: 100,
  UNDERLYING_SECURITY_TYPE_INTEREST_RATE_SWAP: 101,
  UNDERLYING_SECURITY_TYPE_BANK_DEPOSITORY_NOTE: 102,
  UNDERLYING_SECURITY_TYPE_CANADIAN_MONEY_MARKETS: 103,
  UNDERLYING_SECURITY_TYPE_CANADIAN_MORTGAGE_BONDS: 104,
  UNDERLYING_SECURITY_TYPE_CANADIAN_PROVINCIAL_BONDS: 105,
  UNDERLYING_SECURITY_TYPE_CANADIAN_TREASURY_BILLS: 106,
  UNDERLYING_SECURITY_TYPE_CANADIAN_TREASURY_NOTES: 107,
  UNDERLYING_SECURITY_TYPE_CREDIT_DEFAULT_SWAP: 108,
  UNDERLYING_SECURITY_TYPE_EURO_CORPORATE_FLOATING_RATE_NOTES: 109,
  UNDERLYING_SECURITY_TYPE_SECURED_LIQUIDITY_NOTE: 110,
  UNDERLYING_SECURITY_TYPE_TAXABLE_MUNICIPAL_CP: 111,
  UNDERLYING_SECURITY_TYPE_TERM_LIQUIDITY_NOTE: 112,
  UNDERLYING_SECURITY_TYPE_TREASURY_BILL: 113,
  UNDERLYING_SECURITY_TYPE_US_CORPORATE_FLOATING_RATE_NOTES: 114,
  UNDERLYING_SECURITY_TYPE_FX_FORWARD: 115,
  UNDERLYING_SECURITY_TYPE_FX_SPOT: 116,
  UNDERLYING_SECURITY_TYPE_FX_SWAP: 117,
  UNDERLYING_SECURITY_TYPE_NON_DELIVERABLE_FORWARD: 118
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingRestructuringTypeEnum = {
  UNDERLYING_RESTRUCTURING_TYPE_UNSPECIFIED: 0,
  UNDERLYING_RESTRUCTURING_TYPE_FULL_RESTRUCTURING: 1,
  UNDERLYING_RESTRUCTURING_TYPE_MODIFIED_MOD_RESTRUCTURING: 2,
  UNDERLYING_RESTRUCTURING_TYPE_MODIFIED_RESTRUCTURING: 3,
  UNDERLYING_RESTRUCTURING_TYPE_NO_RESTRUCTURING_SPECIFIED: 4
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSeniorityEnum = {
  UNDERLYING_SENIORITY_UNSPECIFIED: 0,
  UNDERLYING_SENIORITY_SENIOR: 1,
  UNDERLYING_SENIORITY_SENIOR_SECURED: 2,
  UNDERLYING_SENIORITY_SUBORDINATED: 3
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingContractMultiplierUnitEnum = {
  UNDERLYING_CONTRACT_MULTIPLIER_UNIT_UNSPECIFIED: 0,
  UNDERLYING_CONTRACT_MULTIPLIER_UNIT_DAYS: 1,
  UNDERLYING_CONTRACT_MULTIPLIER_UNIT_HOURS: 2,
  UNDERLYING_CONTRACT_MULTIPLIER_UNIT_SHARES: 3
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingFlowScheduleTypeEnum = {
  UNDERLYING_FLOW_SCHEDULE_TYPE_UNSPECIFIED: 0,
  UNDERLYING_FLOW_SCHEDULE_TYPE_NERC_CALENDAR_ALL_DAYS_IN_MONTH: 1,
  UNDERLYING_FLOW_SCHEDULE_TYPE_NERC_EASTERN_OFF_PEAK: 2,
  UNDERLYING_FLOW_SCHEDULE_TYPE_NERC_EASTERN_PEAK: 3,
  UNDERLYING_FLOW_SCHEDULE_TYPE_NERC_WESTERN_OFF_PEAK: 4,
  UNDERLYING_FLOW_SCHEDULE_TYPE_NERC_WESTERN_PEAK: 5
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingUnitOfMeasureEnum = {
  UNDERLYING_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  UNDERLYING_UNIT_OF_MEASURE_BARRELS: 1,
  UNDERLYING_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  UNDERLYING_UNIT_OF_MEASURE_BUSHELS: 3,
  UNDERLYING_UNIT_OF_MEASURE_GALLONS: 4,
  UNDERLYING_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  UNDERLYING_UNIT_OF_MEASURE_METRIC_TONS: 6,
  UNDERLYING_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  UNDERLYING_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  UNDERLYING_UNIT_OF_MEASURE_POUNDS: 9,
  UNDERLYING_UNIT_OF_MEASURE_TONS: 10,
  UNDERLYING_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  UNDERLYING_UNIT_OF_MEASURE_USDOLLARS: 12,
  UNDERLYING_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingPriceUnitOfMeasureEnum = {
  UNDERLYING_PRICE_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_BARRELS: 1,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_BUSHELS: 3,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_GALLONS: 4,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_METRIC_TONS: 6,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_POUNDS: 9,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_TONS: 10,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_USDOLLARS: 12,
  UNDERLYING_PRICE_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingTimeUnitEnum = {
  UNDERLYING_TIME_UNIT_UNSPECIFIED: 0,
  UNDERLYING_TIME_UNIT_DAY: 1,
  UNDERLYING_TIME_UNIT_HOUR: 2,
  UNDERLYING_TIME_UNIT_MINUTE: 3,
  UNDERLYING_TIME_UNIT_MONTH: 4,
  UNDERLYING_TIME_UNIT_SECOND: 5,
  UNDERLYING_TIME_UNIT_WEEK: 6,
  UNDERLYING_TIME_UNIT_YEAR: 7
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingExerciseStyleEnum = {
  UNDERLYING_EXERCISE_STYLE_UNSPECIFIED: 0,
  UNDERLYING_EXERCISE_STYLE_AMERICAN: 1,
  UNDERLYING_EXERCISE_STYLE_BERMUDA: 2,
  UNDERLYING_EXERCISE_STYLE_EUROPEAN: 3
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSettlementTypeEnum = {
  UNDERLYING_SETTLEMENT_TYPE_UNSPECIFIED: 0,
  UNDERLYING_SETTLEMENT_TYPE_TPLUS1: 1,
  UNDERLYING_SETTLEMENT_TYPE_TPLUS3: 2,
  UNDERLYING_SETTLEMENT_TYPE_TPLUS4: 3
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingCashTypeEnum = {
  UNDERLYING_CASH_TYPE_UNSPECIFIED: 0,
  UNDERLYING_CASH_TYPE_DIFF: 1,
  UNDERLYING_CASH_TYPE_FIXED: 2
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingFXRateCalcEnum = {
  UNDERLYING_FX_RATE_CALC_UNSPECIFIED: 0,
  UNDERLYING_FX_RATE_CALC_DIVIDE: 1,
  UNDERLYING_FX_RATE_CALC_MULTIPLY: 2
};

/**
 * @enum {number}
 */
proto.Common.YieldTypeEnum = {
  YIELD_TYPE_UNSPECIFIED: 0,
  YIELD_TYPE_AFTER_TAX_YIELD: 1,
  YIELD_TYPE_ANNUAL_YIELD: 2,
  YIELD_TYPE_BOOK_YIELD: 3,
  YIELD_TYPE_CLOSING_YIELD: 4,
  YIELD_TYPE_CLOSING_YIELD_MOST_RECENT_MONTH: 5,
  YIELD_TYPE_CLOSING_YIELD_MOST_RECENT_QUARTER: 6,
  YIELD_TYPE_CLOSING_YIELD_MOST_RECENT_YEAR: 7,
  YIELD_TYPE_COMPOUND_YIELD: 8,
  YIELD_TYPE_CURRENT_YIELD: 9,
  YIELD_TYPE_GVNT_EQUIVALENT_YIELD: 10,
  YIELD_TYPE_INVERSE_FLOATER_BOND_YIELD: 11,
  YIELD_TYPE_MARK_TO_MARKET_YIELD: 12,
  YIELD_TYPE_MOST_RECENT_CLOSING_YIELD: 13,
  YIELD_TYPE_OPEN_AVERAGE_YIELD: 14,
  YIELD_TYPE_PREVIOUS_CLOSE_YIELD: 15,
  YIELD_TYPE_PROCEEDS_YIELD: 16,
  YIELD_TYPE_SEMI_ANNUAL_YIELD: 17,
  YIELD_TYPE_SIMPLE_YIELD: 18,
  YIELD_TYPE_TAX_EQUIVALENT_YIELD: 19,
  YIELD_TYPE_TRUE_GROSS_YIELD: 20,
  YIELD_TYPE_TRUE_YIELD: 21,
  YIELD_TYPE_YIELD_AT_ISSUE: 22,
  YIELD_TYPE_YIELD_CHANGE_SINCE_CLOSE: 23,
  YIELD_TYPE_YIELD_TO_AVERAGE_MATURITY: 24,
  YIELD_TYPE_YIELD_TO_LONGEST_AVERAGE_LIFE: 25,
  YIELD_TYPE_YIELD_TO_MATURITY: 26,
  YIELD_TYPE_YIELD_TO_NEXT_CALL: 27,
  YIELD_TYPE_YIELD_TO_NEXT_PUT: 28,
  YIELD_TYPE_YIELD_TO_NEXT_REFUND: 29,
  YIELD_TYPE_YIELD_TO_SHORTEST_AVERAGE_LIFE: 30,
  YIELD_TYPE_YIELD_TO_TENDER_DATE: 31,
  YIELD_TYPE_YIELD_TO_WORST: 32,
  YIELD_TYPE_YIELD_WITH_INFLATION_ASSUMPTION: 33,
  YIELD_TYPE_YIELD_VALUE_OF32NDS: 34
};

/**
 * @enum {number}
 */
proto.Common.YieldRedemptionPriceTypeEnum = {
  YIELD_REDEMPTION_PRICE_TYPE_UNSPECIFIED: 0,
  YIELD_REDEMPTION_PRICE_TYPE_FIXED_AMOUNT: 1,
  YIELD_REDEMPTION_PRICE_TYPE_PERCENTAGE: 2,
  YIELD_REDEMPTION_PRICE_TYPE_PER_UNIT: 3,
  YIELD_REDEMPTION_PRICE_TYPE_DISCOUNT: 4,
  YIELD_REDEMPTION_PRICE_TYPE_PREMIUM: 5,
  YIELD_REDEMPTION_PRICE_TYPE_SPREAD: 6,
  YIELD_REDEMPTION_PRICE_TYPE_TEDPRICE: 7,
  YIELD_REDEMPTION_PRICE_TYPE_TEDYIELD: 8,
  YIELD_REDEMPTION_PRICE_TYPE_FIXED_CABINET_TRADE_PRICE: 9,
  YIELD_REDEMPTION_PRICE_TYPE_VARIABLE_CABINET_TRADE_PRICE: 10,
  YIELD_REDEMPTION_PRICE_TYPE_YIELD: 11,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_EIGHTS: 12,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_FOURTHS: 13,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_HALFS: 14,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_ONE_TWENTY_EIGHTS: 15,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_SIXTEENTHS: 16,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_SIXTY_FORTHS: 17,
  YIELD_REDEMPTION_PRICE_TYPE_PRODUCT_TICKS_IN_THIRTY_SECONDS: 18
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingStipTypeEnum = {
  UNDERLYING_STIP_TYPE_UNSPECIFIED: 0,
  UNDERLYING_STIP_TYPE_ABSOLUTE_PREPAYMENT_SPEED: 1,
  UNDERLYING_STIP_TYPE_CONSTANT_PREPAYMENT_PENALTY: 2,
  UNDERLYING_STIP_TYPE_CONSTANT_PREPAYMENT_RATE: 3,
  UNDERLYING_STIP_TYPE_CONSTANT_PREPAYMENT_YIELD: 4,
  UNDERLYING_STIP_TYPE_FINAL_CP_ROF_HOME_EQUITY_PREPAYMENT_CURVE: 5,
  UNDERLYING_STIP_TYPE_GEOGRAPHICS: 6,
  UNDERLYING_STIP_TYPE_ISSUE_DATE: 7,
  UNDERLYING_STIP_TYPE_LOT_VARIANCE: 8,
  UNDERLYING_STIP_TYPE_MATURITY_YEAR_AND_MONTH: 9,
  UNDERLYING_STIP_TYPE_MONTHLY_PREPAYMENT_RATE: 10,
  UNDERLYING_STIP_TYPE_NUMBER_OF_PIECES: 11,
  UNDERLYING_STIP_TYPE_PERCENT_OF_BMAPREPAYMENT_CURVE: 12,
  UNDERLYING_STIP_TYPE_PERCENT_OF_MANUFACTURED_HOUSING_PREPAYMENT_CURVE: 13,
  UNDERLYING_STIP_TYPE_PERCENT_OF_PROSPECTUS_PREPAYMENT_CURVE: 14,
  UNDERLYING_STIP_TYPE_POOLS_MAXIMUM: 15,
  UNDERLYING_STIP_TYPE_POOLS_PER_LOT: 16,
  UNDERLYING_STIP_TYPE_POOLS_PER_MILLION: 17,
  UNDERLYING_STIP_TYPE_POOLS_PER_TRADE: 18,
  UNDERLYING_STIP_TYPE_PRODUCTION_YEAR: 19,
  UNDERLYING_STIP_TYPE_SINGLE_MONTHLY_MORTALITY: 20,
  UNDERLYING_STIP_TYPE_TRADE_VARIANCE: 21,
  UNDERLYING_STIP_TYPE_WEIGHTED_AVERAGE_COUPON: 22,
  UNDERLYING_STIP_TYPE_WEIGHTED_AVERAGE_LIFE_COUPON: 23,
  UNDERLYING_STIP_TYPE_WEIGHTED_AVERAGE_LOAN_AGE: 24,
  UNDERLYING_STIP_TYPE_WEIGHTED_AVERAGE_MATURITY: 25,
  UNDERLYING_STIP_TYPE_ALTERNATIVE_MINIMUM_TAX: 26,
  UNDERLYING_STIP_TYPE_AUTO_REINVESTMENT: 27,
  UNDERLYING_STIP_TYPE_BANK_QUALIFIED: 28,
  UNDERLYING_STIP_TYPE_BARGAIN_CONDITIONS: 29,
  UNDERLYING_STIP_TYPE_BENCHMARK_PRICE_SOURCE: 30,
  UNDERLYING_STIP_TYPE_CALL_PROTECTION: 31,
  UNDERLYING_STIP_TYPE_COUPON_RANGE: 32,
  UNDERLYING_STIP_TYPE_CUSTOM_START: 33,
  UNDERLYING_STIP_TYPE_EXPLICIT_LOT_IDENTIFIER: 34,
  UNDERLYING_STIP_TYPE_FREEFORM_TEXT: 35,
  UNDERLYING_STIP_TYPE_INSURED: 36,
  UNDERLYING_STIP_TYPE_ISO_CURRENCY_CODE: 37,
  UNDERLYING_STIP_TYPE_ISSUER: 38,
  UNDERLYING_STIP_TYPE_ISSUE_SIZE_RANGE: 39,
  UNDERLYING_STIP_TYPE_LOOKBACK_DAYS: 40,
  UNDERLYING_STIP_TYPE_MARKET_SECTOR: 41,
  UNDERLYING_STIP_TYPE_MATURITY_RANGE: 42,
  UNDERLYING_STIP_TYPE_MAXIMUM_SUBSTITUTIONS: 43,
  UNDERLYING_STIP_TYPE_MINIMUM_DENOMINATION: 44,
  UNDERLYING_STIP_TYPE_MINIMUM_INCREMENT: 45,
  UNDERLYING_STIP_TYPE_MINIMUM_QUANTITY: 46,
  UNDERLYING_STIP_TYPE_PAYMENT_FREQUENCY: 47,
  UNDERLYING_STIP_TYPE_PRICE_RANGE: 48,
  UNDERLYING_STIP_TYPE_PRICING_FREQUENCY: 49,
  UNDERLYING_STIP_TYPE_PURPOSE: 50,
  UNDERLYING_STIP_TYPE_RATING_SOURCE_AND_RANGE: 51,
  UNDERLYING_STIP_TYPE_RESTRICTED: 52,
  UNDERLYING_STIP_TYPE_SECURITY_TYPE_INCLUDED_OR_EXCLUDED: 53,
  UNDERLYING_STIP_TYPE_STRUCTURE: 54,
  UNDERLYING_STIP_TYPE_SUBSTITUTIONS_FREQUENCY: 55,
  UNDERLYING_STIP_TYPE_SUBSTITUTIONS_LEFT: 56,
  UNDERLYING_STIP_TYPE_TYPE_OF_REDEMPTION: 57,
  UNDERLYING_STIP_TYPE_VALUATION_DISCOUNT: 58,
  UNDERLYING_STIP_TYPE_WHOLE_POOL: 59,
  UNDERLYING_STIP_TYPE_YIELD_RANGE: 60,
  UNDERLYING_STIP_TYPE_AVAILABLE_OFFER_QUANTITY_TO_BE_SHOWN_TO_THE_STREET: 61,
  UNDERLYING_STIP_TYPE_AVERAGE_FICOSCORE: 62,
  UNDERLYING_STIP_TYPE_AVERAGE_LOAN_SIZE: 63,
  UNDERLYING_STIP_TYPE_BROKER_CREDIT: 64,
  UNDERLYING_STIP_TYPE_BROKER_SALES_CREDIT_OVERRIDE: 65,
  UNDERLYING_STIP_TYPE_DISCOUNT_RATE: 66,
  UNDERLYING_STIP_TYPE_INTEREST_OF_ROLLING_OR_CLOSING_TRADE: 67,
  UNDERLYING_STIP_TYPE_MAXIMUM_LOAN_BALANCE: 68,
  UNDERLYING_STIP_TYPE_MAXIMUM_ORDER_SIZE: 69,
  UNDERLYING_STIP_TYPE_OFFER_PRICE_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 70,
  UNDERLYING_STIP_TYPE_OFFER_QUANTITY_TO_BE_SHOWN_TO_INTERNAL_BROKERS: 71,
  UNDERLYING_STIP_TYPE_ORDER_QUANTITY_INCREMENT: 72,
  UNDERLYING_STIP_TYPE_POOL_IDENTIFIER: 73,
  UNDERLYING_STIP_TYPE_PRIMARY_OR_SECONDARY_MARKET_INDICATOR: 74,
  UNDERLYING_STIP_TYPE_PRINCIPAL_OF_ROLLING_OR_CLOSING_TRADE: 75,
  UNDERLYING_STIP_TYPE_REFERENCE_TO_ROLLING_OR_CLOSING_TRADE: 76,
  UNDERLYING_STIP_TYPE_THE_MINIMUM_RESIDUAL_OFFER_QUANTITY: 77,
  UNDERLYING_STIP_TYPE_TRADER_CREDIT: 78,
  UNDERLYING_STIP_TYPE_TYPE_OF_ROLL_TRADE: 79,
  UNDERLYING_STIP_TYPE_YIELD_TO_MATURITY: 80
};

/**
 * @enum {number}
 */
proto.Common.Nested2PartyIDSourceEnum = {
  NESTED2PARTY_ID_SOURCE_UNSPECIFIED: 0,
  NESTED2PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  NESTED2PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  NESTED2PARTY_ID_SOURCE_BIC: 3,
  NESTED2PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  NESTED2PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  NESTED2PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  NESTED2PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  NESTED2PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  NESTED2PARTY_ID_SOURCE_PROPRIETARY: 9,
  NESTED2PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  NESTED2PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  NESTED2PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  NESTED2PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  NESTED2PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  NESTED2PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  NESTED2PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  NESTED2PARTY_ID_SOURCE_ISITCACRONYM: 17,
  NESTED2PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.Nested2PartyRoleEnum = {
  NESTED2PARTY_ROLE_UNSPECIFIED: 0,
  NESTED2PARTY_ROLE_BROKER_OF_CREDIT: 1,
  NESTED2PARTY_ROLE_CLEARING_FIRM: 2,
  NESTED2PARTY_ROLE_CLIENT_ID: 3,
  NESTED2PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  NESTED2PARTY_ROLE_CONTRA_FIRM: 5,
  NESTED2PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  NESTED2PARTY_ROLE_ENTERING_FIRM: 7,
  NESTED2PARTY_ROLE_EXECUTING_FIRM: 8,
  NESTED2PARTY_ROLE_EXECUTING_SYSTEM: 9,
  NESTED2PARTY_ROLE_EXECUTING_TRADER: 10,
  NESTED2PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  NESTED2PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  NESTED2PARTY_ROLE_INTRODUCING_FIRM: 13,
  NESTED2PARTY_ROLE_INVESTOR_ID: 14,
  NESTED2PARTY_ROLE_LOCATE: 15,
  NESTED2PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  NESTED2PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  NESTED2PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  NESTED2PARTY_ROLE_SPONSORING_FIRM: 19,
  NESTED2PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  NESTED2PARTY_ROLE_AGENT: 21,
  NESTED2PARTY_ROLE_BENEFICIARY: 22,
  NESTED2PARTY_ROLE_BUYER: 23,
  NESTED2PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  NESTED2PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  NESTED2PARTY_ROLE_CONTRA_TRADER: 26,
  NESTED2PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  NESTED2PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  NESTED2PARTY_ROLE_CUSTODIAN: 29,
  NESTED2PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  NESTED2PARTY_ROLE_ENTERING_TRADER: 31,
  NESTED2PARTY_ROLE_EXCHANGE: 32,
  NESTED2PARTY_ROLE_INTERESTED_PARTY: 33,
  NESTED2PARTY_ROLE_INTERMEDIARY: 34,
  NESTED2PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  NESTED2PARTY_ROLE_POSITION_ACCOUNT: 36,
  NESTED2PARTY_ROLE_REGULATORY_BODY: 37,
  NESTED2PARTY_ROLE_SUB_CUSTODIAN: 38,
  NESTED2PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  NESTED2PARTY_ROLE_INTRODUCING_BROKER: 40,
  NESTED2PARTY_ROLE_CONTRA_EXCHANGE: 41,
  NESTED2PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  NESTED2PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  NESTED2PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  NESTED2PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  NESTED2PARTY_ROLE_ASSET_MANAGER: 46,
  NESTED2PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  NESTED2PARTY_ROLE_FOREIGN_FIRM: 48,
  NESTED2PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  NESTED2PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  NESTED2PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  NESTED2PARTY_ROLE_SENDER_LOCATION: 52,
  NESTED2PARTY_ROLE_SESSION_ID: 53,
  NESTED2PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  NESTED2PARTY_ROLE_TRADER_MNEMONIC: 55,
  NESTED2PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  NESTED2PARTY_ROLE_ENTERING_UNIT: 57,
  NESTED2PARTY_ROLE_EXECUTING_UNIT: 58,
  NESTED2PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  NESTED2PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  NESTED2PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  NESTED2PARTY_ROLE_DESK_ID: 62,
  NESTED2PARTY_ROLE_EXECUTION_VENUE: 63,
  NESTED2PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  NESTED2PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  NESTED2PARTY_ROLE_INVESTMENT_FIRM: 66,
  NESTED2PARTY_ROLE_LOCATION_ID: 67,
  NESTED2PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  NESTED2PARTY_ROLE_MARKET_DATA_MARKET: 69,
  NESTED2PARTY_ROLE_MARKET_MAKER: 70,
  NESTED2PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  NESTED2PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  NESTED2PARTY_ROLE_REGULATED_MARKET: 73,
  NESTED2PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  NESTED2PARTY_ROLE_REPORT_ORIGINATOR: 75,
  NESTED2PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  NESTED2PARTY_ROLE_ALLOCATION_ENTITY: 77,
  NESTED2PARTY_ROLE_BROKER_CLEARING_ID: 78,
  NESTED2PARTY_ROLE_PRIME_BROKER: 79,
  NESTED2PARTY_ROLE_STEP_OUT_FIRM: 80,
  NESTED2PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  NESTED2PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  NESTED2PARTY_ROLE_CLEARING_ACCOUNT: 83,
  NESTED2PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.Nested3PartyIDSourceEnum = {
  NESTED3PARTY_ID_SOURCE_UNSPECIFIED: 0,
  NESTED3PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  NESTED3PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  NESTED3PARTY_ID_SOURCE_BIC: 3,
  NESTED3PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  NESTED3PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  NESTED3PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  NESTED3PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  NESTED3PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  NESTED3PARTY_ID_SOURCE_PROPRIETARY: 9,
  NESTED3PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  NESTED3PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  NESTED3PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  NESTED3PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  NESTED3PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  NESTED3PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  NESTED3PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  NESTED3PARTY_ID_SOURCE_ISITCACRONYM: 17,
  NESTED3PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.Nested3PartyRoleEnum = {
  NESTED3PARTY_ROLE_UNSPECIFIED: 0,
  NESTED3PARTY_ROLE_BROKER_OF_CREDIT: 1,
  NESTED3PARTY_ROLE_CLEARING_FIRM: 2,
  NESTED3PARTY_ROLE_CLIENT_ID: 3,
  NESTED3PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  NESTED3PARTY_ROLE_CONTRA_FIRM: 5,
  NESTED3PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  NESTED3PARTY_ROLE_ENTERING_FIRM: 7,
  NESTED3PARTY_ROLE_EXECUTING_FIRM: 8,
  NESTED3PARTY_ROLE_EXECUTING_SYSTEM: 9,
  NESTED3PARTY_ROLE_EXECUTING_TRADER: 10,
  NESTED3PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  NESTED3PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  NESTED3PARTY_ROLE_INTRODUCING_FIRM: 13,
  NESTED3PARTY_ROLE_INVESTOR_ID: 14,
  NESTED3PARTY_ROLE_LOCATE: 15,
  NESTED3PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  NESTED3PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  NESTED3PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  NESTED3PARTY_ROLE_SPONSORING_FIRM: 19,
  NESTED3PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  NESTED3PARTY_ROLE_AGENT: 21,
  NESTED3PARTY_ROLE_BENEFICIARY: 22,
  NESTED3PARTY_ROLE_BUYER: 23,
  NESTED3PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  NESTED3PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  NESTED3PARTY_ROLE_CONTRA_TRADER: 26,
  NESTED3PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  NESTED3PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  NESTED3PARTY_ROLE_CUSTODIAN: 29,
  NESTED3PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  NESTED3PARTY_ROLE_ENTERING_TRADER: 31,
  NESTED3PARTY_ROLE_EXCHANGE: 32,
  NESTED3PARTY_ROLE_INTERESTED_PARTY: 33,
  NESTED3PARTY_ROLE_INTERMEDIARY: 34,
  NESTED3PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  NESTED3PARTY_ROLE_POSITION_ACCOUNT: 36,
  NESTED3PARTY_ROLE_REGULATORY_BODY: 37,
  NESTED3PARTY_ROLE_SUB_CUSTODIAN: 38,
  NESTED3PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  NESTED3PARTY_ROLE_INTRODUCING_BROKER: 40,
  NESTED3PARTY_ROLE_CONTRA_EXCHANGE: 41,
  NESTED3PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  NESTED3PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  NESTED3PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  NESTED3PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  NESTED3PARTY_ROLE_ASSET_MANAGER: 46,
  NESTED3PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  NESTED3PARTY_ROLE_FOREIGN_FIRM: 48,
  NESTED3PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  NESTED3PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  NESTED3PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  NESTED3PARTY_ROLE_SENDER_LOCATION: 52,
  NESTED3PARTY_ROLE_SESSION_ID: 53,
  NESTED3PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  NESTED3PARTY_ROLE_TRADER_MNEMONIC: 55,
  NESTED3PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  NESTED3PARTY_ROLE_ENTERING_UNIT: 57,
  NESTED3PARTY_ROLE_EXECUTING_UNIT: 58,
  NESTED3PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  NESTED3PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  NESTED3PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  NESTED3PARTY_ROLE_DESK_ID: 62,
  NESTED3PARTY_ROLE_EXECUTION_VENUE: 63,
  NESTED3PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  NESTED3PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  NESTED3PARTY_ROLE_INVESTMENT_FIRM: 66,
  NESTED3PARTY_ROLE_LOCATION_ID: 67,
  NESTED3PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  NESTED3PARTY_ROLE_MARKET_DATA_MARKET: 69,
  NESTED3PARTY_ROLE_MARKET_MAKER: 70,
  NESTED3PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  NESTED3PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  NESTED3PARTY_ROLE_REGULATED_MARKET: 73,
  NESTED3PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  NESTED3PARTY_ROLE_REPORT_ORIGINATOR: 75,
  NESTED3PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  NESTED3PARTY_ROLE_ALLOCATION_ENTITY: 77,
  NESTED3PARTY_ROLE_BROKER_CLEARING_ID: 78,
  NESTED3PARTY_ROLE_PRIME_BROKER: 79,
  NESTED3PARTY_ROLE_STEP_OUT_FIRM: 80,
  NESTED3PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  NESTED3PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  NESTED3PARTY_ROLE_CLEARING_ACCOUNT: 83,
  NESTED3PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.ClearingInstructionEnum = {
  CLEARING_INSTRUCTION_UNSPECIFIED: 0,
  CLEARING_INSTRUCTION_AUTOMATIC_GIVE_UP_MODE: 1,
  CLEARING_INSTRUCTION_AUTOMATIC_POSTING_MODE: 2,
  CLEARING_INSTRUCTION_BILATERAL_NETTING_ONLY: 3,
  CLEARING_INSTRUCTION_CLEAR_AGAINST_CENTRAL_COUNTERPARTY: 4,
  CLEARING_INSTRUCTION_EXCLUDE_FROM_ALL_NETTING: 5,
  CLEARING_INSTRUCTION_EXCLUDE_FROM_CENTRAL_COUNTERPARTY: 6,
  CLEARING_INSTRUCTION_EX_CLEARING: 7,
  CLEARING_INSTRUCTION_MANUAL_MODE: 8,
  CLEARING_INSTRUCTION_MULTILATERAL_NETTING: 9,
  CLEARING_INSTRUCTION_PROCESS_NORMALLY: 10,
  CLEARING_INSTRUCTION_SPECIAL_TRADE: 11,
  CLEARING_INSTRUCTION_CUSTOMER_TRADE: 12,
  CLEARING_INSTRUCTION_QUALIFIED_SERVICE_REPRESENTATIVE_QSR: 13,
  CLEARING_INSTRUCTION_SELF_CLEARING: 14
};

/**
 * @enum {number}
 */
proto.Common.StatusValueEnum = {
  STATUS_VALUE_UNSPECIFIED: 0,
  STATUS_VALUE_CONNECTED: 1,
  STATUS_VALUE_IN_PROCESS: 2,
  STATUS_VALUE_NOT_CONNECTED_EXPECTED: 3,
  STATUS_VALUE_NOT_CONNECTED_UNEXPECTED: 4
};

/**
 * @enum {number}
 */
proto.Common.ContAmtTypeEnum = {
  CONT_AMT_TYPE_UNSPECIFIED: 0,
  CONT_AMT_TYPE_COMMISSION_AMOUNT: 1,
  CONT_AMT_TYPE_COMMISSION_PERCENT: 2,
  CONT_AMT_TYPE_DILUTION_LEVY_AMOUNT: 3,
  CONT_AMT_TYPE_DILUTION_LEVY_PERCENT: 4,
  CONT_AMT_TYPE_DISCOUNT_AMOUNT: 5,
  CONT_AMT_TYPE_DISCOUNT_PERCENT: 6,
  CONT_AMT_TYPE_EXIT_CHARGE_AMOUNT: 7,
  CONT_AMT_TYPE_EXIT_CHARGE_PERCENT: 8,
  CONT_AMT_TYPE_FUND_BASED_RENEWAL_COMMISSION_ON_FUND: 9,
  CONT_AMT_TYPE_FUND_BASED_RENEWAL_COMMISSION_ON_ORDER: 10,
  CONT_AMT_TYPE_FUND_BASED_RENEWAL_COMMISSION_PERCENT: 11,
  CONT_AMT_TYPE_INITIAL_CHARGE_AMOUNT: 12,
  CONT_AMT_TYPE_INITIAL_CHARGE_PERCENT: 13,
  CONT_AMT_TYPE_NET_SETTLEMENT_AMOUNT: 14,
  CONT_AMT_TYPE_PROJECTED_FUND_VALUE: 15
};

/**
 * @enum {number}
 */
proto.Common.LegSwapTypeEnum = {
  LEG_SWAP_TYPE_UNSPECIFIED: 0,
  LEG_SWAP_TYPE_MODIFIED_DURATION: 1,
  LEG_SWAP_TYPE_PAR_FOR_PAR: 2,
  LEG_SWAP_TYPE_PROCEEDS: 3,
  LEG_SWAP_TYPE_RISK: 4
};

/**
 * @enum {number}
 */
proto.Common.LegPositionEffectEnum = {
  LEG_POSITION_EFFECT_UNSPECIFIED: 0,
  LEG_POSITION_EFFECT_CLOSE: 1,
  LEG_POSITION_EFFECT_OPEN: 2,
  LEG_POSITION_EFFECT_FIFO: 3,
  LEG_POSITION_EFFECT_ROLLED: 4,
  LEG_POSITION_EFFECT_CLOSE_BUT_NOTIFY_ON_OPEN: 5,
  LEG_POSITION_EFFECT_DEFAULT: 6
};

/**
 * @enum {number}
 */
proto.Common.LegCoveredOrUncoveredEnum = {
  LEG_COVERED_OR_UNCOVERED_UNSPECIFIED: 0,
  LEG_COVERED_OR_UNCOVERED_COVERED: 1,
  LEG_COVERED_OR_UNCOVERED_UNCOVERED: 2
};

/**
 * @enum {number}
 */
proto.Common.LegSettlTypeEnum = {
  LEG_SETTL_TYPE_UNSPECIFIED: 0,
  LEG_SETTL_TYPE_CASH: 1,
  LEG_SETTL_TYPE_FUTURE: 2,
  LEG_SETTL_TYPE_NEXT_DAY: 3,
  LEG_SETTL_TYPE_REGULAR: 4,
  LEG_SETTL_TYPE_SELLERS_OPTION: 5,
  LEG_SETTL_TYPE_TPLUS2: 6,
  LEG_SETTL_TYPE_TPLUS3: 7,
  LEG_SETTL_TYPE_TPLUS4: 8,
  LEG_SETTL_TYPE_WHEN_AND_IF_ISSUED: 9,
  LEG_SETTL_TYPE_TPLUS5: 10,
  LEG_SETTL_TYPE_FX_SPOT_NEXT_SETTLEMENT: 11,
  LEG_SETTL_TYPE_BROKEN_DATE: 12
};

/**
 * @enum {number}
 */
proto.Common.LegExecInstEnum = {
  LEG_EXEC_INST_UNSPECIFIED: 0,
  LEG_EXEC_INST_ALL_OR_NONE: 1,
  LEG_EXEC_INST_CALL_FIRST: 2,
  LEG_EXEC_INST_DO_NOT_INCREASE: 3,
  LEG_EXEC_INST_DO_NOT_REDUCE: 4,
  LEG_EXEC_INST_GO_ALONG: 5,
  LEG_EXEC_INST_HELD: 6,
  LEG_EXEC_INST_NOT_HELD: 7,
  LEG_EXEC_INST_NO_CROSS: 8,
  LEG_EXEC_INST_OKTO_CROSS: 9,
  LEG_EXEC_INST_OVER_THE_DAY: 10,
  LEG_EXEC_INST_PARTICIPATE_DO_NOT_INITIATE: 11,
  LEG_EXEC_INST_PERCENT_OF_VOLUME: 12,
  LEG_EXEC_INST_STAY_ON_BID_SIDE: 13,
  LEG_EXEC_INST_STAY_ON_OFFER_SIDE: 14,
  LEG_EXEC_INST_STRICT_SCALE: 15,
  LEG_EXEC_INST_TRY_TO_SCALE: 16,
  LEG_EXEC_INST_WORK: 17,
  LEG_EXEC_INST_INSTITUTIONS_ONLY: 18,
  LEG_EXEC_INST_LAST_PEG: 19,
  LEG_EXEC_INST_MARKET_PEG: 20,
  LEG_EXEC_INST_MID_PRICE_PEG: 21,
  LEG_EXEC_INST_NON_NEGOTIABLE: 22,
  LEG_EXEC_INST_OPENING_PEG: 23,
  LEG_EXEC_INST_PRIMARY_PEG: 24,
  LEG_EXEC_INST_SUSPEND: 25,
  LEG_EXEC_INST_CUSTOMER_DISPLAY_INSTRUCTION: 26,
  LEG_EXEC_INST_NETTING: 27,
  LEG_EXEC_INST_PEG_TO_VWAP: 28,
  LEG_EXEC_INST_CANCEL_ON_SYSTEM_FAILURE: 29,
  LEG_EXEC_INST_CANCEL_ON_TRADING_HALT: 30,
  LEG_EXEC_INST_REINSTATE_ON_SYSTEM_FAILURE: 31,
  LEG_EXEC_INST_REINSTATE_ON_TRADING_HALT: 32,
  LEG_EXEC_INST_TRADE_ALONG: 33,
  LEG_EXEC_INST_TRY_TO_STOP: 34,
  LEG_EXEC_INST_CANCEL_IF_NOT_BEST: 35,
  LEG_EXEC_INST_IGNORE_PRICE_VALIDITY_CHECKS: 36,
  LEG_EXEC_INST_PEG_TO_LIMIT_PRICE: 37,
  LEG_EXEC_INST_STRICT_LIMIT: 38,
  LEG_EXEC_INST_TRAILING_STOP_PEG: 39,
  LEG_EXEC_INST_WORK_TO_TARGET_STRATEGY: 40,
  LEG_EXEC_INST_INTERMARKET_SWEEP: 41,
  LEG_EXEC_INST_SINGLE_EXECUTION_REQUESTED_FOR_BLOCK_TRADE: 42,
  LEG_EXEC_INST_EXTERNAL_ROUTING_ALLOWED: 43,
  LEG_EXEC_INST_EXTERNAL_ROUTING_NOT_ALLOWED: 44,
  LEG_EXEC_INST_IMBALANCE_ONLY: 45,
  LEG_EXEC_INST_BEST_EXECUTION: 46,
  LEG_EXEC_INST_FIXED_PEG_TO_LOCAL_BEST_BID_OR_OFFER_AT_TIME_OF_ORDER: 47,
  LEG_EXEC_INST_CANCEL_ON_CONNECTION_LOSS: 48,
  LEG_EXEC_INST_REINSTATE_ON_CONNECTION_LOSS: 49,
  LEG_EXEC_INST_RELEASE_FROM_SUSPENSION: 50,
  LEG_EXEC_INST_SUSPEND_ON_CONNECTION_LOSS: 51,
  LEG_EXEC_INST_SUSPEND_ON_SYSTEM_FAILURE: 52,
  LEG_EXEC_INST_SUSPEND_ON_TRADING_HALT: 53,
  LEG_EXEC_INST_EXECUTE_AS_DELTA_NEUTRAL: 54,
  LEG_EXEC_INST_EXECUTE_AS_DURATION_NEUTRAL: 55,
  LEG_EXEC_INST_EXECUTE_AS_FX_NEUTRAL: 56
};

/**
 * @enum {number}
 */
proto.Common.LegIOIQtyEnum = {
  LEG_IOI_QTY_UNSPECIFIED: 0,
  LEG_IOI_QTY_LARGE: 1,
  LEG_IOI_QTY_MEDIUM: 2,
  LEG_IOI_QTY_SMALL: 3,
  LEG_IOI_QTY_UNDISCLOSED_QUANTITY: 4
};

/**
 * @enum {number}
 */
proto.Common.QuoteTypeEnum = {
  QUOTE_TYPE_UNSPECIFIED: 0,
  QUOTE_TYPE_INDICATIVE: 1,
  QUOTE_TYPE_RESTRICTED_TRADEABLE: 2,
  QUOTE_TYPE_TRADEABLE: 3,
  QUOTE_TYPE_COUNTER: 4
};

/**
 * @enum {number}
 */
proto.Common.SettlTypeEnum = {
  SETTL_TYPE_UNSPECIFIED: 0,
  SETTL_TYPE_CASH: 1,
  SETTL_TYPE_FUTURE: 2,
  SETTL_TYPE_NEXT_DAY: 3,
  SETTL_TYPE_REGULAR: 4,
  SETTL_TYPE_SELLERS_OPTION: 5,
  SETTL_TYPE_TPLUS2: 6,
  SETTL_TYPE_TPLUS3: 7,
  SETTL_TYPE_TPLUS4: 8,
  SETTL_TYPE_WHEN_AND_IF_ISSUED: 9,
  SETTL_TYPE_TPLUS5: 10,
  SETTL_TYPE_FX_SPOT_NEXT_SETTLEMENT: 11,
  SETTL_TYPE_BROKEN_DATE: 12
};

/**
 * @enum {number}
 */
proto.Common.MiscFeeTypeEnum = {
  MISC_FEE_TYPE_UNSPECIFIED: 0,
  MISC_FEE_TYPE_EXCHANGE_FEES: 1,
  MISC_FEE_TYPE_LEVY: 2,
  MISC_FEE_TYPE_LOCAL_COMMISSION: 3,
  MISC_FEE_TYPE_OTHER: 4,
  MISC_FEE_TYPE_REGULATORY: 5,
  MISC_FEE_TYPE_STAMP: 6,
  MISC_FEE_TYPE_TAX: 7,
  MISC_FEE_TYPE_MARKUP: 8,
  MISC_FEE_TYPE_CONSUMPTION_TAX: 9,
  MISC_FEE_TYPE_AGENT: 10,
  MISC_FEE_TYPE_CONVERSION: 11,
  MISC_FEE_TYPE_PER_TRANSACTION: 12,
  MISC_FEE_TYPE_SECURITY_LENDING: 13,
  MISC_FEE_TYPE_TRANSFER_FEE: 14
};

/**
 * @enum {number}
 */
proto.Common.MiscFeeBasisEnum = {
  MISC_FEE_BASIS_UNSPECIFIED: 0,
  MISC_FEE_BASIS_ABSOLUTE: 1,
  MISC_FEE_BASIS_PERCENTAGE: 2,
  MISC_FEE_BASIS_PER_UNIT: 3
};

/**
 * @enum {number}
 */
proto.Common.AllocAcctIDSourceEnum = {
  ALLOC_ACCT_ID_SOURCE_UNSPECIFIED: 0,
  ALLOC_ACCT_ID_SOURCE_BIC: 1,
  ALLOC_ACCT_ID_SOURCE_DTCCCODE: 2,
  ALLOC_ACCT_ID_SOURCE_OMGEO: 3,
  ALLOC_ACCT_ID_SOURCE_OTHER: 4,
  ALLOC_ACCT_ID_SOURCE_SID_CODE: 5,
  ALLOC_ACCT_ID_SOURCE_TFM: 6
};

/**
 * @enum {number}
 */
proto.Common.RoutingTypeEnum = {
  ROUTING_TYPE_UNSPECIFIED: 0,
  ROUTING_TYPE_BLOCK_FIRM: 1,
  ROUTING_TYPE_BLOCK_LIST: 2,
  ROUTING_TYPE_TARGET_FIRM: 3,
  ROUTING_TYPE_TARGET_LIST: 4
};

/**
 * @enum {number}
 */
proto.Common.TradingSessionIDEnum = {
  TRADING_SESSION_ID_UNSPECIFIED: 0,
  TRADING_SESSION_ID_AFTERNOON: 1,
  TRADING_SESSION_ID_AFTER_HOURS: 2,
  TRADING_SESSION_ID_DAY: 3,
  TRADING_SESSION_ID_EVENING: 4,
  TRADING_SESSION_ID_HALF_DAY: 5,
  TRADING_SESSION_ID_MORNING: 6
};

/**
 * @enum {number}
 */
proto.Common.TradingSessionSubIDEnum = {
  TRADING_SESSION_SUB_ID_UNSPECIFIED: 0,
  TRADING_SESSION_SUB_ID_CLOSING_OR_CLOSING_AUCTION: 1,
  TRADING_SESSION_SUB_ID_CONTINUOUS: 2,
  TRADING_SESSION_SUB_ID_INTRADAY_AUCTION: 3,
  TRADING_SESSION_SUB_ID_OPENING_OR_OPENING_AUCTION: 4,
  TRADING_SESSION_SUB_ID_POST_TRADING: 5,
  TRADING_SESSION_SUB_ID_PRE_TRADING: 6,
  TRADING_SESSION_SUB_ID_QUIESCENT: 7
};

/**
 * @enum {number}
 */
proto.Common.EventTypeEnum = {
  EVENT_TYPE_UNSPECIFIED: 0,
  EVENT_TYPE_CALL: 1,
  EVENT_TYPE_OTHER: 2,
  EVENT_TYPE_PUT: 3,
  EVENT_TYPE_SINKING_FUND_CALL: 4,
  EVENT_TYPE_TENDER: 5,
  EVENT_TYPE_ACTIVATION: 6,
  EVENT_TYPE_INACTIVIATION: 7,
  EVENT_TYPE_LAST_ELIGIBLE_TRADE_DATE: 8,
  EVENT_TYPE_FINAL_INVENTORY_DUE_DATE: 9,
  EVENT_TYPE_FIRST_DELIVERY_DATE: 10,
  EVENT_TYPE_FIRST_INTENT_DATE: 11,
  EVENT_TYPE_INITIAL_INVENTORY_DUE_DATE: 12,
  EVENT_TYPE_LAST_DELIVERY_DATE: 13,
  EVENT_TYPE_LAST_INTENT_DATE: 14,
  EVENT_TYPE_POSITION_REMOVAL_DATE: 15,
  EVENT_TYPE_SWAP_END_DATE: 16,
  EVENT_TYPE_SWAP_NEXT_ROLL_DATE: 17,
  EVENT_TYPE_SWAP_NEXT_START_DATE: 18,
  EVENT_TYPE_SWAP_ROLL_DATE: 19,
  EVENT_TYPE_SWAP_START_DATE: 20
};

/**
 * @enum {number}
 */
proto.Common.SecurityAltIDSourceEnum = {
  SECURITY_ALT_ID_SOURCE_UNSPECIFIED: 0,
  SECURITY_ALT_ID_SOURCE_CUSIP: 1,
  SECURITY_ALT_ID_SOURCE_QUIK: 2,
  SECURITY_ALT_ID_SOURCE_SEDOL: 3,
  SECURITY_ALT_ID_SOURCE_ISIN_NUMBER: 4,
  SECURITY_ALT_ID_SOURCE_RIC_CODE: 5,
  SECURITY_ALT_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  SECURITY_ALT_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  SECURITY_ALT_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  SECURITY_ALT_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  SECURITY_ALT_ID_SOURCE_BELGIAN: 10,
  SECURITY_ALT_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  SECURITY_ALT_ID_SOURCE_COMMON: 12,
  SECURITY_ALT_ID_SOURCE_DUTCH: 13,
  SECURITY_ALT_ID_SOURCE_SICOVAM: 14,
  SECURITY_ALT_ID_SOURCE_VALOREN: 15,
  SECURITY_ALT_ID_SOURCE_WERTPAPIER: 16,
  SECURITY_ALT_ID_SOURCE_CLEARING_HOUSE: 17,
  SECURITY_ALT_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  SECURITY_ALT_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  SECURITY_ALT_ID_SOURCE_LETTER_OF_CREDIT: 20,
  SECURITY_ALT_ID_SOURCE_ISDA_FPML_URL: 21,
  SECURITY_ALT_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.LegSecurityAltIDSourceEnum = {
  LEG_SECURITY_ALT_ID_SOURCE_UNSPECIFIED: 0,
  LEG_SECURITY_ALT_ID_SOURCE_CUSIP: 1,
  LEG_SECURITY_ALT_ID_SOURCE_QUIK: 2,
  LEG_SECURITY_ALT_ID_SOURCE_SEDOL: 3,
  LEG_SECURITY_ALT_ID_SOURCE_ISIN_NUMBER: 4,
  LEG_SECURITY_ALT_ID_SOURCE_RIC_CODE: 5,
  LEG_SECURITY_ALT_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  LEG_SECURITY_ALT_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  LEG_SECURITY_ALT_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  LEG_SECURITY_ALT_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  LEG_SECURITY_ALT_ID_SOURCE_BELGIAN: 10,
  LEG_SECURITY_ALT_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  LEG_SECURITY_ALT_ID_SOURCE_COMMON: 12,
  LEG_SECURITY_ALT_ID_SOURCE_DUTCH: 13,
  LEG_SECURITY_ALT_ID_SOURCE_SICOVAM: 14,
  LEG_SECURITY_ALT_ID_SOURCE_VALOREN: 15,
  LEG_SECURITY_ALT_ID_SOURCE_WERTPAPIER: 16,
  LEG_SECURITY_ALT_ID_SOURCE_CLEARING_HOUSE: 17,
  LEG_SECURITY_ALT_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  LEG_SECURITY_ALT_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  LEG_SECURITY_ALT_ID_SOURCE_LETTER_OF_CREDIT: 20,
  LEG_SECURITY_ALT_ID_SOURCE_ISDA_FPML_URL: 21,
  LEG_SECURITY_ALT_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingSecurityAltIDSourceEnum = {
  UNDERLYING_SECURITY_ALT_ID_SOURCE_UNSPECIFIED: 0,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_CUSIP: 1,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_QUIK: 2,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_SEDOL: 3,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_ISIN_NUMBER: 4,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_RIC_CODE: 5,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_BELGIAN: 10,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_COMMON: 12,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_DUTCH: 13,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_SICOVAM: 14,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_VALOREN: 15,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_WERTPAPIER: 16,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_CLEARING_HOUSE: 17,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_LETTER_OF_CREDIT: 20,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_ISDA_FPML_URL: 21,
  UNDERLYING_SECURITY_ALT_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.InstrAttribTypeEnum = {
  INSTR_ATTRIB_TYPE_UNSPECIFIED: 0,
  INSTR_ATTRIB_TYPE_CALLABLE: 1,
  INSTR_ATTRIB_TYPE_CALLABLE_BELOW_MATURITY_VALUE: 2,
  INSTR_ATTRIB_TYPE_CALLABLE_WITHOUT_NOTICE: 3,
  INSTR_ATTRIB_TYPE_COUPON_PERIOD: 4,
  INSTR_ATTRIB_TYPE_ESCROWED_TO_MATURITY: 5,
  INSTR_ATTRIB_TYPE_ESCROWED_TO_REDEMPTION_DATE: 6,
  INSTR_ATTRIB_TYPE_FLAT: 7,
  INSTR_ATTRIB_TYPE_INDEXED: 8,
  INSTR_ATTRIB_TYPE_INTEREST_BEARING: 9,
  INSTR_ATTRIB_TYPE_IN_DEFAULT: 10,
  INSTR_ATTRIB_TYPE_LESS_FEE_FOR_PUT: 11,
  INSTR_ATTRIB_TYPE_NO_PERIODIC_PAYMENTS: 12,
  INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT: 13,
  INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT_PRICE: 14,
  INSTR_ATTRIB_TYPE_PRE_REFUNDED: 15,
  INSTR_ATTRIB_TYPE_STEPPED_COUPON: 16,
  INSTR_ATTRIB_TYPE_SUBJECT_TO_ALTERNATIVE_MINIMUM_TAX: 17,
  INSTR_ATTRIB_TYPE_TAXABLE: 18,
  INSTR_ATTRIB_TYPE_TEXT: 19,
  INSTR_ATTRIB_TYPE_UNRATED: 20,
  INSTR_ATTRIB_TYPE_VARIABLE_RATE: 21,
  INSTR_ATTRIB_TYPE_WHEN: 22,
  INSTR_ATTRIB_TYPE_ZERO_COUPON: 23,
  INSTR_ATTRIB_TYPE_PRICE_TICK_RULES_FOR_SECURITY: 24,
  INSTR_ATTRIB_TYPE_TRADE_TYPE_ELIGIBILITY_DETAILS_FOR_SECURITY: 25,
  INSTR_ATTRIB_TYPE_INSTRUMENT_DENOMINATOR: 26,
  INSTR_ATTRIB_TYPE_INSTRUMENT_NUMERATOR: 27,
  INSTR_ATTRIB_TYPE_INSTRUMENT_PRICE_PRECISION: 28,
  INSTR_ATTRIB_TYPE_INSTRUMENT_STRIKE_PRICE: 29,
  INSTR_ATTRIB_TYPE_TRADEABLE_INDICATOR: 30
};

/**
 * @enum {number}
 */
proto.Common.SettlInstSourceEnum = {
  SETTL_INST_SOURCE_UNSPECIFIED: 0,
  SETTL_INST_SOURCE_BROKER_CREDIT: 1,
  SETTL_INST_SOURCE_INSTITUTION: 2,
  SETTL_INST_SOURCE_INVESTOR: 3
};

/**
 * @enum {number}
 */
proto.Common.DlvyInstTypeEnum = {
  DLVY_INST_TYPE_UNSPECIFIED: 0,
  DLVY_INST_TYPE_CASH: 1,
  DLVY_INST_TYPE_SECURITIES: 2
};

/**
 * @enum {number}
 */
proto.Common.SettlPartySubIDTypeEnum = {
  SETTL_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  SETTL_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  SETTL_PARTY_SUB_ID_TYPE_BIC: 2,
  SETTL_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  SETTL_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  SETTL_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  SETTL_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  SETTL_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  SETTL_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  SETTL_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  SETTL_PARTY_SUB_ID_TYPE_FIRM: 10,
  SETTL_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  SETTL_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  SETTL_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  SETTL_PARTY_SUB_ID_TYPE_PERSON: 14,
  SETTL_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  SETTL_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  SETTL_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  SETTL_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  SETTL_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  SETTL_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  SETTL_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  SETTL_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  SETTL_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  SETTL_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  SETTL_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  SETTL_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  SETTL_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  SETTL_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  SETTL_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  SETTL_PARTY_SUB_ID_TYPE_LOCATION: 30,
  SETTL_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  SETTL_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  SETTL_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.PartySubIDTypeEnum = {
  PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  PARTY_SUB_ID_TYPE_APPLICATION: 1,
  PARTY_SUB_ID_TYPE_BIC: 2,
  PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  PARTY_SUB_ID_TYPE_FIRM: 10,
  PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  PARTY_SUB_ID_TYPE_PERSON: 14,
  PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  PARTY_SUB_ID_TYPE_SYSTEM: 25,
  PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  PARTY_SUB_ID_TYPE_LOCATION: 30,
  PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.NestedPartySubIDTypeEnum = {
  NESTED_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  NESTED_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  NESTED_PARTY_SUB_ID_TYPE_BIC: 2,
  NESTED_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  NESTED_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  NESTED_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  NESTED_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  NESTED_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  NESTED_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  NESTED_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  NESTED_PARTY_SUB_ID_TYPE_FIRM: 10,
  NESTED_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  NESTED_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  NESTED_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  NESTED_PARTY_SUB_ID_TYPE_PERSON: 14,
  NESTED_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  NESTED_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  NESTED_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  NESTED_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  NESTED_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  NESTED_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  NESTED_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  NESTED_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  NESTED_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  NESTED_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  NESTED_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  NESTED_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  NESTED_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  NESTED_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  NESTED_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  NESTED_PARTY_SUB_ID_TYPE_LOCATION: 30,
  NESTED_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  NESTED_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  NESTED_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.Nested2PartySubIDTypeEnum = {
  NESTED2PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  NESTED2PARTY_SUB_ID_TYPE_APPLICATION: 1,
  NESTED2PARTY_SUB_ID_TYPE_BIC: 2,
  NESTED2PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  NESTED2PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  NESTED2PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  NESTED2PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  NESTED2PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  NESTED2PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  NESTED2PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  NESTED2PARTY_SUB_ID_TYPE_FIRM: 10,
  NESTED2PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  NESTED2PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  NESTED2PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  NESTED2PARTY_SUB_ID_TYPE_PERSON: 14,
  NESTED2PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  NESTED2PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  NESTED2PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  NESTED2PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  NESTED2PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  NESTED2PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  NESTED2PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  NESTED2PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  NESTED2PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  NESTED2PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  NESTED2PARTY_SUB_ID_TYPE_SYSTEM: 25,
  NESTED2PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  NESTED2PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  NESTED2PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  NESTED2PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  NESTED2PARTY_SUB_ID_TYPE_LOCATION: 30,
  NESTED2PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  NESTED2PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  NESTED2PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.Nested3PartySubIDTypeEnum = {
  NESTED3PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  NESTED3PARTY_SUB_ID_TYPE_APPLICATION: 1,
  NESTED3PARTY_SUB_ID_TYPE_BIC: 2,
  NESTED3PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  NESTED3PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  NESTED3PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  NESTED3PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  NESTED3PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  NESTED3PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  NESTED3PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  NESTED3PARTY_SUB_ID_TYPE_FIRM: 10,
  NESTED3PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  NESTED3PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  NESTED3PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  NESTED3PARTY_SUB_ID_TYPE_PERSON: 14,
  NESTED3PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  NESTED3PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  NESTED3PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  NESTED3PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  NESTED3PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  NESTED3PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  NESTED3PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  NESTED3PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  NESTED3PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  NESTED3PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  NESTED3PARTY_SUB_ID_TYPE_SYSTEM: 25,
  NESTED3PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  NESTED3PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  NESTED3PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  NESTED3PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  NESTED3PARTY_SUB_ID_TYPE_LOCATION: 30,
  NESTED3PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  NESTED3PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  NESTED3PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.StrategyParameterTypeEnum = {
  STRATEGY_PARAMETER_TYPE_UNSPECIFIED: 0,
  STRATEGY_PARAMETER_TYPE_AMT: 1,
  STRATEGY_PARAMETER_TYPE_BOOLEAN: 2,
  STRATEGY_PARAMETER_TYPE_CHAR: 3,
  STRATEGY_PARAMETER_TYPE_CURRENCY: 4,
  STRATEGY_PARAMETER_TYPE_DATA: 5,
  STRATEGY_PARAMETER_TYPE_EXCHANGE: 6,
  STRATEGY_PARAMETER_TYPE_FLOAT: 7,
  STRATEGY_PARAMETER_TYPE_INT: 8,
  STRATEGY_PARAMETER_TYPE_LENGTH: 9,
  STRATEGY_PARAMETER_TYPE_LOCAL_MKT_DATE: 10,
  STRATEGY_PARAMETER_TYPE_MONTH_YEAR: 11,
  STRATEGY_PARAMETER_TYPE_MULTIPLE_CHAR_VALUE: 12,
  STRATEGY_PARAMETER_TYPE_NUM_IN_GROUP: 13,
  STRATEGY_PARAMETER_TYPE_PERCENTAGE: 14,
  STRATEGY_PARAMETER_TYPE_PRICE: 15,
  STRATEGY_PARAMETER_TYPE_PRICE_OFFSET: 16,
  STRATEGY_PARAMETER_TYPE_QTY: 17,
  STRATEGY_PARAMETER_TYPE_SEQ_NUM: 18,
  STRATEGY_PARAMETER_TYPE_STRING: 19,
  STRATEGY_PARAMETER_TYPE_TAG_NUM: 20,
  STRATEGY_PARAMETER_TYPE_UTC_DATE_ONLY: 21,
  STRATEGY_PARAMETER_TYPE_UTC_TIMESTAMP: 22,
  STRATEGY_PARAMETER_TYPE_UTC_TIME_ONLY: 23,
  STRATEGY_PARAMETER_TYPE_MULTIPLE_STRING_VALUE: 24,
  STRATEGY_PARAMETER_TYPE_COUNTRY: 25,
  STRATEGY_PARAMETER_TYPE_LANGUAGE: 26,
  STRATEGY_PARAMETER_TYPE_TENOR: 27,
  STRATEGY_PARAMETER_TYPE_TZ_TIMESTAMP: 28,
  STRATEGY_PARAMETER_TYPE_TZ_TIME_ONLY: 29
};

/**
 * @enum {number}
 */
proto.Common.InstrumentPartyIDSourceEnum = {
  INSTRUMENT_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  INSTRUMENT_PARTY_ID_SOURCE_BIC: 3,
  INSTRUMENT_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  INSTRUMENT_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  INSTRUMENT_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  INSTRUMENT_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  INSTRUMENT_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  INSTRUMENT_PARTY_ID_SOURCE_PROPRIETARY: 9,
  INSTRUMENT_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  INSTRUMENT_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  INSTRUMENT_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  INSTRUMENT_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  INSTRUMENT_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  INSTRUMENT_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  INSTRUMENT_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.InstrumentPartyRoleEnum = {
  INSTRUMENT_PARTY_ROLE_UNSPECIFIED: 0,
  INSTRUMENT_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  INSTRUMENT_PARTY_ROLE_CLEARING_FIRM: 2,
  INSTRUMENT_PARTY_ROLE_CLIENT_ID: 3,
  INSTRUMENT_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  INSTRUMENT_PARTY_ROLE_CONTRA_FIRM: 5,
  INSTRUMENT_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  INSTRUMENT_PARTY_ROLE_ENTERING_FIRM: 7,
  INSTRUMENT_PARTY_ROLE_EXECUTING_FIRM: 8,
  INSTRUMENT_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  INSTRUMENT_PARTY_ROLE_EXECUTING_TRADER: 10,
  INSTRUMENT_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  INSTRUMENT_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  INSTRUMENT_PARTY_ROLE_INTRODUCING_FIRM: 13,
  INSTRUMENT_PARTY_ROLE_INVESTOR_ID: 14,
  INSTRUMENT_PARTY_ROLE_LOCATE: 15,
  INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  INSTRUMENT_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  INSTRUMENT_PARTY_ROLE_SPONSORING_FIRM: 19,
  INSTRUMENT_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  INSTRUMENT_PARTY_ROLE_AGENT: 21,
  INSTRUMENT_PARTY_ROLE_BENEFICIARY: 22,
  INSTRUMENT_PARTY_ROLE_BUYER: 23,
  INSTRUMENT_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  INSTRUMENT_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  INSTRUMENT_PARTY_ROLE_CONTRA_TRADER: 26,
  INSTRUMENT_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  INSTRUMENT_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  INSTRUMENT_PARTY_ROLE_CUSTODIAN: 29,
  INSTRUMENT_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  INSTRUMENT_PARTY_ROLE_ENTERING_TRADER: 31,
  INSTRUMENT_PARTY_ROLE_EXCHANGE: 32,
  INSTRUMENT_PARTY_ROLE_INTERESTED_PARTY: 33,
  INSTRUMENT_PARTY_ROLE_INTERMEDIARY: 34,
  INSTRUMENT_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  INSTRUMENT_PARTY_ROLE_POSITION_ACCOUNT: 36,
  INSTRUMENT_PARTY_ROLE_REGULATORY_BODY: 37,
  INSTRUMENT_PARTY_ROLE_SUB_CUSTODIAN: 38,
  INSTRUMENT_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  INSTRUMENT_PARTY_ROLE_INTRODUCING_BROKER: 40,
  INSTRUMENT_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  INSTRUMENT_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  INSTRUMENT_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  INSTRUMENT_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  INSTRUMENT_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  INSTRUMENT_PARTY_ROLE_ASSET_MANAGER: 46,
  INSTRUMENT_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  INSTRUMENT_PARTY_ROLE_FOREIGN_FIRM: 48,
  INSTRUMENT_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  INSTRUMENT_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  INSTRUMENT_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  INSTRUMENT_PARTY_ROLE_SENDER_LOCATION: 52,
  INSTRUMENT_PARTY_ROLE_SESSION_ID: 53,
  INSTRUMENT_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  INSTRUMENT_PARTY_ROLE_TRADER_MNEMONIC: 55,
  INSTRUMENT_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  INSTRUMENT_PARTY_ROLE_ENTERING_UNIT: 57,
  INSTRUMENT_PARTY_ROLE_EXECUTING_UNIT: 58,
  INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  INSTRUMENT_PARTY_ROLE_DESK_ID: 62,
  INSTRUMENT_PARTY_ROLE_EXECUTION_VENUE: 63,
  INSTRUMENT_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  INSTRUMENT_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  INSTRUMENT_PARTY_ROLE_INVESTMENT_FIRM: 66,
  INSTRUMENT_PARTY_ROLE_LOCATION_ID: 67,
  INSTRUMENT_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  INSTRUMENT_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  INSTRUMENT_PARTY_ROLE_MARKET_MAKER: 70,
  INSTRUMENT_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  INSTRUMENT_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  INSTRUMENT_PARTY_ROLE_REGULATED_MARKET: 73,
  INSTRUMENT_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  INSTRUMENT_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  INSTRUMENT_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  INSTRUMENT_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  INSTRUMENT_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  INSTRUMENT_PARTY_ROLE_PRIME_BROKER: 79,
  INSTRUMENT_PARTY_ROLE_STEP_OUT_FIRM: 80,
  INSTRUMENT_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  INSTRUMENT_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  INSTRUMENT_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.InstrumentPartySubIDTypeEnum = {
  INSTRUMENT_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  INSTRUMENT_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  INSTRUMENT_PARTY_SUB_ID_TYPE_BIC: 2,
  INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  INSTRUMENT_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  INSTRUMENT_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  INSTRUMENT_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  INSTRUMENT_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  INSTRUMENT_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  INSTRUMENT_PARTY_SUB_ID_TYPE_FIRM: 10,
  INSTRUMENT_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  INSTRUMENT_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  INSTRUMENT_PARTY_SUB_ID_TYPE_PERSON: 14,
  INSTRUMENT_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  INSTRUMENT_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  INSTRUMENT_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  INSTRUMENT_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  INSTRUMENT_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  INSTRUMENT_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  INSTRUMENT_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  INSTRUMENT_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION: 30,
  INSTRUMENT_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  INSTRUMENT_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  INSTRUMENT_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingInstrumentPartyIDSourceEnum = {
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_BIC: 3,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_PROPRIETARY: 9,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  UNDERLYING_INSTRUMENT_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingInstrumentPartyRoleEnum = {
  UNDERLYING_INSTRUMENT_PARTY_ROLE_UNSPECIFIED: 0,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CLEARING_FIRM: 2,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CLIENT_ID: 3,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_FIRM: 5,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ENTERING_FIRM: 7,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXECUTING_FIRM: 8,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXECUTING_TRADER: 10,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INTRODUCING_FIRM: 13,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INVESTOR_ID: 14,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_LOCATE: 15,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SPONSORING_FIRM: 19,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_AGENT: 21,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_BENEFICIARY: 22,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_BUYER: 23,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_TRADER: 26,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CUSTODIAN: 29,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ENTERING_TRADER: 31,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXCHANGE: 32,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INTERESTED_PARTY: 33,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INTERMEDIARY: 34,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_POSITION_ACCOUNT: 36,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_REGULATORY_BODY: 37,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SUB_CUSTODIAN: 38,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INTRODUCING_BROKER: 40,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ASSET_MANAGER: 46,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_FOREIGN_FIRM: 48,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SENDER_LOCATION: 52,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SESSION_ID: 53,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_TRADER_MNEMONIC: 55,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ENTERING_UNIT: 57,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXECUTING_UNIT: 58,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_DESK_ID: 62,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_EXECUTION_VENUE: 63,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_INVESTMENT_FIRM: 66,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_LOCATION_ID: 67,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_MARKET_MAKER: 70,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_REGULATED_MARKET: 73,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_PRIME_BROKER: 79,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_STEP_OUT_FIRM: 80,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  UNDERLYING_INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.UnderlyingInstrumentPartySubIDTypeEnum = {
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_BIC: 2,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_FIRM: 10,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_PERSON: 14,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION: 30,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  UNDERLYING_INSTRUMENT_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.DisplayWhenEnum = {
  DISPLAY_WHEN_UNSPECIFIED: 0,
  DISPLAY_WHEN_EXHAUST: 1,
  DISPLAY_WHEN_IMMEDIATE: 2
};

/**
 * @enum {number}
 */
proto.Common.DisplayMethodEnum = {
  DISPLAY_METHOD_UNSPECIFIED: 0,
  DISPLAY_METHOD_INITIAL: 1,
  DISPLAY_METHOD_NEW: 2,
  DISPLAY_METHOD_RANDOM: 3,
  DISPLAY_METHOD_UNDISCLOSED: 4
};

/**
 * @enum {number}
 */
proto.Common.TriggerTypeEnum = {
  TRIGGER_TYPE_UNSPECIFIED: 0,
  TRIGGER_TYPE_NEXT_AUCTION: 1,
  TRIGGER_TYPE_PARTIAL_EXECUTION: 2,
  TRIGGER_TYPE_PRICE_MOVEMENT: 3,
  TRIGGER_TYPE_SPECIFIED_TRADING_SESSION: 4
};

/**
 * @enum {number}
 */
proto.Common.TriggerActionEnum = {
  TRIGGER_ACTION_UNSPECIFIED: 0,
  TRIGGER_ACTION_ACTIVATE: 1,
  TRIGGER_ACTION_CANCEL: 2,
  TRIGGER_ACTION_MODIFY: 3
};

/**
 * @enum {number}
 */
proto.Common.TriggerSecurityIDSourceEnum = {
  TRIGGER_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  TRIGGER_SECURITY_ID_SOURCE_CUSIP: 1,
  TRIGGER_SECURITY_ID_SOURCE_QUIK: 2,
  TRIGGER_SECURITY_ID_SOURCE_SEDOL: 3,
  TRIGGER_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  TRIGGER_SECURITY_ID_SOURCE_RIC_CODE: 5,
  TRIGGER_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  TRIGGER_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  TRIGGER_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  TRIGGER_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  TRIGGER_SECURITY_ID_SOURCE_BELGIAN: 10,
  TRIGGER_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  TRIGGER_SECURITY_ID_SOURCE_COMMON: 12,
  TRIGGER_SECURITY_ID_SOURCE_DUTCH: 13,
  TRIGGER_SECURITY_ID_SOURCE_SICOVAM: 14,
  TRIGGER_SECURITY_ID_SOURCE_VALOREN: 15,
  TRIGGER_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  TRIGGER_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  TRIGGER_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  TRIGGER_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  TRIGGER_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  TRIGGER_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  TRIGGER_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.TriggerPriceTypeEnum = {
  TRIGGER_PRICE_TYPE_UNSPECIFIED: 0,
  TRIGGER_PRICE_TYPE_BEST_BID: 1,
  TRIGGER_PRICE_TYPE_BEST_BID_OR_LAST_TRADE: 2,
  TRIGGER_PRICE_TYPE_BEST_MID: 3,
  TRIGGER_PRICE_TYPE_BEST_OFFER: 4,
  TRIGGER_PRICE_TYPE_BEST_OFFER_OR_LAST_TRADE: 5,
  TRIGGER_PRICE_TYPE_LAST_TRADE: 6
};

/**
 * @enum {number}
 */
proto.Common.TriggerPriceTypeScopeEnum = {
  TRIGGER_PRICE_TYPE_SCOPE_UNSPECIFIED: 0,
  TRIGGER_PRICE_TYPE_SCOPE_GLOBAL: 1,
  TRIGGER_PRICE_TYPE_SCOPE_LOCAL: 2,
  TRIGGER_PRICE_TYPE_SCOPE_NATIONAL: 3,
  TRIGGER_PRICE_TYPE_SCOPE_NONE: 4
};

/**
 * @enum {number}
 */
proto.Common.TriggerPriceDirectionEnum = {
  TRIGGER_PRICE_DIRECTION_UNSPECIFIED: 0,
  TRIGGER_PRICE_DIRECTION_DOWN: 1,
  TRIGGER_PRICE_DIRECTION_UP: 2
};

/**
 * @enum {number}
 */
proto.Common.TriggerOrderTypeEnum = {
  TRIGGER_ORDER_TYPE_UNSPECIFIED: 0,
  TRIGGER_ORDER_TYPE_LIMIT: 1,
  TRIGGER_ORDER_TYPE_MARKET: 2
};

/**
 * @enum {number}
 */
proto.Common.RootPartyIDSourceEnum = {
  ROOT_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  ROOT_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  ROOT_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  ROOT_PARTY_ID_SOURCE_BIC: 3,
  ROOT_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  ROOT_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  ROOT_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  ROOT_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  ROOT_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  ROOT_PARTY_ID_SOURCE_PROPRIETARY: 9,
  ROOT_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  ROOT_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  ROOT_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  ROOT_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  ROOT_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  ROOT_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  ROOT_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  ROOT_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  ROOT_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.RootPartyRoleEnum = {
  ROOT_PARTY_ROLE_UNSPECIFIED: 0,
  ROOT_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  ROOT_PARTY_ROLE_CLEARING_FIRM: 2,
  ROOT_PARTY_ROLE_CLIENT_ID: 3,
  ROOT_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  ROOT_PARTY_ROLE_CONTRA_FIRM: 5,
  ROOT_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  ROOT_PARTY_ROLE_ENTERING_FIRM: 7,
  ROOT_PARTY_ROLE_EXECUTING_FIRM: 8,
  ROOT_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  ROOT_PARTY_ROLE_EXECUTING_TRADER: 10,
  ROOT_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  ROOT_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  ROOT_PARTY_ROLE_INTRODUCING_FIRM: 13,
  ROOT_PARTY_ROLE_INVESTOR_ID: 14,
  ROOT_PARTY_ROLE_LOCATE: 15,
  ROOT_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  ROOT_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  ROOT_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  ROOT_PARTY_ROLE_SPONSORING_FIRM: 19,
  ROOT_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  ROOT_PARTY_ROLE_AGENT: 21,
  ROOT_PARTY_ROLE_BENEFICIARY: 22,
  ROOT_PARTY_ROLE_BUYER: 23,
  ROOT_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  ROOT_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  ROOT_PARTY_ROLE_CONTRA_TRADER: 26,
  ROOT_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  ROOT_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  ROOT_PARTY_ROLE_CUSTODIAN: 29,
  ROOT_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  ROOT_PARTY_ROLE_ENTERING_TRADER: 31,
  ROOT_PARTY_ROLE_EXCHANGE: 32,
  ROOT_PARTY_ROLE_INTERESTED_PARTY: 33,
  ROOT_PARTY_ROLE_INTERMEDIARY: 34,
  ROOT_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  ROOT_PARTY_ROLE_POSITION_ACCOUNT: 36,
  ROOT_PARTY_ROLE_REGULATORY_BODY: 37,
  ROOT_PARTY_ROLE_SUB_CUSTODIAN: 38,
  ROOT_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  ROOT_PARTY_ROLE_INTRODUCING_BROKER: 40,
  ROOT_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  ROOT_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  ROOT_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  ROOT_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  ROOT_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  ROOT_PARTY_ROLE_ASSET_MANAGER: 46,
  ROOT_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  ROOT_PARTY_ROLE_FOREIGN_FIRM: 48,
  ROOT_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  ROOT_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  ROOT_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  ROOT_PARTY_ROLE_SENDER_LOCATION: 52,
  ROOT_PARTY_ROLE_SESSION_ID: 53,
  ROOT_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  ROOT_PARTY_ROLE_TRADER_MNEMONIC: 55,
  ROOT_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  ROOT_PARTY_ROLE_ENTERING_UNIT: 57,
  ROOT_PARTY_ROLE_EXECUTING_UNIT: 58,
  ROOT_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  ROOT_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  ROOT_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  ROOT_PARTY_ROLE_DESK_ID: 62,
  ROOT_PARTY_ROLE_EXECUTION_VENUE: 63,
  ROOT_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  ROOT_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  ROOT_PARTY_ROLE_INVESTMENT_FIRM: 66,
  ROOT_PARTY_ROLE_LOCATION_ID: 67,
  ROOT_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  ROOT_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  ROOT_PARTY_ROLE_MARKET_MAKER: 70,
  ROOT_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  ROOT_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  ROOT_PARTY_ROLE_REGULATED_MARKET: 73,
  ROOT_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  ROOT_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  ROOT_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  ROOT_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  ROOT_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  ROOT_PARTY_ROLE_PRIME_BROKER: 79,
  ROOT_PARTY_ROLE_STEP_OUT_FIRM: 80,
  ROOT_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  ROOT_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  ROOT_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  ROOT_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.RootPartySubIDTypeEnum = {
  ROOT_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  ROOT_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  ROOT_PARTY_SUB_ID_TYPE_BIC: 2,
  ROOT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  ROOT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  ROOT_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  ROOT_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  ROOT_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  ROOT_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  ROOT_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  ROOT_PARTY_SUB_ID_TYPE_FIRM: 10,
  ROOT_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  ROOT_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  ROOT_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  ROOT_PARTY_SUB_ID_TYPE_PERSON: 14,
  ROOT_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  ROOT_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  ROOT_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  ROOT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  ROOT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  ROOT_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  ROOT_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  ROOT_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  ROOT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  ROOT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  ROOT_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  ROOT_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  ROOT_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  ROOT_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  ROOT_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  ROOT_PARTY_SUB_ID_TYPE_LOCATION: 30,
  ROOT_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  ROOT_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  ROOT_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.TradSesUpdateActionEnum = {
  TRAD_SES_UPDATE_ACTION_UNSPECIFIED: 0,
  TRAD_SES_UPDATE_ACTION_ADD: 1,
  TRAD_SES_UPDATE_ACTION_DELETE: 2,
  TRAD_SES_UPDATE_ACTION_MODIFY: 3
};

/**
 * @enum {number}
 */
proto.Common.TradSesMethodEnum = {
  TRAD_SES_METHOD_UNSPECIFIED: 0,
  TRAD_SES_METHOD_ELECTRONIC: 1,
  TRAD_SES_METHOD_OPEN_OUTCRY: 2,
  TRAD_SES_METHOD_TWO_PARTY: 3
};

/**
 * @enum {number}
 */
proto.Common.TradSesModeEnum = {
  TRAD_SES_MODE_UNSPECIFIED: 0,
  TRAD_SES_MODE_PRODUCTION: 1,
  TRAD_SES_MODE_SIMULATED: 2,
  TRAD_SES_MODE_TESTING: 3
};

/**
 * @enum {number}
 */
proto.Common.TradSesStatusEnum = {
  TRAD_SES_STATUS_UNSPECIFIED: 0,
  TRAD_SES_STATUS_CLOSED: 1,
  TRAD_SES_STATUS_HALTED: 2,
  TRAD_SES_STATUS_OPEN: 3,
  TRAD_SES_STATUS_PRE_CLOSE: 4,
  TRAD_SES_STATUS_PRE_OPEN: 5,
  TRAD_SES_STATUS_REQUEST_REJECTED: 6,
  TRAD_SES_STATUS_UNKNOWN: 7
};

/**
 * @enum {number}
 */
proto.Common.TradSesStatusRejReasonEnum = {
  TRAD_SES_STATUS_REJ_REASON_UNSPECIFIED: 0,
  TRAD_SES_STATUS_REJ_REASON_UNKNOWN_OR_INVALID_TRADING_SESSION_ID: 1,
  TRAD_SES_STATUS_REJ_REASON_OTHER: 2
};

/**
 * @enum {number}
 */
proto.Common.RefMsgTypeEnum = {
  REF_MSG_TYPE_ADJUSTED_POSITION_REPORT: 0,
  REF_MSG_TYPE_ADVERTISEMENT: 1,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION: 2,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION_ACK: 3,
  REF_MSG_TYPE_ALLOCATION_INSTRUCTION_ALERT: 4,
  REF_MSG_TYPE_ALLOCATION_REPORT: 5,
  REF_MSG_TYPE_ALLOCATION_REPORT_ACK: 6,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REPORT: 7,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REQUEST: 8,
  REF_MSG_TYPE_APPLICATION_MESSAGE_REQUEST_ACK: 9,
  REF_MSG_TYPE_ASSIGNMENT_REPORT: 10,
  REF_MSG_TYPE_BID_REQUEST: 11,
  REF_MSG_TYPE_BID_RESPONSE: 12,
  REF_MSG_TYPE_BUSINESS_MESSAGE_REJECT: 13,
  REF_MSG_TYPE_COLLATERAL_ASSIGNMENT: 14,
  REF_MSG_TYPE_COLLATERAL_INQUIRY: 15,
  REF_MSG_TYPE_COLLATERAL_INQUIRY_ACK: 16,
  REF_MSG_TYPE_COLLATERAL_REPORT: 17,
  REF_MSG_TYPE_COLLATERAL_REQUEST: 18,
  REF_MSG_TYPE_COLLATERAL_RESPONSE: 19,
  REF_MSG_TYPE_CONFIRMATION: 20,
  REF_MSG_TYPE_CONFIRMATION_ACK: 21,
  REF_MSG_TYPE_CONFIRMATION_REQUEST: 22,
  REF_MSG_TYPE_CONTRARY_INTENTION_REPORT: 23,
  REF_MSG_TYPE_CROSS_ORDER_CANCEL_REPLACE_REQUEST: 24,
  REF_MSG_TYPE_CROSS_ORDER_CANCEL_REQUEST: 25,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST: 26,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST_REQUEST: 27,
  REF_MSG_TYPE_DERIVATIVE_SECURITY_LIST_UPDATE_REPORT: 28,
  REF_MSG_TYPE_DONT_KNOW_TRADE: 29,
  REF_MSG_TYPE_EMAIL: 30,
  REF_MSG_TYPE_EXECUTION_ACKNOWLEDGEMENT: 31,
  REF_MSG_TYPE_EXECUTION_REPORT: 32,
  REF_MSG_TYPE_HEARTBEAT: 33,
  REF_MSG_TYPE_IOI: 34,
  REF_MSG_TYPE_LIST_CANCEL_REQUEST: 35,
  REF_MSG_TYPE_LIST_EXECUTE: 36,
  REF_MSG_TYPE_LIST_STATUS: 37,
  REF_MSG_TYPE_LIST_STATUS_REQUEST: 38,
  REF_MSG_TYPE_LIST_STRIKE_PRICE: 39,
  REF_MSG_TYPE_LOGON: 40,
  REF_MSG_TYPE_LOGOUT: 41,
  REF_MSG_TYPE_MARKET_DATA_INCREMENTAL_REFRESH: 42,
  REF_MSG_TYPE_MARKET_DATA_REQUEST: 43,
  REF_MSG_TYPE_MARKET_DATA_REQUEST_REJECT: 44,
  REF_MSG_TYPE_MARKET_DATA_SNAPSHOT_FULL_REFRESH: 45,
  REF_MSG_TYPE_MARKET_DEFINITION: 46,
  REF_MSG_TYPE_MARKET_DEFINITION_REQUEST: 47,
  REF_MSG_TYPE_MARKET_DEFINITION_UPDATE_REPORT: 48,
  REF_MSG_TYPE_MASS_QUOTE: 49,
  REF_MSG_TYPE_MASS_QUOTE_ACKNOWLEDGEMENT: 50,
  REF_MSG_TYPE_MULTILEG_ORDER_CANCEL_REPLACE: 51,
  REF_MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_REQUEST: 52,
  REF_MSG_TYPE_NETWORK_COUNTERPARTY_SYSTEM_STATUS_RESPONSE: 53,
  REF_MSG_TYPE_NEWS: 54,
  REF_MSG_TYPE_NEW_ORDER_CROSS: 55,
  REF_MSG_TYPE_NEW_ORDER_LIST: 56,
  REF_MSG_TYPE_NEW_ORDER_MULTILEG: 57,
  REF_MSG_TYPE_NEW_ORDER_SINGLE: 58,
  REF_MSG_TYPE_ORDER_CANCEL_REJECT: 59,
  REF_MSG_TYPE_ORDER_CANCEL_REPLACE_REQUEST: 60,
  REF_MSG_TYPE_ORDER_CANCEL_REQUEST: 61,
  REF_MSG_TYPE_ORDER_MASS_ACTION_REPORT: 62,
  REF_MSG_TYPE_ORDER_MASS_ACTION_REQUEST: 63,
  REF_MSG_TYPE_ORDER_MASS_CANCEL_REPORT: 64,
  REF_MSG_TYPE_ORDER_MASS_CANCEL_REQUEST: 65,
  REF_MSG_TYPE_ORDER_MASS_STATUS_REQUEST: 66,
  REF_MSG_TYPE_ORDER_STATUS_REQUEST: 67,
  REF_MSG_TYPE_POSITION_MAINTENANCE_REPORT: 68,
  REF_MSG_TYPE_POSITION_MAINTENANCE_REQUEST: 69,
  REF_MSG_TYPE_POSITION_REPORT: 70,
  REF_MSG_TYPE_QUOTE: 71,
  REF_MSG_TYPE_QUOTE_CANCEL: 72,
  REF_MSG_TYPE_QUOTE_REQUEST: 73,
  REF_MSG_TYPE_QUOTE_REQUEST_REJECT: 74,
  REF_MSG_TYPE_QUOTE_RESPONSE: 75,
  REF_MSG_TYPE_QUOTE_STATUS_REPORT: 76,
  REF_MSG_TYPE_QUOTE_STATUS_REQUEST: 77,
  REF_MSG_TYPE_REGISTRATION_INSTRUCTIONS: 78,
  REF_MSG_TYPE_REGISTRATION_INSTRUCTIONS_RESPONSE: 79,
  REF_MSG_TYPE_REJECT: 80,
  REF_MSG_TYPE_REQUEST_FOR_POSITIONS: 81,
  REF_MSG_TYPE_REQUEST_FOR_POSITIONS_ACK: 82,
  REF_MSG_TYPE_RESEND_REQUEST: 83,
  REF_MSG_TYPE_RFQ_REQUEST: 84,
  REF_MSG_TYPE_SECURITY_DEFINITION: 85,
  REF_MSG_TYPE_SECURITY_DEFINITION_REQUEST: 86,
  REF_MSG_TYPE_SECURITY_DEFINITION_UPDATE_REPORT: 87,
  REF_MSG_TYPE_SECURITY_LIST: 88,
  REF_MSG_TYPE_SECURITY_LIST_REQUEST: 89,
  REF_MSG_TYPE_SECURITY_LIST_UPDATE_REPORT: 90,
  REF_MSG_TYPE_SECURITY_STATUS: 91,
  REF_MSG_TYPE_SECURITY_STATUS_REQUEST: 92,
  REF_MSG_TYPE_SECURITY_TYPES: 93,
  REF_MSG_TYPE_SECURITY_TYPE_REQUEST: 94,
  REF_MSG_TYPE_SEQUENCE_RESET: 95,
  REF_MSG_TYPE_SETTLEMENT_INSTRUCTIONS: 96,
  REF_MSG_TYPE_SETTLEMENT_INSTRUCTION_REQUEST: 97,
  REF_MSG_TYPE_SETTLEMENT_OBLIGATION_REPORT: 98,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REPORT: 99,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REPORT_ACK: 100,
  REF_MSG_TYPE_STREAM_ASSIGNMENT_REQUEST: 101,
  REF_MSG_TYPE_TEST_REQUEST: 102,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT: 103,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_ACK: 104,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST: 105,
  REF_MSG_TYPE_TRADE_CAPTURE_REPORT_REQUEST_ACK: 106,
  REF_MSG_TYPE_TRADING_SESSION_LIST: 107,
  REF_MSG_TYPE_TRADING_SESSION_LIST_REQUEST: 108,
  REF_MSG_TYPE_TRADING_SESSION_LIST_UPDATE_REPORT: 109,
  REF_MSG_TYPE_TRADING_SESSION_STATUS: 110,
  REF_MSG_TYPE_TRADING_SESSION_STATUS_REQUEST: 111,
  REF_MSG_TYPE_UNSPECIFIED: 112,
  REF_MSG_TYPE_USER_NOTIFICATION: 113,
  REF_MSG_TYPE_USER_REQUEST: 114,
  REF_MSG_TYPE_USER_RESPONSE: 115,
  REF_MSG_TYPE_XMLNON_FIX: 116
};

/**
 * @enum {number}
 */
proto.Common.MsgDirectionEnum = {
  MSG_DIRECTION_UNSPECIFIED: 0,
  MSG_DIRECTION_RECEIVE: 1,
  MSG_DIRECTION_SEND: 2
};

/**
 * @enum {number}
 */
proto.Common.RefApplVerIDEnum = {
  REF_APPL_VER_ID_UNSPECIFIED: 0,
  REF_APPL_VER_ID_FIX27: 1,
  REF_APPL_VER_ID_FIX30: 2,
  REF_APPL_VER_ID_FIX40: 3,
  REF_APPL_VER_ID_FIX41: 4,
  REF_APPL_VER_ID_FIX42: 5,
  REF_APPL_VER_ID_FIX43: 6,
  REF_APPL_VER_ID_FIX44: 7,
  REF_APPL_VER_ID_FIX50: 8,
  REF_APPL_VER_ID_FIX50SP1: 9,
  REF_APPL_VER_ID_FIX50SP2: 10
};

/**
 * @enum {number}
 */
proto.Common.SettlObligSourceEnum = {
  SETTL_OBLIG_SOURCE_UNSPECIFIED: 0,
  SETTL_OBLIG_SOURCE_INSTRUCTIONS_FOR_INSTITUTION: 1,
  SETTL_OBLIG_SOURCE_INSTRUCTIONS_OF_BROKER: 2,
  SETTL_OBLIG_SOURCE_INVESTOR: 3
};

/**
 * @enum {number}
 */
proto.Common.TickRuleTypeEnum = {
  TICK_RULE_TYPE_UNSPECIFIED: 0,
  TICK_RULE_TYPE_FIXED: 1,
  TICK_RULE_TYPE_REGULAR: 2,
  TICK_RULE_TYPE_SETTLED_AS_ASPREAD_LEG: 3,
  TICK_RULE_TYPE_TRADED_AS_ASPREAD_LEG: 4,
  TICK_RULE_TYPE_VARIABLE: 5
};

/**
 * @enum {number}
 */
proto.Common.StrikeExerciseStyleEnum = {
  STRIKE_EXERCISE_STYLE_UNSPECIFIED: 0,
  STRIKE_EXERCISE_STYLE_AMERICAN: 1,
  STRIKE_EXERCISE_STYLE_BERMUDA: 2,
  STRIKE_EXERCISE_STYLE_EUROPEAN: 3
};

/**
 * @enum {number}
 */
proto.Common.MaturityMonthYearFormatEnum = {
  MATURITY_MONTH_YEAR_FORMAT_UNSPECIFIED: 0,
  MATURITY_MONTH_YEAR_FORMAT_YEAR_MONTH_DAY: 1,
  MATURITY_MONTH_YEAR_FORMAT_YEAR_MONTH_ONLY: 2,
  MATURITY_MONTH_YEAR_FORMAT_YEAR_MONTH_WEEK: 3
};

/**
 * @enum {number}
 */
proto.Common.MaturityMonthYearIncrementUnitsEnum = {
  MATURITY_MONTH_YEAR_INCREMENT_UNITS_UNSPECIFIED: 0,
  MATURITY_MONTH_YEAR_INCREMENT_UNITS_DAYS: 1,
  MATURITY_MONTH_YEAR_INCREMENT_UNITS_MONTHS: 2,
  MATURITY_MONTH_YEAR_INCREMENT_UNITS_WEEKS: 3,
  MATURITY_MONTH_YEAR_INCREMENT_UNITS_YEARS: 4
};

/**
 * @enum {number}
 */
proto.Common.SecondaryPriceLimitTypeEnum = {
  SECONDARY_PRICE_LIMIT_TYPE_UNSPECIFIED: 0,
  SECONDARY_PRICE_LIMIT_TYPE_PERCENTAGE: 1,
  SECONDARY_PRICE_LIMIT_TYPE_PRICE: 2,
  SECONDARY_PRICE_LIMIT_TYPE_TICKS: 3
};

/**
 * @enum {number}
 */
proto.Common.PriceLimitTypeEnum = {
  PRICE_LIMIT_TYPE_UNSPECIFIED: 0,
  PRICE_LIMIT_TYPE_PERCENTAGE: 1,
  PRICE_LIMIT_TYPE_PRICE: 2,
  PRICE_LIMIT_TYPE_TICKS: 3
};

/**
 * @enum {number}
 */
proto.Common.MDBookTypeEnum = {
  MD_BOOK_TYPE_UNSPECIFIED: 0,
  MD_BOOK_TYPE_ORDER_DEPTH: 1,
  MD_BOOK_TYPE_PRICE_DEPTH: 2,
  MD_BOOK_TYPE_TOP_OF_BOOK: 3
};

/**
 * @enum {number}
 */
proto.Common.LotTypeEnum = {
  LOT_TYPE_UNSPECIFIED: 0,
  LOT_TYPE_BLOCK_LOT: 1,
  LOT_TYPE_ODD_LOT: 2,
  LOT_TYPE_ROUND_LOT: 3,
  LOT_TYPE_ROUND_LOT_BASED_UPON: 4
};

/**
 * @enum {number}
 */
proto.Common.MatchTypeEnum = {
  MATCH_TYPE_UNSPECIFIED: 0,
  MATCH_TYPE_A1EXACT_MATCH_SUMMARIZED_QUANTITY: 1,
  MATCH_TYPE_A2EXACT_MATCH_SUMMARIZED_QUANTITY: 2,
  MATCH_TYPE_A3EXACT_MATCH_SUMMARIZED_QUANTITY: 3,
  MATCH_TYPE_A4EXACT_MATCH_SUMMARIZED_QUANTITY: 4,
  MATCH_TYPE_A5EXACT_MATCH_SUMMARIZED_QUANTITY: 5,
  MATCH_TYPE_ACTACCEPTED_TRADE: 6,
  MATCH_TYPE_ACTDEFAULT_AFTER_M2: 7,
  MATCH_TYPE_ACTDEFAULT_TRADE: 8,
  MATCH_TYPE_ACTM6MATCH: 9,
  MATCH_TYPE_EXACT_MATCH_MINUS_BADGES_TIMES: 10,
  MATCH_TYPE_EXACT_MATCH_PLUS2BADGES: 11,
  MATCH_TYPE_EXACT_MATCH_PLUS2BADGES_EXEC_TIME: 12,
  MATCH_TYPE_EXACT_MATCH_PLUS4BADGES: 13,
  MATCH_TYPE_EXACT_MATCH_PLUS4BADGES_EXEC_TIME: 14,
  MATCH_TYPE_EXACT_MATCH_PLUS_EXEC_TIME: 15,
  MATCH_TYPE_OCSLOCKED_IN: 16,
  MATCH_TYPE_STAMPED_ADVISORIES_OR_SPECIALIST_ACCEPTS: 17,
  MATCH_TYPE_SUMMARIZED_MATCH_MINUS_BADGES_TIMES: 18,
  MATCH_TYPE_AUTO_MATCH: 19,
  MATCH_TYPE_CALL_AUCTION: 20,
  MATCH_TYPE_CONFIRMED_TRADE_REPORT: 21,
  MATCH_TYPE_COUNTER_ORDER_SELECTION: 22,
  MATCH_TYPE_CROSS_AUCTION: 23,
  MATCH_TYPE_ONE_PARTY_TRADE_REPORT: 24,
  MATCH_TYPE_TWO_PARTY_TRADE_REPORT: 25,
  MATCH_TYPE_ISSUING: 26
};

/**
 * @enum {number}
 */
proto.Common.ExecInstValueEnum = {
  EXEC_INST_VALUE_UNSPECIFIED: 0,
  EXEC_INST_VALUE_ALL_OR_NONE: 1,
  EXEC_INST_VALUE_CALL_FIRST: 2,
  EXEC_INST_VALUE_DO_NOT_INCREASE: 3,
  EXEC_INST_VALUE_DO_NOT_REDUCE: 4,
  EXEC_INST_VALUE_GO_ALONG: 5,
  EXEC_INST_VALUE_HELD: 6,
  EXEC_INST_VALUE_NOT_HELD: 7,
  EXEC_INST_VALUE_NO_CROSS: 8,
  EXEC_INST_VALUE_OKTO_CROSS: 9,
  EXEC_INST_VALUE_OVER_THE_DAY: 10,
  EXEC_INST_VALUE_PARTICIPATE_DO_NOT_INITIATE: 11,
  EXEC_INST_VALUE_PERCENT_OF_VOLUME: 12,
  EXEC_INST_VALUE_STAY_ON_BID_SIDE: 13,
  EXEC_INST_VALUE_STAY_ON_OFFER_SIDE: 14,
  EXEC_INST_VALUE_STRICT_SCALE: 15,
  EXEC_INST_VALUE_TRY_TO_SCALE: 16,
  EXEC_INST_VALUE_WORK: 17,
  EXEC_INST_VALUE_INSTITUTIONS_ONLY: 18,
  EXEC_INST_VALUE_LAST_PEG: 19,
  EXEC_INST_VALUE_MARKET_PEG: 20,
  EXEC_INST_VALUE_MID_PRICE_PEG: 21,
  EXEC_INST_VALUE_NON_NEGOTIABLE: 22,
  EXEC_INST_VALUE_OPENING_PEG: 23,
  EXEC_INST_VALUE_PRIMARY_PEG: 24,
  EXEC_INST_VALUE_SUSPEND: 25,
  EXEC_INST_VALUE_CUSTOMER_DISPLAY_INSTRUCTION: 26,
  EXEC_INST_VALUE_NETTING: 27,
  EXEC_INST_VALUE_PEG_TO_VWAP: 28,
  EXEC_INST_VALUE_CANCEL_ON_SYSTEM_FAILURE: 29,
  EXEC_INST_VALUE_CANCEL_ON_TRADING_HALT: 30,
  EXEC_INST_VALUE_REINSTATE_ON_SYSTEM_FAILURE: 31,
  EXEC_INST_VALUE_REINSTATE_ON_TRADING_HALT: 32,
  EXEC_INST_VALUE_TRADE_ALONG: 33,
  EXEC_INST_VALUE_TRY_TO_STOP: 34,
  EXEC_INST_VALUE_CANCEL_IF_NOT_BEST: 35,
  EXEC_INST_VALUE_IGNORE_PRICE_VALIDITY_CHECKS: 36,
  EXEC_INST_VALUE_PEG_TO_LIMIT_PRICE: 37,
  EXEC_INST_VALUE_STRICT_LIMIT: 38,
  EXEC_INST_VALUE_TRAILING_STOP_PEG: 39,
  EXEC_INST_VALUE_WORK_TO_TARGET_STRATEGY: 40,
  EXEC_INST_VALUE_INTERMARKET_SWEEP: 41,
  EXEC_INST_VALUE_SINGLE_EXECUTION_REQUESTED_FOR_BLOCK_TRADE: 42,
  EXEC_INST_VALUE_EXTERNAL_ROUTING_ALLOWED: 43,
  EXEC_INST_VALUE_EXTERNAL_ROUTING_NOT_ALLOWED: 44,
  EXEC_INST_VALUE_IMBALANCE_ONLY: 45,
  EXEC_INST_VALUE_BEST_EXECUTION: 46,
  EXEC_INST_VALUE_FIXED_PEG_TO_LOCAL_BEST_BID_OR_OFFER_AT_TIME_OF_ORDER: 47,
  EXEC_INST_VALUE_CANCEL_ON_CONNECTION_LOSS: 48,
  EXEC_INST_VALUE_REINSTATE_ON_CONNECTION_LOSS: 49,
  EXEC_INST_VALUE_RELEASE_FROM_SUSPENSION: 50,
  EXEC_INST_VALUE_SUSPEND_ON_CONNECTION_LOSS: 51,
  EXEC_INST_VALUE_SUSPEND_ON_SYSTEM_FAILURE: 52,
  EXEC_INST_VALUE_SUSPEND_ON_TRADING_HALT: 53,
  EXEC_INST_VALUE_EXECUTE_AS_DELTA_NEUTRAL: 54,
  EXEC_INST_VALUE_EXECUTE_AS_DURATION_NEUTRAL: 55,
  EXEC_INST_VALUE_EXECUTE_AS_FX_NEUTRAL: 56
};

/**
 * @enum {number}
 */
proto.Common.TimeInForceEnum = {
  TIME_IN_FORCE_UNSPECIFIED: 0,
  TIME_IN_FORCE_AT_THE_OPENING: 1,
  TIME_IN_FORCE_DAY: 2,
  TIME_IN_FORCE_FILL_OR_KILL: 3,
  TIME_IN_FORCE_GOOD_TILL_CANCEL: 4,
  TIME_IN_FORCE_GOOD_TILL_CROSSING: 5,
  TIME_IN_FORCE_IMMEDIATE_OR_CANCEL: 6,
  TIME_IN_FORCE_GOOD_TILL_DATE: 7,
  TIME_IN_FORCE_AT_THE_CLOSE: 8,
  TIME_IN_FORCE_AT_CROSSING: 9,
  TIME_IN_FORCE_GOOD_THROUGH_CROSSING: 10
};

/**
 * @enum {number}
 */
proto.Common.OrdTypeEnum = {
  ORD_TYPE_UNSPECIFIED: 0,
  ORD_TYPE_LIMIT: 1,
  ORD_TYPE_LIMIT_ON_CLOSE: 2,
  ORD_TYPE_LIMIT_OR_BETTER: 3,
  ORD_TYPE_LIMIT_WITH_OR_WITHOUT: 4,
  ORD_TYPE_MARKET: 5,
  ORD_TYPE_MARKET_ON_CLOSE: 6,
  ORD_TYPE_ON_BASIS: 7,
  ORD_TYPE_ON_CLOSE: 8,
  ORD_TYPE_STOP: 9,
  ORD_TYPE_STOP_LIMIT: 10,
  ORD_TYPE_WITH_OR_WITHOUT: 11,
  ORD_TYPE_PEGGED: 12,
  ORD_TYPE_FOREX_MARKET: 13,
  ORD_TYPE_PREVIOUSLY_INDICATED: 14,
  ORD_TYPE_PREVIOUSLY_QUOTED: 15,
  ORD_TYPE_FOREX_LIMIT: 16,
  ORD_TYPE_FOREX_PREVIOUSLY_QUOTED: 17,
  ORD_TYPE_FOREX_SWAP: 18,
  ORD_TYPE_FUNARI: 19,
  ORD_TYPE_MARKET_IF_TOUCHED: 20,
  ORD_TYPE_MARKET_WITH_LEFT_OVER_AS_LIMIT: 21,
  ORD_TYPE_NEXT_FUND_VALUATION_POINT: 22,
  ORD_TYPE_PREVIOUS_FUND_VALUATION_POINT: 23,
  ORD_TYPE_COUNTER_ORDER_SELECTION: 24
};

/**
 * @enum {number}
 */
proto.Common.ExpirationCycleEnum = {
  EXPIRATION_CYCLE_UNSPECIFIED: 0,
  EXPIRATION_CYCLE_EXPIRE_ON_TRADING_SESSION_CLOSE: 1,
  EXPIRATION_CYCLE_EXPIRE_ON_TRADING_SESSION_OPEN: 2,
  EXPIRATION_CYCLE_SPECIFIED_EXPIRATION: 3
};

/**
 * @enum {number}
 */
proto.Common.ImpliedMarketIndicatorEnum = {
  IMPLIED_MARKET_INDICATOR_UNSPECIFIED: 0,
  IMPLIED_MARKET_INDICATOR_BOTH_IMPLIED_IN_AND_IMPLIED_OUT: 1,
  IMPLIED_MARKET_INDICATOR_IMPLIED_IN: 2,
  IMPLIED_MARKET_INDICATOR_IMPLIED_OUT: 3,
  IMPLIED_MARKET_INDICATOR_NOT_IMPLIED: 4
};

/**
 * @enum {number}
 */
proto.Common.MultilegModelEnum = {
  MULTILEG_MODEL_UNSPECIFIED: 0,
  MULTILEG_MODEL_PREDEFINED_MULTILEG_SECURITY: 1,
  MULTILEG_MODEL_USER_DEFINED: 2,
  MULTILEG_MODEL_USER_DEFINED_MULTILEG_SECURITY: 3
};

/**
 * @enum {number}
 */
proto.Common.MultilegPriceMethodEnum = {
  MULTILEG_PRICE_METHOD_UNSPECIFIED: 0,
  MULTILEG_PRICE_METHOD_CONTRACT_WEIGHTED_AVERAGE_PRICE: 1,
  MULTILEG_PRICE_METHOD_INDIVIDUAL: 2,
  MULTILEG_PRICE_METHOD_MULTIPLIED_PRICE: 3,
  MULTILEG_PRICE_METHOD_NET_PRICE: 4,
  MULTILEG_PRICE_METHOD_REVERSED_NET_PRICE: 5,
  MULTILEG_PRICE_METHOD_YIELD_DIFFERENCE: 6
};

/**
 * @enum {number}
 */
proto.Common.PriceTypeEnum = {
  PRICE_TYPE_UNSPECIFIED: 0,
  PRICE_TYPE_FIXED_AMOUNT: 1,
  PRICE_TYPE_PERCENTAGE: 2,
  PRICE_TYPE_PER_UNIT: 3,
  PRICE_TYPE_DISCOUNT: 4,
  PRICE_TYPE_PREMIUM: 5,
  PRICE_TYPE_SPREAD: 6,
  PRICE_TYPE_TEDPRICE: 7,
  PRICE_TYPE_TEDYIELD: 8,
  PRICE_TYPE_FIXED_CABINET_TRADE_PRICE: 9,
  PRICE_TYPE_VARIABLE_CABINET_TRADE_PRICE: 10,
  PRICE_TYPE_YIELD: 11,
  PRICE_TYPE_PRODUCT_TICKS_IN_EIGHTS: 12,
  PRICE_TYPE_PRODUCT_TICKS_IN_FOURTHS: 13,
  PRICE_TYPE_PRODUCT_TICKS_IN_HALFS: 14,
  PRICE_TYPE_PRODUCT_TICKS_IN_ONE_TWENTY_EIGHTS: 15,
  PRICE_TYPE_PRODUCT_TICKS_IN_SIXTEENTHS: 16,
  PRICE_TYPE_PRODUCT_TICKS_IN_SIXTY_FORTHS: 17,
  PRICE_TYPE_PRODUCT_TICKS_IN_THIRTY_SECONDS: 18
};

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrumentPartySubIDTypeEnum = {
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_APPLICATION: 1,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_BIC: 2,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_FIRM: 10,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_PERSON: 14,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_SYSTEM: 25,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_LOCATION: 30,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  DERIVATIVE_INSTRUMENT_PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrumentPartyIDSourceEnum = {
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_BIC: 3,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_PROPRIETARY: 9,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  DERIVATIVE_INSTRUMENT_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrumentPartyRoleEnum = {
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_UNSPECIFIED: 0,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CLEARING_FIRM: 2,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CLIENT_ID: 3,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_FIRM: 5,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ENTERING_FIRM: 7,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXECUTING_FIRM: 8,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXECUTING_TRADER: 10,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INTRODUCING_FIRM: 13,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INVESTOR_ID: 14,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_LOCATE: 15,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SPONSORING_FIRM: 19,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_AGENT: 21,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_BENEFICIARY: 22,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_BUYER: 23,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_TRADER: 26,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CUSTODIAN: 29,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ENTERING_TRADER: 31,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXCHANGE: 32,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INTERESTED_PARTY: 33,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INTERMEDIARY: 34,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_POSITION_ACCOUNT: 36,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_REGULATORY_BODY: 37,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SUB_CUSTODIAN: 38,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INTRODUCING_BROKER: 40,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ASSET_MANAGER: 46,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_FOREIGN_FIRM: 48,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SENDER_LOCATION: 52,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SESSION_ID: 53,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_TRADER_MNEMONIC: 55,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ENTERING_UNIT: 57,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXECUTING_UNIT: 58,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_DESK_ID: 62,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_EXECUTION_VENUE: 63,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_INVESTMENT_FIRM: 66,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_LOCATION_ID: 67,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_MARKET_MAKER: 70,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_REGULATED_MARKET: 73,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_PRIME_BROKER: 79,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_STEP_OUT_FIRM: 80,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  DERIVATIVE_INSTRUMENT_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrAttribTypeEnum = {
  DERIVATIVE_INSTR_ATTRIB_TYPE_UNSPECIFIED: 0,
  DERIVATIVE_INSTR_ATTRIB_TYPE_CALLABLE: 1,
  DERIVATIVE_INSTR_ATTRIB_TYPE_CALLABLE_BELOW_MATURITY_VALUE: 2,
  DERIVATIVE_INSTR_ATTRIB_TYPE_CALLABLE_WITHOUT_NOTICE: 3,
  DERIVATIVE_INSTR_ATTRIB_TYPE_COUPON_PERIOD: 4,
  DERIVATIVE_INSTR_ATTRIB_TYPE_ESCROWED_TO_MATURITY: 5,
  DERIVATIVE_INSTR_ATTRIB_TYPE_ESCROWED_TO_REDEMPTION_DATE: 6,
  DERIVATIVE_INSTR_ATTRIB_TYPE_FLAT: 7,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INDEXED: 8,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INTEREST_BEARING: 9,
  DERIVATIVE_INSTR_ATTRIB_TYPE_IN_DEFAULT: 10,
  DERIVATIVE_INSTR_ATTRIB_TYPE_LESS_FEE_FOR_PUT: 11,
  DERIVATIVE_INSTR_ATTRIB_TYPE_NO_PERIODIC_PAYMENTS: 12,
  DERIVATIVE_INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT: 13,
  DERIVATIVE_INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT_PRICE: 14,
  DERIVATIVE_INSTR_ATTRIB_TYPE_PRE_REFUNDED: 15,
  DERIVATIVE_INSTR_ATTRIB_TYPE_STEPPED_COUPON: 16,
  DERIVATIVE_INSTR_ATTRIB_TYPE_SUBJECT_TO_ALTERNATIVE_MINIMUM_TAX: 17,
  DERIVATIVE_INSTR_ATTRIB_TYPE_TAXABLE: 18,
  DERIVATIVE_INSTR_ATTRIB_TYPE_TEXT: 19,
  DERIVATIVE_INSTR_ATTRIB_TYPE_UNRATED: 20,
  DERIVATIVE_INSTR_ATTRIB_TYPE_VARIABLE_RATE: 21,
  DERIVATIVE_INSTR_ATTRIB_TYPE_WHEN: 22,
  DERIVATIVE_INSTR_ATTRIB_TYPE_ZERO_COUPON: 23,
  DERIVATIVE_INSTR_ATTRIB_TYPE_PRICE_TICK_RULES_FOR_SECURITY: 24,
  DERIVATIVE_INSTR_ATTRIB_TYPE_TRADE_TYPE_ELIGIBILITY_DETAILS_FOR_SECURITY: 25,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INSTRUMENT_DENOMINATOR: 26,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INSTRUMENT_NUMERATOR: 27,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INSTRUMENT_PRICE_PRECISION: 28,
  DERIVATIVE_INSTR_ATTRIB_TYPE_INSTRUMENT_STRIKE_PRICE: 29,
  DERIVATIVE_INSTR_ATTRIB_TYPE_TRADEABLE_INDICATOR: 30
};

/**
 * @enum {number}
 */
proto.Common.NestedInstrAttribTypeEnum = {
  NESTED_INSTR_ATTRIB_TYPE_UNSPECIFIED: 0,
  NESTED_INSTR_ATTRIB_TYPE_CALLABLE: 1,
  NESTED_INSTR_ATTRIB_TYPE_CALLABLE_BELOW_MATURITY_VALUE: 2,
  NESTED_INSTR_ATTRIB_TYPE_CALLABLE_WITHOUT_NOTICE: 3,
  NESTED_INSTR_ATTRIB_TYPE_COUPON_PERIOD: 4,
  NESTED_INSTR_ATTRIB_TYPE_ESCROWED_TO_MATURITY: 5,
  NESTED_INSTR_ATTRIB_TYPE_ESCROWED_TO_REDEMPTION_DATE: 6,
  NESTED_INSTR_ATTRIB_TYPE_FLAT: 7,
  NESTED_INSTR_ATTRIB_TYPE_INDEXED: 8,
  NESTED_INSTR_ATTRIB_TYPE_INTEREST_BEARING: 9,
  NESTED_INSTR_ATTRIB_TYPE_IN_DEFAULT: 10,
  NESTED_INSTR_ATTRIB_TYPE_LESS_FEE_FOR_PUT: 11,
  NESTED_INSTR_ATTRIB_TYPE_NO_PERIODIC_PAYMENTS: 12,
  NESTED_INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT: 13,
  NESTED_INSTR_ATTRIB_TYPE_ORIGINAL_ISSUE_DISCOUNT_PRICE: 14,
  NESTED_INSTR_ATTRIB_TYPE_PRE_REFUNDED: 15,
  NESTED_INSTR_ATTRIB_TYPE_STEPPED_COUPON: 16,
  NESTED_INSTR_ATTRIB_TYPE_SUBJECT_TO_ALTERNATIVE_MINIMUM_TAX: 17,
  NESTED_INSTR_ATTRIB_TYPE_TAXABLE: 18,
  NESTED_INSTR_ATTRIB_TYPE_TEXT: 19,
  NESTED_INSTR_ATTRIB_TYPE_UNRATED: 20,
  NESTED_INSTR_ATTRIB_TYPE_VARIABLE_RATE: 21,
  NESTED_INSTR_ATTRIB_TYPE_WHEN: 22,
  NESTED_INSTR_ATTRIB_TYPE_ZERO_COUPON: 23,
  NESTED_INSTR_ATTRIB_TYPE_PRICE_TICK_RULES_FOR_SECURITY: 24,
  NESTED_INSTR_ATTRIB_TYPE_TRADE_TYPE_ELIGIBILITY_DETAILS_FOR_SECURITY: 25,
  NESTED_INSTR_ATTRIB_TYPE_INSTRUMENT_DENOMINATOR: 26,
  NESTED_INSTR_ATTRIB_TYPE_INSTRUMENT_NUMERATOR: 27,
  NESTED_INSTR_ATTRIB_TYPE_INSTRUMENT_PRICE_PRECISION: 28,
  NESTED_INSTR_ATTRIB_TYPE_INSTRUMENT_STRIKE_PRICE: 29,
  NESTED_INSTR_ATTRIB_TYPE_TRADEABLE_INDICATOR: 30
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSymbolSfxEnum = {
  DERIVATIVE_SYMBOL_SFX_UNSPECIFIED: 0,
  DERIVATIVE_SYMBOL_SFX_EUCP_WITH_LUMP_SUM_INTEREST: 1,
  DERIVATIVE_SYMBOL_SFX_WHEN_ISSUED: 2
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSecurityIDSourceEnum = {
  DERIVATIVE_SECURITY_ID_SOURCE_UNSPECIFIED: 0,
  DERIVATIVE_SECURITY_ID_SOURCE_CUSIP: 1,
  DERIVATIVE_SECURITY_ID_SOURCE_QUIK: 2,
  DERIVATIVE_SECURITY_ID_SOURCE_SEDOL: 3,
  DERIVATIVE_SECURITY_ID_SOURCE_ISIN_NUMBER: 4,
  DERIVATIVE_SECURITY_ID_SOURCE_RIC_CODE: 5,
  DERIVATIVE_SECURITY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  DERIVATIVE_SECURITY_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  DERIVATIVE_SECURITY_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  DERIVATIVE_SECURITY_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  DERIVATIVE_SECURITY_ID_SOURCE_BELGIAN: 10,
  DERIVATIVE_SECURITY_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  DERIVATIVE_SECURITY_ID_SOURCE_COMMON: 12,
  DERIVATIVE_SECURITY_ID_SOURCE_DUTCH: 13,
  DERIVATIVE_SECURITY_ID_SOURCE_SICOVAM: 14,
  DERIVATIVE_SECURITY_ID_SOURCE_VALOREN: 15,
  DERIVATIVE_SECURITY_ID_SOURCE_WERTPAPIER: 16,
  DERIVATIVE_SECURITY_ID_SOURCE_CLEARING_HOUSE: 17,
  DERIVATIVE_SECURITY_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  DERIVATIVE_SECURITY_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  DERIVATIVE_SECURITY_ID_SOURCE_LETTER_OF_CREDIT: 20,
  DERIVATIVE_SECURITY_ID_SOURCE_ISDA_FPML_URL: 21,
  DERIVATIVE_SECURITY_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.DerivativeProductEnum = {
  DERIVATIVE_PRODUCT_UNSPECIFIED: 0,
  DERIVATIVE_PRODUCT_AGENCY: 1,
  DERIVATIVE_PRODUCT_COMMODITY: 2,
  DERIVATIVE_PRODUCT_CORPORATE: 3,
  DERIVATIVE_PRODUCT_CURRENCY: 4,
  DERIVATIVE_PRODUCT_EQUITY: 5,
  DERIVATIVE_PRODUCT_GOVERNMENT: 6,
  DERIVATIVE_PRODUCT_INDEX: 7,
  DERIVATIVE_PRODUCT_LOAN: 8,
  DERIVATIVE_PRODUCT_MONEYMARKET: 9,
  DERIVATIVE_PRODUCT_MORTGAGE: 10,
  DERIVATIVE_PRODUCT_MUNICIPAL: 11,
  DERIVATIVE_PRODUCT_OTHER: 12,
  DERIVATIVE_PRODUCT_FINANCING: 13
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSecurityTypeEnum = {
  DERIVATIVE_SECURITY_TYPE_UNSPECIFIED: 0,
  DERIVATIVE_SECURITY_TYPE_BANKERS_ACCEPTANCE: 1,
  DERIVATIVE_SECURITY_TYPE_CERTIFICATE_OF_DEPOSIT: 2,
  DERIVATIVE_SECURITY_TYPE_COLLATERALIZED_MORTGAGE_OBLIGATION: 3,
  DERIVATIVE_SECURITY_TYPE_COMMERCIAL_PAPER: 4,
  DERIVATIVE_SECURITY_TYPE_COMMON_STOCK: 5,
  DERIVATIVE_SECURITY_TYPE_CORPORATE_BOND: 6,
  DERIVATIVE_SECURITY_TYPE_CORPORATE_PRIVATE_PLACEMENT: 7,
  DERIVATIVE_SECURITY_TYPE_FOREIGN_EXCHANGE_CONTRACT: 8,
  DERIVATIVE_SECURITY_TYPE_FUTURE: 9,
  DERIVATIVE_SECURITY_TYPE_MISCELLANEOUS_PASS_THROUGH: 10,
  DERIVATIVE_SECURITY_TYPE_MORTGAGE_INTEREST_ONLY: 11,
  DERIVATIVE_SECURITY_TYPE_MORTGAGE_PRINCIPAL_ONLY: 12,
  DERIVATIVE_SECURITY_TYPE_MORTGAGE_PRIVATE_PLACEMENT: 13,
  DERIVATIVE_SECURITY_TYPE_MUTUAL_FUND: 14,
  DERIVATIVE_SECURITY_TYPE_NO_SECURITY_TYPE: 15,
  DERIVATIVE_SECURITY_TYPE_OPTION: 16,
  DERIVATIVE_SECURITY_TYPE_PREFERRED_STOCK: 17,
  DERIVATIVE_SECURITY_TYPE_TIME_DEPOSIT: 18,
  DERIVATIVE_SECURITY_TYPE_US_TREASURY_BILL_OLD: 19,
  DERIVATIVE_SECURITY_TYPE_WARRANT: 20,
  DERIVATIVE_SECURITY_TYPE_CONVERTIBLE_BOND: 21,
  DERIVATIVE_SECURITY_TYPE_IOETTEMORTGAGE: 22,
  DERIVATIVE_SECURITY_TYPE_WILDCARD: 23,
  DERIVATIVE_SECURITY_TYPE_AMENDED: 24,
  DERIVATIVE_SECURITY_TYPE_ASSET_BACKED_SECURITIES: 25,
  DERIVATIVE_SECURITY_TYPE_BANK_NOTES: 26,
  DERIVATIVE_SECURITY_TYPE_BILL_OF_EXCHANGES: 27,
  DERIVATIVE_SECURITY_TYPE_BRADY_BOND: 28,
  DERIVATIVE_SECURITY_TYPE_BRIDGE_LOAN: 29,
  DERIVATIVE_SECURITY_TYPE_CALL_LOANS: 30,
  DERIVATIVE_SECURITY_TYPE_CERTIFICATE_OF_OBLIGATION: 31,
  DERIVATIVE_SECURITY_TYPE_CERTIFICATE_OF_PARTICIPATION: 32,
  DERIVATIVE_SECURITY_TYPE_CORP: 33,
  DERIVATIVE_SECURITY_TYPE_DEBTOR_IN_POSSESSION: 34,
  DERIVATIVE_SECURITY_TYPE_DEFAULTED: 35,
  DERIVATIVE_SECURITY_TYPE_DEPOSIT_NOTES: 36,
  DERIVATIVE_SECURITY_TYPE_DUAL_CURRENCY: 37,
  DERIVATIVE_SECURITY_TYPE_EXTENDED_COMM_NOTE: 38,
  DERIVATIVE_SECURITY_TYPE_FEDERAL_AGENCY_COUPON: 39,
  DERIVATIVE_SECURITY_TYPE_FEDERAL_AGENCY_DISCOUNT_NOTE: 40,
  DERIVATIVE_SECURITY_TYPE_GENERAL_OBLIGATION_BONDS: 41,
  DERIVATIVE_SECURITY_TYPE_INDEXED_LINKED: 42,
  DERIVATIVE_SECURITY_TYPE_INTEREST_STRIP_FROM_ANY_BOND_OR_NOTE: 43,
  DERIVATIVE_SECURITY_TYPE_LETTER_OF_CREDIT: 44,
  DERIVATIVE_SECURITY_TYPE_LIQUIDITY_NOTE: 45,
  DERIVATIVE_SECURITY_TYPE_MANDATORY_TENDER: 46,
  DERIVATIVE_SECURITY_TYPE_MATURED: 47,
  DERIVATIVE_SECURITY_TYPE_MEDIUM_TERM_NOTES: 48,
  DERIVATIVE_SECURITY_TYPE_MORTGAGE_BACKED_SECURITIES: 49,
  DERIVATIVE_SECURITY_TYPE_MULTILEG_INSTRUMENT: 50,
  DERIVATIVE_SECURITY_TYPE_OTHER_ANTICIPATION_NOTES: 51,
  DERIVATIVE_SECURITY_TYPE_OVERNIGHT: 52,
  DERIVATIVE_SECURITY_TYPE_PLAZOS_FIJOS: 53,
  DERIVATIVE_SECURITY_TYPE_PRINCIPAL_STRIP_FROM_ANON_CALLABLE_BOND_OR_NOTE: 54,
  DERIVATIVE_SECURITY_TYPE_PRINCIPAL_STRIP_OF_ACALLABLE_BOND_OR_NOTE: 55,
  DERIVATIVE_SECURITY_TYPE_PRIVATE_EXPORT_FUNDING: 56,
  DERIVATIVE_SECURITY_TYPE_PROMISSORY_NOTE: 57,
  DERIVATIVE_SECURITY_TYPE_REPLACED: 58,
  DERIVATIVE_SECURITY_TYPE_RETIRED: 59,
  DERIVATIVE_SECURITY_TYPE_REVENUE_ANTICIPATION_NOTE: 60,
  DERIVATIVE_SECURITY_TYPE_REVENUE_BONDS: 61,
  DERIVATIVE_SECURITY_TYPE_REVOLVER: 62,
  DERIVATIVE_SECURITY_TYPE_REVOLVER_LOAN: 63,
  DERIVATIVE_SECURITY_TYPE_SHORT_TERM_LOAN_NOTE: 64,
  DERIVATIVE_SECURITY_TYPE_SPECIAL_ASSESSMENT: 65,
  DERIVATIVE_SECURITY_TYPE_SPECIAL_OBLIGATION: 66,
  DERIVATIVE_SECURITY_TYPE_SPECIAL_TAX: 67,
  DERIVATIVE_SECURITY_TYPE_STRUCTURED_NOTES: 68,
  DERIVATIVE_SECURITY_TYPE_SWING_LINE_FACILITY: 69,
  DERIVATIVE_SECURITY_TYPE_TAX_ALLOCATION: 70,
  DERIVATIVE_SECURITY_TYPE_TAX_ANTICIPATION_NOTE: 71,
  DERIVATIVE_SECURITY_TYPE_TAX_EXEMPT_COMMERCIAL_PAPER: 72,
  DERIVATIVE_SECURITY_TYPE_TAX_REVENUE_ANTICIPATION_NOTE: 73,
  DERIVATIVE_SECURITY_TYPE_TERM_LOAN: 74,
  DERIVATIVE_SECURITY_TYPE_TO_BE_ANNOUNCED: 75,
  DERIVATIVE_SECURITY_TYPE_TREASURY_INFLATION_PROTECTED_SECURITIES: 76,
  DERIVATIVE_SECURITY_TYPE_US_TREASURY_BOND: 77,
  DERIVATIVE_SECURITY_TYPE_US_TREASURY_NOTE_OLD: 78,
  DERIVATIVE_SECURITY_TYPE_VARIABLE_RATE_DEMAND_NOTE: 79,
  DERIVATIVE_SECURITY_TYPE_WITHDRAWN: 80,
  DERIVATIVE_SECURITY_TYPE_YANKEE_CORPORATE_BOND: 81,
  DERIVATIVE_SECURITY_TYPE_BUY_SELLBACK: 82,
  DERIVATIVE_SECURITY_TYPE_EURO_CERTIFICATE_OF_DEPOSIT: 83,
  DERIVATIVE_SECURITY_TYPE_EURO_COMMERCIAL_PAPER: 84,
  DERIVATIVE_SECURITY_TYPE_EURO_CORPORATE_BOND: 85,
  DERIVATIVE_SECURITY_TYPE_EURO_SOVEREIGNS: 86,
  DERIVATIVE_SECURITY_TYPE_EURO_SUPRANATIONAL_COUPONS: 87,
  DERIVATIVE_SECURITY_TYPE_FORWARD: 88,
  DERIVATIVE_SECURITY_TYPE_PFANDBRIEFE: 89,
  DERIVATIVE_SECURITY_TYPE_REPURCHASE: 90,
  DERIVATIVE_SECURITY_TYPE_SECURITIES_LOAN: 91,
  DERIVATIVE_SECURITY_TYPE_SECURITIES_PLEDGE: 92,
  DERIVATIVE_SECURITY_TYPE_USD_SUPRANATIONAL_COUPONS: 93,
  DERIVATIVE_SECURITY_TYPE_US_TREASURY_BILL: 94,
  DERIVATIVE_SECURITY_TYPE_US_TREASURY_NOTE: 95,
  DERIVATIVE_SECURITY_TYPE_YANKEE_CERTIFICATE_OF_DEPOSIT: 96,
  DERIVATIVE_SECURITY_TYPE_OPTIONS_ON_FUTURES: 97,
  DERIVATIVE_SECURITY_TYPE_OPTIONS_ON_PHYSICAL: 98,
  DERIVATIVE_SECURITY_TYPE_CASH: 99,
  DERIVATIVE_SECURITY_TYPE_OPTIONS_ON_COMBO: 100,
  DERIVATIVE_SECURITY_TYPE_INTEREST_RATE_SWAP: 101,
  DERIVATIVE_SECURITY_TYPE_BANK_DEPOSITORY_NOTE: 102,
  DERIVATIVE_SECURITY_TYPE_CANADIAN_MONEY_MARKETS: 103,
  DERIVATIVE_SECURITY_TYPE_CANADIAN_MORTGAGE_BONDS: 104,
  DERIVATIVE_SECURITY_TYPE_CANADIAN_PROVINCIAL_BONDS: 105,
  DERIVATIVE_SECURITY_TYPE_CANADIAN_TREASURY_BILLS: 106,
  DERIVATIVE_SECURITY_TYPE_CANADIAN_TREASURY_NOTES: 107,
  DERIVATIVE_SECURITY_TYPE_CREDIT_DEFAULT_SWAP: 108,
  DERIVATIVE_SECURITY_TYPE_EURO_CORPORATE_FLOATING_RATE_NOTES: 109,
  DERIVATIVE_SECURITY_TYPE_SECURED_LIQUIDITY_NOTE: 110,
  DERIVATIVE_SECURITY_TYPE_TAXABLE_MUNICIPAL_CP: 111,
  DERIVATIVE_SECURITY_TYPE_TERM_LIQUIDITY_NOTE: 112,
  DERIVATIVE_SECURITY_TYPE_TREASURY_BILL: 113,
  DERIVATIVE_SECURITY_TYPE_US_CORPORATE_FLOATING_RATE_NOTES: 114,
  DERIVATIVE_SECURITY_TYPE_FX_FORWARD: 115,
  DERIVATIVE_SECURITY_TYPE_FX_SPOT: 116,
  DERIVATIVE_SECURITY_TYPE_FX_SWAP: 117,
  DERIVATIVE_SECURITY_TYPE_NON_DELIVERABLE_FORWARD: 118
};

/**
 * @enum {number}
 */
proto.Common.DerivativeInstrmtAssignmentMethodEnum = {
  DERIVATIVE_INSTRMT_ASSIGNMENT_METHOD_UNSPECIFIED: 0
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSecurityStatusEnum = {
  DERIVATIVE_SECURITY_STATUS_UNSPECIFIED: 0,
  DERIVATIVE_SECURITY_STATUS_ACTIVE: 1,
  DERIVATIVE_SECURITY_STATUS_INACTIVE: 2
};

/**
 * @enum {number}
 */
proto.Common.DerivativeContractMultiplierUnitEnum = {
  DERIVATIVE_CONTRACT_MULTIPLIER_UNIT_UNSPECIFIED: 0,
  DERIVATIVE_CONTRACT_MULTIPLIER_UNIT_DAYS: 1,
  DERIVATIVE_CONTRACT_MULTIPLIER_UNIT_HOURS: 2,
  DERIVATIVE_CONTRACT_MULTIPLIER_UNIT_SHARES: 3
};

/**
 * @enum {number}
 */
proto.Common.DerivativeFlowScheduleTypeEnum = {
  DERIVATIVE_FLOW_SCHEDULE_TYPE_UNSPECIFIED: 0,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_NERC_CALENDAR_ALL_DAYS_IN_MONTH: 1,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_NERC_EASTERN_OFF_PEAK: 2,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_NERC_EASTERN_PEAK: 3,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_NERC_WESTERN_OFF_PEAK: 4,
  DERIVATIVE_FLOW_SCHEDULE_TYPE_NERC_WESTERN_PEAK: 5
};

/**
 * @enum {number}
 */
proto.Common.DerivativeUnitOfMeasureEnum = {
  DERIVATIVE_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  DERIVATIVE_UNIT_OF_MEASURE_BARRELS: 1,
  DERIVATIVE_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  DERIVATIVE_UNIT_OF_MEASURE_BUSHELS: 3,
  DERIVATIVE_UNIT_OF_MEASURE_GALLONS: 4,
  DERIVATIVE_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  DERIVATIVE_UNIT_OF_MEASURE_METRIC_TONS: 6,
  DERIVATIVE_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  DERIVATIVE_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  DERIVATIVE_UNIT_OF_MEASURE_POUNDS: 9,
  DERIVATIVE_UNIT_OF_MEASURE_TONS: 10,
  DERIVATIVE_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  DERIVATIVE_UNIT_OF_MEASURE_USDOLLARS: 12,
  DERIVATIVE_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.DerivativePriceUnitOfMeasureEnum = {
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_UNSPECIFIED: 0,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_BARRELS: 1,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_BILLION_CUBIC_FEET: 2,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_BUSHELS: 3,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_GALLONS: 4,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_MEGAWATT_HOURS: 5,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_METRIC_TONS: 6,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_MILLION_BARRELS: 7,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_ONE_MILLION_BTU: 8,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_POUNDS: 9,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_TONS: 10,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_TROY_OUNCES: 11,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_USDOLLARS: 12,
  DERIVATIVE_PRICE_UNIT_OF_MEASURE_ALLOWANCES: 13
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSettlMethodEnum = {
  DERIVATIVE_SETTL_METHOD_UNSPECIFIED: 0,
  DERIVATIVE_SETTL_METHOD_CASH_SETTLEMENT_REQUIRED: 1,
  DERIVATIVE_SETTL_METHOD_PHYSICAL_SETTLEMENT_REQUIRED: 2
};

/**
 * @enum {number}
 */
proto.Common.DerivativePriceQuoteMethodEnum = {
  DERIVATIVE_PRICE_QUOTE_METHOD_UNSPECIFIED: 0,
  DERIVATIVE_PRICE_QUOTE_METHOD_INDEX: 1,
  DERIVATIVE_PRICE_QUOTE_METHOD_INTEREST_RATE_INDEX: 2,
  DERIVATIVE_PRICE_QUOTE_METHOD_STANDARD: 3,
  DERIVATIVE_PRICE_QUOTE_METHOD_PERCENT_OF_PAR: 4
};

/**
 * @enum {number}
 */
proto.Common.DerivativeValuationMethodEnum = {
  DERIVATIVE_VALUATION_METHOD_UNSPECIFIED: 0,
  DERIVATIVE_VALUATION_METHOD_FUTURES_STYLE_MARK_TO_MARKET: 1,
  DERIVATIVE_VALUATION_METHOD_FUTURES_STYLE_WITH_AN_ATTACHED_CASH_ADJUSTMENT: 2,
  DERIVATIVE_VALUATION_METHOD_PREMIUM_STYLE: 3,
  DERIVATIVE_VALUATION_METHOD_CDS_IN_DELIVERY_USE_RECOVERY_RATE_TO_CALCULATE: 4,
  DERIVATIVE_VALUATION_METHOD_CDS_STYLE_COLLATERALIZATION: 5
};

/**
 * @enum {number}
 */
proto.Common.DerivativeListMethodEnum = {
  DERIVATIVE_LIST_METHOD_UNSPECIFIED: 0,
  DERIVATIVE_LIST_METHOD_PRE_LISTED_ONLY: 1,
  DERIVATIVE_LIST_METHOD_USER_REQUESTED: 2
};

/**
 * @enum {number}
 */
proto.Common.DerivativePutOrCallEnum = {
  DERIVATIVE_PUT_OR_CALL_UNSPECIFIED: 0,
  DERIVATIVE_PUT_OR_CALL_CALL: 1,
  DERIVATIVE_PUT_OR_CALL_PUT: 2
};

/**
 * @enum {number}
 */
proto.Common.DerivativeExerciseStyleEnum = {
  DERIVATIVE_EXERCISE_STYLE_UNSPECIFIED: 0,
  DERIVATIVE_EXERCISE_STYLE_AMERICAN: 1,
  DERIVATIVE_EXERCISE_STYLE_BERMUDA: 2,
  DERIVATIVE_EXERCISE_STYLE_EUROPEAN: 3
};

/**
 * @enum {number}
 */
proto.Common.DerivativeTimeUnitEnum = {
  DERIVATIVE_TIME_UNIT_UNSPECIFIED: 0,
  DERIVATIVE_TIME_UNIT_DAY: 1,
  DERIVATIVE_TIME_UNIT_HOUR: 2,
  DERIVATIVE_TIME_UNIT_MINUTE: 3,
  DERIVATIVE_TIME_UNIT_MONTH: 4,
  DERIVATIVE_TIME_UNIT_SECOND: 5,
  DERIVATIVE_TIME_UNIT_WEEK: 6,
  DERIVATIVE_TIME_UNIT_YEAR: 7
};

/**
 * @enum {number}
 */
proto.Common.DerivativeSecurityAltIDSourceEnum = {
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_UNSPECIFIED: 0,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_CUSIP: 1,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_QUIK: 2,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_SEDOL: 3,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_ISIN_NUMBER: 4,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_RIC_CODE: 5,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_ISO_CURRENCY_CODE: 7,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_CONSOLIDATED_TAPE_ASSOCIATION: 8,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_EXCHANGE_SYMBOL: 9,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_BELGIAN: 10,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_BLOOMBERG_SYMBOL: 11,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_COMMON: 12,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_DUTCH: 13,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_SICOVAM: 14,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_VALOREN: 15,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_WERTPAPIER: 16,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_CLEARING_HOUSE: 17,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_ISDA_FPML_SPECIFICATION: 18,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_OPTION_PRICE_REPORTING_AUTHORITY: 19,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_LETTER_OF_CREDIT: 20,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_ISDA_FPML_URL: 21,
  DERIVATIVE_SECURITY_ALT_ID_SOURCE_MARKETPLACE_ASSIGNED_IDENTIFIER: 22
};

/**
 * @enum {number}
 */
proto.Common.DerivativeEventTypeEnum = {
  DERIVATIVE_EVENT_TYPE_UNSPECIFIED: 0,
  DERIVATIVE_EVENT_TYPE_CALL: 1,
  DERIVATIVE_EVENT_TYPE_OTHER: 2,
  DERIVATIVE_EVENT_TYPE_PUT: 3,
  DERIVATIVE_EVENT_TYPE_SINKING_FUND_CALL: 4,
  DERIVATIVE_EVENT_TYPE_TENDER: 5,
  DERIVATIVE_EVENT_TYPE_ACTIVATION: 6,
  DERIVATIVE_EVENT_TYPE_INACTIVIATION: 7,
  DERIVATIVE_EVENT_TYPE_LAST_ELIGIBLE_TRADE_DATE: 8,
  DERIVATIVE_EVENT_TYPE_FINAL_INVENTORY_DUE_DATE: 9,
  DERIVATIVE_EVENT_TYPE_FIRST_DELIVERY_DATE: 10,
  DERIVATIVE_EVENT_TYPE_FIRST_INTENT_DATE: 11,
  DERIVATIVE_EVENT_TYPE_INITIAL_INVENTORY_DUE_DATE: 12,
  DERIVATIVE_EVENT_TYPE_LAST_DELIVERY_DATE: 13,
  DERIVATIVE_EVENT_TYPE_LAST_INTENT_DATE: 14,
  DERIVATIVE_EVENT_TYPE_POSITION_REMOVAL_DATE: 15,
  DERIVATIVE_EVENT_TYPE_SWAP_END_DATE: 16,
  DERIVATIVE_EVENT_TYPE_SWAP_NEXT_ROLL_DATE: 17,
  DERIVATIVE_EVENT_TYPE_SWAP_NEXT_START_DATE: 18,
  DERIVATIVE_EVENT_TYPE_SWAP_ROLL_DATE: 19,
  DERIVATIVE_EVENT_TYPE_SWAP_START_DATE: 20
};

/**
 * @enum {number}
 */
proto.Common.ListUpdateActionEnum = {
  LIST_UPDATE_ACTION_UNSPECIFIED: 0,
  LIST_UPDATE_ACTION_ADD: 1,
  LIST_UPDATE_ACTION_DELETE: 2,
  LIST_UPDATE_ACTION_MODIFY: 3
};

/**
 * @enum {number}
 */
proto.Common.CorporateActionEnum = {
  CORPORATE_ACTION_UNSPECIFIED: 0,
  CORPORATE_ACTION_EX_DISTRIBUTION: 1,
  CORPORATE_ACTION_EX_DIVIDEND: 2,
  CORPORATE_ACTION_EX_INTEREST: 3,
  CORPORATE_ACTION_EX_RIGHTS: 4,
  CORPORATE_ACTION_NEW: 5,
  CORPORATE_ACTION_CASH_DIVIDEND: 6,
  CORPORATE_ACTION_CUSIP: 7,
  CORPORATE_ACTION_LIQUIDATION_REORGANIZATION: 8,
  CORPORATE_ACTION_MERGER_REORGANIZATION: 9,
  CORPORATE_ACTION_NON_INTEGER_STOCK_SPLIT: 10,
  CORPORATE_ACTION_POSITION_CONSOLIDATION: 11,
  CORPORATE_ACTION_REVERSE_STOCK_SPLIT: 12,
  CORPORATE_ACTION_RIGHTS_OFFERING: 13,
  CORPORATE_ACTION_SHAREHOLDER_MEETING: 14,
  CORPORATE_ACTION_SPECIAL_ACTION: 15,
  CORPORATE_ACTION_SPINOFF: 16,
  CORPORATE_ACTION_STANDARD_INTEGER_STOCK_SPLIT: 17,
  CORPORATE_ACTION_STOCK_DIVIDEND: 18,
  CORPORATE_ACTION_SYMBOL_CONVERSION: 19,
  CORPORATE_ACTION_TENDER_OFFER: 20,
  CORPORATE_ACTION_WARRANT: 21,
  CORPORATE_ACTION_LEAP_ROLLOVER: 22,
  CORPORATE_ACTION_SUCCESSION_EVENT: 23
};

/**
 * @enum {number}
 */
proto.Common.Nested4PartySubIDTypeEnum = {
  NESTED4PARTY_SUB_ID_TYPE_UNSPECIFIED: 0,
  NESTED4PARTY_SUB_ID_TYPE_APPLICATION: 1,
  NESTED4PARTY_SUB_ID_TYPE_BIC: 2,
  NESTED4PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NAME: 3,
  NESTED4PARTY_SUB_ID_TYPE_CASH_ACCOUNT_NUMBER: 4,
  NESTED4PARTY_SUB_ID_TYPE_CONTACT_NAME: 5,
  NESTED4PARTY_SUB_ID_TYPE_CSDPARTICIPANT_MEMBER_CODE: 6,
  NESTED4PARTY_SUB_ID_TYPE_DEPARTMENT: 7,
  NESTED4PARTY_SUB_ID_TYPE_EMAIL_ADDRESS: 8,
  NESTED4PARTY_SUB_ID_TYPE_FAX_NUMBER: 9,
  NESTED4PARTY_SUB_ID_TYPE_FIRM: 10,
  NESTED4PARTY_SUB_ID_TYPE_FULL_LEGAL_NAME_OF_FIRM: 11,
  NESTED4PARTY_SUB_ID_TYPE_FUND_ACCOUNT_NAME: 12,
  NESTED4PARTY_SUB_ID_TYPE_LOCATION_DESK: 13,
  NESTED4PARTY_SUB_ID_TYPE_PERSON: 14,
  NESTED4PARTY_SUB_ID_TYPE_PHONE_NUMBER: 15,
  NESTED4PARTY_SUB_ID_TYPE_POSITION_ACCOUNT_TYPE: 16,
  NESTED4PARTY_SUB_ID_TYPE_POSTAL_ADDRESS: 17,
  NESTED4PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS: 18,
  NESTED4PARTY_SUB_ID_TYPE_REGISTERED_ADDRESS_FOR_CONFIRMATION: 19,
  NESTED4PARTY_SUB_ID_TYPE_REGISTRATION_NAME: 20,
  NESTED4PARTY_SUB_ID_TYPE_REGISTRATION_NUMBER: 21,
  NESTED4PARTY_SUB_ID_TYPE_REGULATORY_STATUS: 22,
  NESTED4PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NAME: 23,
  NESTED4PARTY_SUB_ID_TYPE_SECURITIES_ACCOUNT_NUMBER: 24,
  NESTED4PARTY_SUB_ID_TYPE_SYSTEM: 25,
  NESTED4PARTY_SUB_ID_TYPE_TELEX_NUMBER: 26,
  NESTED4PARTY_SUB_ID_TYPE_SECURITY_LOCATE_ID: 27,
  NESTED4PARTY_SUB_ID_TYPE_ELIGIBLE_COUNTERPARTY: 28,
  NESTED4PARTY_SUB_ID_TYPE_EXECUTION_VENUE: 29,
  NESTED4PARTY_SUB_ID_TYPE_LOCATION: 30,
  NESTED4PARTY_SUB_ID_TYPE_MARKET_MAKER: 31,
  NESTED4PARTY_SUB_ID_TYPE_PROFESSIONAL_CLIENT: 32,
  NESTED4PARTY_SUB_ID_TYPE_CURRENCY_DELIVERY_IDENTIFIER: 33
};

/**
 * @enum {number}
 */
proto.Common.Nested4PartyIDSourceEnum = {
  NESTED4PARTY_ID_SOURCE_UNSPECIFIED: 0,
  NESTED4PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  NESTED4PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  NESTED4PARTY_ID_SOURCE_BIC: 3,
  NESTED4PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  NESTED4PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  NESTED4PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  NESTED4PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  NESTED4PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  NESTED4PARTY_ID_SOURCE_PROPRIETARY: 9,
  NESTED4PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  NESTED4PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  NESTED4PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  NESTED4PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  NESTED4PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  NESTED4PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  NESTED4PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  NESTED4PARTY_ID_SOURCE_ISITCACRONYM: 17,
  NESTED4PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.Nested4PartyRoleEnum = {
  NESTED4PARTY_ROLE_UNSPECIFIED: 0,
  NESTED4PARTY_ROLE_BROKER_OF_CREDIT: 1,
  NESTED4PARTY_ROLE_CLEARING_FIRM: 2,
  NESTED4PARTY_ROLE_CLIENT_ID: 3,
  NESTED4PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  NESTED4PARTY_ROLE_CONTRA_FIRM: 5,
  NESTED4PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  NESTED4PARTY_ROLE_ENTERING_FIRM: 7,
  NESTED4PARTY_ROLE_EXECUTING_FIRM: 8,
  NESTED4PARTY_ROLE_EXECUTING_SYSTEM: 9,
  NESTED4PARTY_ROLE_EXECUTING_TRADER: 10,
  NESTED4PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  NESTED4PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  NESTED4PARTY_ROLE_INTRODUCING_FIRM: 13,
  NESTED4PARTY_ROLE_INVESTOR_ID: 14,
  NESTED4PARTY_ROLE_LOCATE: 15,
  NESTED4PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  NESTED4PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  NESTED4PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  NESTED4PARTY_ROLE_SPONSORING_FIRM: 19,
  NESTED4PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  NESTED4PARTY_ROLE_AGENT: 21,
  NESTED4PARTY_ROLE_BENEFICIARY: 22,
  NESTED4PARTY_ROLE_BUYER: 23,
  NESTED4PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  NESTED4PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  NESTED4PARTY_ROLE_CONTRA_TRADER: 26,
  NESTED4PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  NESTED4PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  NESTED4PARTY_ROLE_CUSTODIAN: 29,
  NESTED4PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  NESTED4PARTY_ROLE_ENTERING_TRADER: 31,
  NESTED4PARTY_ROLE_EXCHANGE: 32,
  NESTED4PARTY_ROLE_INTERESTED_PARTY: 33,
  NESTED4PARTY_ROLE_INTERMEDIARY: 34,
  NESTED4PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  NESTED4PARTY_ROLE_POSITION_ACCOUNT: 36,
  NESTED4PARTY_ROLE_REGULATORY_BODY: 37,
  NESTED4PARTY_ROLE_SUB_CUSTODIAN: 38,
  NESTED4PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  NESTED4PARTY_ROLE_INTRODUCING_BROKER: 40,
  NESTED4PARTY_ROLE_CONTRA_EXCHANGE: 41,
  NESTED4PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  NESTED4PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  NESTED4PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  NESTED4PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  NESTED4PARTY_ROLE_ASSET_MANAGER: 46,
  NESTED4PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  NESTED4PARTY_ROLE_FOREIGN_FIRM: 48,
  NESTED4PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  NESTED4PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  NESTED4PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  NESTED4PARTY_ROLE_SENDER_LOCATION: 52,
  NESTED4PARTY_ROLE_SESSION_ID: 53,
  NESTED4PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  NESTED4PARTY_ROLE_TRADER_MNEMONIC: 55,
  NESTED4PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  NESTED4PARTY_ROLE_ENTERING_UNIT: 57,
  NESTED4PARTY_ROLE_EXECUTING_UNIT: 58,
  NESTED4PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  NESTED4PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  NESTED4PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  NESTED4PARTY_ROLE_DESK_ID: 62,
  NESTED4PARTY_ROLE_EXECUTION_VENUE: 63,
  NESTED4PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  NESTED4PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  NESTED4PARTY_ROLE_INVESTMENT_FIRM: 66,
  NESTED4PARTY_ROLE_LOCATION_ID: 67,
  NESTED4PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  NESTED4PARTY_ROLE_MARKET_DATA_MARKET: 69,
  NESTED4PARTY_ROLE_MARKET_MAKER: 70,
  NESTED4PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  NESTED4PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  NESTED4PARTY_ROLE_REGULATED_MARKET: 73,
  NESTED4PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  NESTED4PARTY_ROLE_REPORT_ORIGINATOR: 75,
  NESTED4PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  NESTED4PARTY_ROLE_ALLOCATION_ENTITY: 77,
  NESTED4PARTY_ROLE_BROKER_CLEARING_ID: 78,
  NESTED4PARTY_ROLE_PRIME_BROKER: 79,
  NESTED4PARTY_ROLE_STEP_OUT_FIRM: 80,
  NESTED4PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  NESTED4PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  NESTED4PARTY_ROLE_CLEARING_ACCOUNT: 83,
  NESTED4PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.RateSourceEnum = {
  RATE_SOURCE_UNSPECIFIED: 0,
  RATE_SOURCE_BLOOMBERG: 1,
  RATE_SOURCE_OTHER: 2,
  RATE_SOURCE_REUTERS: 3,
  RATE_SOURCE_TELERATE: 4
};

/**
 * @enum {number}
 */
proto.Common.RateSourceTypeEnum = {
  RATE_SOURCE_TYPE_UNSPECIFIED: 0,
  RATE_SOURCE_TYPE_PRIMARY: 1,
  RATE_SOURCE_TYPE_SECONDARY: 2
};

/**
 * @enum {number}
 */
proto.Common.TargetPartyIDSourceEnum = {
  TARGET_PARTY_ID_SOURCE_UNSPECIFIED: 0,
  TARGET_PARTY_ID_SOURCE_AUSTRALIAN_BUSINESS_NUMBER: 1,
  TARGET_PARTY_ID_SOURCE_AUSTRALIAN_TAX_FILE_NUMBER: 2,
  TARGET_PARTY_ID_SOURCE_BIC: 3,
  TARGET_PARTY_ID_SOURCE_CHINESE_INVESTOR_ID: 4,
  TARGET_PARTY_ID_SOURCE_GENERAL_IDENTIFIER: 5,
  TARGET_PARTY_ID_SOURCE_ISO_COUNTRY_CODE: 6,
  TARGET_PARTY_ID_SOURCE_KOREAN_INVESTOR_ID: 7,
  TARGET_PARTY_ID_SOURCE_MALAYSIAN_CENTRAL_DEPOSITORY: 8,
  TARGET_PARTY_ID_SOURCE_PROPRIETARY: 9,
  TARGET_PARTY_ID_SOURCE_SETTLEMENT_ENTITY_LOCATION: 10,
  TARGET_PARTY_ID_SOURCE_TAIWANESE_FOREIGN_INVESTOR_ID: 11,
  TARGET_PARTY_ID_SOURCE_TAIWANESE_TRADING_ACCT: 12,
  TARGET_PARTY_ID_SOURCE_UK_NATIONAL_INSURANCE_OR_PENSION_NUMBER: 13,
  TARGET_PARTY_ID_SOURCE_US_EMPLOYER_OR_TAX_ID_NUMBER: 14,
  TARGET_PARTY_ID_SOURCE_US_SOCIAL_SECURITY_NUMBER: 15,
  TARGET_PARTY_ID_SOURCE_CSDPARTICIPANT: 16,
  TARGET_PARTY_ID_SOURCE_ISITCACRONYM: 17,
  TARGET_PARTY_ID_SOURCE_MIC: 18
};

/**
 * @enum {number}
 */
proto.Common.TargetPartyRoleEnum = {
  TARGET_PARTY_ROLE_UNSPECIFIED: 0,
  TARGET_PARTY_ROLE_BROKER_OF_CREDIT: 1,
  TARGET_PARTY_ROLE_CLEARING_FIRM: 2,
  TARGET_PARTY_ROLE_CLIENT_ID: 3,
  TARGET_PARTY_ROLE_CONTRA_CLEARING_FIRM: 4,
  TARGET_PARTY_ROLE_CONTRA_FIRM: 5,
  TARGET_PARTY_ROLE_CORRESPONDANT_CLEARING_FIRM: 6,
  TARGET_PARTY_ROLE_ENTERING_FIRM: 7,
  TARGET_PARTY_ROLE_EXECUTING_FIRM: 8,
  TARGET_PARTY_ROLE_EXECUTING_SYSTEM: 9,
  TARGET_PARTY_ROLE_EXECUTING_TRADER: 10,
  TARGET_PARTY_ROLE_FUND_MANAGER_CLIENT_ID: 11,
  TARGET_PARTY_ROLE_GIVEUP_CLEARING_FIRM: 12,
  TARGET_PARTY_ROLE_INTRODUCING_FIRM: 13,
  TARGET_PARTY_ROLE_INVESTOR_ID: 14,
  TARGET_PARTY_ROLE_LOCATE: 15,
  TARGET_PARTY_ROLE_ORDER_ORIGINATION_FIRM: 16,
  TARGET_PARTY_ROLE_ORDER_ORIGINATION_TRADER: 17,
  TARGET_PARTY_ROLE_SETTLEMENT_LOCATION: 18,
  TARGET_PARTY_ROLE_SPONSORING_FIRM: 19,
  TARGET_PARTY_ROLE_UNDERLYING_CONTRA_FIRM: 20,
  TARGET_PARTY_ROLE_AGENT: 21,
  TARGET_PARTY_ROLE_BENEFICIARY: 22,
  TARGET_PARTY_ROLE_BUYER: 23,
  TARGET_PARTY_ROLE_CLEARING_ORGANIZATION: 24,
  TARGET_PARTY_ROLE_CONTRA_INVESTOR_ID: 25,
  TARGET_PARTY_ROLE_CONTRA_TRADER: 26,
  TARGET_PARTY_ROLE_CORRESPONDENT_BROKER: 27,
  TARGET_PARTY_ROLE_CORRESPONDENT_CLEARING_ORGANIZATION: 28,
  TARGET_PARTY_ROLE_CUSTODIAN: 29,
  TARGET_PARTY_ROLE_CUSTOMER_ACCOUNT: 30,
  TARGET_PARTY_ROLE_ENTERING_TRADER: 31,
  TARGET_PARTY_ROLE_EXCHANGE: 32,
  TARGET_PARTY_ROLE_INTERESTED_PARTY: 33,
  TARGET_PARTY_ROLE_INTERMEDIARY: 34,
  TARGET_PARTY_ROLE_LIQUIDITY_PROVIDER: 35,
  TARGET_PARTY_ROLE_POSITION_ACCOUNT: 36,
  TARGET_PARTY_ROLE_REGULATORY_BODY: 37,
  TARGET_PARTY_ROLE_SUB_CUSTODIAN: 38,
  TARGET_PARTY_ROLE_TRANSFER_TO_FIRM: 39,
  TARGET_PARTY_ROLE_INTRODUCING_BROKER: 40,
  TARGET_PARTY_ROLE_CONTRA_EXCHANGE: 41,
  TARGET_PARTY_ROLE_CONTRA_POSITION_ACCOUNT: 42,
  TARGET_PARTY_ROLE_INTERNAL_CARRY_ACCOUNT: 43,
  TARGET_PARTY_ROLE_ORDER_ENTRY_OPERATOR_ID: 44,
  TARGET_PARTY_ROLE_SECONDARY_ACCOUNT_NUMBER: 45,
  TARGET_PARTY_ROLE_ASSET_MANAGER: 46,
  TARGET_PARTY_ROLE_CLAIMING_ACCOUNT: 47,
  TARGET_PARTY_ROLE_FOREIGN_FIRM: 48,
  TARGET_PARTY_ROLE_LARGE_TRADER_REPORTABLE_ACCOUNT: 49,
  TARGET_PARTY_ROLE_PLEDGEE_ACCOUNT: 50,
  TARGET_PARTY_ROLE_PLEDGOR_ACCOUNT: 51,
  TARGET_PARTY_ROLE_SENDER_LOCATION: 52,
  TARGET_PARTY_ROLE_SESSION_ID: 53,
  TARGET_PARTY_ROLE_THIRD_PARTY_ALLOCATION_FIRM: 54,
  TARGET_PARTY_ROLE_TRADER_MNEMONIC: 55,
  TARGET_PARTY_ROLE_ACCEPTABLE_COUNTERPARTY: 56,
  TARGET_PARTY_ROLE_ENTERING_UNIT: 57,
  TARGET_PARTY_ROLE_EXECUTING_UNIT: 58,
  TARGET_PARTY_ROLE_UNACCEPTABLE_COUNTERPARTY: 59,
  TARGET_PARTY_ROLE_COMPETENT_AUTHORITY_LIQUIDITY: 60,
  TARGET_PARTY_ROLE_COMPETENT_AUTHORITY_TRANSACTION_VENUE: 61,
  TARGET_PARTY_ROLE_DESK_ID: 62,
  TARGET_PARTY_ROLE_EXECUTION_VENUE: 63,
  TARGET_PARTY_ROLE_HOME_COMPETENT_AUTHORITY: 64,
  TARGET_PARTY_ROLE_HOST_COMPETENT_AUTHORITY: 65,
  TARGET_PARTY_ROLE_INVESTMENT_FIRM: 66,
  TARGET_PARTY_ROLE_LOCATION_ID: 67,
  TARGET_PARTY_ROLE_MARKET_DATA_ENTRY_ORIGINATOR: 68,
  TARGET_PARTY_ROLE_MARKET_DATA_MARKET: 69,
  TARGET_PARTY_ROLE_MARKET_MAKER: 70,
  TARGET_PARTY_ROLE_MULTILATERAL_TRADING_FACILITY: 71,
  TARGET_PARTY_ROLE_QUOTE_ORIGINATOR: 72,
  TARGET_PARTY_ROLE_REGULATED_MARKET: 73,
  TARGET_PARTY_ROLE_REPORTING_INTERMEDIARY: 74,
  TARGET_PARTY_ROLE_REPORT_ORIGINATOR: 75,
  TARGET_PARTY_ROLE_SYSTEMATIC_INTERNALISER: 76,
  TARGET_PARTY_ROLE_ALLOCATION_ENTITY: 77,
  TARGET_PARTY_ROLE_BROKER_CLEARING_ID: 78,
  TARGET_PARTY_ROLE_PRIME_BROKER: 79,
  TARGET_PARTY_ROLE_STEP_OUT_FIRM: 80,
  TARGET_PARTY_ROLE_CENTRAL_REGISTRATION_DEPOSITORY: 81,
  TARGET_PARTY_ROLE_ACCEPTABLE_SETTLING_COUNTERPARTY: 82,
  TARGET_PARTY_ROLE_CLEARING_ACCOUNT: 83,
  TARGET_PARTY_ROLE_UNACCEPTABLE_SETTLING_COUNTERPARTY: 84
};

/**
 * @enum {number}
 */
proto.Common.ComplexEventTypeEnum = {
  COMPLEX_EVENT_TYPE_UNSPECIFIED: 0,
  COMPLEX_EVENT_TYPE_CAPPED: 1,
  COMPLEX_EVENT_TYPE_KNOCK_IN_UP: 2,
  COMPLEX_EVENT_TYPE_KNOCK_OUT_DOWN: 3,
  COMPLEX_EVENT_TYPE_KNOCK_OUT_UP: 4,
  COMPLEX_EVENT_TYPE_KOCK_IN_DOWN: 5,
  COMPLEX_EVENT_TYPE_RESET_BARRIER: 6,
  COMPLEX_EVENT_TYPE_ROLLING_BARRIER: 7,
  COMPLEX_EVENT_TYPE_TRIGGER: 8,
  COMPLEX_EVENT_TYPE_UNDERLYING: 9
};

/**
 * @enum {number}
 */
proto.Common.ComplexEventPriceBoundaryMethodEnum = {
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_UNSPECIFIED: 0,
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_EQUAL_TO_COMPLEX_EVENT_PRICE: 1,
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_GREATER_THAN_COMPLEX_EVENT_PRICE: 2,
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_GREATER_THAN_OR_EQUAL_TO_COMPLEX_EVENT_PRICE: 3,
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_LESS_THAN_COMPLEX_EVENT_PRICE: 4,
  COMPLEX_EVENT_PRICE_BOUNDARY_METHOD_LESS_THAN_OR_EQUAL_TO_COMPLEX_EVENT_PRICE: 5
};

/**
 * @enum {number}
 */
proto.Common.ComplexEventPriceTimeTypeEnum = {
  COMPLEX_EVENT_PRICE_TIME_TYPE_UNSPECIFIED: 0,
  COMPLEX_EVENT_PRICE_TIME_TYPE_EXPIRATION: 1,
  COMPLEX_EVENT_PRICE_TIME_TYPE_IMMEDIATE: 2,
  COMPLEX_EVENT_PRICE_TIME_TYPE_SPECIFIED_DATE: 3
};

/**
 * @enum {number}
 */
proto.Common.ComplexEventConditionEnum = {
  COMPLEX_EVENT_CONDITION_UNSPECIFIED: 0,
  COMPLEX_EVENT_CONDITION_AND: 1,
  COMPLEX_EVENT_CONDITION_OR: 2
};

goog.object.extend(exports, proto.Common);
